export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DobDay: any;
  DobMonth: any;
  DobYear: any;
  GeoLocation: any;
  JSON: any;
};

/** Enumeration for address normalization status returned from AMS address-verify */
export enum AmsAddressNormalizationStatus {
  /** One or more of the input address elements have been corrected to match an address in the reference data */
  Corrected = 'CORRECTED',
  /** Address is invalid, or not found in reference data or country is not supported */
  Invalid = 'INVALID',
  /** Address is verified and can be considered as valid */
  Verified = 'VERIFIED'
}

/**
 * Address Type Codes sent by AMS. https://ppaas/api/3719176155272334#apiReference
 *  B: Building.
 *  F: Company or Firm.
 *  G: General delivery address.
 *  H: High-rise Building.
 *  L: Large volume receiver.
 *  M: Military address.
 *  P: Post Office Box (PO Box).
 *  R: Rural route address.
 *  S: Street address.
 *  U: Unidentified address.
 */
export enum AmsAddressTypeCode {
  /** Building */
  B = 'B',
  /** Company or Firm */
  F = 'F',
  /** General delivery address */
  G = 'G',
  /** High-rise Building */
  H = 'H',
  /** Large volume receiver */
  L = 'L',
  /** Military address */
  M = 'M',
  /** Post Office Box (PO Box) */
  P = 'P',
  /** Rural route address */
  R = 'R',
  /** Street address */
  S = 'S',
  /** Unidentified address */
  U = 'U'
}

/** An enumeration of AMS matching scope value. */
export enum AmsMatchingScope {
  /** validate every inputs of address */
  All = 'ALL',
  /** validate the province, locality, postalcode, street, house number */
  DeliverypointLevel = 'DELIVERYPOINT_LEVEL',
  /** validate province, locality, postalcode */
  LocalityLevel = 'LOCALITY_LEVEL',
  /** validate the province, locality, postalcode, street */
  StreetLevel = 'STREET_LEVEL'
}

/** Metadata returned by AMS response */
export type AmsMetadata = {
  __typename?: 'AMSMetadata';
  /** Postal Relevances */
  postalRelevances?: Maybe<AddressElementsMetadata>;
  /** Similarities */
  similarities?: Maybe<AddressElementsMetadata>;
  /** Transformations */
  transformations?: Maybe<AddressElementsMetadata>;
};

/**
 * An enumeration of AMS Metadata response values.
 * Doc: https://engineering.paypalcorp.com/confluence/pages/viewpage.action?pageId=901150143#LocationSpecfieldsDefinitions-AddressElementMetadata
 * API: https://ppaas/api/3719176155272334#apiReference
 */
export enum AmsMetadataValues {
  /** Could mean invalid in following context: metadata.similarities */
  Invalid = 'INVALID',
  /** Could mean irrelevant in following context: metadata.postal_relevances */
  Irrelevant = 'IRRELEVANT',
  /** Could mean a major change in following context: metadata.transformations */
  MajorChange = 'MAJOR_CHANGE',
  /** Could mean mandatory in following context: metadata.postal_relevances */
  Mandatory = 'MANDATORY',
  /** Could mean match in following context: metadata.similarities */
  Match = 'MATCH',
  /** Could mean a minor change in following context: metadata.transformations */
  MinorChange = 'MINOR_CHANGE',
  /** Could mean newly introduced value in following context: metadata.transformations */
  NewlyIntroduced = 'NEWLY_INTRODUCED',
  /** Could mean not a match in following context: metadata.similarities */
  NoMatch = 'NO_MATCH',
  /** Could mean optional in following context: metadata.postal_relevances */
  Optional = 'OPTIONAL',
  /** Could mean partial match in following context: metadata.similarities */
  PartialMatch = 'PARTIAL_MATCH',
  /** Could mean standardized in following context: metadata.transformations */
  Standardized = 'STANDARDIZED',
  /** Could mean unchanged in following context: metadata.transformations */
  Unchanged = 'UNCHANGED',
  /** Could mean undetermined in following context: metadata.similarities, metadata.tranformations, metadata.postal_relevances */
  Undetermined = 'UNDETERMINED',
  /** Could mean updated in following context: metadata.transformations */
  Updated = 'UPDATED'
}

/** An enumeration of all potential API status calls returned when returned in body */
export enum ApiCallStatus {
  /** Failure */
  Failed = 'FAILED',
  /** Success */
  Success = 'SUCCESS'
}

/**
 * Specifies how the partner-specific merchant account is managed.
 * The value can be one of the following LINKED_HYBRID, STANDALONE_HYBRID or PARTNER_MANAGED.
 */
export enum AccountManagementType {
  /** This represents the hybrid spoke account linked to hub account. */
  LinkedHybrid = 'LINKED_HYBRID',
  /** This represents managed path and *_HYBRID represents hybrid path partner specific merchant integrations. */
  PartnerManaged = 'PARTNER_MANAGED',
  /** This represents there is no linked hub account and it is managed via the partner. */
  StandaloneHybrid = 'STANDALONE_HYBRID'
}

/** Encapsulates all properties related to an Account Quality address. */
export type AccountQualityAddressInput = {
  /** Address's  Auto Complete Type (Ex: 'GOOGLE / BROWSER / UNKNOWN / MERCHANT_PREFILLED / ANS / MANUAL'). This type will be set from specific enum depending on how user chose to auto complete the address */
  autoCompleteType?: InputMaybe<AddressAutoCompleteType>;
  /** Address's isUserModified (Ex: true/false). This will be set as true incase user selected one of the autoComplete address and still modifies it */
  isUserModified?: InputMaybe<Scalars['Boolean']>;
  /** 2FA verfication id if buyer has initialized phone confirmation during checkout onboarding flow */
  twoFactorPhoneVerificationId?: InputMaybe<Scalars['String']>;
};

/** An enumeration of user account status. (Ex: 'OPEN / CLOSED / LOCKED / UNKNOWN') */
export enum AccountStatus {
  /** User account status is CLOSED */
  Closed = 'CLOSED',
  /** User account status is LOCKED */
  Locked = 'LOCKED',
  /** User account status is OPEN */
  Open = 'OPEN',
  /** User account status is UNKNOWN */
  Unknown = 'UNKNOWN'
}

/** An enumeration of user account type. (Ex: 'ANONYMOUS / GUEST / PERSONAL / BUSINESS') */
export enum AccountType {
  /** User account is an anonymous account */
  Anonymous = 'ANONYMOUS',
  /** User account is a business account */
  Business = 'BUSINESS',
  /** User account is a guest account */
  Guest = 'GUEST',
  /** User account is a personal account */
  Personal = 'PERSONAL'
}

/** Details for an account type, including its classification and a list of ineligible brands with constraint reasons. */
export type AccountTypeDetails = {
  __typename?: 'AccountTypeDetails';
  /** A list of brands that are ineligible for this account type. */
  brands?: Maybe<Array<Maybe<BrandDetails>>>;
  /** The classification of the account type, such as CREDIT or DEBIT. */
  productClass?: Maybe<Scalars['String']>;
};

/** Response wrapper for addBillingAddress. */
export type AddBillingAddressResponse = {
  __typename?: 'AddBillingAddressResponse';
  /** Whether or not a billing address has been added. */
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Billing address input type for adding a new card
 *
 * See: https://github.paypal.com/Checkout/xo-hermes-fi/blob/master/apis/addCard/inputSchema.js#L81
 */
export type AddCardBillingAddressInput = {
  /** Portable address: An address first line street address */
  addressLine1?: InputMaybe<Scalars['String']>;
  /** Portable address: An address second line street address */
  addressLine2?: InputMaybe<Scalars['String']>;
  /** Portable address: An address third line street address */
  addressLine3?: InputMaybe<Scalars['String']>;
  /** Portable address: An address first line admin area */
  adminArea1?: InputMaybe<Scalars['String']>;
  /** Portable address: An address second line admin area */
  adminArea2?: InputMaybe<Scalars['String']>;
  /** Portable address: An address third line admin area */
  adminArea3?: InputMaybe<Scalars['String']>;
  /** Portable address: An address forth line admin area */
  adminArea4?: InputMaybe<Scalars['String']>;
  /** @Deprecated: Coarse format addresses are being phased out for portable format addresses. Use adminArea2 instead for portable format. */
  city?: InputMaybe<Scalars['String']>;
  /** A billing address two-letter country code (Ex: 'US') */
  country?: InputMaybe<Scalars['String']>;
  /** Portable address: An address two-letter country code */
  countryCode?: InputMaybe<Scalars['String']>;
  /** Existing billing address Id (Ex: '7100887737437037359') */
  id?: InputMaybe<Scalars['String']>;
  /** @Deprecated: Coarse format addresses are being phased out for portable format addresses. Use addressLine1 instead for portable format. */
  line1?: InputMaybe<Scalars['String']>;
  /** @Deprecated: Coarse format addresses are being phased out for portable format addresses. Use addressLine2 instead for portable format. */
  line2?: InputMaybe<Scalars['String']>;
  /** @Deprecated: Coarse format addresses are being phased out for portable format addresses. Use adminArea1 instead for portable format. */
  postalCode?: InputMaybe<Scalars['String']>;
  /** @Deprecated: Coarse format addresses are being phased out for portable format addresses. Use adminArea1 instead for portable format. */
  state?: InputMaybe<Scalars['String']>;
};

/**
 * Card input type for adding a new card
 *
 * See: https://github.paypal.com/Checkout/xo-hermes-fi/blob/master/apis/addCard/inputSchema.js#L42
 */
export type AddCardInput = {
  /** 2 digits code for expiration month for the given card (Ex: '01', '12', '10') */
  expiryMonth?: InputMaybe<Scalars['String']>;
  /** 4 digits code for the expiration year for the given card. (Ex, '2020') */
  expiryYear?: InputMaybe<Scalars['String']>;
  /**
   * Some Debit Cards and Credit Cards have an Issue Number, which is normally `01` unless the card has been replaced at any time.
   *
   * **Maestro cards**, for example, have an issue number.
   */
  issueNumber?: InputMaybe<Scalars['String']>;
  /** 13 to 19 digits number of a card. (Ex: '4111111111111111') */
  number: Scalars['String'];
  /** 3 or 4 digits security code of the given card (Ex: '123' or '3456') depends on the type of credit card */
  securityCode?: InputMaybe<Scalars['String']>;
  /** Starting month for the given card. (Ex: '01', '02', '12')  */
  startMonth?: InputMaybe<Scalars['String']>;
  /** Starting year for the given card. (Ex: '2018') */
  startYear?: InputMaybe<Scalars['String']>;
  /** The card issuer as a CardIssuerType (Ex: 'VISA', 'AMEX', 'MASTER', 'DISCOVER') */
  type: CardIssuerType;
};

/**
 * User input type for adding a new card
 *
 * See: https://github.paypal.com/Checkout/xo-hermes-fi/blob/master/apis/addCard/inputSchema.js#L16
 */
export type AddCardUserInput = {
  /** 2 digits code for the actual date for user's birthday (Ex: '21', '05') */
  dobDay?: InputMaybe<Scalars['String']>;
  /** 2 digits code for the actual mnonth for user's birthday (Ex: '01', '10') */
  dobMonth?: InputMaybe<Scalars['String']>;
  /** 4 digits code for the actual year for user's birthady (Ex: '1988', '1963) */
  dobYear?: InputMaybe<Scalars['String']>;
  /** User's first name (Ex: 'John') */
  firstName: Scalars['String'];
  /** User's last name (Ex: 'Greathouse') */
  lastName: Scalars['String'];
};

/** The Address interface encapsulates all properties related to an address. */
export type Address = {
  /** A billing address city (Ex: 'San Jose') */
  city?: Maybe<Scalars['String']>;
  /** A billing address two-letter country code (Ex: 'US') */
  country?: Maybe<Scalars['String']>;
  /**
   * A billing address on a single line
   * (Ex: '2211 North 1st St, Apt 123, San Jose, CA 95131')
   */
  fullAddress?: Maybe<Scalars['String']>;
  /** A billing address first line street address (Ex: '2211 North 1st St') */
  line1?: Maybe<Scalars['String']>;
  /** A billing address second line street address (Ex: 'Apt 123') */
  line2?: Maybe<Scalars['String']>;
  /** A billing address postal code (Ex: '95131') */
  postalCode?: Maybe<Scalars['String']>;
  /** A billing address state/province (Ex: 'CA') */
  state?: Maybe<Scalars['String']>;
};

/** A container type for address field's allowed values and labels. */
export type AddressAllowedValues = {
  __typename?: 'AddressAllowedValues';
  /** The display text for the field EX: a state can have: California, Buenos Aires (Provincia), etc */
  displayText?: Maybe<Scalars['String']>;
  /** The input value for the field EX: a state can have: CA, BUENOS AIRES, etc */
  value?: Maybe<Scalars['String']>;
};

/**
 * GAAC - Google Address Auto Complete
 * Response of google api call to get address auto suggestion based on line1 of address field
 */
export type AddressAutoComplete = {
  __typename?: 'AddressAutoComplete';
  /** Suggestions is an array of object with placeId and addressText */
  suggestions?: Maybe<Array<Maybe<AddressAutoCompleteElement>>>;
};

/**
 * GAAC - Google Address Auto Complete
 * each address format of GAAC should be this format for frontends to process
 */
export type AddressAutoCompleteElement = {
  __typename?: 'AddressAutoCompleteElement';
  /** addressText is a plain text full address */
  addressText?: Maybe<Scalars['String']>;
  /**
   * mainText is usually first line of address with which user input is matched
   * 2211 North first street
   */
  mainText?: Maybe<Scalars['String']>;
  /** placeId is a unique identifier of addressText, and it can be used to get normalized address from google */
  placeId?: Maybe<Scalars['ID']>;
  /**
   * secondaryText is usually city state country separated by comma
   * San Jose, CA, USA
   */
  secondaryText?: Maybe<Scalars['String']>;
};

/** An enumeration of types that an address can be completed by an user. (Ex: 'GOOGLE / BROWSER / UNKNOWN / MERCHANT_PREFILLED / ANS / MANUAL') */
export enum AddressAutoCompleteType {
  /** An address populated from normalized service */
  Ans = 'ANS',
  /** An address selected by user incase auto-populated from BROWSER */
  Browser = 'BROWSER',
  /** An address populated from Google */
  Google = 'GOOGLE',
  /** An address added manually by user */
  Manual = 'MANUAL',
  /** An address populated from Merchant */
  MerchantPrefilled = 'MERCHANT_PREFILLED',
  /** An address unknown */
  Unknown = 'UNKNOWN'
}

/**
 * Lists of all address elements that makes an address. The value of the address field elements are mapped from the metadata response from AMS
 * address-verify API. Some of the fields in this type are non-portable additional address details that are sometimes needed for compliance, risk,
 * or other scenarios where fine-grain address information might be needed. Not portable with common third party and open source. Redundant with core fields.
 * For example, address_portable.address_line_1 is usually a combination of address_details.street_number, street_name, and street_type
 */
export type AddressElementsMetadata = {
  __typename?: 'AddressElementsMetadata';
  /**
   * The highest level sub-division in a country, which is usually a province, state, or ISO-3166-2 subdivision. Format for postal delivery.
   * For example, `CA` and not `California`. Value, by country, is: UK -> a county. US -> a state. Canada -> a province. Japan -> a prefecture.
   * Switzerland -> a kanton.
   */
  adminArea1?: Maybe<AmsMetadataValues>;
  /** Smaller than admin area 1. A city, town, or village. */
  adminArea2?: Maybe<AmsMetadataValues>;
  /**
   * Smaller than admin area 2. A sub-locality, suburb, neighborhood, or district. Value is: Brazil: Suburb, bairro, or neighborhood. India: Sub-locality or district.
   * Street name information is not always available but a sub-locality or district can be a very small area.
   */
  adminArea3?: Maybe<AmsMetadataValues>;
  /**
   * Smaller than admin area 3. The neighborhood, ward, or district. Value is:The postal sorting code for
   * Guernsey and many French territories, such as French Guiana. The fine-grained administrative levels in China.
   */
  adminArea4?: Maybe<AmsMetadataValues>;
  /** A named locations that represents the premise. Usually a building name or number or collection of buildings with a common name or number. For example, Craven House */
  buildingName?: Maybe<AmsMetadataValues>;
  /** Two digit ISO2 representation of the country. */
  countryCode?: Maybe<AmsMetadataValues>;
  /** The delivery service. Post office box, bag number, or post office name. */
  deliveryService?: Maybe<AmsMetadataValues>;
  /** The postal code, which is the zip code or equivalent. Typically required for countries with a postal code or an equivalent. See [postal code](https://en.wikipedia.org/wiki/Postal_code). */
  postalCode?: Maybe<AmsMetadataValues>;
  /** The street name in an address element. Example: Hawthorne Way in 15 Hawthorne Way */
  streetName?: Maybe<AmsMetadataValues>;
  /** The street number in an address element. Example: 15 in 15 Hawthorne Way */
  streetNumber?: Maybe<AmsMetadataValues>;
  /** The street type. For example, avenue, boulevard, road, or expressway. */
  streetType?: Maybe<AmsMetadataValues>;
  /** The first-order entity below a named building or location that represents the sub-premise. Usually a single building within a collection of buildings with a common name. Can be a flat, story, floor, room, or apartment. */
  subBuilding?: Maybe<AmsMetadataValues>;
};

/** True or False values for each element of an address */
export type AddressFieldBools = {
  __typename?: 'AddressFieldBools';
  /** Portable address: An address first line street address */
  addressLine1?: Maybe<Scalars['Boolean']>;
  /** Portable address: An address second line street address */
  addressLine2?: Maybe<Scalars['Boolean']>;
  /** Portable address: An address third line street address */
  addressLine3?: Maybe<Scalars['Boolean']>;
  /** Portable address: An address first line admin area */
  adminArea1?: Maybe<Scalars['Boolean']>;
  /** Portable address: An address second line admin area */
  adminArea2?: Maybe<Scalars['Boolean']>;
  /** Portable address: An address third line admin area */
  adminArea3?: Maybe<Scalars['Boolean']>;
  /** Portable address: An address forth line admin area */
  adminArea4?: Maybe<Scalars['Boolean']>;
  /** A billing address city (Ex: 'San Jose') */
  city?: Maybe<Scalars['Boolean']>;
  /** A billing address two-letter country code (Ex: 'US') */
  country?: Maybe<Scalars['Boolean']>;
  /** Portable address: An address two-letter country code */
  countryCode?: Maybe<Scalars['Boolean']>;
  /** A billing address first line street address (Ex: '2211 North 1st St') */
  line1?: Maybe<Scalars['Boolean']>;
  /** A billing address second line street address (Ex: 'Apt 123') */
  line2?: Maybe<Scalars['Boolean']>;
  /** A billing address postal code (Ex: '95131') */
  postalCode?: Maybe<Scalars['Boolean']>;
  /** A billing address state/province (Ex: 'CA') */
  state?: Maybe<Scalars['Boolean']>;
};

/**
 * GAAC - Google Address Auto Complete
 * Address response based on a place id - basically this is google returned address elements
 */
export type AddressForPlaceId = {
  __typename?: 'AddressForPlaceId';
  /**
   * address mapping from google places api response
   * we are having address key to create a griffin mapped google response
   * In future if we need any google specific fields then we can add a new key
   * with name additionalAddressFields or something similar
   *
   * If state is missing in GenericAddress then it means google returned state
   * did not match the griffin state list we have for a country
   */
  address?: Maybe<GenericAddress>;
};

/** Address input type */
export type AddressInput = {
  /** An address quality from user */
  accountQuality?: InputMaybe<AccountQualityAddressInput>;
  /** Portable address: An address first line street address (Ex: '2211 North 1st St') */
  addressLine1?: InputMaybe<Scalars['String']>;
  /** Portable address: An address second line street address (Ex: 'Apt 123') */
  addressLine2?: InputMaybe<Scalars['String']>;
  /** Portable address: An address third line street address (Ex: 'Near CVS') */
  addressLine3?: InputMaybe<Scalars['String']>;
  /** Portable address: An address first line admin area (Ex: 'CA') */
  adminArea1?: InputMaybe<Scalars['String']>;
  /** Portable address: An address second line admin area (Ex: 'San Jose') */
  adminArea2?: InputMaybe<Scalars['String']>;
  /** Portable address: An address third line admin area */
  adminArea3?: InputMaybe<Scalars['String']>;
  /** Portable address: An address forth line admin area */
  adminArea4?: InputMaybe<Scalars['String']>;
  /** @Deprecated: Coarse format addresses are being phased out for portable format addresses. Use adminArea2 instead for portable format. (Ex: 'San Jose') */
  city?: InputMaybe<Scalars['String']>;
  /** @Deprecated: Coarse format addresses are being phased out for portable format addresses. Use countryCode instead for portable format. (Ex: 'US') */
  country?: InputMaybe<Scalars['String']>;
  /** Portable address: An address two-letter country code (Ex: 'US') */
  countryCode?: InputMaybe<Scalars['String']>;
  /** The last name of the address (Ex: 'Smith') */
  familyName?: InputMaybe<Scalars['String']>;
  /** The first name of the address (Ex: 'John') */
  givenName?: InputMaybe<Scalars['String']>;
  /** @Deprecated: Coarse format addresses are being phased out for portable format addresses. Use addressLine1 instead for portable format. (Ex: '2211 North 1st St') */
  line1?: InputMaybe<Scalars['String']>;
  /** @Deprecated: Coarse format addresses are being phased out for portable format addresses. Use addressLine2 instead for portable format. (Ex: 'Apt 123') */
  line2?: InputMaybe<Scalars['String']>;
  /** An Address postal code (Ex: '95131') */
  postalCode?: InputMaybe<Scalars['String']>;
  /** @Deprecated: Coarse format addresses are being phased out for portable format addresses. Use adminArea1 instead for portable format. (Ex: 'CA') */
  state?: InputMaybe<Scalars['String']>;
};

/** A container type for portable address metadata */
export type AddressLineLayout = {
  __typename?: 'AddressLineLayout';
  /** A list of parts in the address line */
  parts?: Maybe<Array<Maybe<AddressLinePart>>>;
};

/** A container type for address input field metadata. */
export type AddressLinePart = {
  __typename?: 'AddressLinePart';
  /** Allowed values for the field */
  allowedValues?: Maybe<Array<Maybe<AddressAllowedValues>>>;
  /** Whether or not a field is required */
  isRequired?: Maybe<Scalars['Boolean']>;
  /** Label for the field */
  label?: Maybe<Scalars['String']>;
  /** Maximum length of field - Ex: 5 */
  maxLength?: Maybe<Scalars['Int']>;
  /** Minimum length of field - Ex: 1 */
  minLength?: Maybe<Scalars['Int']>;
  /** Name of field - Ex: adminArea1 */
  name?: Maybe<Scalars['String']>;
  /** Validation regex of field */
  regex?: Maybe<Scalars['String']>;
};

/** Enumeration for Address Normalization's ansraptor process mode params */
export enum AddressNormalizationProcessModes {
  /** For prefill case */
  Fastcompletion = 'FASTCOMPLETION',
  /** For normalization case */
  Interactive = 'INTERACTIVE'
}

/** Enumeration for Address Normalization's ansraptor scope */
export enum AddressNormalizationScopes {
  /** validate every inputs of address */
  All = 'ALL',
  /** validate the province, locality, postalcode, street, house number */
  DeliverypointLevel = 'DELIVERYPOINT_LEVEL',
  /** validate province locality. postal code */
  LocalityLevel = 'LOCALITY_LEVEL',
  /** validate the province, locality, postalcode. street */
  StreetLevel = 'STREET_LEVEL'
}

/** Transforms address in a particular script to another script. This is a best effort feature and might not take effect in all the countries. */
export enum AddressNormalizationTransliterationType {
  /** Transliterate with ASCII character set, if possible. */
  Ascii = 'ASCII',
  /** Transliterate with primary native script the country uses. */
  Default = 'DEFAULT',
  /** Transliterate with Latin-1 (ISO-8859-1) character set, if possible. */
  Latin_1 = 'LATIN_1',
  /** Transliterate with alternate Latin character set, if there are any, applicable to the country, if possible. */
  LatinAlt = 'LATIN_ALT',
  /** Transliterate with the same script as the input. */
  PreserveInput = 'PRESERVE_INPUT'
}

/**
 * An enumeration of address types that an Address can be. PROFILE, SHIPPING, BUSINESS, etc. These types are maintained in User Domain Model.
 * Address types have been consolidated in PartyProfileServ(PPS). UserPlatformServ(UPS) have a lot more address types when compared to PPS.
 * This enumeration contains both legacy and new address types from UPS and PPS respectively.
 * Read more here: https://github.paypal.com/vayipalayamchand/UserDevDocs/blob/master/UPS_Migration.md#address-type-mapping
 */
export enum AddressType {
  /** A business address */
  Business = 'BUSINESS',
  /** An alternate communication (home/mailing) address for the user. Could be international or PO box etc. */
  Communication = 'COMMUNICATION',
  /** A drop-off address */
  DropOff = 'DROP_OFF',
  /** A gift address */
  Gift = 'GIFT',
  /** A home or work address */
  HomeOrWork = 'HOME_OR_WORK',
  /** Office address */
  Office = 'OFFICE',
  /** Main business address */
  PrincipleBusiness = 'PRINCIPLE_BUSINESS',
  /** A prior/inactive address */
  Prior = 'PRIOR',
  /** An address that used to be the address of the user */
  PriorAddress = 'PRIOR_ADDRESS',
  /** An address associated with a user profile */
  Profile = 'PROFILE',
  /** A shipping address */
  Shipping = 'SHIPPING',
  /** Additional business address */
  SmiAdditionalBusiness = 'SMI_ADDITIONAL_BUSINESS',
  /** Address of the owner of the business. (owner is different from account holder) */
  SmiOwner = 'SMI_OWNER',
  /** Previous address of the business conducted by the account holder. */
  SmiPrevBusiness = 'SMI_PREV_BUSINESS',
  /** Address of the supplier for the business */
  SmiSupplier = 'SMI_SUPPLIER',
  /** 3rd party address - *not* one of the user's home/work addresses. */
  ThirdParty = 'THIRD_PARTY',
  /** 3rd party address that doesn't have an addressee name */
  ThirdPartyNoAddressee = 'THIRD_PARTY_NO_ADDRESSEE',
  /** A verisign address */
  Verisign = 'VERISIGN',
  /** Billing address for a Verisign Merchant */
  VerisignBilling = 'VERISIGN_BILLING',
  /** Billing address added to a WAX (WebAcceptExpress) account. */
  Wax = 'WAX',
  /** Shipping/gift address added to a WAX (WebAcceptExpress) account. */
  WaxGift = 'WAX_GIFT'
}

/**
 * Encapsulates all properties related to an Amount.
 * Ex: currencySymbol, currencyValue, currencyCode, etc.
 */
export type Amount = {
  __typename?: 'Amount';
  /** Amount's currency code (Ex: 'USD', 'HUF') */
  currencyCode?: Maybe<SupportedCountryCurrencies>;
  /** Amount's formatted currency symbol and value (Ex: '$0.01', 'Ft10') */
  currencyFormat?: Maybe<Scalars['String']>;
  /** Amount's formatted currency symbol, value, and code (Ex: '$0.01 USD', 'Ft10 HUF') */
  currencyFormatSymbolISOCurrency?: Maybe<Scalars['String']>;
  /** Amount's currency symbol (Ex: '$', 'Ft') */
  currencySymbol?: Maybe<Scalars['String']>;
  /** Amount's currency value without format(Ex: '0.01', 10.00') */
  currencyValue?: Maybe<Scalars['String']>;
};

/** Encapsulates all properties related to an Amount. */
export type AmountInput = {
  /** Amount's currency code (Ex: 'USD') */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Amount's currency value (Ex: '0.01') */
  currencyValue?: InputMaybe<Scalars['String']>;
};

/** Encapsulates all properties related to the app download banner for client rendering */
export type AppDownloadBanner = {
  __typename?: 'AppDownloadBanner';
  /** A string of the CSS styles tag */
  css: Scalars['String'];
  /** A string of the HTML markup */
  html: Scalars['String'];
  /** A string of JavaScript script tag */
  js: Scalars['String'];
};

/** Schema to validate merchant as Apple Pay eligible */
export type ApplePayMerchantSession = {
  __typename?: 'ApplePayMerchantSession';
  /** Opaque session from Apple */
  session?: Maybe<Scalars['String']>;
};

/** Schema for Apple Pay contact */
export type ApplePayPaymentContact = {
  /** Address from Apple */
  addressLines?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** State from Apple */
  administrativeArea?: InputMaybe<Scalars['String']>;
  /** Country from Apple */
  country?: InputMaybe<Scalars['String']>;
  /** Country code from Apple */
  countryCode?: InputMaybe<CountryCodes>;
  /** Email address from Apple */
  emailAddress?: InputMaybe<Scalars['String']>;
  /** Last name from Apple */
  familyName?: InputMaybe<Scalars['String']>;
  /** First name from Apple */
  givenName?: InputMaybe<Scalars['String']>;
  /** City from Apple */
  locality?: InputMaybe<Scalars['String']>;
  /** Phone number from Apple */
  phoneNumber?: InputMaybe<Scalars['String']>;
  /** Phonetic last name from Apple */
  phoneticFamilyName?: InputMaybe<Scalars['String']>;
  /** Phonetic first name from Apple */
  phoneticGivenName?: InputMaybe<Scalars['String']>;
  /** Postal code from Apple */
  postalCode?: InputMaybe<Scalars['String']>;
  /** County from Apple */
  subAdministrativeArea?: InputMaybe<Scalars['String']>;
  /** Township from Apple */
  subLocality?: InputMaybe<Scalars['String']>;
};

/** Schema for Apple Pay payment method */
export type ApplePayPaymentInput = {
  /** Apple Pay payment billing information */
  billingContact?: InputMaybe<ApplePayPaymentContact>;
  /** Apple Pay payment shipping information */
  shippingContact?: InputMaybe<ApplePayPaymentContact>;
  /** Apple Pay payment token */
  token?: InputMaybe<ApplePayPaymentToken>;
};

/** Schema for Apple Pay payment method */
export type ApplePayPaymentMethod = {
  /** Billing contact associated with the card. */
  billingContact?: InputMaybe<ApplePayPaymentContact>;
  /** A string, suitable for display, that describes the card. */
  displayName?: InputMaybe<Scalars['String']>;
  /** Name of the payment network backing the card */
  network?: InputMaybe<Scalars['String']>;
  /** The payment pass object currently selected to complete the payment. */
  paymentPass?: InputMaybe<ApplePayPaymentPass>;
  /** A value representing the card's type of payment. */
  type?: InputMaybe<ApplePayPaymentMethodType>;
};

/**
 * An enumeration of all potential payment method for apple pay
 * From the Apple Pay API docs: https://developer.apple.com/documentation/apple_pay_on_the_web/applepaypaymentmethodtype/
 * 'debit' | 'credit' | 'prepaid' | 'store'
 */
export enum ApplePayPaymentMethodType {
  /** credit card */
  Credit = 'credit',
  /** debit card */
  Debit = 'debit',
  /** prepaid */
  Prepaid = 'prepaid',
  /** pay in store */
  Store = 'store'
}

/**
 * Schema for Apple Pay payment method
 * Apple Pay API docs: https://developer.apple.com/documentation/apple_pay_on_the_web/applepaypaymentpass
 */
export type ApplePayPaymentPass = {
  /** Activation state: activated | requiresActivation | activating | suspended | deactivated */
  activationState?: InputMaybe<ApplePayPaymentPassActivationState>;
  /** The unique identifier for the device-specific account number. */
  deviceAccountIdentifier?: InputMaybe<Scalars['String']>;
  /** A version of the device account number suitable for display in your UI. */
  deviceAccountNumberSuffix?: InputMaybe<Scalars['String']>;
  /** The unique identifier for the primary account number for the payment card. */
  primaryAccountIdentifier: Scalars['String'];
  /** A version of the primary account number suitable for display in your UI. */
  primaryAccountNumberSuffix: Scalars['String'];
};

/**
 * An enumeration of all potential apple pay payment pass activation state
 * From the Apple Pay API docs: https://developer.apple.com/documentation/apple_pay_on_the_web/applepaypaymentpassactivationstate/
 * activated | requiresActivation | activating | suspended | deactivated
 */
export enum ApplePayPaymentPassActivationState {
  /** Active and ready to be used for payment. */
  Activated = 'activated',
  /** Not ready for use but activation is in progress. */
  Activating = 'activating',
  /** Not active because the issuer has disabled the account associated with the device. */
  Deactivated = 'deactivated',
  /** Not active but may be activated by the issuer. */
  RequiresActivation = 'requiresActivation',
  /** Not active and can't be activated. */
  Suspended = 'suspended'
}

/**
 * Schema for Apple Pay payment token
 * Apple Pay API docs: https://developer.apple.com/documentation/apple_pay_on_the_web/applepaypaymenttoken
 */
export type ApplePayPaymentToken = {
  /** Payment data */
  paymentData?: InputMaybe<Scalars['JSON']>;
  /** Payment method */
  paymentMethod?: InputMaybe<ApplePayPaymentMethod>;
  /** Transaction identifier */
  transactionIdentifier?: InputMaybe<Scalars['String']>;
};

/**
 * ApplePay config data
 * For ApplePay requests
 */
export type ApplepayConfig = {
  __typename?: 'ApplepayConfig';
  /** Merchant eligibility for Apple Pay */
  isEligible: Scalars['Boolean'];
  /** An array of the payment capabilities that the merchant supports, such as credit or debit. */
  merchantCapabilities: Array<Maybe<ApplepayMerchantCapabilities>>;
  /** A country code that represents the merchant's country (Ex: 'US') */
  merchantCountry?: Maybe<CountryCodes>;
  /** An array of supported card financial instrument (FI) brands */
  supportedNetworks: Array<Maybe<ApplepaySupportedNetworks>>;
  /** Token notification url for recurring payment request */
  tokenNotificationURL: Scalars['String'];
};

/**
 * An enumeration of all potential payment networks returned for Applepay config
 * https://developer.apple.com/documentation/apple_pay_on_the_web/applepaypaymentrequest/1916123-merchantcapabilities
 */
export enum ApplepayMerchantCapabilities {
  /** supports3DS */
  Supports3Ds = 'supports3DS',
  /** supportsCredit */
  SupportsCredit = 'supportsCredit',
  /** supportsDebit */
  SupportsDebit = 'supportsDebit'
}

/**
 * An enumeration of all potential payment networks returned for Applepay config
 * https://developer.apple.com/documentation/apple_pay_on_the_web/applepaypaymentrequest/1916122-supportednetworks
 */
export enum ApplepaySupportedNetworks {
  /** amex */
  Amex = 'amex',
  /** cartesBancaires */
  CartesBancaires = 'cartesBancaires',
  /** discover */
  Discover = 'discover',
  /** jcb */
  Jcb = 'jcb',
  /** maestro */
  Maestro = 'maestro',
  /** masterCard */
  MasterCard = 'masterCard',
  /** visa */
  Visa = 'visa'
}

/** Encapsulates all properties related to attribution. */
export type AttributionDetails = {
  __typename?: 'AttributionDetails';
  /** Identifier for an attribution. */
  attributionId?: Maybe<Scalars['String']>;
  /** attribution description in compact format. */
  compactDescription?: Maybe<Scalars['String']>;
  /** attribution description. */
  shortDescription?: Maybe<Scalars['String']>;
  /** attribution terms label */
  termsLabel?: Maybe<Scalars['String']>;
  /** attribution terms link */
  termsLink?: Maybe<Scalars['String']>;
  /** attribution tracking details */
  trackingDetails?: Maybe<TrackingDetails>;
};

/**
 * Encapsulates all properties related to a User's auth.
 * Ex: Access token
 * Average SLA response time - x ms
 *
 * Required auth states: LOGGEDIN, REMEMBERED or IDENTIFIED
 */
export type Auth = {
  __typename?: 'Auth';
  /** A user's access token */
  accessToken?: Maybe<Scalars['String']>;
  /** A user's auth code */
  authCode?: Maybe<Scalars['String']>;
  /** Url to run user through connect flow */
  connectUrl?: Maybe<GenericUrl>;
  /** A user's id token */
  idToken?: Maybe<Scalars['String']>;
  /** A user's refresh token */
  refreshToken?: Maybe<Scalars['String']>;
};


/**
 * Encapsulates all properties related to a User's auth.
 * Ex: Access token
 * Average SLA response time - x ms
 *
 * Required auth states: LOGGEDIN, REMEMBERED or IDENTIFIED
 */
export type AuthConnectUrlArgs = {
  billingType?: InputMaybe<Scalars['String']>;
  fundingSource?: InputMaybe<Scalars['String']>;
  payerId?: InputMaybe<Scalars['String']>;
  scopes: Array<InputMaybe<Scalars['String']>>;
  token: Scalars['String'];
};

/**
 * Encapsulates all properties related to a User's auth.
 * Ex: Access token
 *
 * Temp measure to get the @auth directive updated to use PARTIALLY_AUTHENTICATED, will
 * be removed once updated to using newest version of @paypalcorp/graphql-directive
 *
 * Required auth states: LOGGEDIN, REMEMBERED, IDENTIFIED or PARTIALLY_AUTHENTICATED
 */
export enum AuthState {
  /** Anonymous */
  Anonymous = 'ANONYMOUS',
  /** Guest */
  Identified = 'IDENTIFIED',
  /** Fully logged in */
  Loggedin = 'LOGGEDIN',
  /** Partially authenticated for SCA */
  PartiallyAuthenticated = 'PARTIALLY_AUTHENTICATED',
  /** Remember Me */
  Remembered = 'REMEMBERED'
}

/**
 * Provides further information about the authorization of an FI from
 * the corresponding issuer.
 */
export type AuthorizationContext = {
  __typename?: 'AuthorizationContext';
  /** Predicted approval score for funding source (LOW, MEDIUM, or HIGH) */
  predictedApprovalScore?: Maybe<PredictedApprovalScore>;
};

/** Encapsulates all properties related to the available Rewards */
export type AvailableRewards = {
  __typename?: 'AvailableRewards';
  /** The Rewards code description - example 'points' */
  denominationTypeDescription?: Maybe<Scalars['String']>;
  /** The equivalent monetary value of the rewards */
  monetaryValue?: Maybe<Amount>;
  /** Rewards value amount */
  value?: Maybe<Scalars['Float']>;
};

/**
 * An enumeration of types that a BalancePreference can be.
 * OPT_IN or OPT_OUT
 */
export enum BalancePreference {
  /** If Buyer chooses to use Balance for BA payments */
  OptIn = 'OPT_IN',
  /** If Buyer chooses not to use Balance for BA payments */
  OptOut = 'OPT_OUT'
}

/** An enumeration of all potential balance types for an offer */
export enum BalanceType {
  /** MSB - Merchant Specific Balance */
  Msb = 'MSB',
  /** PSB - PayPal Specific Balance */
  Psb = 'PSB'
}

/** The metadata for a particular bank account */
export type BankAccount = {
  __typename?: 'BankAccount';
  /** The bank account number */
  accountNumber: Scalars['String'];
  /** The last characters of the bank account's account number */
  accountNumberShort: Scalars['String'];
  /** The bank identifier code */
  bankIdentifierCode: Scalars['String'];
  /** The bank account's beneficiaries */
  beneficiaries: Array<Maybe<BankAccountBeneficiary>>;
  /** The bank account's billing address */
  billingAddress?: Maybe<GenericAddress>;
  /** The bank account creditor's information */
  creditor?: Maybe<BankAccountCreditor>;
  /** The bank account's currency code */
  currencyCode: Scalars['String'];
  /** A unique identifier for the bank account within the PayPal system */
  id: Scalars['String'];
  /** The bank account issuer's information */
  issuer?: Maybe<BankAccountIssuer>;
  /** Short name for the bank account created by the user */
  nickname?: Maybe<Scalars['String']>;
  /** The bank account's routing number */
  routingNumber: Scalars['String'];
  /** The bank account's type */
  type: BankAccountType;
};

/** Extra arguments needed for Add Bank flow. */
export type BankAccountAuthorizationsInput = {
  /** Indicates whether the bank has to resolve sepa authorization */
  acceptSepa?: InputMaybe<Scalars['Boolean']>;
};

/** Bank Account Beneficiary Information */
export type BankAccountBeneficiary = {
  __typename?: 'BankAccountBeneficiary';
  /** The full name of the bank account's beneficiary. */
  fullName: Scalars['String'];
};

/** Bank Account Beneficiary Input */
export type BankAccountBeneficiaryInput = {
  /** The birth date of the bank account's beneficiary */
  birthDate?: InputMaybe<DateOfBirth>;
  /** The first name of the bank account's beneficiary. */
  firstName?: InputMaybe<Scalars['String']>;
  /** The last name of the bank account's beneficiary. */
  lastName?: InputMaybe<Scalars['String']>;
  /** Phone number of the bank account's beneficiary */
  phone?: InputMaybe<PhoneInput>;
};

/** The attributes of an invidual bank account's creditor (the settler of the transaction) */
export type BankAccountCreditor = {
  __typename?: 'BankAccountCreditor';
  /** The address of the creditor */
  address?: Maybe<GenericAddress>;
  /** A creditor's insitutional ID */
  id: Scalars['String'];
  /** A creditor's name */
  name: Scalars['String'];
};

/** Bank Account Input */
export type BankAccountInput = {
  /** The account number of the bank account */
  accountNumber?: InputMaybe<Scalars['String']>;
  /** The International Bank Account Number for the account */
  iban?: InputMaybe<Scalars['String']>;
  /** The routing number for the given bank account */
  routingNumber?: InputMaybe<Scalars['String']>;
  /** The type of bank account (i.e. Checking, Savings, etc.) */
  type?: InputMaybe<BankAccountType>;
};

/** The attributes of an individual bank account's issuer */
export type BankAccountIssuer = {
  __typename?: 'BankAccountIssuer';
  /** An issuer's branch location */
  branchLocation?: Maybe<Scalars['String']>;
  /** An issuer's city */
  city: Scalars['String'];
  /** An issuer's country code */
  country: CountryCodes;
  /** An issuer's name */
  name: Scalars['String'];
};

/**
 * An enumeration of bank types that a bank account can identify with
 *
 * Reference: https://ppaas/api/3719176155268854#apiReference
 */
export enum BankAccountType {
  /** A business checking account */
  BusinessChecking = 'BUSINESS_CHECKING',
  /** A business savings account */
  BusinessSavings = 'BUSINESS_SAVINGS',
  /** A checking account */
  Checking = 'CHECKING',
  /** A custom account type */
  Custom = 'CUSTOM',
  /** A normal account type */
  Normal = 'NORMAL',
  /** A savings account type */
  Savings = 'SAVINGS',
  /** An unknown account type */
  Unknown = 'UNKNOWN'
}

/** BillingAddress */
export type BillingAddress = {
  /** address line 1 */
  addressLine1?: InputMaybe<Scalars['String']>;
  /** address line 2 */
  addressLine2?: InputMaybe<Scalars['String']>;
  /** admin area 1 */
  adminArea1?: InputMaybe<Scalars['String']>;
  /** admin area 2 */
  adminArea2?: InputMaybe<Scalars['String']>;
  /** country code */
  countryCode?: InputMaybe<Scalars['String']>;
  /** postal code */
  postalCode?: InputMaybe<Scalars['String']>;
};

/**
 * Enumeration to identify different billing charge patterns
 * The pattern in which the agreement will be used for charging.
 */
export enum BillingChargePattern {
  /** Pay after use, non-recurring post-paid, variable amount, irregular frequency. */
  Deferred = 'DEFERRED',
  /** On-demand instant payments – non-recurring , pre-paid, variable amount, variable frequency. */
  Immediate = 'IMMEDIATE',
  /** Pay on a fixed date based on usage or consumption after the goods/service is delivered. */
  RecurringPostpaid = 'RECURRING_POSTPAID',
  /** Pay upfront fixed or variable amount on a fixed date before the goods/service is delivered. */
  RecurringPrepaid = 'RECURRING_PREPAID',
  /** Charge payer when the set amount is reached or monthly billing cycle, whichever comes first, after the goods/service is delivered. */
  ThresholdPostpaid = 'THRESHOLD_POSTPAID',
  /** Charge payer when the set amount is reached or monthly billing cycle, whichever comes first, before the goods/service is delivered. */
  ThresholdPrepaid = 'THRESHOLD_PREPAID'
}

/**
 * Encapsulates all properties related to a subscription plan's billing cycle frequency.
 * (Ex: interval_unit = DAY, inverval_count = 2, means every 2 days)
 */
export type BillingCycleFrequency = {
  __typename?: 'BillingCycleFrequency';
  /** The number of intervals after which a subscriber is billed */
  intervalCount?: Maybe<Scalars['Int']>;
  /** Interval at which the subscription is charged/billed */
  intervalUnit?: Maybe<IntervalUnit>;
};

/** An enumeration of types that a BillingIntent can be. */
export enum BillingIntent {
  /** All Other integrations */
  Other = 'OTHER',
  /** VAULT integration */
  Vault = 'VAULT'
}

/** An enumeration of types that a billing payment experience can be. */
export enum BillingPaymentExperience {
  /** HERMES experience */
  Hermes = 'HERMES',
  /** HERMESNODE experience */
  Hermesnode = 'HERMESNODE'
}

/** Enumeration to identify different billing types */
export enum BillingType {
  /** Partner initiated billing type. */
  ChannelInitiatedBilling = 'CHANNEL_INITIATED_BILLING',
  /** Partner initiated billing type */
  ChannelInitiatedBillingSingleAgreement = 'CHANNEL_INITIATED_BILLING_SINGLE_AGREEMENT',
  /** Merchant initiated billing type. Default billing type */
  MerchantInitiatedBilling = 'MERCHANT_INITIATED_BILLING',
  /** Merchant initiated billing type but agreement already exists between buyer and merchant */
  MerchantInitiatedSingleBilling = 'MERCHANT_INITIATED_SINGLE_BILLING',
  /** Legacy Recurring Payments type */
  RecurringPayments = 'RECURRING_PAYMENTS',
  /** Next generation Recurring Payments */
  RecurringPaymentsV1 = 'RECURRING_PAYMENTS_V1',
  /** Next generation subscriptions type */
  SubscriptionsV1 = 'SUBSCRIPTIONS_V1'
}

/** Details for a brand, including its name and reasons for being ineligible. */
export type BrandDetails = {
  __typename?: 'BrandDetails';
  /** A list of reasons why this brand is ineligible for the transaction. */
  constraintReasons?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The name of the payment brand (e.g., AMEX, VISA). */
  name?: Maybe<Scalars['String']>;
};

/** High level container for offers estimate */
export type BurnableRewards = {
  __typename?: 'BurnableRewards';
  /** Specify if burnable rewards are present */
  hasBurnableRewards?: Maybe<Scalars['Boolean']>;
};

/** Business Information */
export type BusinessInformation = {
  /** Business name */
  businessName?: InputMaybe<Scalars['String']>;
  /** Business tagging id */
  businessTaggingId?: InputMaybe<Scalars['String']>;
  /** Merchant category code */
  merchantCategoryCode?: InputMaybe<Scalars['String']>;
  /** Notify url */
  notifyUrl?: InputMaybe<Scalars['String']>;
  /** Soft descriptor */
  softDescriptor?: InputMaybe<Scalars['String']>;
};

/** Customization for an animation in checkout */
export type ButtonAnimationCustomization = {
  __typename?: 'ButtonAnimationCustomization';
  /** Simple Text */
  id?: Maybe<Scalars['String']>;
  /** Simple Text */
  text?: Maybe<Scalars['String']>;
  /** Tracking details */
  tracking?: Maybe<CustomizationTracking>;
};

/** Customization for an design in checkout */
export type ButtonDesignCustomization = {
  __typename?: 'ButtonDesignCustomization';
  /** Simple Text */
  id?: Maybe<Scalars['String']>;
  /** Simple Text */
  text?: Maybe<Scalars['String']>;
  /** Tracking details */
  tracking?: Maybe<CustomizationTracking>;
};

/** Types of client config button funding source */
export enum ButtonFundingSourceType {
  /** Apple Pay */
  Applepay = 'applepay',
  /** Bancontact */
  Bancontact = 'bancontact',
  /** Blik */
  Blik = 'blik',
  /** Boleto */
  Boleto = 'boleto',
  /** Boletobancario */
  Boletobancario = 'boletobancario',
  /** Card */
  Card = 'card',
  /** Credit */
  Credit = 'credit',
  /** Elv */
  Elv = 'elv',
  /** EPS */
  Eps = 'eps',
  /** GiroPay */
  Giropay = 'giropay',
  /** Ideal */
  Ideal = 'ideal',
  /** Maxima */
  Maxima = 'maxima',
  /** Mercadopago */
  Mercadopago = 'mercadopago',
  /** Multibanco */
  Multibanco = 'multibanco',
  /** MyBank */
  Mybank = 'mybank',
  /** OXXO */
  Oxxo = 'oxxo',
  /** P24 */
  P24 = 'p24',
  /** Paidy */
  Paidy = 'paidy',
  /** Pay Later */
  Paylater = 'paylater',
  /** PayPal */
  Paypal = 'paypal',
  /** PayU */
  Payu = 'payu',
  /** Satispay */
  Satispay = 'satispay',
  /** Sepa */
  Sepa = 'sepa',
  /** SoFort */
  Sofort = 'sofort',
  /** Trustly */
  Trustly = 'trustly',
  /** Venmo */
  Venmo = 'venmo',
  /** WeChatPay */
  Wechatpay = 'wechatpay',
  /** Zimpler */
  Zimpler = 'zimpler'
}

/** List of all button labels for Smart Payment Buttons */
export enum ButtonLabels {
  /** Buy Now */
  Buynow = 'BUYNOW',
  /** Checkout */
  Checkout = 'CHECKOUT',
  /** Credit: checkout.js v4 only */
  Credit = 'CREDIT',
  /** Donate */
  Donate = 'DONATE',
  /** Installment */
  Installment = 'INSTALLMENT',
  /** Pay */
  Pay = 'PAY',
  /** Paypal */
  Paypal = 'PAYPAL',
  /** Subscribe */
  Subscribe = 'SUBSCRIBE'
}

/** List of all button layouts for Smart Payment Buttons */
export enum ButtonLayouts {
  /** Horizontal */
  Horizontal = 'horizontal',
  /** Vertical */
  Vertical = 'vertical'
}

/** List of all button sizes for Smart Payment Buttons */
export enum ButtonSizes {
  /** huge */
  Huge = 'huge',
  /** large */
  Large = 'large',
  /** medium */
  Medium = 'medium',
  /** small */
  Small = 'small',
  /** tiny */
  Tiny = 'tiny'
}

/** Types of buyer intent */
export enum BuyerIntentType {
  /** pay */
  Pay = 'PAY',
  /** pay_with_different_account */
  PayWithDifferentAccount = 'PAY_WITH_DIFFERENT_ACCOUNT',
  /** pay_with_different_funding_shipping */
  PayWithDifferentFundingShipping = 'PAY_WITH_DIFFERENT_FUNDING_SHIPPING'
}

/** An enumeration of types of integrations for shipping callback. */
export enum CallbackIntegrationType {
  /** Shipping address callback supported on the client */
  ClientSide = 'CLIENT_SIDE',
  /** Shipping address callback supported on the server */
  ServerSide = 'SERVER_SIDE'
}

/** Shipping methods to display to the buyer */
export type CallbackShippingMethodInput = {
  /** Default shipping method returned from cart/profile/callback url */
  default: Scalars['Boolean'];
  /** Unique UUID for this input */
  id?: InputMaybe<Scalars['String']>;
  /** Insurance Amount value for this method */
  insuranceAmount?: InputMaybe<AmountInput>;
  /** Custom label to display to the buyer for this method */
  label?: InputMaybe<Scalars['String']>;
  /** Whether or not this is the selected method */
  selected: Scalars['Boolean'];
  /** Shipping Amount value for this method */
  shippingAmount?: InputMaybe<AmountInput>;
  /** Tax Amount value for this method */
  taxAmount?: InputMaybe<AmountInput>;
};

/** Version of shipping callback integration. */
export enum CallbackVersion {
  /** V1 */
  V1 = 'V1',
  /** V2 */
  V2 = 'V2'
}

/** Card */
export type Card = {
  /** billing address */
  billingAddress?: InputMaybe<BillingAddress>;
  /** expiry */
  expiry: Scalars['String'];
  /** name */
  name?: InputMaybe<Scalars['String']>;
  /** number */
  number: Scalars['String'];
  /** cvv */
  securityCode?: InputMaybe<Scalars['String']>;
};

/**
 * An enumeration of types that FundingOption can have.
 * PROCESSOR_DECLINE, PAYPAL_ELIGIBILITY or PREAUTH
 */
export enum CardAuthType {
  /** Full amount transaction authorization */
  Full = 'FULL',
  /** Partial amount transaction authorization */
  Partial = 'PARTIAL'
}

/** Encapsulates key metadata for a particular card. */
export type CardDefinition = {
  __typename?: 'CardDefinition';
  /** The card issuer as a CardIssuerType (e.g. 'VISA', 'DISCOVER') */
  brand: CardIssuerType;
  /** The classification(s) for the card (e.g. 'CREDIT_CARD', 'DEBIT_CARD') */
  classifications: Array<Maybe<InstrumentClassification>>;
  /** The available method(s) for confirming the card (e.g. 'ONE_TIME_PASSWORD_CONFIRMATION') */
  confirmationMethods: Array<Maybe<Scalars['String']>>;
  /** The card issuer's country code */
  countryCode?: Maybe<CountryCodes>;
  /** The card's currency code */
  currencyCode: SupportedCountryCurrencies;
};

/** The metadata for a particular credit card */
export type CardDetails = {
  __typename?: 'CardDetails';
  /** A unique identifier for the credit card within the PayPal system */
  lastFourDigits: Scalars['String'];
  /** The card issuer as a CardIssuerType (Ex: 'VISA', 'AMEX', 'MASTER', 'DISCOVER') */
  type: CardIssuerType;
};

/** Container type for card eligibility, branded card eligibility, and associated vendors */
export type CardEligibility = {
  __typename?: 'CardEligibility';
  /** Whether or not a card is branded */
  branded?: Maybe<Scalars['Boolean']>;
  /** Whether or not a card type is eligible */
  eligible: Scalars['Boolean'];
  /** Whether Guest Checkout is enabled */
  guestEnabled?: Maybe<Scalars['Boolean']>;
  /** Whether installments are eligible */
  installments?: Maybe<Scalars['Boolean']>;
  /** Reasons why card is eligible. This is an internal field and is not accessible for external use */
  reasons: Array<Maybe<Scalars['String']>>;
  /** Associated credit card vendors.  See CardVendorEligibility */
  vendors: CardVendorEligibility;
};

/**
 * Encapsulates the card art image data
 * Contains the card art image and its dimensions
 */
export type CardImage = Image & {
  __typename?: 'CardImage';
  /** An image's height in pixels (number value only) */
  height?: Maybe<Scalars['String']>;
  /** An image's URL. A URL type. */
  url?: Maybe<GenericUrl>;
  /** An image's width in pixels (number value only) */
  width?: Maybe<Scalars['String']>;
};

/** Card input type represents a card to be added to an account */
export type CardInput = {
  /** 13 to 19 digits number of a card. (Ex: '4111111111111111') */
  cardNumber: Scalars['String'];
  /** Expiration date of a card (Ex: '02/2020') */
  expirationDate?: InputMaybe<Scalars['String']>;
  /** Starting month for the given card. (Ex: '01', '02', '12') */
  issueDate?: InputMaybe<Scalars['String']>;
  /** Postal code of  (Ex: '123') */
  postalCode?: InputMaybe<Scalars['String']>;
  /** Card product class (Ex: 'CREDIT', 'DEBIT') */
  productClass?: InputMaybe<CardProductClass>;
  /** 3 or 4 digits security code of a card (Ex: '123') */
  securityCode?: InputMaybe<Scalars['String']>;
  /** The card issuer as a CardIssuerType (Ex: 'VISA', 'AMEX', 'MASTER_CARD', 'DISCOVER') */
  type?: InputMaybe<CardIssuerType>;
};

/**
 * An enumeration of credit card issuers that a card can have.
 * VISA, MASTER_CARD, AMEX, etc
 */
export enum CardIssuerType {
  /** American Express */
  Amex = 'AMEX',
  /** CB Nationale */
  CbNationale = 'CB_NATIONALE',
  /** Cetelem */
  Cetelem = 'CETELEM',
  /** UnionPay */
  ChinaUnionPay = 'CHINA_UNION_PAY',
  /** Cofidis */
  Cofidis = 'COFIDIS',
  /** Cofinoga */
  Cofinoga = 'COFINOGA',
  /** Diners Club */
  Diners = 'DINERS',
  /** Discover */
  Discover = 'DISCOVER',
  /** Eftpos */
  Eftpos = 'EFTPOS',
  /** Elo */
  Elo = 'ELO',
  /** Hiper */
  Hiper = 'HIPER',
  /** Hipercard */
  Hipercard = 'HIPERCARD',
  /** JCB */
  Jcb = 'JCB',
  /** Maestro */
  Maestro = 'MAESTRO',
  /** Mastercard */
  MasterCard = 'MASTER_CARD',
  /** RuPay */
  Rupay = 'RUPAY',
  /** Visa */
  Visa = 'VISA'
}

/** Allows you to query for card metadata */
export type CardMeta = {
  __typename?: 'CardMeta';
  /** Returns the cobrand of the card if the card is cobranded (e.g. DISNEY_CREDIT) */
  cobrand?: Maybe<Scalars['String']>;
  /**
   * Allows you to query for card definitions.
   *
   * cardNumber - a partial or full card number for which to retrieve definitions
   * countryCode - a country code that represents the user's country (e.g. 'US')
   *
   * If a countryCode is not provided, it will be detected based on the request.
   *
   * Required Roles: None
   */
  definitions: Array<Maybe<CardDefinition>>;
};

/** Contains validation rules for credit card number and CSC length */
export type CardNumberLengthRules = {
  __typename?: 'CardNumberLengthRules';
  /** Maximum length of card number */
  cardNumberMaxLength: Scalars['Int'];
  /** Minimum length of card number */
  cardNumberMinLength: Scalars['Int'];
  /** Length of security code */
  securityCodeLength: Scalars['Int'];
};

/**
 * An enumeration of types that card product classes
 * CREDIT, DEBIT
 */
export enum CardProductClass {
  /** Credit Card */
  Credit = 'CREDIT',
  /** Debit Card */
  Debit = 'DEBIT',
  /** Gift Card */
  Gift = 'GIFT',
  /** Mixed card */
  Mixed = 'MIXED',
  /** PayPal Prepaid card */
  PaypalPrepaid = 'PAYPAL_PREPAID',
  /** Prepaid card */
  Prepaid = 'PREPAID',
  /** Tokenized card */
  Tokenized = 'TOKENIZED',
  /** Unknown card */
  Unknown = 'UNKNOWN',
  /** Vaulted card */
  Vaulted = 'VAULTED'
}

/** Contains all validation rules/metadata for a credit card */
export type CardRule = {
  __typename?: 'CardRule';
  /** Rules of card fields */
  fields: FieldRules;
  /** Contains information about maximum/minimum card number and security code length */
  length: CardNumberLengthRules;
  /** Indicate whether luhn validation is required */
  luhnValidationRequired: Scalars['Boolean'];
  /** Name of the card's type */
  name: Scalars['String'];
  /** Regex to validate card type. (Ex: /^(6011|65|64[4-9]|622|36|38|30[0-5])/) */
  pattern?: Maybe<Scalars['String']>;
  /** Indices for injecting spaces in a formatted credit card string (Ex: [4,8,12]) */
  spaceIndices: Array<Maybe<Scalars['Int']>>;
};

/** An enumeration of card transaction characteristics. PRE_AUTH, FINAL_AUTH, RECURRING_PAYMENT, UNKNOWN */
export enum CardTransactionType {
  /** The card characteristics is for Final Auth */
  FinalAuth = 'FINAL_AUTH',
  /** The card characteristics is for Pre Auth */
  PreAuth = 'PRE_AUTH',
  /** The card characteristics is for RECURRING_PAYMENT */
  RecurringPayment = 'RECURRING_PAYMENT',
  /** The card characteristics is for not known */
  Unknown = 'UNKNOWN'
}

/** Container type for a payment's eligibility for card vendors */
export type CardVendorEligibility = {
  __typename?: 'CardVendorEligibility';
  /** AMEX (or American Express) */
  amex: PaymentEligibility;
  /** CB_NATIONALE */
  cb_nationale: PaymentEligibility;
  /** CUP */
  cup: PaymentEligibility;
  /** DINERS */
  diners: PaymentEligibility;
  /** DISCOVER */
  discover: PaymentEligibility;
  /** ELO -- Mostly used in Brazil */
  elo: PaymentEligibility;
  /** Hipercard -- Mostly used in Brazil */
  hiper: PaymentEligibility;
  /** JCB -- Mostly used in Japan */
  jcb: PaymentEligibility;
  /** MAESTRO */
  maestro: PaymentEligibility;
  /** MASTERCARD */
  mastercard: PaymentEligibility;
  /** VISA */
  visa: PaymentEligibility;
};

/**
 * Encapsulates all properties related to a Cart.
 * Ex: cancelUrl, returnUrl, merchant, total, etc.
 * Average SLA response time - 170ms
 */
export type Cart = {
  __typename?: 'Cart';
  /** A Cart's amounts. */
  amounts?: Maybe<CartAmounts>;
  /** A Cart's associated billing address passed by merchant. */
  billingAddress?: Maybe<CartAddress>;
  /** Billing Charge pattern, for billing agreement transactions (Ex: 'IMMEDIATE', 'DEFERRED') */
  billingChargePattern?: Maybe<BillingChargePattern>;
  /** Billing intent, for billing without purchase flow integration (Ex: 'VAULT') */
  billingIntent?: Maybe<BillingIntent>;
  /** Billing token, for billing agreement transactions (Ex: 'BA-12345678901234567') */
  billingToken?: Maybe<Scalars['String']>;
  /** Billing type, for billing agreement transactions (Ex: 'MERCHANT_INITIATED_BILLING', 'CHANNEL_INITIATED_BILLING') */
  billingType?: Maybe<BillingType>;
  /**
   * A Cart's associated buyer.
   * Required Roles: LOGGEDIN, REMEMBERED, IDENTIFIED
   * A Cart's associated shipping address passed by merchant.
   * @deprecated Cart.buyer has been deprecated because it is not related to cart specific data. Use CheckoutSession.buyer instead.
   */
  buyer?: Maybe<User>;
  /** Indicates the type of shipping callback integration. Null if not a shipping callback integration. */
  callbackIntegrationType?: Maybe<CallbackIntegrationType>;
  /** Indicates the version of the shipping callback integration. Null if not a shipping callback integration. */
  callbackVersion?: Maybe<CallbackVersion>;
  /** Cart's cancel URL (Ex: www.merchant.com/cancel.html) */
  cancelUrl?: Maybe<GenericUrl>;
  /** Cart's ID (Ex: '9CH70521YP797774F') */
  cartId?: Maybe<Scalars['String']>;
  /** Items' category in the Cart. (e.g. PHYSICAL, DIGITAL, DONATION) */
  category?: Maybe<CartCategory>;
  /** Consent code, is part of oAuth context from merchant */
  consentCode?: Maybe<Scalars['String']>;
  /** A Cart's description. */
  description?: Maybe<Scalars['String']>;
  /** Cart's associated email passed by the merchant (Ex: dev@paypal.com) */
  email?: Maybe<Email>;
  /**
   * Cart's associated phone number passed by the merchant (Ex: '1112223333')
   * Returns international phone format
   */
  formattedPhoneNumber?: Maybe<Scalars['String']>;
  /** Cart's intent (Ex: 'SALE'). */
  intent?: Maybe<CartIntent>;
  /** A Cart's items. */
  items?: Maybe<Array<Maybe<CartItem>>>;
  /** The seller supplied note to the buyer. */
  noteToBuyer?: Maybe<Scalars['String']>;
  /**
   * All payees information
   * @deprecated Cart.payees has been deprecated because it is not related to cart specific data. Use CheckoutSession.payees instead.
   */
  payees?: Maybe<Array<Maybe<Payee>>>;
  /** A payer information sellers supply when creating the checkout session */
  payer?: Maybe<SuppliedUserInfo>;
  /** Payment ID, if transaction has one. (Ex: 'PAY-12345678901234567') */
  paymentId?: Maybe<Scalars['String']>;
  /**
   * Cart's associated phone number passed by the merchant (Ex: '1112223333')
   * If shouldValidate is true then only numbers that pass validation will be returned
   */
  phoneNumber?: Maybe<Scalars['String']>;
  /** Cart's return URL (Ex: www.merchant.com/thanks.html) */
  returnUrl?: Maybe<GenericUrl>;
  /** A Cart's associated shipping address passed by merchant. */
  shippingAddress?: Maybe<CartShippingAddress>;
  /** A Cart's associated shipping options passed by merchant. */
  shippingMethods?: Maybe<Array<Maybe<CartShippingMethod>>>;
  /** Cart's sold out flag, when sold out page should be presented */
  showSoldoutPage?: Maybe<Scalars['Boolean']>;
  /** Cart's soldout URL (Ex: www.merchant.com/soldout.html) */
  soldoutUrl?: Maybe<Scalars['String']>;
  /** Cart's state (Ex: 'CREATED') */
  state?: Maybe<CartState>;
  /** Subscription plan details, for EC-Subscription transactions */
  subscriptionDetails?: Maybe<SubscriptionDetails>;
  /** Supplementary Data in the Cart */
  supplementary?: Maybe<Supplementary>;
  /** A Cart's total amount. */
  total?: Maybe<Amount>;
  /** Total amount we allow for over captures in a transaction. The predicted amount comes from PAPS -> EDM  */
  totalAllowedOverCaptureAmount?: Maybe<Amount>;
  /** Total Quantity of the items in the cart. Returns 0 for no cart items or error during calculation */
  totalQuantity?: Maybe<Scalars['String']>;
};


/**
 * Encapsulates all properties related to a Cart.
 * Ex: cancelUrl, returnUrl, merchant, total, etc.
 * Average SLA response time - 170ms
 */
export type CartFormattedPhoneNumberArgs = {
  shouldValidate?: InputMaybe<Scalars['Boolean']>;
  useInternationalFormat?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Encapsulates all properties related to a Cart.
 * Ex: cancelUrl, returnUrl, merchant, total, etc.
 * Average SLA response time - 170ms
 */
export type CartPhoneNumberArgs = {
  shouldValidate?: InputMaybe<Scalars['Boolean']>;
  stripDialingCode?: InputMaybe<Scalars['Boolean']>;
};

/**
 * Encapsulates all properties related to a address
 * attached to a cart by merchant
 */
export type CartAddress = {
  __typename?: 'CartAddress';
  /** A shipping address city (Ex: 'San Jose') */
  city?: Maybe<Scalars['String']>;
  /** A shipping address two-letter country code (Ex: 'US') */
  country?: Maybe<CountryCodes>;
  /** Buyer's first name (Ex: 'John') */
  firstName?: Maybe<Scalars['String']>;
  /** Multiline string format of payer's billing address */
  formattedFullAddress?: Maybe<Scalars['String']>;
  /** Address is full address */
  isFullAddress?: Maybe<Scalars['Boolean']>;
  /** Buyer's last name (Ex: 'Smith') */
  lastName?: Maybe<Scalars['String']>;
  /** A shipping address first line street address (Ex: '2211 North 1st St') */
  line1?: Maybe<Scalars['String']>;
  /** A shipping address second line street address (Ex: 'Apt 123') */
  line2?: Maybe<Scalars['String']>;
  /** A shipping address postal code (Ex: '95131') */
  postalCode?: Maybe<Scalars['String']>;
  /** A shipping address state/province (Ex: 'CA') */
  state?: Maybe<Scalars['String']>;
};

/**
 * Encapsulates all properties related to a cart item.
 * Ex: description, quantity, amount
 * Average SLA response time - 170ms
 */
export type CartAmounts = {
  __typename?: 'CartAmounts';
  /** A Cart's discount. */
  discount?: Maybe<Amount>;
  /** A Cart's handling fee. */
  handlingFee?: Maybe<Amount>;
  /** Flag indicating when to hide amount details */
  hideAmountDetails?: Maybe<Scalars['Boolean']>;
  /** A Cart's insurance fee. */
  insurance?: Maybe<Amount>;
  /** A Cart's Insurance and handling fee combined */
  insuranceAndHandling?: Maybe<Amount>;
  /** A Cart's shipping fee. */
  shipping?: Maybe<Amount>;
  /** A Cart's combined shipping and handling fee. A sum of the shipping fee (with shipping discount applied) and the handling fee. */
  shippingAndHandling?: Maybe<Amount>;
  /** A Cart's Shipping and Shipping Discount */
  shippingAndShippingDiscount?: Maybe<Amount>;
  /** A Cart's shipping discount. */
  shippingDiscount?: Maybe<Amount>;
  /** A Cart's subtotal amount. */
  subtotal?: Maybe<Amount>;
  /** A Cart's tax amount. */
  tax?: Maybe<Amount>;
  /** A Cart's total amount. */
  total?: Maybe<Amount>;
};

/**
 * An enumeration of cart category, defined by item category in the cart.
 * DONATION
 */
export enum CartCategory {
  /** If item category is DIGITAL. */
  Digital = 'DIGITAL',
  /** If item category is DONATION. */
  Donation = 'DONATION',
  /** If item category is PHYSICAL. */
  Physical = 'PHYSICAL'
}

/** An enumeration of intents that a Cart can have. SALE, AUTHORIZE, or ORDER */
export enum CartIntent {
  /** The Cart's intent is for Authorization transactions. Same as AUTHORIZE. */
  Authorization = 'AUTHORIZATION',
  /** The Cart's intent is for Auth transactions */
  Authorize = 'AUTHORIZE',
  /** The Cart's intent is for Capture transactions */
  Capture = 'CAPTURE',
  /** The Cart's intent is for Order transactions */
  Order = 'ORDER',
  /** The Cart's intent is for Sale transactions */
  Sale = 'SALE'
}

/**
 * Encapsulates all properties related to a cart item.
 * Ex: description, quantity, amount
 * Average SLA response time - 170ms
 */
export type CartItem = {
  __typename?: 'CartItem';
  /** Cart item's description (Ex: 'Medium, Light Grey, V-Neck T-Shirt') */
  description?: Maybe<Scalars['String']>;
  /** Cart item's details.  Any extra metadata passed by the Merchant. */
  details?: Maybe<Scalars['JSON']>;
  /** Set of selected options for the item. (Ex: name: 'Size', select: 'Large') */
  itemOptionSelections?: Maybe<Array<Maybe<ItemOptionSelection>>>;
  /** Cart item's name (Ex: 'Wolf T-Shirt') */
  name?: Maybe<Scalars['String']>;
  /**
   * Cart item's number
   * @deprecated Instead of using the number, use item's SKU (stock keeping unit) number instead
   */
  number?: Maybe<Scalars['String']>;
  /** Cart item's quantity (Ex: 1) */
  quantity?: Maybe<Scalars['Float']>;
  /** Cart item's SKU number */
  sku?: Maybe<Scalars['String']>;
  /** Cart item's total amount. */
  total?: Maybe<Amount>;
  /** Cart item's unit price. */
  unitPrice?: Maybe<Amount>;
};

/**
 * Encapsulates all properties related to a shipping address
 * attached to a cart by merchant
 */
export type CartShippingAddress = {
  __typename?: 'CartShippingAddress';
  /** A shipping address city (Ex: 'San Jose') */
  city?: Maybe<Scalars['String']>;
  /** A shipping address two-letter country code (Ex: 'US') */
  country?: Maybe<CountryCodes>;
  /** Buyer's first name (Ex: 'John') */
  firstName?: Maybe<Scalars['String']>;
  /** Multiline string format of recipient's shipping address */
  formattedFullAddress?: Maybe<Scalars['String']>;
  /** Address is full address */
  isFullAddress?: Maybe<Scalars['Boolean']>;
  /** Flag for ship to store */
  isStoreAddress?: Maybe<Scalars['Boolean']>;
  /** Buyer's last name (Ex: 'Smith') */
  lastName?: Maybe<Scalars['String']>;
  /** A shipping address first line street address (Ex: '2211 North 1st St') */
  line1?: Maybe<Scalars['String']>;
  /** A shipping address second line street address (Ex: 'Apt 123') */
  line2?: Maybe<Scalars['String']>;
  /** A shipping address postal code (Ex: '95131') */
  postalCode?: Maybe<Scalars['String']>;
  /** A shipping address state/province (Ex: 'CA') */
  state?: Maybe<Scalars['String']>;
};

/**
 * Encapsulates all properties related to a shipping method.
 * attached to a cart by merchant
 */
export type CartShippingMethod = {
  __typename?: 'CartShippingMethod';
  /** Amount value for this method */
  amount?: Maybe<Amount>;
  /** Unique identifier for the option */
  id?: Maybe<Scalars['String']>;
  /** Custom display name (Ex: '2-Day Shipping') */
  label?: Maybe<Scalars['String']>;
  /** Whether or not the this method is selected */
  selected?: Maybe<Scalars['Boolean']>;
  /** Category, or type. ('SHIPPING' or 'PICKUP') */
  type?: Maybe<ShippingMethodType>;
};

/**
 * An enumeration of states that a Cart can be in.
 * CREATED, APPROVED, FAILED or SUBMITTED
 */
export enum CartState {
  /** A Cart was approved */
  Approved = 'APPROVED',
  /** A Cart was created */
  Created = 'CREATED',
  /** A Cart is failed */
  Failed = 'FAILED',
  /** The Payer authentication is required to continue checkout */
  PayerAuthenticationRequired = 'PAYER_AUTHENTICATION_REQUIRED',
  /** A Cart was submitted */
  Submitted = 'SUBMITTED'
}

/**
 * Encapsulates all properties related to a billing address which is extend from our
 * generic Address type
 *
 * Ex: line1, city, state, postalCode, fullAddress, etc.
 */
export type CheckoutBillingAddress = Address & {
  __typename?: 'CheckoutBillingAddress';
  /** A billing address ID (Ex: '285166') */
  addressId?: Maybe<Scalars['String']>;
  /** Portable address: An address first line street address */
  addressLine1?: Maybe<Scalars['String']>;
  /** Portable address: An address second line street address */
  addressLine2?: Maybe<Scalars['String']>;
  /** Portable address: An address third line street address */
  addressLine3?: Maybe<Scalars['String']>;
  /** Portable address: An address first line admin area */
  adminArea1?: Maybe<Scalars['String']>;
  /** Portable address: An address second line admin area */
  adminArea2?: Maybe<Scalars['String']>;
  /** Portable address: An address third line admin area */
  adminArea3?: Maybe<Scalars['String']>;
  /** Portable address: An address forth line admin area */
  adminArea4?: Maybe<Scalars['String']>;
  /**
   * A billing address city (Ex: 'San Jose')
   * @deprecated Coarse format addresses are being phased out for portable format addresses. Use adminArea2 instead for portable format.
   */
  city?: Maybe<Scalars['String']>;
  /**
   * A billing address two-letter country code (Ex: 'US')
   * @deprecated Coarse format addresses are being phased out for portable format addresses. Use countryCode instead for portable format.
   */
  country?: Maybe<Scalars['String']>;
  /** Portable address: An address two-letter country code */
  countryCode?: Maybe<Scalars['String']>;
  /**
   * A billing address on a single line
   * (Ex: '2211 North 1st St, Apt 123, San Jose, CA 95131')
   */
  fullAddress?: Maybe<Scalars['String']>;
  /** Indicates a billing address is selected or not. */
  isSelected?: Maybe<Scalars['Boolean']>;
  /**
   * A billing address first line street address (Ex: '2211 North 1st St')
   * @deprecated Coarse format addresses are being phased out for portable format addresses. Use addressLine1 instead for portable format.
   */
  line1?: Maybe<Scalars['String']>;
  /**
   * A billing address second line street address (Ex: 'Apt 123')
   * @deprecated Coarse format addresses are being phased out for portable format addresses. Use addressLine2 instead for portable format.
   */
  line2?: Maybe<Scalars['String']>;
  /** A billing address postal code (Ex: '95131') */
  postalCode?: Maybe<Scalars['String']>;
  /**
   * A billing address state/province (Ex: 'CA')
   * @deprecated Coarse format addresses are being phased out for portable format addresses. Use adminArea1 instead for portable format.
   */
  state?: Maybe<Scalars['String']>;
};

/** Countries which support localized strings from xo-content */
export enum CheckoutContentCountryCode {
  /** AUSTRIA */
  At = 'AT',
  /** AUSTRALIA */
  Au = 'AU',
  /** BELGIUM */
  Be = 'BE',
  /** BRAZIL */
  Br = 'BR',
  /** CHINA */
  C2 = 'C2',
  /** CANADA */
  Ca = 'CA',
  /** SWITZERLAND */
  Ch = 'CH',
  /** CZECH REPUBLIC */
  Cz = 'CZ',
  /** GERMANY */
  De = 'DE',
  /** DENMARK */
  Dk = 'DK',
  /** ESTONIA */
  Ee = 'EE',
  /** SPAIN */
  Es = 'ES',
  /** FINLAND */
  Fi = 'FI',
  /** FRANCE */
  Fr = 'FR',
  /** UNITED KINGDOM */
  Gb = 'GB',
  /** GREECE */
  Gr = 'GR',
  /** APAC */
  GroupApac = 'GROUP_APAC',
  /** EMEA */
  GroupEmea = 'GROUP_EMEA',
  /** LATAM */
  GroupLatam = 'GROUP_LATAM',
  /** HONG KONG */
  Hk = 'HK',
  /** HUNGARY */
  Hu = 'HU',
  /** INDONESIA */
  Id = 'ID',
  /** IRELAND */
  Ie = 'IE',
  /** ISRAEL */
  Il = 'IL',
  /** INDIA */
  In = 'IN',
  /** ITALY */
  It = 'IT',
  /** JAPAN */
  Jp = 'JP',
  /** REPUBLIC OF KOREA */
  Kr = 'KR',
  /** LITHUANIA */
  Lt = 'LT',
  /** LUXEMBOURG */
  Lu = 'LU',
  /** LATVIA */
  Lv = 'LV',
  /** MEXICO */
  Mx = 'MX',
  /** MALAYSIA */
  My = 'MY',
  /** NETHERLANDS */
  Nl = 'NL',
  /** NORWAY */
  No = 'NO',
  /** NEW ZEALAND */
  Nz = 'NZ',
  /** PHILIPPINES */
  Ph = 'PH',
  /** POLAND */
  Pl = 'PL',
  /** PORTUGAL */
  Pt = 'PT',
  /** ROMANIA */
  Ro = 'RO',
  /** RUSSIAN FEDERATION */
  Ru = 'RU',
  /** SWEDEN */
  Se = 'SE',
  /** SINGAPORE */
  Sg = 'SG',
  /** SLOVENIA */
  Si = 'SI',
  /** SLOVAKIA */
  Sk = 'SK',
  /** THAILAND */
  Th = 'TH',
  /** TURKEY */
  Tr = 'TR',
  /** TAIWAN */
  Tw = 'TW',
  /** UKRAINE */
  Ua = 'UA',
  /** UNITED STATES */
  Us = 'US',
  /** VIETNAM */
  Vn = 'VN'
}

/** Possible languages that xo-content may return */
export enum CheckoutContentLanguageCode {
  /** Arabic */
  Ar = 'ar',
  /** Belarusian */
  Be = 'be',
  /** Bulgarian */
  Bg = 'bg',
  /** Bengali */
  Bn = 'bn',
  /** Catalan */
  Ca = 'ca',
  /** Czech */
  Cs = 'cs',
  /** Welsh */
  Cy = 'cy',
  /** Danish */
  Da = 'da',
  /** German */
  De = 'de',
  /** Greek */
  El = 'el',
  /** English */
  En = 'en',
  /** Spanish */
  Es = 'es',
  /** Estonian */
  Et = 'et',
  /** Basque */
  Eu = 'eu',
  /** Finnish */
  Fi = 'fi',
  /** French */
  Fr = 'fr',
  /** Galician */
  Gl = 'gl',
  /** Hebrew */
  He = 'he',
  /** Hindi */
  Hi = 'hi',
  /** Croatian */
  Hr = 'hr',
  /** Hungarian */
  Hu = 'hu',
  /** Indonesian */
  Id = 'id',
  /** Icelandic */
  Is = 'is',
  /** Italian */
  It = 'it',
  /** Japanese */
  Ja = 'ja',
  /** Georgian */
  Ka = 'ka',
  /** Kazakh */
  Kk = 'kk',
  /** Khmer */
  Km = 'km',
  /** Korean */
  Ko = 'ko',
  /** Lithuanian */
  Lt = 'lt',
  /** Latvian */
  Lv = 'lv',
  /** Macedonian */
  Mk = 'mk',
  /** Mongolian */
  Mn = 'mn',
  /** Marathi */
  Mr = 'mr',
  /** Malay */
  Ms = 'ms',
  /** Dutch */
  Nl = 'nl',
  /** Norwegian */
  No = 'no',
  /** Punjabi */
  Pa = 'pa',
  /** Polish */
  Pl = 'pl',
  /** Portuguese */
  Pt = 'pt',
  /** Romanian */
  Ro = 'ro',
  /** Russian */
  Ru = 'ru',
  /** Sinhala */
  Si = 'si',
  /** Slovak */
  Sk = 'sk',
  /** Slovenian */
  Sl = 'sl',
  /** Albanian */
  Sq = 'sq',
  /** Swedish */
  Sv = 'sv',
  /** Swahili */
  Sw = 'sw',
  /** Tamil */
  Ta = 'ta',
  /** Telugu */
  Te = 'te',
  /** Thai */
  Th = 'th',
  /** Tagalog */
  Tl = 'tl',
  /** Turkish */
  Tr = 'tr',
  /** Ukrainian */
  Uk = 'uk',
  /** Urdu */
  Ur = 'ur',
  /** Vietnamese */
  Vi = 'vi',
  /** Chinese */
  Zh = 'zh'
}

/**
 * Encapsulates all properties related to a CheckoutCurrencyConversion.
 *
 * There are 2 types of the coversion rate: "PAYPAL" and "VENDOR"
 * Please note that conversion rate information is always for PAYPAL's type.
 * The only 2 fields that are associated with VENDOR type are "type" and "isReadOnly"
 */
export type CheckoutCurrencyConversion = {
  __typename?: 'CheckoutCurrencyConversion';
  /**
   * Whether or not a user can change the conversion type. If `false`, the conversion
   * type in the `type` field cannot be changed. If `true`, the user can switch between
   * the different types of `CheckoutCurrencyConversionType`.
   */
  canChangeConversionType?: Maybe<Scalars['Boolean']>;
  /**
   * The amount of cash back the user will receive in case of opting for selecting the PayPal's currency conversion rate.
   * User has to be enrolled in a cashback campaign in order to get cashback.
   */
  cashbackPercentage?: Maybe<Scalars['Int']>;
  /** The converted amount to be charged on the card.  */
  convertedAmount?: Maybe<Amount>;
  /**
   * The cart total with the currency conversion rate applied.
   * @deprecated convertedCartTotal is computed using cart totals, which is more inaccurate than using planning data about the user's mix of funding instruments. Use convertedAmount instead.
   */
  convertedCartTotal?: Maybe<Amount>;
  /** PayPal currency conversion fee rate in percentage. (e.g '5.00') */
  feeRate?: Maybe<Scalars['String']>;
  /** PayPal currency conversion fee rate in percentage formatted based on the locale. (e.g. '5,00 %') */
  feeRateFormatted?: Maybe<Scalars['String']>;
  /** What the currency is converted from. */
  from?: Maybe<Amount>;
  /**
   * Whether or not a user can change the conversion type. If `true`, the conversion
   * type in the `type` field cannot be changed. If `false`, the user can switch between
   * the different types of `CheckoutCurrencyConversionType`.
   * @deprecated Renamed to `canChangeConversionType` for more clarity around the purpose.
   */
  isReadOnly?: Maybe<Scalars['Boolean']>;
  /** Date of validity.  The date that the conversion rate was issued. */
  issuedDate?: Maybe<GenericDate>;
  /** The currency conversion rate. */
  rate?: Maybe<Scalars['String']>;
  /** The currency conversion rate formatted. (Ex: 0.019991 INR) */
  rateFormatted?: Maybe<Scalars['String']>;
  /** The currency conversion rate spread. */
  spread?: Maybe<Scalars['String']>;
  /** What the currency is converted to. */
  to?: Maybe<Amount>;
  /** Type of currency conversion rate. */
  type?: Maybe<CheckoutCurrencyConversionType>;
};

/** An enumeration of types that CheckoutCurrencyConversion can have.  PAYPAL, VENDOR */
export enum CheckoutCurrencyConversionType {
  /** PayPal conversion rate */
  Paypal = 'PAYPAL',
  /** Vendor conversion rate */
  Vendor = 'VENDOR'
}

/** Customization type for checkout */
export type CheckoutCustomization = {
  __typename?: 'CheckoutCustomization';
  /**
   * Animation Info
   * @deprecated Renamed to design because some of the designs are not animated.
   */
  buttonAnimation?: Maybe<ButtonAnimationCustomization>;
  /** Design Info */
  buttonDesign?: Maybe<ButtonDesignCustomization>;
  /** Button Text */
  buttonText?: Maybe<ElementCustomization>;
  /** Tagline */
  tagline?: Maybe<ElementCustomization>;
};

/** UI interaction types for checkout */
export enum CheckoutExperienceType {
  /** Full page UI type */
  FullPage = 'FULL_PAGE',
  /** In context UI type */
  InContext = 'IN_CONTEXT'
}

/** Enumeration to identify different flows of the checkout session */
export enum CheckoutFlow {
  /**
   * Configuration to set `client_configuration` for Link and Pay flow.
   * Setting this configuration will allow PAPS to fetch only the
   * FI which is attached to the billing agreement id
   */
  LinkAndPay = 'LINK_AND_PAY'
}

/** The number of possible installments, defined as "terms", for a given installment plan */
export enum CheckoutInstallmentOptionsTerm {
  /** Nine Months */
  Nine = 'NINE',
  /** One Month */
  One = 'ONE',
  /** Six Months */
  Six = 'SIX',
  /** Three Months */
  Three = 'THREE',
  /** Twelve Months */
  Twelve = 'TWELVE'
}

/**
 * Encapsulates all properties related to a locale.
 *
 * CheckoutLocale differs from GenericLocale,
 * because it takes into account Merchant preferences and
 * SetExpressCheckout API parameters.
 *
 * CheckoutLocale should be used for Checkout specific use cases.
 * GenericLocale should be used for all other use cases.
 * Ex: country, language, directionality, etc.
 */
export type CheckoutLocale = Locale & {
  __typename?: 'CheckoutLocale';
  /** A locale's country (Ex: 'US') */
  country?: Maybe<Scalars['String']>;
  /** A locale's culture (Ex: 'en-US') */
  culture?: Maybe<Scalars['String']>;
  /** A locale's directionality (Ex: 'ltr') */
  directionality?: Maybe<Directionality>;
  /** A locale's language (Ex: 'en') */
  language?: Maybe<Scalars['String']>;
  /** A locale's locale (Ex: 'en_US') */
  locale?: Maybe<Scalars['String']>;
};

/** Represents a string which can be localized */
export type CheckoutLocalizedString = {
  __typename?: 'CheckoutLocalizedString';
  /**
   * Returns a list of CheckoutLocalizedTuple types.  See CheckoutLocalizedTuple
   * Passing 'country' is optional, otherwise all are returned.
   */
  translations: Array<CheckoutLocalizedTuple>;
};


/** Represents a string which can be localized */
export type CheckoutLocalizedStringTranslationsArgs = {
  country?: InputMaybe<CheckoutContentCountryCode>;
};

/** Represents a translation, encapsulating both language translated to and the content */
export type CheckoutLocalizedTuple = {
  __typename?: 'CheckoutLocalizedTuple';
  /** Content (Ex: 'Visa Credit Card') */
  content: Scalars['String'];
  /** Language (Ex: 'en') */
  language: CheckoutContentLanguageCode;
};

/**
 * Encapsulates all properties related to Checkout Propensity Score.
 * Determines the usage propensity in a given session for different categories.
 */
export type CheckoutPropensityScore = {
  __typename?: 'CheckoutPropensityScore';
  /**  Field encapsulating scores for credit related stuff  */
  creditScore: CreditScores;
  /** Field encapsulating scores for FI related stuff */
  fiScore: FiScores;
};

/**
 * Encapsulates all properties related to a CheckoutSession.
 * Ex: Cart, Plans, FundingOptions, etc
 */
export type CheckoutSession = {
  __typename?: 'CheckoutSession';
  /**
   * The card issuers allowed to be used for a given CheckoutSession.
   * An array of CardIssuerType enums.
   *
   * Optionally pass a CountryCode if you want to be explicit, otherwise defaults
   * to node locale resolution that provides best guess based on user information, LANG cookie, etc
   *
   * Average SLA response time -- 250ms
   *
   * Required auth states: Any
   */
  allowedCardIssuers?: Maybe<Array<Maybe<CardIssuerType>>>;
  /**
   * A Checkout session's billing addresses.
   * An Array of CheckoutBillingAddress types.
   *
   * Average SLA response time -- 30ms
   *
   * Required auth states: LOGGEDIN, REMEMBERED, or IDENTIFIED
   */
  billingAddresses?: Maybe<Array<Maybe<CheckoutBillingAddress>>>;
  /** A Checkout session's current potential buyer */
  buyer?: Maybe<User>;
  /**
   * The card product classes will be used to find whether a card is DEBIT/CREDIT/etc.
   * An array of CardProductClass enums.
   *
   * Required auth states: Any
   */
  cardProductClasses: Array<Maybe<InstrumentClassification>>;
  /**
   * A Checkout session's cart.
   * Average SLA response time - 170ms
   *
   * Optionally pass a CountryCode, otherwise defaults to node locale resolution that provides
   * best guess based on user information, LANG cookie, etc (CountryCode is necessary to
   * retrieve the max over capture amount for the transaction).
   *
   * Required auth states: Any
   */
  cart?: Maybe<Cart>;
  /** Returns type of checkout session: BILLING_WITH_PURCHASE, BILLING_WITHOUT_PURCHASE, PURCHASE. */
  checkoutSessionType?: Maybe<CheckoutSessionType>;
  /** Returns all properties related to a completed payment */
  completedPaymentInfo?: Maybe<CompletedPaymentInfo>;
  /**
   * Integration details for portable credit applications.
   * Average SLA response time - ??ms
   *
   * Required auth states: LOGGEDIN, REMEMBERED, or IDENTIFIED
   */
  creditApplyPortableIntegration?: Maybe<CreditApplyPortable>;
  /**
   * A Checkout session's credit as FI marketing offers.
   * Average SLA response time - 50ms - (This might change)
   *
   * Required auth states: LOGGEDIN, REMEMBERED, or IDENTIFIED
   */
  creditAsFIOffers?: Maybe<Array<Maybe<CreditAsFiOffer>>>;
  /**
   * A Checkout session's selected credit financing option that was patched to the cart.
   *
   * Required auth states: LOGGEDIN, REMEMBERED, or IDENTIFIED
   */
  creditFinancingOption?: Maybe<CreditFinancingOption>;
  /** Credit metadata. For instance credit flags, settings and tools tips */
  creditMeta: CreditMeta;
  /**
   * A Checkout session's PPC credit marketing offers.
   * Average SLA response time - 50ms
   *
   * Required auth states: LOGGEDIN, REMEMBERED, or IDENTIFIED
   */
  creditPPCOffers?: Maybe<Array<Maybe<CreditPpcOffer>>>;
  /**
   * Quote of the live value of a given crypto funding instrument, valid for 30 seconds.
   * Values returned are based on the amount of crypto the user has for that holding, and the amount that the user is
   * using in the purchase.
   */
  cryptocurrencyQuotes?: Maybe<Array<Maybe<CryptocurrencyQuote>>>;
  /** Most recent declined instrument for the current checkout session. */
  declinedInstruments?: Maybe<Array<Maybe<DeclinedInstrument>>>;
  /** Disallowed funding instruments for the given checkout session. */
  disallowedInstruments?: Maybe<Array<Maybe<DisallowedInstrument>>>;
  /** Returns rewards-related offers pertinent to Checkout session. */
  estimatedRewards?: Maybe<EstimatedRewards>;
  /**
   * Existing Billing Agreement Details
   * Migrated from billingnodeserv for billing without purchase flow
   */
  existingBillingAgreementDetails?: Maybe<ExistingBillingAgreementDetails>;
  /**
   * A Checkout session's application data flags.
   * Average SLA response time - 40ms
   *
   * Required Roles: See CheckoutSessionFlags
   */
  flags?: Maybe<CheckoutSessionFlags>;
  /**
   * A Checkout session's funding options, which lists the options the buyer has to pay for the transaction.
   *
   * Average SLA response time - 1750ms
   *
   * Required auth states: LOGGEDIN, REMEMBERED, or IDENTIFIED
   */
  fundingOptions?: Maybe<Array<Maybe<FundingOption>>>;
  /**
   * Represents instrument types that are ineligible for this CheckoutSession.
   * Provides details such as card account types and brand-specific constraints.
   *
   * Average SLA response time -- 300ms.
   *
   * Required auth states: Any.
   */
  ineligibleInstrumentTypes?: Maybe<IneligibleInstrumentTypes>;
  /**
   * A Checkout session's locale.
   *
   * Required auth states: Any
   */
  locale?: Maybe<CheckoutLocale>;
  /** A Checkout session's associated merchant */
  merchant: Merchant;
  /**
   * Returns all credit offers available to users who are not PayPal members
   *
   * countryCode - The country code of the buyer (e.g. US)
   * languageCode - The language code of the buyer (e.g. en). If not provided it will be resolved via req.locality.
   */
  nonMemberCreditOffers?: Maybe<NonMemberCreditOffers>;
  /**
   * Optionally takes a list of offer program names (enums).
   * Returns a list of offers the user is eligible for,
   * non eligible offers will not be listed.
   */
  offers: Array<Maybe<Offer>>;
  /** Returns an array of payees. */
  payees?: Maybe<Array<Maybe<Payee>>>;
  /** A Checkout session's payment contingencies */
  paymentContingencies?: Maybe<PaymentContingencies>;
  /** Provides the user's current SCA status and exemption reason, if any */
  secureCustomerAuthenticationContext?: Maybe<SecureCustomerAuthenticationContext>;
  /**
   * A Checkout session's shipping addresses.
   * An Array of CheckoutShippingAddress types.
   * Average SLA response time - 1750ms
   *
   * Required auth states: LOGGEDIN, REMEMBERED, or IDENTIFIED
   */
  shippingAddresses?: Maybe<Array<Maybe<CheckoutShippingAddress>>>;
  /** Returns a list of eligible `SplitFundingOption`s */
  splitFundingOptions?: Maybe<Array<Maybe<SplitFundingOptions>>>;
  /**
   * Return state of checkout Session
   * Average SLA response time - 1750ms
   * Required auth states: Any
   */
  state?: Maybe<CheckoutSessionState>;
  /**
   * A checkout session's giving recommendation.
   * Average SLA response time - 50ms
   *
   * Required auth states: LOGGEDIN, REMEMBERED, or IDENTIFIED
   */
  suggestedDonation?: Maybe<SuggestedDonation>;
  /**
   * Returns an array of allowed card brands and corresponding supported bank issuers array returned by IDS.
   * Card brands and bank issuers may vary by user's country and merchant's country.
   * Separated from allowedCardIssuers - returned by PAPS and only returns supported card brands.
   *
   * IDS also returns funding sources' logo image urls
   */
  supportedFundingSources?: Maybe<Array<Maybe<SupportedFundingSource>>>;
  /** Indicates if it's a Continue or Pay Now checkout flow. */
  userAction: CheckoutUserAction;
};


/**
 * Encapsulates all properties related to a CheckoutSession.
 * Ex: Cart, Plans, FundingOptions, etc
 */
export type CheckoutSessionAllowedCardIssuersArgs = {
  country?: InputMaybe<CountryCodes>;
};


/**
 * Encapsulates all properties related to a CheckoutSession.
 * Ex: Cart, Plans, FundingOptions, etc
 */
export type CheckoutSessionCartArgs = {
  country?: InputMaybe<CountryCodes>;
};


/**
 * Encapsulates all properties related to a CheckoutSession.
 * Ex: Cart, Plans, FundingOptions, etc
 */
export type CheckoutSessionCreditApplyPortableIntegrationArgs = {
  downsellOfferId?: InputMaybe<Scalars['String']>;
  selectedCRCOffer?: InputMaybe<SelectedCrcOffer>;
  selectedCRCfi?: InputMaybe<SelectedCrCfi>;
  selectedContinueGPLInterstitial?: InputMaybe<Scalars['Boolean']>;
  selectedShippingAddressId?: InputMaybe<Scalars['String']>;
};


/**
 * Encapsulates all properties related to a CheckoutSession.
 * Ex: Cart, Plans, FundingOptions, etc
 */
export type CheckoutSessionCreditAsFiOffersArgs = {
  allowCache?: InputMaybe<Scalars['Boolean']>;
  areCookiesDisabled?: InputMaybe<Scalars['Boolean']>;
  isIframe?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Encapsulates all properties related to a CheckoutSession.
 * Ex: Cart, Plans, FundingOptions, etc
 */
export type CheckoutSessionCreditPpcOffersArgs = {
  allowCache?: InputMaybe<Scalars['Boolean']>;
  allowNonQualifyingOffers?: InputMaybe<Scalars['Boolean']>;
  areCookiesDisabled?: InputMaybe<Scalars['Boolean']>;
  isIframe?: InputMaybe<Scalars['Boolean']>;
  merchantAppVersion?: InputMaybe<Scalars['String']>;
};


/**
 * Encapsulates all properties related to a CheckoutSession.
 * Ex: Cart, Plans, FundingOptions, etc
 */
export type CheckoutSessionCryptocurrencyQuotesArgs = {
  amount: AmountInput;
  symbols: Array<InputMaybe<CryptocurrencySymbol>>;
};


/**
 * Encapsulates all properties related to a CheckoutSession.
 * Ex: Cart, Plans, FundingOptions, etc
 */
export type CheckoutSessionFundingOptionsArgs = {
  groupSourcesOnType?: InputMaybe<Array<InputMaybe<FundingOptionGroupingType>>>;
  returnAllPlans?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Encapsulates all properties related to a CheckoutSession.
 * Ex: Cart, Plans, FundingOptions, etc
 */
export type CheckoutSessionIneligibleInstrumentTypesArgs = {
  country?: InputMaybe<CountryCodes>;
};


/**
 * Encapsulates all properties related to a CheckoutSession.
 * Ex: Cart, Plans, FundingOptions, etc
 */
export type CheckoutSessionNonMemberCreditOffersArgs = {
  countryCode: CountryCodes;
  languageCode?: InputMaybe<CheckoutContentLanguageCode>;
};


/**
 * Encapsulates all properties related to a CheckoutSession.
 * Ex: Cart, Plans, FundingOptions, etc
 */
export type CheckoutSessionOffersArgs = {
  type?: InputMaybe<Array<OfferPrograms>>;
};


/**
 * Encapsulates all properties related to a CheckoutSession.
 * Ex: Cart, Plans, FundingOptions, etc
 */
export type CheckoutSessionSupportedFundingSourcesArgs = {
  userCountry?: InputMaybe<CountryCodes>;
};

/**
 * Encapsulates all flags related to a Checkout session.
 * Ex: isBillingAgreement, isVZeroIntegration, etc.
 */
export type CheckoutSessionFlags = {
  __typename?: 'CheckoutSessionFlags';
  /**
   * Indicates whether user can add a card without a billing address for the given country
   *
   * Required auth states: LOGGEDIN, REMEMBERED or IDENTIFIED
   */
  allowAddresslessAddCard?: Maybe<Scalars['Boolean']>;
  /** Indicates if it is allowed to create billing agreement without backup funding source or not */
  allowBillingAgreementWithoutBackupFundingSource?: Maybe<Scalars['Boolean']>;
  /** Indicates whether the user is allowed to change payment methods */
  allowChangePaymentMethod?: Maybe<Scalars['Boolean']>;
  /** Indicates whether non-domestic cards are blocked for the transaction. */
  blockNonDomesticCards?: Maybe<Scalars['Boolean']>;
  /** Indicates whether non-domestic transactions are blocked */
  blockNonDomesticPayer?: Maybe<Scalars['Boolean']>;
  /** Indicates whether international shipping is blocked or not */
  blockNonDomesticShipping?: Maybe<Scalars['Boolean']>;
  /** Flag indicating that the buyer has given the consent for promotional emails. */
  hasBuyerConsentedToPromotionalEmail?: Maybe<Scalars['Boolean']>;
  /**
   * Indicates when a transaction supports PayPal Credit payment installations, based on buyer and merchant eligibility.
   *
   * Required auth states: LOGGEDIN, REMEMBERED or IDENTIFIED
   */
  hasPPCreditInstallments?: Maybe<Scalars['Boolean']>;
  /** Indicates when the user has entered Checkout through a "Pay Later" button */
  hasPayLaterIntent?: Maybe<Scalars['Boolean']>;
  /** Indicates the entire cart (amount and details) should be hidden. */
  hideCart?: Maybe<Scalars['Boolean']>;
  /** Indicates the cart details should be hidden. */
  hideCartDetails?: Maybe<Scalars['Boolean']>;
  /** Indicates whether the merchant has passed the hide_cart_details flag. */
  hideCartDetailsFlag?: Maybe<Scalars['Boolean']>;
  /**
   * Predicts when the shipping address should be hidden.
   * Note: this is an optimistic flag and _usually_ means that
   * the checkout session will **not** have a selected address.
   *
   * Required auth states: Any
   */
  hideShipping?: Maybe<Scalars['Boolean']>;
  /**
   * A contingency for if the 3D Secure (3DS) flow is required.
   * If required, it must be resolved before approving the payment.
   * Average SLA response time - 1750ms
   *
   * Required auth states: LOGGEDIN, REMEMBERED or IDENTIFIED
   */
  is3DSecureRequired?: Maybe<Scalars['Boolean']>;
  /**
   * Flag indicating whether PayPal Balance is disallowed as FI or not.
   *
   * Required auth states: LOGGEDIN, REMEMBERED or IDENTIFIED
   */
  isBalanceDisallowed?: Maybe<Scalars['Boolean']>;
  /** Flag indicating whether the billing address of the Payer can be shared or not. */
  isBillingAddressConsentRequired?: Maybe<Scalars['Boolean']>;
  /**
   * Whether or not a checkout session is a Billing Agreement.  A Boolean.
   *
   * Required auth states: Any
   */
  isBillingAgreement?: Maybe<Scalars['Boolean']>;
  /**
   * Whether or not changing a shipping address in a Checkout session is allowed.  A Boolean.
   *
   * Required auth states: Any
   */
  isChangeShippingAddressAllowed?: Maybe<Scalars['Boolean']>;
  /** Contextual consent eligibility for PayPal on File Experiment */
  isContextualConsentEligibilityMet?: Maybe<Scalars['Boolean']>;
  /** Indicates when the user has entered Checkout through a "PayPal Credit" button */
  isCreditSecondButton?: Maybe<Scalars['Boolean']>;
  /**
   * Indicates when a checkout session requires a patch CVV call.
   *
   * Required auth states: Any
   */
  isCvvConfirmationRequired?: Maybe<Scalars['Boolean']>;
  /**
   * Whether or not a debit card is required to make a pyment.
   *
   * Required auth states: Any
   */
  isDebitRequired?: Maybe<Scalars['Boolean']>;
  /**
   * Whether or not a checkout session is a Digital Goods integration. A Boolean.
   *
   * Required auth states: Any
   */
  isDigitalGoodsIntegration?: Maybe<Scalars['Boolean']>;
  /**
   * Whether or not the current transaction is a donation.
   *
   * Required auth states: Any
   */
  isDonation?: Maybe<Scalars['Boolean']>;
  /**
   * Indicates when a credit offer should be shown to the user for second button
   *
   * Required auth states: LOGGEDIN, REMEMBERED or IDENTIFIED
   */
  isEligibleForCreditSecondButton?: Maybe<Scalars['Boolean']>;
  /**
   * Indicates if FRS(Free Return Shipping) is applicable for the Merchant.
   * @deprecated Org wide effort to remove FRS due to high costs and low usage
   */
  isFrsApplicable?: Maybe<Scalars['Boolean']>;
  /**
   * Whether or not a payment is eligible to be paid by a Guest.  A Boolean.
   *
   * Required auth states: Any
   */
  isGuestEligible?: Maybe<Scalars['Boolean']>;
  /**
   * Whether or not a guest is eligible for upgrade to member.  A Boolean.
   * @deprecated created a new query isGuestUpgradeableToMember
   */
  isGuestEligibleForUpgrade?: Maybe<Scalars['Boolean']>;
  /**
   * Whether or not a payment is eligible for inlined fields by a Guest.  A Boolean.
   *
   * Required auth states: Any
   */
  isHostedFieldsAllowed: Scalars['Boolean'];
  /**
   * A flag to check if the checkoutSession contains INCENTIVE.
   * Average SLA response time - 1750ms
   *
   * Required auth states: LOGGEDIN, REMEMBERED or IDENTIFIED
   */
  isIncentivePresent?: Maybe<Scalars['Boolean']>;
  /**
   * Whether or not a payment is eligible for installments.  A Boolean.
   *
   * Required auth states: Any
   */
  isInstallmentsEligible?: Maybe<Scalars['Boolean']>;
  /** Indicates whether or not the flow is an invoicing flow. */
  isInvoiceFlow?: Maybe<Scalars['Boolean']>;
  /** Indicates if it is legacy billing integration or not */
  isLegacyBillingIntegration?: Maybe<Scalars['Boolean']>;
  /** Indicates whether the txn is a multi seller purchase. */
  isMultiSellerPurchase?: Maybe<Scalars['Boolean']>;
  /**
   * Whether or not sharing address with merchant is optional. A Boolean.
   * For a donation transaction, we should not share user's address unless we
   * get user's consent to do so.
   *
   * Required auth states: Any
   */
  isOptionallyShareAddress?: Maybe<Scalars['Boolean']>;
  /** Whether or not a funding instrument is PAD preferred by the user when PAD is enabled. A Boolean. */
  isPadPreferred?: Maybe<Scalars['Boolean']>;
  /** Indicates whether shipping address is required */
  isShippingAddressRequired?: Maybe<Scalars['Boolean']>;
  /**
   * Whether or not a payment is eligible to be paid by a Guest that signs up.  A Boolean.
   *
   * Required auth states: Any
   */
  isSignupEligible?: Maybe<Scalars['Boolean']>;
  /** Whether or not a guest is eligible for signup incentives. A Boolean */
  isSignupIncentiveEligible?: Maybe<Scalars['Boolean']>;
  /** Whether or not a guest is eligible for stretch rewards signup incentives. A Boolean */
  isSignupIncentiveEligibleStretchRewards?: Maybe<Scalars['Boolean']>;
  /** Whether or not Shipping and Taxes are supported in the checkout flow. A Boolean. */
  isSntSupported?: Maybe<Scalars['Boolean']>;
  /**
   * Whether or not a checkout session is a V.Zero (Braintree) integration. A Boolean.
   *
   * Required auth states: any
   */
  isVZeroIntegration?: Maybe<Scalars['Boolean']>;
  /** Indicates whether or not the flow is a WPS (Website Payments Standard) flow. */
  isWPS?: Maybe<Scalars['Boolean']>;
  /** Indicates whether or not the flow is a WPS (Website Payments Standard) autobilling flow. */
  isWpsAutobilling?: Maybe<Scalars['Boolean']>;
  /** Indicates whether or not the flow is a WPS (Website Payments Standard) installment plan flow. */
  isWpsInstallmentPlan?: Maybe<Scalars['Boolean']>;
  /** Indicates whether or not the flow is a WPS (Website Payments Standard) subscription flow. */
  isWpsSubscription?: Maybe<Scalars['Boolean']>;
  /** Indicates billing payment experience, ex: 'HERMES' */
  paymentExperience?: Maybe<BillingPaymentExperience>;
  /** Flag indicating if processor has previously declined for this token */
  processorDeclined?: Maybe<Scalars['Boolean']>;
  /** Indicates if set Sticky FI is allowed for the merchant */
  setStickyBillingAllowed?: Maybe<Scalars['Boolean']>;
  /**
   * Indicates when a PayPal Credit offer should be presented, based on session eligibility and whether user already has a PayPal Credit instrument.
   * Note that this only applies to PayPal Credit acquisition offers, not to GPL offers.
   *
   * Required auth states: LOGGEDIN, REMEMBERED or IDENTIFIED
   */
  showPPCreditOffer?: Maybe<Scalars['Boolean']>;
  /** Indicates whether or not the flow requires to disclose RTR text. */
  showRemittanceDisclosure?: Maybe<Scalars['Boolean']>;
};


/**
 * Encapsulates all flags related to a Checkout session.
 * Ex: isBillingAgreement, isVZeroIntegration, etc.
 */
export type CheckoutSessionFlagsAllowAddresslessAddCardArgs = {
  country?: InputMaybe<CountryCodes>;
};


/**
 * Encapsulates all flags related to a Checkout session.
 * Ex: isBillingAgreement, isVZeroIntegration, etc.
 */
export type CheckoutSessionFlagsIsGuestEligibleArgs = {
  fundingSource?: InputMaybe<ButtonFundingSourceType>;
};


/**
 * Encapsulates all flags related to a Checkout session.
 * Ex: isBillingAgreement, isVZeroIntegration, etc.
 */
export type CheckoutSessionFlagsIsGuestEligibleForUpgradeArgs = {
  fundingSource?: InputMaybe<ButtonFundingSourceType>;
};


/**
 * Encapsulates all flags related to a Checkout session.
 * Ex: isBillingAgreement, isVZeroIntegration, etc.
 */
export type CheckoutSessionFlagsIsSignupEligibleArgs = {
  fundingSource?: InputMaybe<ButtonFundingSourceType>;
};

/** An enumeration of State of Checkout Session. NOT_PAYABLE, PAYABLE, PAID */
export enum CheckoutSessionState {
  /** APPROVED. Session is Approved & DoEC can be called */
  Approved = 'APPROVED',
  /** NON_PAYABLE. Session Not Authorised & has contingencies or error for approving the call */
  NonPayable = 'NON_PAYABLE',
  /** PAID. Money Movemement has happened */
  Paid = 'PAID',
  /** PAYABLE. Session is eligible for ApprovePayment Call */
  Payable = 'PAYABLE',
  /** PAYMENT_ALREADY_DONE. Transaction completed and Money Movement has done */
  PaymentAlreadyDone = 'PAYMENT_ALREADY_DONE'
}

/** Enumeration to identify different checkout sessions such as Billing with purchase, or just purchase with no billing type */
export enum CheckoutSessionType {
  /** BILLING_WITHOUT_PURCHASE. A user is creating/updating a billing agreement without doing a purchase. It could be NextGen(V1) subscriptions as well. */
  BillingWithoutPurchase = 'BILLING_WITHOUT_PURCHASE',
  /** BILLING_WITH_PURCHASE. Session Type where a Billing Agreement is created with purchase. */
  BillingWithPurchase = 'BILLING_WITH_PURCHASE',
  /** PURCHASE. Default checkout session type */
  Purchase = 'PURCHASE'
}

/**
 * Encapsulates all properties related to a generic address.
 * Ex: line1, city, state, postalCode, fullAddress, etc.
 */
export type CheckoutShippingAddress = Address & {
  __typename?: 'CheckoutShippingAddress';
  /** An Address ID (Ex: '285166') */
  addressId?: Maybe<Scalars['String']>;
  /** Portable address: An address first line street address (Ex: '2211 North 1st St') */
  addressLine1?: Maybe<Scalars['String']>;
  /** Portable address: An address second line street address (Ex: 'Apt 123') */
  addressLine2?: Maybe<Scalars['String']>;
  /** Portable address: An address third line street address */
  addressLine3?: Maybe<Scalars['String']>;
  /** Portable address: An address first line admin area - state/province (Ex: 'CA')  */
  adminArea1?: Maybe<Scalars['String']>;
  /** Portable address: An address second line admin area - city (Ex: 'San Jose') */
  adminArea2?: Maybe<Scalars['String']>;
  /** Portable address: An address third line admin area */
  adminArea3?: Maybe<Scalars['String']>;
  /** Portable address: An address forth line admin area */
  adminArea4?: Maybe<Scalars['String']>;
  /**
   * An Address city (Ex: 'San Jose')
   * @deprecated Coarse format addresses are being phased out for portable format addresses. Use adminArea2 instead for portable format.
   */
  city?: Maybe<Scalars['String']>;
  /**
   * An Address two-letter country code (Ex: 'US')
   * @deprecated Coarse format addresses are being phased out for portable format addresses. Use countryCode instead for portable format.
   */
  country?: Maybe<Scalars['String']>;
  /** Portable address: An address two-letter country code */
  countryCode?: Maybe<Scalars['String']>;
  /**
   * An Address on a single line
   * (Ex: '2211 North 1st St, Apt 123, San Jose, CA 95131')
   */
  fullAddress?: Maybe<Scalars['String']>;
  /**
   * A full name associated with an Address, as a String (Ex: 'John Doe')
   * @deprecated CheckoutShippingAddress.fullName has been deprecated bceause 'name' is a better alternative being a PersonName type, rather than a String.  Use 'name' instead.
   */
  fullName?: Maybe<Scalars['String']>;
  /** If an Address is the default shipping address */
  isDefault?: Maybe<Scalars['Boolean']>;
  /**
   * If an Address is the default shipping address
   * @deprecated CheckoutShippingAddress.isDefaultShipping has been deprecated because 'Shipping' is redundant when part of the CheckoutShippingAddress type.  Use 'isDefault' instead.
   */
  isDefaultShipping?: Maybe<Scalars['Boolean']>;
  /** If an Address is disabled for transaction */
  isDisabled?: Maybe<Scalars['Boolean']>;
  /** If an Address is the primary address */
  isPrimary?: Maybe<Scalars['Boolean']>;
  /**
   * An Address is selected. If you are listing out addresses in a UI, and
   * need to show that an address is selected, use this property.
   */
  isSelected?: Maybe<Scalars['Boolean']>;
  /**
   * An Address first line street address (Ex: '2211 North 1st St')
   * @deprecated Coarse format addresses are being phased out for portable format addresses. Use addressLine1 instead for portable format.
   */
  line1?: Maybe<Scalars['String']>;
  /**
   * An Address second line street address (Ex: 'Apt 123')
   * @deprecated Coarse format addresses are being phased out for portable format addresses. Use addressLine2 instead for portable format.
   */
  line2?: Maybe<Scalars['String']>;
  /** A name associated with the address */
  name?: Maybe<PersonName>;
  /**
   * Normalization status of the address, enum ["UNKNOWN", "NORMALIZED", "NORMALIZATION_REJECTED", "UNNORMALIZED_USER_PREFERRED"]
   * Ideally, we should have declared an enum for normalizationStatus. However, changing that now can break client apps.
   * UNNORMALIZED_USER_PREFERRED is a PAPS equivalent to NORMALIZATION_REJECTED which is used by User Domain.
   */
  normalizationStatus?: Maybe<Scalars['String']>;
  /** An Address postal code (Ex: '95131') */
  postalCode?: Maybe<Scalars['String']>;
  /**
   * An Address state/province (Ex: 'CA')
   * @deprecated Coarse format addresses are being phased out for portable format addresses. Use adminArea1 instead for portable format.
   */
  state?: Maybe<Scalars['String']>;
  /** The suggested reformatted address */
  suggestedAddress?: Maybe<ValidatedAddress>;
  /** The type of Address (Ex: 'BILLING') */
  type?: Maybe<AddressType>;
};

/** Types of checkout integration */
export enum CheckoutSolutionType {
  /** Buyer must have a PayPal account to check out. */
  Mark = 'MARK',
  /** See https://developer.paypal.com/docs/classic/express-checkout/ec-shortcut/ */
  Shortcut = 'SHORTCUT',
  /** Buyer can check out without creating a PayPal account. This is referred to as PayPal Account Optional. */
  Sole = 'SOLE'
}

/** An enumeration of User Action in Checkout Session. CONTINUE, PAY_NOW */
export enum CheckoutUserAction {
  /**
   * Continue button appears when the final amount is not known
   * and buyer needs to get redirected to the merchant page without processing the payment."
   */
  Continue = 'CONTINUE',
  /**
   * Pay Now button appears when the final amount is known
   * and merchant wants to process the payment immediately when the buyer clicks Pay Now."
   */
  PayNow = 'PAY_NOW'
}

/** CCO Input */
export type ClientConfigInput = {
  /** ButtonSessionID */
  buttonSessionID?: InputMaybe<Scalars['String']>;
  /** Buyer pay intent type */
  buyerIntent?: InputMaybe<BuyerIntentType>;
  /** Channel (Ex: Web, app) If not provided, will attempt to be detected based on request info. */
  channel?: InputMaybe<ProductChannel>;
  /** Type of client config button funding source */
  fundingSource?: InputMaybe<ButtonFundingSourceType>;
  /** Merchant integration (Ex: sdk, v3, v4..) */
  integrationArtifact?: InputMaybe<IntegrationArtifactType>;
  /** Type of client config product code */
  productCode?: InputMaybe<ProductCodeType>;
  /** The payment product features a payment for donations */
  productFeature?: InputMaybe<ProductFeatureType>;
  /** Flow type (Ex: buyer BA, suscription, hermes, SPB, Donation */
  productFlow?: InputMaybe<ProductFlowType>;
  /** How the flow was initiated (Ex: Honey, redirect, inline iframe..) */
  userExperienceFlow?: InputMaybe<UserExperienceFlowType>;
};

/** CollectedConsent input represents the user agreement consent collected during signup. */
export type CollectedConsent = {
  /** collected consent name, ex: PRIVACY_STATEMENT_AGREEMENT */
  consentName?: InputMaybe<CollectedConsentName>;
  /** collected consent type, ex: FULL_CONSENT */
  consentType?: InputMaybe<CollectedConsentType>;
};

/** An enumeration of collected user consent name for signup. */
export enum CollectedConsentName {
  /** Privacy statement agreement consent */
  PrivacyStatementAgreement = 'PRIVACY_STATEMENT_AGREEMENT',
  /** privacy statement third party data sharing agreement consent */
  PrivacyStatementThirdPartyDataSharingAgreement = 'PRIVACY_STATEMENT_THIRD_PARTY_DATA_SHARING_AGREEMENT',
  /** privacy statement unique identification information processing agreement consent */
  PrivacyStatementUniqueIdentificationInformationProcessingAgreement = 'PRIVACY_STATEMENT_UNIQUE_IDENTIFICATION_INFORMATION_PROCESSING_AGREEMENT'
}

/** An enumeration of collected user consent type for signup. FULL_CONSENT, DENY_CONSENT */
export enum CollectedConsentType {
  /** Customer/Entity has denied or has declined to the consent/Legal Agreement. */
  DenyConsent = 'DENY_CONSENT',
  /** Customer/Entity has agreed or has provided the acceptance to the consent/Legal Agreement. */
  FullConsent = 'FULL_CONSENT'
}

/**
 * Encapsulates all properties related to the Common Reporting Standards mandate.
 * This new mandate requires PayPal to gather tax information from the user so PayPal can
 * report that to the goverment.
 */
export type CommonReportingStandardsInput = {
  /** Buyer's first name (Ex: 'John') */
  firstName: Scalars['String'];
  /** Buyer's last name (Ex: 'Smith') */
  lastName: Scalars['String'];
  /** Whether or not the user pays taxes in a different country */
  subjectToTaxOutsideLegalCountry: Scalars['Boolean'];
  /** Encapsulates all additional information the user needs to present when paying taxes in another country */
  taxDetails?: InputMaybe<Array<InputMaybe<TaxDetailsInput>>>;
};

/** Complete card otp confirmation input for otp verification for a new card. */
export type CompleteCardOtpConfirmationInput = {
  /** Expiration date of a card (Ex: '02/2021') */
  expirationDate?: InputMaybe<Scalars['String']>;
  /** one time password code entered by the user (Ex: 1234) */
  otpCode: Scalars['String'];
  /** 3 or 4 digits security code of a card (Ex: '123') */
  securityCode?: InputMaybe<Scalars['String']>;
};

/** Encapsulates the status of complete otp confirmation response. */
export type CompleteOtpConfirmationResponse = {
  __typename?: 'CompleteOtpConfirmationResponse';
  /** Overall status of complete otp call */
  status?: Maybe<Scalars['String']>;
};

/** Encapsulates all properties related to a completed payment. */
export type CompletedPaymentInfo = {
  __typename?: 'CompletedPaymentInfo';
  /** Postback data about payment that merchant's can leverage */
  postbackData?: Maybe<Scalars['JSON']>;
  /** The receipt ID (Ex: '8L1648555R462703G').  */
  receiptId?: Maybe<Scalars['String']>;
  /** Soft descriptor about the merchant, appears on bank statements (Ex: 'PP*SPECIALDAYW'). */
  softDescriptor?: Maybe<Scalars['String']>;
  /** The transaction's ID (Ex: '57E19243DN3823220'). */
  transactionId?: Maybe<Scalars['String']>;
  /** The transaction's state (Ex: 'COMPLETED' or 'PENDING'). */
  transactionState?: Maybe<TransactionState>;
};

/** Encapsulates the cvv data that will be returned when a confirm credit card cvv payment contingency is surfaced by PAPS */
export type ConfirmCreditCardCvvContingency = {
  __typename?: 'ConfirmCreditCardCvvContingency';
  /** The encrypted id of the user's credit card */
  encryptedId: Scalars['String'];
  /** The last 4 digits of the user's credit card number */
  lastFourDigits: Scalars['String'];
  /** The user's card issuer */
  type: CardIssuerType;
};

/** Represents the desired data for confirming a credit card's cvv */
export type ConfirmCreditCardCvvInput = {
  /** The credit card's cvv number as a String (Ex: '123') */
  cvv: Scalars['String'];
  /** An ecrypted credit card is as a String (Ex: 'CCA2NP3NVAPABBQ') */
  encryptedId: Scalars['String'];
  /** The last four digits of the user's credit card number as a String (Ex: '7062') */
  lastFourDigits: Scalars['String'];
  /** The card issuer as a CardIssuerType(Ex: 'VISA') */
  type: CardIssuerType;
};

/**
 * Encapsulates all properties related to constraint on fi.
 * EX(Constarint for AUTH)
 */
export type Constraint = {
  __typename?: 'Constraint';
  /** amount of constraint */
  amount?: Maybe<Amount>;
  /** type for constraint.(EX: 'AUTH') */
  type?: Maybe<ConstraintType>;
};

/** An enumeration of types that an ConstraintType can be. AUTH, etc */
export enum ConstraintType {
  /** the constraint type is smart auth */
  Auth = 'AUTH'
}

/** Encapsulates the flow id returned by consumer flow library */
export type ConsumerFlowId = {
  __typename?: 'ConsumerFlowId';
  /** The flow id */
  flowId: Scalars['String'];
};

/**
 * Encapsulates all properties related to IC2B consumer fee in installments.
 * Ex: currencySymbol, currencyValue, currencyCode, etc.
 */
export type ConsumerInstallmentFee = {
  __typename?: 'ConsumerInstallmentFee';
  /** Amount of discount */
  amount?: Maybe<Amount>;
  /** Amount of discount's percentage (Ex: '5.0') */
  percentage?: Maybe<Scalars['String']>;
};

/** Encapsulates all properties related to the cookie banner for client rendering */
export type CookieBanner = {
  __typename?: 'CookieBanner';
  /** A string of the CSS styles tag */
  css: Scalars['String'];
  /** A string of the HTML markup */
  html: Scalars['String'];
  /** A string of JavaScript script tag */
  js: Scalars['String'];
};

/** An enumeration of Country Codes by ISO-3166-1 ALPHA-2 standards */
export enum CountryCodes {
  /** Andorra */
  Ad = 'AD',
  /** United Arab Emirates */
  Ae = 'AE',
  /** Afghanistan */
  Af = 'AF',
  /** Antigua and Barbuda */
  Ag = 'AG',
  /** Anguilla */
  Ai = 'AI',
  /** Albania */
  Al = 'AL',
  /** Armenia */
  Am = 'AM',
  /** Netherlands Antilles */
  An = 'AN',
  /** Angola */
  Ao = 'AO',
  /** Antarctica */
  Aq = 'AQ',
  /** Argentina */
  Ar = 'AR',
  /** American Samoa */
  As = 'AS',
  /** Austria */
  At = 'AT',
  /** Australia */
  Au = 'AU',
  /** Aruba */
  Aw = 'AW',
  /** Aland Islands */
  Ax = 'AX',
  /** Azerbaijan */
  Az = 'AZ',
  /** Bosnia and Herzegovina */
  Ba = 'BA',
  /** Barbados */
  Bb = 'BB',
  /** Bangladesh */
  Bd = 'BD',
  /** Belgium */
  Be = 'BE',
  /** Burkina Faso */
  Bf = 'BF',
  /** Bulgaria */
  Bg = 'BG',
  /** Bahrain */
  Bh = 'BH',
  /** Burundi */
  Bi = 'BI',
  /** Benin */
  Bj = 'BJ',
  /** Saint Barthelemy */
  Bl = 'BL',
  /** Bermuda */
  Bm = 'BM',
  /** Brunei */
  Bn = 'BN',
  /** Bolivia */
  Bo = 'BO',
  /** Bonaire, Saint Eustatius and Saba */
  Bq = 'BQ',
  /** Brazil */
  Br = 'BR',
  /** Bahamas */
  Bs = 'BS',
  /** Bhutan */
  Bt = 'BT',
  /** Bouvet Island */
  Bv = 'BV',
  /** Botswana */
  Bw = 'BW',
  /** Belarus */
  By = 'BY',
  /** Belize */
  Bz = 'BZ',
  /** China */
  C2 = 'C2',
  /** Canada */
  Ca = 'CA',
  /** Cocos Islands */
  Cc = 'CC',
  /** Democratic Republic of the Congo */
  Cd = 'CD',
  /** Central African Republic */
  Cf = 'CF',
  /** Republic of the Congo */
  Cg = 'CG',
  /** Switzerland */
  Ch = 'CH',
  /** Ivory Coast */
  Ci = 'CI',
  /** Cook Islands */
  Ck = 'CK',
  /** Chile */
  Cl = 'CL',
  /** Cameroon */
  Cm = 'CM',
  /** China */
  Cn = 'CN',
  /** Colombia */
  Co = 'CO',
  /** Costa Rica */
  Cr = 'CR',
  /** Serbia and Montenegro */
  Cs = 'CS',
  /** Cuba */
  Cu = 'CU',
  /** Cape Verde */
  Cv = 'CV',
  /** Curacao */
  Cw = 'CW',
  /** Christmas Island */
  Cx = 'CX',
  /** Cyprus */
  Cy = 'CY',
  /** Czech Republic */
  Cz = 'CZ',
  /** Germany */
  De = 'DE',
  /** Djibouti */
  Dj = 'DJ',
  /** Denmark */
  Dk = 'DK',
  /** Dominica */
  Dm = 'DM',
  /** Dominican Republic */
  Do = 'DO',
  /** Algeria */
  Dz = 'DZ',
  /** Ecuador */
  Ec = 'EC',
  /** Estonia */
  Ee = 'EE',
  /** Egypt */
  Eg = 'EG',
  /** Western Sahara */
  Eh = 'EH',
  /** Eritrea */
  Er = 'ER',
  /** Spain */
  Es = 'ES',
  /** Ethiopia */
  Et = 'ET',
  /** Finland */
  Fi = 'FI',
  /** Fiji */
  Fj = 'FJ',
  /** Falkland Islands */
  Fk = 'FK',
  /** Micronesia */
  Fm = 'FM',
  /** Faroe Islands */
  Fo = 'FO',
  /** France */
  Fr = 'FR',
  /** Gabon */
  Ga = 'GA',
  /** United Kingdom */
  Gb = 'GB',
  /** Grenada */
  Gd = 'GD',
  /** Georgia */
  Ge = 'GE',
  /** French Guiana */
  Gf = 'GF',
  /** Guernsey */
  Gg = 'GG',
  /** Ghana */
  Gh = 'GH',
  /** Gibraltar */
  Gi = 'GI',
  /** Greenland */
  Gl = 'GL',
  /** Gambia */
  Gm = 'GM',
  /** Guinea */
  Gn = 'GN',
  /** Guadeloupe */
  Gp = 'GP',
  /** Equatorial Guinea */
  Gq = 'GQ',
  /** Greece */
  Gr = 'GR',
  /** South Georgia and the South Sandwich Islands */
  Gs = 'GS',
  /** Guatemala */
  Gt = 'GT',
  /** Guam */
  Gu = 'GU',
  /** Guinea-Bissau */
  Gw = 'GW',
  /** Guyana */
  Gy = 'GY',
  /** Hong Kong */
  Hk = 'HK',
  /** Heard Island and McDonald Islands */
  Hm = 'HM',
  /** Honduras */
  Hn = 'HN',
  /** Croatia */
  Hr = 'HR',
  /** Haiti */
  Ht = 'HT',
  /** Hungary */
  Hu = 'HU',
  /** Indonesia */
  Id = 'ID',
  /** Ireland */
  Ie = 'IE',
  /** Israel */
  Il = 'IL',
  /** Isle of Man */
  Im = 'IM',
  /** India */
  In = 'IN',
  /** British Indian Ocean Territory */
  Io = 'IO',
  /** Iraq */
  Iq = 'IQ',
  /** Iran */
  Ir = 'IR',
  /** Iceland */
  Is = 'IS',
  /** Italy */
  It = 'IT',
  /** Jersey */
  Je = 'JE',
  /** Jamaica */
  Jm = 'JM',
  /** Jordan */
  Jo = 'JO',
  /** Japan */
  Jp = 'JP',
  /** Kenya */
  Ke = 'KE',
  /** Kyrgyzstan */
  Kg = 'KG',
  /** Cambodia */
  Kh = 'KH',
  /** Kiribati */
  Ki = 'KI',
  /** Comoros */
  Km = 'KM',
  /** Saint Kitts and Nevis */
  Kn = 'KN',
  /** North Korea */
  Kp = 'KP',
  /** South Korea */
  Kr = 'KR',
  /** Kuwait */
  Kw = 'KW',
  /** Cayman Islands */
  Ky = 'KY',
  /** Kazakhstan */
  Kz = 'KZ',
  /** Laos */
  La = 'LA',
  /** Lebanon */
  Lb = 'LB',
  /** Saint Lucia */
  Lc = 'LC',
  /** Liechtenstein */
  Li = 'LI',
  /** Sri Lanka */
  Lk = 'LK',
  /** Liberia */
  Lr = 'LR',
  /** Lesotho */
  Ls = 'LS',
  /** Lithuania */
  Lt = 'LT',
  /** Luxembourg */
  Lu = 'LU',
  /** Latvia */
  Lv = 'LV',
  /** Libya */
  Ly = 'LY',
  /** Morocco */
  Ma = 'MA',
  /** Monaco */
  Mc = 'MC',
  /** Moldova */
  Md = 'MD',
  /** Montenegro */
  Me = 'ME',
  /** Saint Martin */
  Mf = 'MF',
  /** Madagascar */
  Mg = 'MG',
  /** Marshall Islands */
  Mh = 'MH',
  /** Macedonia */
  Mk = 'MK',
  /** Mali */
  Ml = 'ML',
  /** Myanmar */
  Mm = 'MM',
  /** Mongolia */
  Mn = 'MN',
  /** Macao */
  Mo = 'MO',
  /** Northern Mariana Islands */
  Mp = 'MP',
  /** Martinique */
  Mq = 'MQ',
  /** Mauritania */
  Mr = 'MR',
  /** Montserrat */
  Ms = 'MS',
  /** Malta */
  Mt = 'MT',
  /** Mauritius */
  Mu = 'MU',
  /** Maldives */
  Mv = 'MV',
  /** Malawi */
  Mw = 'MW',
  /** Mexico */
  Mx = 'MX',
  /** Malaysia */
  My = 'MY',
  /** Mozambique */
  Mz = 'MZ',
  /** Namibia */
  Na = 'NA',
  /** New Caledonia */
  Nc = 'NC',
  /** Niger */
  Ne = 'NE',
  /** Norfolk Island */
  Nf = 'NF',
  /** Nigeria */
  Ng = 'NG',
  /** Nicaragua */
  Ni = 'NI',
  /** Netherlands */
  Nl = 'NL',
  /** Norway */
  No = 'NO',
  /** Nepal */
  Np = 'NP',
  /** Nauru */
  Nr = 'NR',
  /** Niue */
  Nu = 'NU',
  /** New Zealand */
  Nz = 'NZ',
  /** Oman */
  Om = 'OM',
  /** Panama */
  Pa = 'PA',
  /** Peru */
  Pe = 'PE',
  /** French Polynesia */
  Pf = 'PF',
  /** Papua New Guinea */
  Pg = 'PG',
  /** Philippines */
  Ph = 'PH',
  /** Pakistan */
  Pk = 'PK',
  /** Poland */
  Pl = 'PL',
  /** Saint Pierre and Miquelon */
  Pm = 'PM',
  /** Pitcairn */
  Pn = 'PN',
  /** Puerto Rico */
  Pr = 'PR',
  /** Palestinian Territory */
  Ps = 'PS',
  /** Portugal */
  Pt = 'PT',
  /** Palau */
  Pw = 'PW',
  /** Paraguay */
  Py = 'PY',
  /** Qatar */
  Qa = 'QA',
  /** Reunion */
  Re = 'RE',
  /** Romania */
  Ro = 'RO',
  /** Serbia */
  Rs = 'RS',
  /** Russia */
  Ru = 'RU',
  /** Rwanda */
  Rw = 'RW',
  /** Saudi Arabia */
  Sa = 'SA',
  /** Solomon Islands */
  Sb = 'SB',
  /** Seychelles */
  Sc = 'SC',
  /** Sudan */
  Sd = 'SD',
  /** Sweden */
  Se = 'SE',
  /** Singapore */
  Sg = 'SG',
  /** Saint Helena */
  Sh = 'SH',
  /** Slovenia */
  Si = 'SI',
  /** Svalbard and Jan Mayen */
  Sj = 'SJ',
  /** Slovakia */
  Sk = 'SK',
  /** Sierra Leone */
  Sl = 'SL',
  /** San Marino */
  Sm = 'SM',
  /** Senegal */
  Sn = 'SN',
  /** Somalia */
  So = 'SO',
  /** Suriname */
  Sr = 'SR',
  /** South Sudan */
  Ss = 'SS',
  /** Sao Tome and Principe */
  St = 'ST',
  /** El Salvador */
  Sv = 'SV',
  /** Sint Maarten */
  Sx = 'SX',
  /** Syria */
  Sy = 'SY',
  /** Swaziland */
  Sz = 'SZ',
  /** Turks and Caicos Islands */
  Tc = 'TC',
  /** Chad */
  Td = 'TD',
  /** French Southern Territories */
  Tf = 'TF',
  /** Togo */
  Tg = 'TG',
  /** Thailand */
  Th = 'TH',
  /** Tajikistan */
  Tj = 'TJ',
  /** Tokelau */
  Tk = 'TK',
  /** East Timor */
  Tl = 'TL',
  /** Turkmenistan */
  Tm = 'TM',
  /** Tunisia */
  Tn = 'TN',
  /** Tonga */
  To = 'TO',
  /** Turkey */
  Tr = 'TR',
  /** Trinidad and Tobago */
  Tt = 'TT',
  /** Tuvalu */
  Tv = 'TV',
  /** Taiwan */
  Tw = 'TW',
  /** Tanzania */
  Tz = 'TZ',
  /** Ukraine */
  Ua = 'UA',
  /** Uganda */
  Ug = 'UG',
  /** United States Minor Outlying Islands */
  Um = 'UM',
  /** United States */
  Us = 'US',
  /** Uruguay */
  Uy = 'UY',
  /** Uzbekistan */
  Uz = 'UZ',
  /** Vatican */
  Va = 'VA',
  /** Saint Vincent and the Grenadines */
  Vc = 'VC',
  /** Venezuela */
  Ve = 'VE',
  /** British Virgin Islands */
  Vg = 'VG',
  /** U.S. Virgin Islands */
  Vi = 'VI',
  /** Vietnam */
  Vn = 'VN',
  /** Vanuatu */
  Vu = 'VU',
  /** Wallis and Futuna */
  Wf = 'WF',
  /** Samoa */
  Ws = 'WS',
  /** Kosovo */
  Xk = 'XK',
  /** Yemen */
  Ye = 'YE',
  /** Mayotte */
  Yt = 'YT',
  /** South Africa */
  Za = 'ZA',
  /** Zambia */
  Zm = 'ZM',
  /** Zimbabwe */
  Zw = 'ZW'
}

/**
 * Encapsulates all properties related to portable credit integrations.
 * Average SLA response time - ??ms
 */
export type CreditApplyPortable = {
  __typename?: 'CreditApplyPortable';
  /** Encrypted payload for initial data to CAP for the GPL flow */
  capInitialData?: Maybe<Scalars['String']>;
};

/** Encapsulates all properties related to a credit as a Funding Instrument. */
export type CreditAsFi = {
  __typename?: 'CreditAsFI';
  /** Encapsulates all properties related to a credit as FI offer */
  creditOffer?: Maybe<CreditAsFiOffer>;
  /**
   * Total fee for installments
   * repaymentInstrument is not applicable for PPC
   */
  repaymentInstrument?: Maybe<FundingInstrument>;
};

/**
 * Encapsulates all properties related to a credit as FI offer for the RYI page.
 * Average SLA response time - 50ms - (This might change)
 */
export type CreditAsFiOffer = {
  __typename?: 'CreditAsFIOffer';
  /**
   * Offer ID for the offer returned by crcofferserv
   * crcOfferId is not applicable for PPC
   */
  crcOfferId?: Maybe<Scalars['String']>;
  /** Credit Offer Type i.e. CORE, SAC, INST, EZP etc */
  creditOfferType?: Maybe<CreditOfferType>;
  /**
   * All the Credit PayLater Product deatils
   * creditPayLater is not applicable for PPC
   */
  creditPayLater?: Maybe<CreditPayLater>;
  /** All the Cross Currency related information */
  crossCurrencyInfo?: Maybe<CreditCrossCurrency>;
  /** Financing code is the id for a particular offer returned by credit financing serv. */
  financingCode?: Maybe<Scalars['String']>;
  /** Offer Category i.e. ACQ, reuse etc */
  offerCategory?: Maybe<CreditOfferCategoryType>;
  /** PresentmentType for offer i.e. radio/banner */
  presentmentType?: Maybe<CreditPresentmentType>;
  /** Credit product associated with this offer. For example Pay later, PayPal Credit, etc. */
  product?: Maybe<CreditProductType>;
  /**
   * Rank of this specific offer within the overall list.  Rank will not necessarily
   * be consecutive if other touchpoints had higher priorities.
   */
  rank?: Maybe<Scalars['Int']>;
  /** A marketing offer's reference ID. */
  referenceId?: Maybe<Scalars['String']>;
  /** Uitilities for tracking this offer and the user's interaction with it */
  trackingDetails?: Maybe<MorsMrTrackingDetails>;
  /** All the UI Elements data (offer, RYI etc) */
  uiElements?: Maybe<CreditUiElements>;
};

/**
 * Encapsulates all properties related Cross Currency.
 * Ex: rate, to, rate, etc.
 */
export type CreditCrossCurrency = {
  __typename?: 'CreditCrossCurrency';
  /** Descriptor text for cross currency with Details on the validity of the offered rate */
  currencyConversionDescriptor?: Maybe<Scalars['String']>;
  /** Conversion rate offered by PayPal upto 10 decimals(Eg: 1.511645640091386) */
  currencyConversionRate?: Maybe<Scalars['String']>;
  /** Currency to which conversion offered (Eg. EUR in the case of GPL/FR) */
  fromCurrencyCode?: Maybe<SupportedCountryCurrencies>;
  /** Currency to which amount converted (Eg. 1,00 in the case of fr_FR) */
  fromFormattedCurrencyConversionValue?: Maybe<Scalars['String']>;
  /** Honour FX Id or AuditTrail Id */
  fxAuditTrailId?: Maybe<Scalars['String']>;
  /** Learn More url to be redirected when clicked on Learn More Text */
  learnMoreLink?: Maybe<Scalars['String']>;
  /** Learn More Text to be used as link text */
  learnMoreText?: Maybe<Scalars['String']>;
  /** Descriptor text for PayPal Rate (Eg: PayPal rate:) */
  rateDescriptor?: Maybe<Scalars['String']>;
  /** Currency from which conversion offered (Eg. USD in the case of USD transaction for GPL/FR) */
  toCurrencyCode?: Maybe<SupportedCountryCurrencies>;
  /** Formatted rate as per forex format decimals mostly 5 (Eg: 1.51165) */
  toFormattedCurrencyConversionValue?: Maybe<Scalars['String']>;
};

/** Encapsulates all properties related to the down payment for a credit offer. */
export type CreditDownPayment = {
  __typename?: 'CreditDownPayment';
  /** The total currency amount of the down payment */
  amount?: Maybe<Amount>;
  /**
   * The rate of the down payment relative to the total cost
   * e.g. For a $25 down payment on a $100 transaction the rate is 25%
   */
  rate?: Maybe<Rate>;
};

/** Encapsulates all properties related to a credit as FI offer for the RYI page. */
export type CreditFiuiProperties = {
  __typename?: 'CreditFIUIProperties';
  /** Checkout button text (continue) */
  continueButtonText?: Maybe<Scalars['String']>;
  /** Description text */
  descriptorText?: Maybe<Scalars['String']>;
  /** Headline text */
  headlineText?: Maybe<Scalars['String']>;
  /** Checkout button text (pay) */
  payButtonText?: Maybe<Scalars['String']>;
  /** Recurring Payment Formatted Text */
  paymentFormattedText?: Maybe<Scalars['String']>;
  /** Section Headline text */
  sectionHeadlineText?: Maybe<Scalars['String']>;
  /** Term Formatted Text */
  termFormattedText?: Maybe<Scalars['String']>;
  /** Terms Text */
  termsText?: Maybe<Scalars['String']>;
};

/** Credit FI details */
export type CreditFinancialInstrumentDetailsInput = {
  /** APR */
  apr?: InputMaybe<Scalars['String']>;
  /** Credit type */
  creditType?: InputMaybe<Scalars['String']>;
  /** Currency */
  currency?: InputMaybe<Scalars['String']>;
  /** Financing code */
  financingCode?: InputMaybe<Scalars['String']>;
  /** Monthly payment */
  monthlyPayment?: InputMaybe<Scalars['String']>;
  /** Monthly percentage rate */
  monthlyPercentageRate?: InputMaybe<Scalars['String']>;
  /** PayPal subsidy */
  paypalSubsidy?: InputMaybe<Scalars['Boolean']>;
  /** Terms */
  term?: InputMaybe<Scalars['Int']>;
  /** Total cost */
  totalCost?: InputMaybe<Scalars['String']>;
  /** Total interest */
  totalInterest?: InputMaybe<Scalars['String']>;
};

/** Encapsulates all properties related to the credit financing option patched to the Cart. */
export type CreditFinancingOption = {
  __typename?: 'CreditFinancingOption';
  /** The percentage, as string. For example, 19.99% interest rate as 19.99. */
  apr?: Maybe<Scalars['String']>;
  /** Type of credit. For example, INST for installment */
  creditType?: Maybe<CreditOfferType>;
  /** Identifier of the credit option */
  financingCode?: Maybe<Scalars['String']>;
  /** Amount to be payed each month */
  monthlyPayment?: Maybe<Scalars['String']>;
  /** Monthly interest rate. For example, 1.08% interest rate as 1.08. */
  monthlyPercentageRate?: Maybe<Scalars['String']>;
  /** True if credit fee is funded by PayPal */
  paypalSubsidy?: Maybe<Scalars['Boolean']>;
  /** The term (period of time) over which to finance the transaction. */
  term?: Maybe<Scalars['Int']>;
  /** Total purchase cost + interest */
  totalCost?: Maybe<Scalars['String']>;
  /** Total interest amount */
  totalInterest?: Maybe<Scalars['String']>;
};

/** Credit Incentive Details */
export type CreditIncentiveDetailsInput = {
  /** Buy item ID, same as reference ID */
  buyItemId?: InputMaybe<Scalars['String']>;
  /** Headline text */
  headlineText?: InputMaybe<Scalars['String']>;
  /** Incentive offer currency code */
  offerCurrencyCode?: InputMaybe<Scalars['String']>;
  /** Incentive offer program code */
  offerProgramCode?: InputMaybe<Scalars['String']>;
  /** Incentive offer ID */
  offerProgramId?: InputMaybe<Scalars['String']>;
  /** Offer text 1 */
  offerText1?: InputMaybe<Scalars['String']>;
  /** Offer text 2 */
  offerText2?: InputMaybe<Scalars['String']>;
  /** Incentive offer value */
  offerValue?: InputMaybe<Scalars['String']>;
  /** Terms link */
  termsLink?: InputMaybe<Scalars['String']>;
  /** Terms link text */
  termsLinkText?: InputMaybe<Scalars['String']>;
  /** Terms text */
  termsText?: InputMaybe<Scalars['String']>;
  /** Touchpoint of incentive offer */
  touchpoint?: InputMaybe<Scalars['String']>;
};

/** Allows you to query for credit metadata */
export type CreditMeta = {
  __typename?: 'CreditMeta';
  /**
   * Credit suggestion call-to-action text
   *
   * Call-to-action text that can be used with creditSuggestion
   * Example: 'See offers'
   */
  creditSuggestionCTAText?: Maybe<Scalars['String']>;
  /**
   * Credit suggestion text
   *
   * A short phrase highlighting credit options to the user
   * Example: 'More ways to pay over time'
   */
  creditSuggestionText?: Maybe<Scalars['String']>;
  /** Indicates whether the merchant is an EZP (Easy Payments) merchant */
  easyPaymentsMerchant: Scalars['Boolean'];
  /**
   * Secondary credit suggestion call-to-action text
   *
   * Call-to-action text for the secondaryCreditSuggestion
   * Example: 'See offers'
   */
  secondaryCreditSuggestionCTAText?: Maybe<Scalars['String']>;
  /**
   * Secondary credit suggestion text
   *
   * Similar to creditSuggestionText, but may be a different phrase used in a
   * different location on the frontend
   */
  secondaryCreditSuggestionText?: Maybe<Scalars['String']>;
  /** Indicates whether there was upstream (merchant) credit presentment */
  upstreamCreditPresentment: Scalars['Boolean'];
};

/** An enumeration of types that an CreditOfferCategoryType can be. ACQ, REUSE, etc. */
export enum CreditOfferCategoryType {
  /** An acquisition banner */
  Acq = 'ACQ',
  /** A reuse banner for credit */
  Reuse = 'REUSE'
}

/** An enumeration of types that an CreditOfferType can be. INST, NI, CORE, etc. */
export enum CreditOfferType {
  /** Core offer type */
  Core = 'CORE',
  /** Easy Pay offer type */
  Ezp = 'EZP',
  /** Installment offer type */
  Inst = 'INST',
  /** NO Interest offer type */
  Ni = 'NI',
  /** Pay As Low As offer type */
  Pala = 'PALA',
  /** Pay Upon Invoice */
  Pui = 'PUI'
}

/**
 * Encapsulates all properties related to a credit PPC offer for the RYI page.
 * Average SLA response time - 50ms
 */
export type CreditPpcOffer = {
  __typename?: 'CreditPPCOffer';
  /**
   * A marketing offer's content.
   * An object of key/values that are relevant to a campaign.  This is an opaque
   * object, so be very careful removing fields and do not change existing fields
   */
  content?: Maybe<Scalars['JSON']>;
  /** Pay later offer details */
  creditPayLater?: Maybe<CreditPayLater>;
  /**
   * Indicates whether this message is associated to an 'approved' GPL-FI.
   * Currently, this only apply to multi-offer messages;
   */
  isApproved?: Maybe<Scalars['Boolean']>;
  /**
   * Indicates whether this message is 'selected'.
   * This only apply to:
   * - credit re-use offers
   *   (since you can't pre-select any acquistion offer for the user)
   *   When isSelected: true for a re-use offer it means that the credit FI
   *   is the buyer's default selected FI
   * - multi-offer messages
   *   When isSelected: true for a multi-offer message it means that it will be
   *   pre-selected inside the RYI
   */
  isSelected?: Maybe<Scalars['Boolean']>;
  /** Indicates whether a credit offer is 'qualifying' or not */
  qualifyingOffer?: Maybe<Scalars['Boolean']>;
  /**
   * Rank of this specific offer within the overall list.  Rank will not necessarily
   * be consecutive if other touchpoints had higher priorities.
   */
  rank?: Maybe<Scalars['Int']>;
  /** A marketing offer's reference ID. */
  referenceId?: Maybe<Scalars['String']>;
  /** A marketing offer's touchpoint used as campaign placement code. */
  touchpoint?: Maybe<Scalars['String']>;
  /** Uitilities for tracking this offer and the user's interaction with it. */
  trackingDetails?: Maybe<MorsMrTrackingDetails>;
};

/** Encapsulates all properties related to a credit pay later. */
export type CreditPayLater = {
  __typename?: 'CreditPayLater';
  /** Installments schedule */
  installmentsSchedule?: Maybe<Array<Maybe<InstallmentSchedule>>>;
  /** No down payment amount */
  noDownPaymentAmt?: Maybe<Amount>;
  /** Offer Text Display for installments */
  offerText1?: Maybe<Scalars['String']>;
  /** Offer Text 2 Display for installments */
  offerText2?: Maybe<Scalars['String']>;
  /** Total cost is cart amount */
  totalCost?: Maybe<Amount>;
  /** Total fee for installments */
  totalFee?: Maybe<Amount>;
  /** Total interests for installments */
  totalInterest?: Maybe<Amount>;
};

/** An enumeration of types that an CreditPaymentType can be. DOWN_PAYMENT, INSTALLMENT, etc. */
export enum CreditPaymentType {
  /** A down payment for first installment in schedule */
  DownPayment = 'DOWN_PAYMENT',
  /** An installment after the first down payment */
  Installment = 'INSTALLMENT'
}

/** An enumeration of types that an CreditPresentmentType can be. RADIO, BANNER, etc. */
export enum CreditPresentmentType {
  /** Banner Presentment Type */
  Banner = 'Banner',
  /** NativeMobileXOCarousel Presentment Type for native */
  NativeMobileXoCarousel = 'NativeMobileXOCarousel',
  /** Radio Presentment Type */
  Radio = 'Radio'
}

/** Contains actual score and metadata */
export type CreditProductScoreInfo = {
  __typename?: 'CreditProductScoreInfo';
  /**
   * Meta data: credit product name associated. Example: PAYPAL_CREDIT, PAY_IN_4, PAY_IN_3
   * Can be used by client for instrumentation purposes, indentification of underlying product for a returned score.
   */
  productName: CreditProducts;
  /** Actual Score */
  score?: Maybe<Scalars['Float']>;
};

/** An enumeration of types that an CreditProductType can be. GPL, PPC, CO-BRAND, etc. */
export enum CreditProductType {
  /** Credit card installments */
  CreditCardInstallments = 'CREDIT_CARD_INSTALLMENTS',
  /** Global Pay Later */
  Gpl = 'GPL',
  /** PayPal Credit */
  Ppc = 'PPC',
  /** Pay upon invoice */
  Pui = 'PUI'
}

/** Enums for all Credit related Products */
export enum CreditProducts {
  /** Paypal Credit */
  PaypalCredit = 'PAYPAL_CREDIT',
  /** Pay in 3 */
  PayIn_3 = 'PAY_IN_3',
  /** Pay in 4 */
  PayIn_4 = 'PAY_IN_4',
  /** Pay in 4x */
  PayIn_4X = 'PAY_IN_4X',
  /** Pay in 30 */
  PayIn_30 = 'PAY_IN_30',
  /** Pay Monthly */
  PayMonthly = 'PAY_MONTHLY'
}

/** Installment details */
export type CreditRedirectFinancialInstrumentDetails = {
  __typename?: 'CreditRedirectFinancialInstrumentDetails';
  /** APR */
  apr?: Maybe<Scalars['String']>;
  /** Credit type */
  credit_type?: Maybe<Scalars['String']>;
  /** Currency */
  currency?: Maybe<Scalars['String']>;
  /** Financing code */
  financing_code?: Maybe<Scalars['String']>;
  /** Monthly payment */
  monthly_payment?: Maybe<Scalars['String']>;
  /** Monthly percentage rate */
  monthly_percentage_rate?: Maybe<Scalars['String']>;
  /** PayPal subsidy */
  paypal_subsidy?: Maybe<Scalars['Boolean']>;
  /** Terms */
  term?: Maybe<Scalars['Int']>;
  /** Total cost */
  total_cost?: Maybe<Scalars['String']>;
  /** Total interest */
  total_interest?: Maybe<Scalars['String']>;
};

/** User account details */
export type CreditRedirectLoginDetails = {
  __typename?: 'CreditRedirectLoginDetails';
  /** Whether a new account was created */
  new_account_created?: Maybe<Scalars['Boolean']>;
  /** PP account number */
  paypal_account_number?: Maybe<Scalars['String']>;
};

/** Mayfly response from redirecting back from CAPE */
export type CreditRedirectMayflyResponse = {
  __typename?: 'CreditRedirectMayflyResponse';
  /** Credit decision */
  credit_decision?: Maybe<Scalars['String']>;
  /** Installment details */
  financial_instrument_details?: Maybe<CreditRedirectFinancialInstrumentDetails>;
  /** Credit FI ID */
  financial_instrument_id?: Maybe<Scalars['String']>;
  /** Is reuse */
  is_reuse?: Maybe<Scalars['Boolean']>;
  /** Login details */
  login_details?: Maybe<CreditRedirectLoginDetails>;
  /** User selected shipping address */
  user_selected_address_id?: Maybe<Scalars['String']>;
  /** User selected preferred shipping address */
  user_selected_preferred_shipping_address_id?: Maybe<Scalars['String']>;
};

/**
 * Encapsulates all properties related to Credit products related Scores.
 * Each property refers to a score determined for a credit related product.
 */
export type CreditScores = {
  __typename?: 'CreditScores';
  /** Propensity Score for Pay Monthly */
  paymonthly: CreditProductScoreInfo;
  /** Propensity Score for Pay in 4 */
  pi4: CreditProductScoreInfo;
  /** Propensity Score for PayPal Credit */
  ppc: CreditProductScoreInfo;
};

/** Encapsulates all properties related to all the RYI pages. */
export type CreditUiElements = {
  __typename?: 'CreditUIElements';
  /** Data required to display credit installments FI with other FIs on return RYI */
  creditFI?: Maybe<CreditFiuiProperties>;
  /** Data related to offer */
  creditOffer?: Maybe<CreditFiuiProperties>;
  /** Data required to display specialized credit installments only RYI */
  creditOnlyFI?: Maybe<CreditFiuiProperties>;
  /** Highlight Text for offer */
  fiHighlightText?: Maybe<Scalars['String']>;
  /** Indicates the GPL loan formatted maximum capture amount (apply to PSD2 countries: DE, GB, ES, FR, IT) */
  formattedMaxCaptureAmount?: Maybe<Scalars['String']>;
  /**
   * Indicates whether this is a multi-offer message
   * GPL-FI associated to multi-offer messages will be hidden in final RYI
   */
  isMultiOffer?: Maybe<Scalars['Boolean']>;
  /** Credit installments logo */
  logo?: Maybe<GenericUrl>;
  /** Alternate text for logo */
  logoAltText?: Maybe<Scalars['String']>;
};

/** Encapsulates all properties related to the cryptocurrency holding details. */
export type CryptocurrencyHoldingDetails = {
  __typename?: 'CryptocurrencyHoldingDetails';
  /** Full amount of cryptocurrency the user has */
  quantity?: Maybe<Scalars['String']>;
  /** Symbol of the cryptocurrency */
  symbol?: Maybe<CryptocurrencySymbol>;
};

/** Encapsulates all properties related to the cryptocurrency quote. */
export type CryptocurrencyQuote = {
  __typename?: 'CryptocurrencyQuote';
  /** Amount for 1 of the asset (effectively the rate) */
  assetPrice?: Maybe<Amount>;
  /** Quote ID */
  id?: Maybe<Scalars['String']>;
  /** Quantity of the asset that would be used for the sell */
  quantity?: Maybe<Scalars['String']>;
  /** Symbol of the cryptocurrency */
  symbol?: Maybe<CryptocurrencySymbol>;
  /** Total amount that user's crypto asset is worth */
  totalAmount?: Maybe<Amount>;
};

/** An enumeration of types that an Cryptocurrency can be. BTC, BCH, etc.  */
export enum CryptocurrencySymbol {
  /** Bitcoin Cash */
  Bch = 'BCH',
  /** Bitcoin */
  Btc = 'BTC',
  /** Ethereum */
  Eth = 'ETH',
  /** Chainlink */
  Link = 'LINK',
  /** Litecoin */
  Ltc = 'LTC',
  /** Polygon */
  Matic = 'MATIC',
  /** PayPal USD */
  Pyusd = 'PYUSD',
  /** Solana */
  Sol = 'SOL'
}

/**
 * Encapsulates all properties related to a Pricing.
 * Ex: from, to, rate, etc.
 */
export type CurrencyConversion = {
  __typename?: 'CurrencyConversion';
  /** PayPal currency conversion fee rate in percentage. (e.g '5.00') */
  feeRate?: Maybe<Scalars['String']>;
  /** What the currency is converted from. */
  from?: Maybe<Amount>;
  /** Date of validity.  The date that the conversion rate was issued. */
  issuedDate?: Maybe<GenericDate>;
  /** The currency conversion rate. */
  rate?: Maybe<Scalars['String']>;
  /** The currency conversion rate formatted. */
  rateFormatted?: Maybe<Scalars['String']>;
  /** The currency conversion rate spread. */
  spread?: Maybe<Scalars['String']>;
  /** What the currency is converted to. */
  to?: Maybe<Amount>;
};

/** customer object, currently consists of only a customer id */
export type Customer = {
  __typename?: 'Customer';
  /** id */
  id?: Maybe<Scalars['String']>;
};

/** Tracking for customization */
export type CustomizationTracking = {
  __typename?: 'CustomizationTracking';
  /** Click URL from MORS */
  click?: Maybe<Scalars['String']>;
  /** Impression URL from MORS */
  impression?: Maybe<Scalars['String']>;
};

/** Date of Birth input type */
export type DateOfBirth = {
  /** Specific day of birth */
  day?: InputMaybe<Scalars['DobDay']>;
  /** Month of birth */
  month?: InputMaybe<Scalars['DobMonth']>;
  /** Year of birth */
  year?: InputMaybe<Scalars['DobYear']>;
};

/** Encapsulates details of the declined instrument */
export type DeclinedInstrument = {
  __typename?: 'DeclinedInstrument';
  /** Indicator to allow cpa retries */
  allowCpaRetry?: Maybe<Scalars['Boolean']>;
  /** Indicates the reason for the instrument's decline */
  declineReason: Scalars['String'];
  /** Indicates how the funding instrument is declined */
  declineType?: Maybe<DeclinedInstrumentType>;
  /**
   * Funding option's ID (Ex: 'BA8JUE35JC6JBU4')
   * This differs from ID because ID will sometimes have an extra
   * keyword appended
   */
  id?: Maybe<Scalars['ID']>;
  /**
   * The card art image
   *
   * Takes optional input for image size and type
   */
  image?: Maybe<CardImage>;
  /** Declined instrument's issuer product description. This is the card issuer's product and brand information. For Example, Chase Sapphire Reserve. */
  issuerProductDescription?: Maybe<Scalars['String']>;
  /** Last digits of a credit card */
  lastDigits?: Maybe<Scalars['String']>;
  /** Funding option's name (Ex: 'BANK OF AMERICA') */
  name?: Maybe<Scalars['String']>;
  /** Normalized processor response for the decline reason from issuer */
  normalizedProcessorResponse?: Maybe<Scalars['String']>;
  /**
   * Partial fpan is a flag from PAPS for determining
   * whether we have only partial funding PAN so we need to replace FI record
   * or we have full funding PAN so we need to add FI record
   */
  partialFpan?: Maybe<Scalars['Boolean']>;
  /** Indicates the type of the funding instrument */
  type: FundingOptionType;
};


/** Encapsulates details of the declined instrument */
export type DeclinedInstrumentImageArgs = {
  size?: InputMaybe<SquareImageSize>;
  type?: InputMaybe<ImageType>;
};

/**
 * An enumeration of types that FundingOption can have.
 * PROCESSOR_DECLINE, PAYPAL_ELIGIBILITY or PREAUTH
 */
export enum DeclinedInstrumentType {
  /** DO_EC PayPal credit DO_EC decline */
  PaypalEligibility = 'PAYPAL_ELIGIBILITY',
  /** CC Preauthorization decline */
  Preauth = 'PREAUTH',
  /** DO_EC issuer decline */
  ProcessorDecline = 'PROCESSOR_DECLINE'
}

/** Encapsulates all properties related to DeviceInfo. */
export type DeviceInfo = {
  /** Browser height */
  browserHeight?: InputMaybe<Scalars['String']>;
  /** List Browser plugins. Example - pdf,Shockwave Flash 28.0 r0 */
  browserPlugins?: InputMaybe<Scalars['String']>;
  /** Browser width */
  browserWidth?: InputMaybe<Scalars['String']>;
  /** Color Depth - window.screen.colorDepth - Number of bits used to represent the color of a single pixel on the screen, or in the buffer when off-screen buffering is enabled. */
  colorDepth?: InputMaybe<Scalars['String']>;
  /** window.devicePixelRatio - Returns the ratio between physical pixels and device independent pixels of the existing display */
  devicePixelRatio?: InputMaybe<Scalars['String']>;
  /** navigator.hardwareConcurrency - Number of logical processors available to run threads on the user’s device */
  numCores?: InputMaybe<Scalars['String']>;
  /** Example - fr_FR */
  rosettaLanguage?: InputMaybe<Scalars['String']>;
  /** window.screen.availHeight - Available vertical resolution of the screen, in pixels */
  screenAvailHeight?: InputMaybe<Scalars['String']>;
  /** window.screen.width - Available horizontal resolution of the screen, in pixels */
  screenAvailWidth?: InputMaybe<Scalars['String']>;
  /** window.screen.height - Vertical resolution of the screen, in pixels */
  screenHeight?: InputMaybe<Scalars['String']>;
  /** window.screen.width - Horizontal resolution of the screen, in pixels */
  screenWidth?: InputMaybe<Scalars['String']>;
};

/** An enumeration of types that deviceType can have. */
export enum DeviceType {
  /** Desktop */
  Desktop = 'DESKTOP',
  /** Mobile */
  Mobile = 'MOBILE',
  /** Tablet */
  Tablet = 'TABLET'
}

/** An enumeration of values that language directionality can be. LTR or RTL */
export enum Directionality {
  /** Left-to-right */
  Ltr = 'LTR',
  /** Right-to-left */
  Rtl = 'RTL'
}

/** Encapsulates details of a disallowed instrument */
export type DisallowedInstrument = {
  __typename?: 'DisallowedInstrument';
  /** Funding instrument's formatted type (Ex: 'Bank') */
  formattedType?: Maybe<Scalars['String']>;
  /** Funding instrument's ID (Ex: 'BA8JUE35JC6JBU4') */
  id?: Maybe<Scalars['ID']>;
  /**
   * The card art image
   *
   * Takes optional input for image size and type
   */
  image?: Maybe<CardImage>;
  /**
   * Funding instrument's sub type of it's `type`.
   * (EX: 'CREDIT', 'DEBIT', 'CHECKING', 'SAVINGS').
   */
  instrumentSubType?: Maybe<FundingInstrumentSubType>;
  /** Indicates if the disallowed instrument is the preferred funding instrument */
  isPreferred?: Maybe<Scalars['Boolean']>;
  /**
   * Funding instrument's mapped name. This can be used as a display name. Currently
   * does not use localization.
   * (Ex: 'BILL_ME_LATER' -> 'PayPal Credit', label: disallowedToallowedMap[name] || name)
   */
  label?: Maybe<Scalars['String']>;
  /** Funding instrument's last 4 digits (Ex: '3071') */
  lastDigits?: Maybe<Scalars['String']>;
  /**
   * Funding instrument's name. This is the raw response, and should be treated more
   * as a code, if the client wants to do some logic based on the specific name of
   * the instrument.
   * (Ex: 'BANK OF AMERICA')
   */
  name?: Maybe<Scalars['String']>;
  /**
   * Funding instrument's nickname to be displayed. If nickname doesn't exist, returns funding instrument's issuer product description which is the card issuer's product and brand information.
   * (Ex: 'My card acc' || 'Chase Sapphire Reserve' )
   */
  nameDescription?: Maybe<Scalars['String']>;
  /** Indicates the reason for the current disallowed funding instrument */
  reason: Scalars['String'];
  /** Indicates the type of the given disallowed funding instrument (Ex: 'BALANCE') */
  type?: Maybe<FundingOptionType>;
};


/** Encapsulates details of a disallowed instrument */
export type DisallowedInstrumentImageArgs = {
  size?: InputMaybe<SquareImageSize>;
  type?: InputMaybe<ImageType>;
};

/** Customization for an element in checkout (Eg: tagline in a button) */
export type ElementCustomization = {
  __typename?: 'ElementCustomization';
  /** Simple Text */
  text?: Maybe<Scalars['String']>;
  /** Tracking details */
  tracking?: Maybe<CustomizationTracking>;
};

/**
 * Encapsulates all properties related to installments.
 * Ex: installmentType, hasDiscount, Installments etc.
 */
export type EligibleInstallments = {
  __typename?: 'EligibleInstallments';
  /** Whether or not discount is applicable for the payment */
  hasDiscount?: Maybe<Scalars['Boolean']>;
  /** Installment Type */
  installmentType?: Maybe<InstallmentType>;
  /** Eligible Installment options */
  installments?: Maybe<Array<Maybe<InstallmentOption>>>;
};

/** Encapsulates all properties of an Elmo experiment */
export type ElmoExperiment = {
  __typename?: 'ElmoExperiment';
  /** Array of user treatments returned by Elmo */
  treatments: Array<Maybe<ElmoTreatment>>;
};

/** Encapsulates all properties related to an Elmo filter input. */
export type ElmoFilterInput = {
  /** The key name of the filter (Ex: 'Country') */
  key: Scalars['String'];
  /** The value that is associated with the filter key */
  value: Scalars['String'];
};

/** Additional arguments needed for elmo realtime filters can be added here. Every argument has to optional */
export type ElmoRealTimeFilterArgs = {
  /** RPS - RealtimeProfileServ Customer List identifier. Eg: CL-1344242 */
  customerListName?: InputMaybe<RpsCustomerList>;
  /** segment - this will be the name of the segement which needs to be mapped to array of customer lists in code */
  segmentName?: InputMaybe<RpsSegmentName>;
};

/** Encapsulates all properties related to an Elmo filter input where values are Real Time values got from an API call. */
export type ElmoRealTimeFilterInput = {
  /** Additional arguments needed for API call made before calling Elmo */
  args?: InputMaybe<ElmoRealTimeFilterArgs>;
  /** The key name of the filter (Ex: 'Country') */
  key: Scalars['String'];
  /** The value that is associated with the filter key */
  value: ElmoRealTimeFilterValues;
};

/** An enumeration of values for Elmo filters that gets substituted with API call response */
export enum ElmoRealTimeFilterValues {
  /** BILLING_TYPE value will be fetched from getBillingTypeForElmo call */
  BillingType = 'BILLING_TYPE',
  /** CHECKOUT_SESSION_TYPE value will be fetched from getCheckoutSessionTypeForElmo call */
  CheckoutSessionType = 'CHECKOUT_SESSION_TYPE',
  /** IS_BILLING_AGREEMENT value will be fetched from getIsBillingAgreementFlag call and value is from 'isBillingAgreement' key in response object */
  IsBillingAgreement = 'IS_BILLING_AGREEMENT',
  /** IS_EXISTING_MEMBER_FROM_UL_CONTEXT this will call mayfly to get UL context and check for the flag hasExistingAccount on onboardingContext */
  IsExistingMemberFromUlContext = 'IS_EXISTING_MEMBER_FROM_UL_CONTEXT',
  /** IS_GUEST_ELIGIBLE value will be fetched from getFlowEligibility call and value is from 'guest' key in response object */
  IsGuestEligible = 'IS_GUEST_ELIGIBLE',
  /** IS_MERCHANT_IN_CUSTOMER_LIST this will trigger an API call to rpsreadserv to see if merchant id exists in a customer list or not */
  IsMerchantInCustomerList = 'IS_MERCHANT_IN_CUSTOMER_LIST',
  /** IS_WPS value will be fetched from getApplicationData call and value is from 'flags.is_wps_flow' key in response object */
  IsWps = 'IS_WPS',
  /** MERCHANT_ID value will get fetched from getPayee() and the path to value is merchant.accountNumber */
  MerchantId = 'MERCHANT_ID',
  /** MERCHANT_IN_CUSTOMER_LIST_NAME this will call dynsegmentationserv/evaluate API to see if merchant belongs to a segment or not */
  MerchantInCustomerListName = 'MERCHANT_IN_CUSTOMER_LIST_NAME',
  /** WEASLEY_ELIGIBILITY_FILTERS this will call getFiltersFromJunoCache and populates this as filters to elmo call */
  WeasleyEligibilityFilters = 'WEASLEY_ELIGIBILITY_FILTERS'
}

/** Encapsulates all properties for a user treatment for a particular experiment */
export type ElmoTreatment = {
  __typename?: 'ElmoTreatment';
  /** Allocation percentage for the returned treatment */
  allocationPercentage: Scalars['Int'];
  /** ID of the experiment that the returned treatment belongs to */
  experimentId: Scalars['String'];
  /** Name of the experiment that the returned treatment belongs to */
  experimentName: Scalars['String'];
  /** List of factors defined for the returned treatment */
  factors?: Maybe<Array<Maybe<ElmoTreatmentFactor>>>;
  /** Hash value */
  hashValue: Scalars['String'];
  /** ID of the returned treatment */
  treatmentId: Scalars['String'];
  /** Name of the returned treatment */
  treatmentName: Scalars['String'];
  /** Version of the experiment the returned treatment belongs to */
  version: Scalars['String'];
};

/**
 * Encapsulates an Elmo treatment factor, a key-value pair used to provide
 * additional configuration.
 */
export type ElmoTreatmentFactor = {
  __typename?: 'ElmoTreatmentFactor';
  /** The treatment factor key */
  key: Scalars['String'];
  /** The treatment factor value */
  value: Scalars['String'];
};

/** Encapsulates all properties related to an email. Ex: url, width, height */
export type Email = {
  __typename?: 'Email';
  /** The domain of the e-mail address (Ex: domain.com) */
  domainPart?: Maybe<Scalars['String']>;
  /** The local-part of the e-mail address (Ex: 'user') */
  localPart?: Maybe<Scalars['String']>;
  /** The full e-mail address (Ex: user@domain.com) */
  stringValue?: Maybe<Scalars['String']>;
};

/** Supported Enrollment Status enum values */
export enum EnrollmentStatusType {
  /** Merchant authentication rule is triggered to bypass authentication in this use case */
  Bypass = 'BYPASS',
  /** Bank is not participating in 3-D Secure protocol */
  No = 'NO',
  /** The DS or ACS is not available for authentication at the time of the request */
  Unavailable = 'UNAVAILABLE',
  /** Unknown */
  Unknown = 'UNKNOWN',
  /** Bank is participating in 3-D Secure protocol and will return the ACSUrl */
  Yes = 'YES'
}

/** Rewards identifiers and details */
export type EstimatedReward = {
  __typename?: 'EstimatedReward';
  /** Reward progress from previous transactions */
  completedProgress?: Maybe<EstimatedRewardStretchGoal>;
  /** Reward progress including current transaction */
  estimatedProgress?: Maybe<EstimatedRewardStretchGoal>;
  /** Details of the rewards offer */
  reward?: Maybe<EstimatedRewardDetails>;
  /** Unique identifier of the rewards offer */
  rewardId?: Maybe<Scalars['String']>;
  /** Name of the reward used by a campaign, eg StoreA Cashback Reward */
  rewardName?: Maybe<Scalars['String']>;
};

/** Rewards details for type and denomination */
export type EstimatedRewardDetails = {
  __typename?: 'EstimatedRewardDetails';
  /** Amount of rewards */
  amount?: Maybe<Amount>;
  /** Rewards crypto when rewardType is `CRYPTOCURRENCY` */
  cryptocurrency?: Maybe<CryptocurrencyHoldingDetails>;
  /** Percentage for Rewards */
  percent?: Maybe<Scalars['String']>;
  /** Rewards points when rewardType is `POINTS` */
  points?: Maybe<Scalars['Int']>;
  /** The reward type (i.e. `AMOUNT`, `POINTS`, `CRYPTOCURRENCY`, `PERCENT`) */
  rewardType?: Maybe<EstimatedRewardType>;
};

/** Details for rewards merchant */
export type EstimatedRewardMerchantDetails = {
  __typename?: 'EstimatedRewardMerchantDetails';
  /** Merchant Affiliate Tag URL to be further formatted on the client side - e.g. o-staging.honey.io/store/100/website */
  affiliateLinkData?: Maybe<Scalars['String']>;
  /** Merchant name associated with the rewards campaign */
  merchantName?: Maybe<Scalars['String']>;
  /** External identifier for the transaction seller e.g. Honey Store Id */
  storeId?: Maybe<Scalars['String']>;
};

/**
 * Transaction stretch award details
 * (i.e. spend $x on y transactions and earn z points back)
 */
export type EstimatedRewardStretchGoal = {
  __typename?: 'EstimatedRewardStretchGoal';
  /** Details of award that will be granted when all transactions are completed */
  potentialEligibleReward?: Maybe<EstimatedRewardDetails>;
  /** Number of transactions completed for stretch award */
  transactionCountCompleted?: Maybe<Scalars['Int']>;
  /** Number of transactions remaining for stretch award */
  transactionCountRemaining?: Maybe<Scalars['Int']>;
};

/** The type of Estimated Rewards associated with purchase */
export enum EstimatedRewardType {
  /** Amount in a currency denomination */
  Amount = 'AMOUNT',
  /** Cryptocurrency */
  Cryptocurrency = 'CRYPTOCURRENCY',
  /** Percent */
  Percent = 'PERCENT',
  /** PayPal Rewards points */
  Points = 'POINTS',
  /** Qualifying Points */
  QualifyingPoints = 'QUALIFYING_POINTS'
}

/** High level container for rewards estimate */
export type EstimatedRewards = {
  __typename?: 'EstimatedRewards';
  /** List of rewards offers */
  totalEstimatedRewards?: Maybe<Array<Maybe<EstimatedRewardDetails>>>;
  /** List of user-specific rewards campaigns */
  userEstimatedRewards?: Maybe<Array<Maybe<UserEstimatedReward>>>;
};

/**
 * An enumeration of all flow types accepted by Notice and Consent evalPolicy API.
 * Based on those flags, the Notice and Consent API will determine what to do based on guest and member use cases.
 */
export enum EvalPolicyFlowType {
  /** For member use cases, we need to pass in the API flow as CHECKOUT. */
  Checkout = 'CHECKOUT',
  /** For guest and sign up use cases, we need to pass in the API flow ONBOARDING */
  Onboarding = 'ONBOARDING'
}

/**
 * Encapsulates all properties of existing billing agreement Id.
 * Ex: balancePreference, stickyFundingOptionId, billingAgreementId
 */
export type ExistingBillingAgreementDetails = {
  __typename?: 'ExistingBillingAgreementDetails';
  /** Balance Preference of the Billing Agreement */
  balancePreference?: Maybe<BalancePreference>;
  /** Billing Agreement Id, ex: B-55N53089XX761722H */
  id?: Maybe<Scalars['String']>;
  /** Sticky fuding instrument of the Billing Agreement */
  stickyFundingInstrument?: Maybe<FundingInstrument>;
};

/** An enumeration of internal PayPal experience channels */
export enum ExperienceChannel {
  /** Any type of Checkout */
  Any = 'ANY',
  /** Braintree */
  Braintree = 'BRAINTREE',
  /** Member or Guest PayPal Checkout */
  Hermes = 'HERMES',
  /** PROX/eBay Checkout */
  Prox = 'PROX',
  /** Venmo */
  Venmo = 'VENMO'
}

/**
 * Encapsulates everything related to a PXP test.
 * Ex: type, values, stringValue
 *
 * Required auth states: Any
 */
export type Experiment = {
  __typename?: 'Experiment';
  /** The name of this experiment. */
  name: Scalars['String'];
  /** The tracking tags associated with a Experiment. */
  trackingTags?: Maybe<Array<Maybe<TrackingTag>>>;
  /**
   * The tracking tags associated with a Experiment, but represented as a String.
   * (Ex: 'qt=6496,2252,7579;qc=2621440,2623488,2621440;uqt=6001;uqc=2621440;ot=;os=')
   */
  trackingTagsString?: Maybe<Scalars['String']>;
  /** An Array of Treatment types, which are treatments associated with this experiment. */
  treatments: Array<Maybe<Treatment>>;
};

/** For experiments field on root Query type */
export type ExperimentInput = {
  /** Name of experiment. (Ex: 'pxp_hermesnode_kmli') */
  name: Scalars['String'];
  /** Any kind of params (Ex: Objects, Arrays, etc.) */
  params?: InputMaybe<Scalars['JSON']>;
};

/** Phone confirmation state with additional fields for exceeded retries and voip numbers */
export enum ExtendedPhoneConfirmationState {
  /** CONFIRMED */
  Confirmed = 'CONFIRMED',
  /** Number not supported, e.g. it is a VoIP number. */
  NumberNotSupported = 'NUMBER_NOT_SUPPORTED',
  /** PENDING */
  Pending = 'PENDING',
  /** The provided number has already exceeded the SMS limit. */
  SmsLimitExceeded = 'SMS_LIMIT_EXCEEDED',
  /** UNKNOWN */
  Unknown = 'UNKNOWN',
  /** Incorrect pin */
  ValidationFailed = 'VALIDATION_FAILED'
}

/**
 * Enum for all FI related products
 * FI_SWITCH_RATE: Rate at which a buyer switches between different funding instruments in a xo session
 */
export enum FiProductEnum {
  /** Depicts FI Switch Rate */
  FiSwitchRate = 'FI_SWITCH_RATE'
}

/** Contains actual score and metadata */
export type FiScoreInfo = {
  __typename?: 'FIScoreInfo';
  /**
   * Identifier name for the FI score sent. Example: FI_SWITCH_RATE
   * Can be used by client for instrumentation purposes, indentification of underlying nature or FI type for a returned score.
   */
  productName: FiProductEnum;
  /** Actual Score */
  score?: Maybe<Scalars['Float']>;
};

/**
 * Encapsulates all properties related to FI related scores.
 * Each property refers to a score determined in context of an FI.
 */
export type FiScores = {
  __typename?: 'FIScores';
  /** Propensity Score for FI Switch Rate */
  fiSwitchRateScore: FiScoreInfo;
};

/** Encapsulates everything related to a Factor. Ex: name, value */
export type Factor = {
  __typename?: 'Factor';
  /** Name of the Factor */
  name?: Maybe<Scalars['String']>;
  /** Value of the Factor */
  value?: Maybe<Scalars['String']>;
};

/** The rules of the card field */
export type FieldRules = {
  __typename?: 'FieldRules';
  /** Indicate whether billing address is required */
  address: Scalars['Boolean'];
  /** Indicate whether security code is required */
  cvv: Scalars['Boolean'];
  /** Indicate whether date of birth is required */
  dob: Scalars['Boolean'];
  /** Indicate whether expiration data is required */
  expiry: Scalars['Boolean'];
  /** Indicate whether issuer bank is required */
  issue: Scalars['Boolean'];
  /** Indicate whether phone number is required */
  phone: Scalars['Boolean'];
};

/** Financial Institution */
export type FinancialInstitution = {
  __typename?: 'FinancialInstitution';
  /** Refers to the partner id that will be used to identify the partner in the flow ex: americanexpress */
  identityProvider: Scalars['String'];
  /** Reference to an Icon to show next to the institution name in a list */
  institutionImage: InstitutionImage;
  /** Refers to the name of the partner ex: American Express */
  name: Scalars['String'];
};

/** Interface with the FireBase api */
export type FireBase = {
  __typename?: 'FireBase';
  /** A user's firebase auth token */
  auth: FireBaseAuth;
};


/** Interface with the FireBase api */
export type FireBaseAuthArgs = {
  sessionUID: Scalars['String'];
};

/** FireBase authentication */
export type FireBaseAuth = {
  __typename?: 'FireBaseAuth';
  /** The Firebase project ID */
  projectID: Scalars['String'];
  /** The firebase session token generated for the user */
  sessionToken: Scalars['String'];
  /** A client-generated session id for the user */
  sessionUID: Scalars['String'];
};

/** Encapsulates all properties related to flow eligible Methods. */
export type FlowEligibleMethods = {
  __typename?: 'FlowEligibleMethods';
  /** Guest eligibility */
  guest: Scalars['Boolean'];
  /** Signup eligibilty */
  signup: Scalars['Boolean'];
};

/** A FullWallet Status type */
export enum FullWalletStatus {
  /** User has not made any decision on FullWallet */
  New = 'NEW',
  /** FullWallet Opted In */
  OptedIn = 'OPTED_IN',
  /** Full Wallet Opted out */
  OptedOut = 'OPTED_OUT'
}

/** Encapsulates all button types that can be rendered by the smart payment button */
export enum FundingButtonType {
  /** ApplePay */
  Applepay = 'applepay',
  /** Bancontact */
  Bancontact = 'bancontact',
  /** Blik */
  Blik = 'blik',
  /** Boleto */
  Boleto = 'boleto',
  /** Boletobancario */
  Boletobancario = 'boletobancario',
  /** Cards */
  Card = 'card',
  /** PayPal Credit */
  Credit = 'credit',
  /** EPS */
  Eps = 'eps',
  /** Giropay */
  Giropay = 'giropay',
  /** Ideal */
  Ideal = 'ideal',
  /** Itau */
  Itau = 'itau',
  /** Maxima */
  Maxima = 'maxima',
  /** Mercadopago */
  Mercadopago = 'mercadopago',
  /** Multibanco */
  Multibanco = 'multibanco',
  /** MYBANK */
  Mybank = 'mybank',
  /** OXXO */
  Oxxo = 'oxxo',
  /** p24 */
  P24 = 'p24',
  /** Paidy */
  Paidy = 'paidy',
  /** PayPal Pay Later */
  Paylater = 'paylater',
  /** PayPal */
  Paypal = 'paypal',
  /** Payu */
  Payu = 'payu',
  /** Satispay */
  Satispay = 'satispay',
  /** Sepa */
  Sepa = 'sepa',
  /** SOFORT */
  Sofort = 'sofort',
  /** Trustly */
  Trustly = 'trustly',
  /** Venmo */
  Venmo = 'venmo',
  /** WeChat Pay */
  Wechatpay = 'wechatpay',
  /** Zimpler */
  Zimpler = 'zimpler'
}

/**
 * Encapsulates all data related to a Checkout session's funding contingencies
 * Ex: threeDomainSecure, cvvConfirm, etc.
 */
export type FundingContingency = ConfirmCreditCardCvvContingency | OpenBankingContingency | PaycodeContingency | SepaMandateAcceptenceNeededContingency | ThreeDomainSecureResolutionContingency;

/** Encapsulates all properties related to eligible Payment Methods. */
export type FundingEligibility = {
  __typename?: 'FundingEligibility';
  /** ApplePay */
  applepay: PaymentEligibility;
  /** Bancontact */
  bancontact: PaymentEligibility;
  /** Blik */
  blik: PaymentEligibility;
  /** Boleto */
  boleto: PaymentEligibility;
  /** Boletobancario */
  boletobancario: PaymentEligibility;
  /** Cards */
  card: CardEligibility;
  /** PayPal Credit */
  credit: PaymentEligibility;
  /** EPS */
  eps: PaymentEligibility;
  /** Giropay */
  giropay: PaymentEligibility;
  /** Ideal */
  ideal: PaymentEligibility;
  /** Itau */
  itau: PaymentEligibility;
  /** Maxima */
  maxima: PaymentEligibility;
  /** Mercadopago */
  mercadopago: PaymentEligibility;
  /** Multibanco */
  multibanco: PaymentEligibility;
  /** MYBANK */
  mybank: PaymentEligibility;
  /** OXXO */
  oxxo: PaymentEligibility;
  /** p24 */
  p24: PaymentEligibility;
  /** Paidy */
  paidy: PaymentEligibility;
  /** PayPal Pay Later */
  paylater: PaymentEligibility;
  /** PayPal */
  paypal: PaymentEligibility;
  /** Payu */
  payu: PaymentEligibility;
  /** Satispay */
  satispay: PaymentEligibility;
  /** Sepa */
  sepa: PaymentEligibility;
  /** SOFORT */
  sofort: PaymentEligibility;
  /** Trustly */
  trustly: PaymentEligibility;
  /** Venmo */
  venmo: PaymentEligibility;
  /** WeChat Pay */
  wechatpay: PaymentEligibility;
  /** Zimpler */
  zimpler: PaymentEligibility;
};

/** An enumeration of intents that a Cart can have. SALE, AUTHORIZE, or ORDER */
export enum FundingEligibilityIntent {
  /** The Cart's intent is for Auth transactions */
  Authorize = 'AUTHORIZE',
  /** The Cart's intent is for Capture transactions */
  Capture = 'CAPTURE',
  /** The Cart's intent is for Order transactions */
  Order = 'ORDER',
  /** The Cart's intent is for Sale transactions */
  Sale = 'SALE',
  /** Subscription only, with no transaction */
  Subscription = 'SUBSCRIPTION',
  /** Tokenize only, with no transaction */
  Tokenize = 'TOKENIZE'
}

/**
 * Encapsulates all properties related to a FundingInstrument.
 * Ex: name, type, lastDigits, amount, etc.
 */
export type FundingInstrument = {
  __typename?: 'FundingInstrument';
  /**
   * Funding option's amount.
   * @deprecated Read amount from a Plan that contains this FundingInstrument instead, as the amount charged to the FundingInstrument can change depending on the Plan being used.
   */
  amount?: Maybe<Amount>;
  /**
   * Attributions are data that can be associated with a financial instrument that can influence a user to select that instrument. This may be a message that reminds the user of special incentive such as an extra 5% back on purchases made using the card.
   *
   * > Example: *"Earn 5% Cashback Bonus on up to $1,500 in qualifying PayPal and more purchases from 7/1/19 – 9/30/19, if activated.  For Discover it® and Discover® More® card members only."*
   * @deprecated New object attributionDetails is already added in FndingInstrument which holds attribution related information.
   */
  attribution?: Maybe<Scalars['String']>;
  /** Attributions are data that can be associated with a financial instrument that can influence a user to select that instrument. This may be a message that reminds the user of special incentive such as an extra 5% back on purchases made using the card. */
  attributionDetails?: Maybe<AttributionDetails>;
  /** Billing without purchase constraint for smart auth */
  constraint?: Maybe<Constraint>;
  /**
   * Additional data required to present the Credit Installment funding option
   * @deprecated Renamed to use `creditFields` instead to better match good graphQL schema practices.
   */
  creditFIAdditionalData?: Maybe<CreditAsFiOffer>;
  /** Additional data required to present the Credit Installment funding option */
  creditFields?: Maybe<CreditAsFi>;
  /** Contains details for CRYPTOCURRENCY type instruments */
  cryptocurrencyHoldingDetails?: Maybe<CryptocurrencyHoldingDetails>;
  /** Funding instrument's formatted type (Ex: 'Bank') */
  formattedType?: Maybe<Scalars['String']>;
  /**
   * Funding option's ID (Ex: 'BA8JUE35JC6JBU4')
   * @deprecated Renamed to use `id` instead to better match good graphQL schema practices.
   */
  fundingOptionId?: Maybe<Scalars['String']>;
  /** Funding instrument's ID (Ex: 'BA8JUE35JC6JBU4') */
  id?: Maybe<Scalars['ID']>;
  /**
   * The card art image
   *
   * Takes optional input for image size and type
   */
  image?: Maybe<CardImage>;
  /** Contains additional details for INCENTIVE type instruments */
  incentiveDetails?: Maybe<Offer>;
  /**
   * Available installment options.
   * An Array of Installments types.
   */
  installments?: Maybe<Array<Maybe<Installments>>>;
  /**
   * The related institution images
   *
   * Takes optional input for image category, size, and type
   */
  institutionImages?: Maybe<Array<Maybe<InstitutionImage>>>;
  /** Provides additional context about the FI */
  instrumentContext?: Maybe<InstrumentContext>;
  /**
   * Funding instrument's sub type of it's `type`.
   * (EX: 'CREDIT', 'DEBIT', 'CHECKING', 'SAVINGS', `PPDC`).
   */
  instrumentSubType?: Maybe<FundingInstrumentSubType>;
  /** If a funding instrument is preferred by the user */
  isPreferred?: Maybe<Scalars['Boolean']>;
  /** If a funding option is a stcky FI */
  isSticky?: Maybe<Scalars['Boolean']>;
  /**
   * Funding instrument's issuer product description. This is the card issuer's product and brand information. For Example, Chase Sapphire Reserve.
   * @deprecated Replaced by `nameDescription`. `nameDescription` returns `issuerProductDescription` when fi nickname is not present.
   */
  issuerProductDescription?: Maybe<Scalars['String']>;
  /**
   * Funding instrument's mapped name. This can be used as a display name. Currently
   * does not use localization.
   * (Ex: 'BILL_ME_LATER' -> 'PayPal Credit', label: disallowedToallowedMap[name] || name)
   */
  label?: Maybe<Scalars['String']>;
  /** Funding instrument's last 4 digits (Ex: '3071') */
  lastDigits?: Maybe<Scalars['String']>;
  /**
   * Funding instrument's name. This is the raw response, and should be treated more
   * as a code, if the client wants to do some logic based on the specific name of
   * the instrument.
   * (Ex: 'BANK OF AMERICA')
   */
  name?: Maybe<Scalars['String']>;
  /**
   * Funding instrument's nickname to be displayed. If nickname doesn't exist, returns funding instrument's issuer product description which is the card issuer's product and brand information.
   * (Ex: 'My card acc' || 'Chase Sapphire Reserve' )
   */
  nameDescription?: Maybe<Scalars['String']>;
  /** Additional data required to display disclaimers for specific cards (Ex: 'COBRANDED') */
  payerDisclaimer?: Maybe<PayerDisclaimer>;
  /**
   * The rewards information for a specific card. Rewards can be in the form of points or miles, etc and can be used to fund all or part of the transaction.
   *
   * The rewards info contains:
   * - how many rewards are available for use
   * - what the conversion is from rewards to amount
   * - any constraints such as limits
   */
  rewards?: Maybe<Rewards>;
  /**
   * Funding option's sub type (Ex: 'IACH')
   * @deprecated Subtype as in IACH/DELAYED should be read from `FundingSource.subType`. Subtype as in DEBIT/CREDIT/SAVINGS/CHECKING should be read from `instrumentSubType`.
   */
  subType?: Maybe<FundingOptionSubType>;
  /** For tokenized cards, the source of where the tokenized card comes from */
  tokenSource?: Maybe<PaymentTokenSource>;
  /** Funding instrument's type (Ex: 'BANK') */
  type?: Maybe<FundingOptionType>;
};


/**
 * Encapsulates all properties related to a FundingInstrument.
 * Ex: name, type, lastDigits, amount, etc.
 */
export type FundingInstrumentImageArgs = {
  size?: InputMaybe<SquareImageSize>;
  type?: InputMaybe<ImageType>;
};


/**
 * Encapsulates all properties related to a FundingInstrument.
 * Ex: name, type, lastDigits, amount, etc.
 */
export type FundingInstrumentInstitutionImagesArgs = {
  category?: InputMaybe<InstitutionCategory>;
  size?: InputMaybe<SquareImageSize>;
  type?: InputMaybe<ImageType>;
};

/** The fiancing properties of selcted funding source */
export type FundingInstrumentFinancingInput = {
  /** Identifier of the financing option assocaited to the funding instrument */
  financingCode?: InputMaybe<Scalars['String']>;
  /** Funding instrument's ID (Ex: 'BA8JUE35JC6JBU4') */
  id?: InputMaybe<Scalars['ID']>;
};

/** Delivery Method of Funding Instrument */
export enum FundingInstrumentMethodType {
  /**
   * Delayed transfer, also known as PAD. Applies to banks. Funding instrument will
   * be charged after the products are delivered.
   */
  Delayed = 'DELAYED',
  /**
   * E-check. Applies to banks. The amount charged may show up on the funding instrument
   * a few days after the transaction is completed on PayPal's side.
   */
  Echeck = 'ECHECK',
  /** Instant transfer. Funding instrument will be charged immediately. */
  Instant = 'INSTANT',
  /**
   * Manual transfer. User should be given information to bring to the bank token
   * fulfill the payment.
   *
   * This should be a deprecated funding method type - we should not be seeing third_party_response
   * anymore.
   */
  Manual = 'MANUAL'
}

/** Subtype of Funding Instrument (more descriptive than FundingInstrumentType) */
export enum FundingInstrumentSubType {
  /** PayPal Balance */
  Balance = 'BALANCE',
  /** Checking account (Bank) */
  Checking = 'CHECKING',
  /** Credit Card */
  Credit = 'CREDIT',
  /** Cryptocurrency */
  Cryptocurrency = 'CRYPTOCURRENCY',
  /** Debit Card */
  Debit = 'DEBIT',
  /** Honey gold */
  HoneyGold = 'HONEY_GOLD',
  /** Incentive */
  Incentive = 'INCENTIVE',
  /** Merchant Card/Balance */
  Merchant = 'MERCHANT',
  /** Merchant Specific Incentive */
  MerchantSpecificBalance = 'MERCHANT_SPECIFIC_BALANCE',
  /** PayPal Credit */
  Paypal = 'PAYPAL',
  /** PayPal Specific Incentive */
  PaypalSpecificBalance = 'PAYPAL_SPECIFIC_BALANCE',
  /** PayPal Debit Card */
  Ppdc = 'PPDC',
  /** Prepaid Card */
  Prepaid = 'PREPAID',
  /** Savings account (Bank) */
  Savings = 'SAVINGS',
  /** Unknown */
  Unknown = 'UNKNOWN'
}

/** Type of funding instrument */
export enum FundingInstrumentType {
  /** PayPal Balance */
  Balance = 'BALANCE',
  /** Bank */
  Bank = 'BANK',
  /** Credit card */
  Card = 'CARD',
  /** PayPal Credit */
  Credit = 'CREDIT',
  /** Incentive */
  Incentive = 'INCENTIVE',
  /** Standalone reward */
  StandaloneRewards = 'STANDALONE_REWARDS'
}

/**
 * A funding option encompasses a `fundingInstrument` that can be used to fully
 * cover the transaction, and the different `plans` that use that funding instrument.
 *
 * For details of the funding instrument, like name and lastDigits, query the
 * `fundingInstrument` field.
 *
 * For details of the options for how the funding instrument can be charged, query
 * the `allPlans` field.
 *
 * For more docs on this, refer to docs/samples/FundingOptions.md
 */
export type FundingOption = {
  __typename?: 'FundingOption';
  /**
   * Plans that are associated with the funding instrument of this funding option.
   * Each plan is a different option that can be used with the funding instruments
   * in order to pay with the transaction.  Each of the plans will contain the
   * funding instrument as a funding source, but may also include other funding
   * sources with different funding instruments as well.
   */
  allPlans?: Maybe<Array<Maybe<Plan>>>;
  /**
   * Funding option's amount.
   * @deprecated FundingOption is being repurposed into a container for a FundingInstrument
   * and Plans. Amount can change depending on the plan and source used - look
   * at `allPlans.fundingSources.amount` to find the amount charged for each
   * funding source.
   */
  amount?: Maybe<Amount>;
  /** Available amount of the funding option (currently only applies to PAYPAL_BALANCE) */
  availableAmount?: Maybe<Amount>;
  /**
   * Funding option's currency conversion information
   * @deprecated FundingOption is being repurposed into a container for a FundingInstrument
   * and Plans. Currency conversion can be found at `allPlans.currencyConversion`.
   */
  currencyConversion?: Maybe<CheckoutCurrencyConversion>;
  /**
   * Funding option's formatted type (Ex: 'Bank')
   * @deprecated FundingOption is being repurposed into a container for a FundingInstrument and Plans. Look in `fundingInstrument` for this field.
   */
  formattedType?: Maybe<Scalars['String']>;
  /**
   * The funding option's funding instrument. All plans of this `FundingOption`
   * are based on this funding instrument.
   */
  fundingInstrument: FundingInstrument;
  /**
   * Funding option's ID (Ex: 'BA8JUE35JC6JBU4')
   * @deprecated FundingOption is being repurposed into a container for a FundingInstrument and Plans. Look in `fundingInstrument` for this field.
   */
  fundingOptionId?: Maybe<Scalars['String']>;
  /** The ID of the funding option's `fundingInstrument`. */
  id?: Maybe<Scalars['ID']>;
  /**
   * If a funding option is preferred by the user
   * @deprecated FundingOption is being repurposed into a container for a FundingInstrument and Plans. Look in `fundingInstrument` for this field.
   */
  isPreferred?: Maybe<Scalars['Boolean']>;
  /**
   * If a funding option is selected by the user
   * @deprecated FundingOption is being repurposed into a container for a FundingInstrument
   * and Plans. Look in `allPlans` for this field, to see which plan is selected.
   */
  isSelected?: Maybe<Scalars['Boolean']>;
  /**
   * Funding option's mapped name (Ex: 'BILL_ME_LATER' -> 'PayPal Credit', label: disallowedToallowedMap[name] || name)
   * @deprecated FundingOption is being repurposed into a container for a FundingInstrument and Plans. Look in `fundingInstrument` for this field.
   */
  label?: Maybe<Scalars['String']>;
  /**
   * Funding option's last 4 digits (Ex: '3071')
   * @deprecated FundingOption is being repurposed into a container for a FundingInstrument and Plans. Look in `fundingInstrument` for this field.
   */
  lastDigits?: Maybe<Scalars['String']>;
  /**
   * Funding option's name (Ex: 'BANK OF AMERICA')
   * @deprecated FundingOption is being repurposed into a container for a FundingInstrument and Plans. Look in `fundingInstrument` for this field.
   */
  name?: Maybe<Scalars['String']>;
  /**
   * Funding option's associated plans
   * @deprecated Migrating this data into allPlans, because return type changed to array of Plans.
   */
  plans?: Maybe<PlanTypes>;
  /**
   * Funding option's sub type (Ex: 'IACH')
   * @deprecated FundingOption is being repurposed into a container for a FundingInstrument and Plans. Look in `fundingInstrument` for this field.
   */
  subType?: Maybe<FundingOptionSubType>;
  /**
   * Funding option's type (Ex: 'BANK')
   * @deprecated FundingOption is being repurposed into a container for a FundingInstrument and Plans. Look in `fundingInstrument` for this field.
   */
  type?: Maybe<FundingOptionType>;
};

/** Instrument types that can be grouped */
export enum FundingOptionGroupingType {
  /** Incentive */
  Incentive = 'INCENTIVE'
}

/**
 * An enumeration of subtypes that FundingOption can have.
 * DELAYED_TRANSFER, ECHECK, INSTANT_TRANSFER or MANUAL_BANK_TRANSFER
 */
export enum FundingOptionSubType {
  /** Credit Card */
  Credit = 'CREDIT',
  /** Delayed Transfer, also known as Pay After Delivery (PAD). */
  DelayedTransfer = 'DELAYED_TRANSFER',
  /** E-Check */
  Echeck = 'ECHECK',
  /** Instant Transfer, also known as IACH. */
  InstantTransfer = 'INSTANT_TRANSFER',
  /** Manual Bank Transfer, also known as MEFT. */
  ManualBankTransfer = 'MANUAL_BANK_TRANSFER'
}

/**
 * An enumeration of types that FundingOption can have.
 * BANK_ACCOUNT, CREDIT_CARD, PAYPAL_BALANCE, PAYPAL_CREDIT, etc.
 */
export enum FundingOptionType {
  /** Bank Account */
  BankAccount = 'BANK_ACCOUNT',
  /** Bill Me Later */
  BillMeLater = 'BILL_ME_LATER',
  /** Credit Card */
  CreditCard = 'CREDIT_CARD',
  /** Cryptocurrency */
  Cryptocurrency = 'CRYPTOCURRENCY',
  /** Debit Card */
  DebitCard = 'DEBIT_CARD',
  /** Incentive */
  Incentive = 'INCENTIVE',
  /** PayPal Balance */
  PaypalBalance = 'PAYPAL_BALANCE',
  /** PayPal Credit */
  PaypalCredit = 'PAYPAL_CREDIT',
  /** Pay Later */
  PayLater = 'PAY_LATER',
  /** Pay_Token */
  PayToken = 'PAY_TOKEN',
  /** Private Label Credit Card */
  PrivateLabelCreditCard = 'PRIVATE_LABEL_CREDIT_CARD',
  /** Rewards */
  Rewards = 'REWARDS',
  /** Standalone reward */
  StandaloneRewards = 'STANDALONE_REWARDS'
}

/** Container type for funding product eligibility */
export type FundingProductEligibility = {
  __typename?: 'FundingProductEligibility';
  /** Whether or not a user is eligible for a funding product */
  eligible?: Maybe<Scalars['Boolean']>;
  /** Reasons why a funding product is eligible. This is an internal field and is not accessible for external use */
  reasons?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Used to determine the localization source of a funding product */
  variant?: Maybe<Scalars['String']>;
};

/** Container type for a funding source's child product eligibility */
export type FundingProductsEligibility = {
  __typename?: 'FundingProductsEligibility';
  /** Credit */
  credit: FundingProductEligibility;
  /** EZ Pay */
  ezpay: FundingProductEligibility;
  /** Pay After Delivery */
  pad: FundingProductEligibility;
  /** Pay In 3 */
  payIn3: FundingProductEligibility;
  /** Pay In 4 */
  payIn4: FundingProductEligibility;
  /** Pay Later */
  paylater: FundingProductEligibility;
};

/**
 * A source used in payment. Contains `fundingInstrument`, and information on how
 * the funding instrument will be charged in the payment like the amount charged to
 * the it, currency conversion used by the instrument, or rewards information used
 * by the instrument.
 */
export type FundingSource = {
  __typename?: 'FundingSource';
  /** The amount that will be charged to the instrument associated with this funding source */
  amount?: Maybe<Amount>;
  /** Scheduled date of withdrawal. Example: DELAYED (PAD) bank account */
  delayedPaymentDate?: Maybe<GenericDate>;
  /** The funding instrument that will be used */
  fundingInstrument?: Maybe<FundingInstrument>;
  /** The method of how the funding instrument will be charged when this funding source is used */
  fundingMethodType: FundingInstrumentMethodType;
  /** Array of individual funding sources in case of incentives */
  groupedSources?: Maybe<Array<Maybe<FundingSource>>>;
  /** Incentives and their max discount and percent off */
  incentives?: Maybe<Offer>;
};

/** Pre-selected funding source type provided by the merchant */
export enum FundingSourceType {
  /** Bill Me Later (aka PayPal Credit) */
  Bml = 'BML'
}

/** Encapsulates all properties related to a GDPR banner for client rendering */
export type GdprBanner = {
  __typename?: 'GdprBanner';
  /** A string of CSS properties */
  css: Scalars['String'];
  /** A string of HTML properties */
  html: Scalars['String'];
  /** A string of JavaScript properties */
  js: Scalars['String'];
};

/** An enumeration of the gender of a user. This is based off of the ISO/IEC5218 standard. */
export enum Gender {
  /** Female */
  Female = 'FEMALE',
  /** Male */
  Male = 'MALE',
  /** Not applicable */
  NotApplicable = 'NOT_APPLICABLE',
  /** Not known */
  NotKnown = 'NOT_KNOWN'
}

/**
 * Encapsulates all properties related to a generic address.
 * Ex: line1, city, state, postalCode, fullAddress, isDefaultBilling, etc.
 */
export type GenericAddress = Address & {
  __typename?: 'GenericAddress';
  /** Portable address: An address first line street address */
  addressLine1?: Maybe<Scalars['String']>;
  /** Portable address: An address second line street address */
  addressLine2?: Maybe<Scalars['String']>;
  /** Portable address: An address third line street address */
  addressLine3?: Maybe<Scalars['String']>;
  /** Portable address: An address first line admin area */
  adminArea1?: Maybe<Scalars['String']>;
  /** Portable address: An address second line admin area */
  adminArea2?: Maybe<Scalars['String']>;
  /** Portable address: An address third line admin area */
  adminArea3?: Maybe<Scalars['String']>;
  /** Portable address: An address forth line admin area */
  adminArea4?: Maybe<Scalars['String']>;
  /**
   * An Address city (Ex: 'San Jose')
   * @deprecated Coarse format addresses are being phased out for portable format addresses. Use adminArea2 instead for portable format.
   */
  city?: Maybe<Scalars['String']>;
  /**
   * An Address two-letter country code (Ex: 'US')
   * @deprecated Coarse format addresses are being phased out for portable format addresses. Use countryCode instead
   */
  country?: Maybe<Scalars['String']>;
  /** Portable address: An address two-letter country code */
  countryCode?: Maybe<Scalars['String']>;
  /** An Address on a single line (Ex: '2211 North 1st St, Apt 123, San Jose, CA 95131') */
  fullAddress?: Maybe<Scalars['String']>;
  /**
   * An Address first line street address (Ex: '2211 North 1st St')
   * @deprecated Coarse format addresses are being phased out for portable format addresses. Use addressLine1 instead for portable format.
   */
  line1?: Maybe<Scalars['String']>;
  /**
   * An Address second line street address (Ex: 'Apt 123')
   * @deprecated Coarse format addresses are being phased out for portable format addresses. Use addressLine2 instead for portable format.
   */
  line2?: Maybe<Scalars['String']>;
  /** An Address postal code (Ex: '95131') */
  postalCode?: Maybe<Scalars['String']>;
  /**
   * An Address state/province (Ex: 'CA')
   * @deprecated Coarse format addresses are being phased out for portable format addresses. Use adminArea1 instead for portable format.
   */
  state?: Maybe<Scalars['String']>;
};

/** Encapsulates many ways that a date can be formatted. Ex: E, Hm, Ms, etc. */
export type GenericDate = {
  __typename?: 'GenericDate';
  /** Fri */
  E?: Maybe<Scalars['String']>;
  /** Fri 14:10 */
  EHm?: Maybe<Scalars['String']>;
  /** Fri 14:10:10 */
  EHms?: Maybe<Scalars['String']>;
  /** 21 Fri */
  Ed?: Maybe<Scalars['String']>;
  /** Fri 2:10 PM */
  Ehm?: Maybe<Scalars['String']>;
  /** Fri 2:10:10 PM */
  Ehms?: Maybe<Scalars['String']>;
  /** 2014 AD */
  Gy?: Maybe<Scalars['String']>;
  /** Mar 2014 AD */
  GyMMM?: Maybe<Scalars['String']>;
  /** Fri, 21 Mar 2014 AD */
  GyMMMEd?: Maybe<Scalars['String']>;
  /** Mar 21, 2014 AD */
  GyMMMd?: Maybe<Scalars['String']>;
  /** 14 */
  H?: Maybe<Scalars['String']>;
  /** 14:10 */
  Hm?: Maybe<Scalars['String']>;
  /** 14:10:10 */
  Hms?: Maybe<Scalars['String']>;
  /** 3 */
  M?: Maybe<Scalars['String']>;
  /** Fri, 3/21 */
  MEd?: Maybe<Scalars['String']>;
  /** Mar */
  MMM?: Maybe<Scalars['String']>;
  /** Fri, Mar 21 */
  MMMEd?: Maybe<Scalars['String']>;
  /** March 21 */
  MMMMd?: Maybe<Scalars['String']>;
  /** March 21 */
  MMMMdd?: Maybe<Scalars['String']>;
  /** Mar 21 */
  MMMd?: Maybe<Scalars['String']>;
  /** Mar 21 */
  MMMdd?: Maybe<Scalars['String']>;
  /** 3/21 */
  Md?: Maybe<Scalars['String']>;
  /** 21 */
  d?: Maybe<Scalars['String']>;
  /** Thursday, September 28, 2017 */
  dateFull?: Maybe<Scalars['String']>;
  /** Thursday, September 28, 2017 at 5:32:00 PM */
  dateFullTimeMedium?: Maybe<Scalars['String']>;
  /** Thursday, September 28, 2017 at 5:32 PM */
  dateFullTimeShort?: Maybe<Scalars['String']>;
  /** September 28, 2017 */
  dateLong?: Maybe<Scalars['String']>;
  /** September 28, 2017 at 5:32 PM */
  dateLongTimeShort?: Maybe<Scalars['String']>;
  /** Sep 28, 2017 */
  dateMedium?: Maybe<Scalars['String']>;
  /** 9/28/17 */
  dateShort?: Maybe<Scalars['String']>;
  /** Thursday, September 28, 2017 at 5:32:00 PM Pacific Daylight Time */
  dateTimeFull?: Maybe<Scalars['String']>;
  /** September 28, 2017 at 5:32:00 PM PDT */
  dateTimeLong?: Maybe<Scalars['String']>;
  /** Sep 28, 2017, 5:32:00 PM */
  dateTimeMedium?: Maybe<Scalars['String']>;
  /** 9/28/17, 5:32 PM */
  dateTimeShort?: Maybe<Scalars['String']>;
  /** 2 PM */
  h?: Maybe<Scalars['String']>;
  /** 2:10 PM */
  hm?: Maybe<Scalars['String']>;
  /** 2:10:10 PM */
  hms?: Maybe<Scalars['String']>;
  /** 10:10 */
  ms?: Maybe<Scalars['String']>;
  /** 5:32:00 PM Pacific Daylight Time */
  timeFull?: Maybe<Scalars['String']>;
  /** 5:32:00 PM PDT */
  timeLong?: Maybe<Scalars['String']>;
  /** 5:32:00 PM */
  timeMedium?: Maybe<Scalars['String']>;
  /** 5:32 PM */
  timeShort?: Maybe<Scalars['String']>;
  /** 2014 */
  y?: Maybe<Scalars['String']>;
  /** 3/2014 */
  yM?: Maybe<Scalars['String']>;
  /** Fri, 3/21/2014 */
  yMEd?: Maybe<Scalars['String']>;
  /** 03/2014 */
  yMM?: Maybe<Scalars['String']>;
  /** Mar 2014 */
  yMMM?: Maybe<Scalars['String']>;
  /** Fri, Mar 21, 2014 */
  yMMMEd?: Maybe<Scalars['String']>;
  /** Mar 21, 2014 */
  yMMMd?: Maybe<Scalars['String']>;
  /** 03/21/2014 */
  yMMdd?: Maybe<Scalars['String']>;
  /** 3/21/2014 */
  yMd?: Maybe<Scalars['String']>;
  /** Q1 2014 */
  yQQQ?: Maybe<Scalars['String']>;
  /** 1st quarter 2014 */
  yQQQQ?: Maybe<Scalars['String']>;
  /** March 2014 */
  yyyyMMMM?: Maybe<Scalars['String']>;
};

/** Encapsulates all properties related to a generic image. */
export type GenericImage = Image & {
  __typename?: 'GenericImage';
  /** An image's height in pixels (number value only) */
  height?: Maybe<Scalars['String']>;
  /** An image's URL. A URL type. */
  url?: Maybe<GenericUrl>;
  /** An image's width in pixels (number value only) */
  width?: Maybe<Scalars['String']>;
};

/** Encapsulates all properties related to a locale. GenericLocale should be used for most use cases. CheckoutLocale should be used for Checkout specific use cases. Ex: country, language, directionality, etc. */
export type GenericLocale = Locale & {
  __typename?: 'GenericLocale';
  /** A locale's country (Ex: 'US') */
  country?: Maybe<Scalars['String']>;
  /** A locale's culture (Ex: 'en-US') */
  culture?: Maybe<Scalars['String']>;
  /** A locale's directionality (Ex: 'ltr') */
  directionality?: Maybe<Directionality>;
  /** A locale's language (Ex: 'en') */
  language?: Maybe<Scalars['String']>;
  /** A locale's locale (Ex: 'en_US') */
  locale?: Maybe<Scalars['String']>;
};

/**
 * Encapsulates all properties related to a generic phone number.
 * Ex: countryCode, nationalNumber, type, national, international, etc.
 */
export type GenericPhone = {
  __typename?: 'GenericPhone';
  /** A country code associated with a phone number (Ex: '1') */
  countryCode?: Maybe<Scalars['String']>;
  /** An E164 representation of a phone number (Ex: '+12015550123') */
  e164?: Maybe<Scalars['String']>;
  /** An international representation of a phone number (Ex: '+1 201-555-0123') */
  international?: Maybe<Scalars['String']>;
  /** Whether or not a phone is marked as active */
  isActive?: Maybe<Scalars['Boolean']>;
  /** Whether or not a phone is marked as primary */
  isPrimary?: Maybe<Scalars['Boolean']>;
  /** A national representation of a phone number (Ex: '(201) 555-0123') */
  national?: Maybe<Scalars['String']>;
  /** A national (obscured) representation of a phone number (Ex: '(2**) ***-0123') */
  nationalObscured?: Maybe<Scalars['String']>;
  /** An unformatted phone number (Ex: '2015550123') */
  number?: Maybe<Scalars['String']>;
  /** An RFC3966 representation of a phone number (Ex: 'tel:+1-201-555-0123') */
  rfc3966?: Maybe<Scalars['String']>;
  /** Type of phone (Ex: 'MOBILE').  See PhoneType enum. */
  type?: Maybe<PhoneType>;
};

/**
 * Encapsulates all properties related to a URL.
 * Ex: protocol, host, port, hostname, query, href, etc.
 * See https://nodejs.org/api/url.html#url_class_url for more details.
 */
export type GenericUrl = Url & {
  __typename?: 'GenericURL';
  /** Username/password portion of the URL (Ex: user:pass) */
  auth?: Maybe<Scalars['String']>;
  /** Fragment portion of the URL including the leading ASCII hash (#) character. (Ex: #hash) */
  hash?: Maybe<Scalars['String']>;
  /** Full lower-cased host portion of the URL (Ex: google.com:8000) */
  host?: Maybe<Scalars['String']>;
  /** Hostname portion of the URL.  Does not contain a port. (Ex: google.com) */
  hostname?: Maybe<Scalars['String']>;
  /** The serialized, full URL with all properties included. (Ex: https://google.com/path?key=value#hash) */
  href?: Maybe<Scalars['String']>;
  /** Path portion of the URL which includes the query string. (Ex: /path?key=value) */
  path?: Maybe<Scalars['String']>;
  /** Path portion of the URL, but does not include the query string. (Ex: /path) */
  pathname?: Maybe<Scalars['String']>;
  /** Numeric port portion of the URL (Ex: 8000) */
  port?: Maybe<Scalars['String']>;
  /** Protocol property of the URL (Ex: https:) */
  protocol?: Maybe<Scalars['String']>;
  /** Query string of the URL.  Does not include the leading question mark (?) character. (Ex: key=value) */
  query?: Maybe<Scalars['String']>;
  /** Query params of the URL, as an Object */
  queryParams?: Maybe<Scalars['JSON']>;
  /** Search property consists of the entire 'query string' portion of the URL, including the leading ASCII question mark (?) character. (Ex: ?key=value) */
  search?: Maybe<Scalars['String']>;
  /** If true, two forward slashes are required following the colon in the protocol */
  slashes?: Maybe<Scalars['Boolean']>;
};

/**
 * GAAC - Google Address Auto Complete
 * Address fields is the type of field we are expecting google places
 * API to return with every place_id we send in the request
 * This is not all the available options. Refer to google places API
 * documentation if you want to enable more fields
 */
export enum GoogleAddressFields {
  /** mostly line1 line2 city state postal_code and country is returned in response */
  AddressComponent = 'ADDRESS_COMPONENT',
  /** html formatted address */
  AdrAddress = 'ADR_ADDRESS',
  /** comma separated full address text */
  FormattedAddress = 'FORMATTED_ADDRESS'
}

/**
 * An enumeration of all potential allowed auth methods for Card Transactions
 * https://developers.google.com/pay/api/web/reference/request-objects#CardParameters
 */
export enum GooglePayAuthMethods {
  /** Cryptogram 3DS */
  Cryptogram_3Ds = 'CRYPTOGRAM_3DS',
  /** Pan Only */
  PanOnly = 'PAN_ONLY'
}

/**
 * Billing Address Parameters
 *
 * Reference: https://developers.google.com/pay/api/web/reference/request-objects#BillingAddressParameters
 */
export type GooglePayBillingAddressParams = {
  __typename?: 'GooglePayBillingAddressParams';
  /** Format */
  format?: Maybe<Scalars['String']>;
  /** Is Phone Number Required */
  phoneNumberRequired?: Maybe<Scalars['Boolean']>;
};

/**
 * Card Parameters
 * Reference: https://developers.google.com/pay/api/web/reference/request-objects#CardParameters
 */
export type GooglePayCardParams = {
  __typename?: 'GooglePayCardParams';
  /** Allow Credit Cards */
  allowCreditCards?: Maybe<Scalars['Boolean']>;
  /** Allow Prepaid Cards */
  allowPrepaidCards?: Maybe<Scalars['Boolean']>;
  /** Allowed Auth Methods */
  allowedAuthMethods: Array<GooglePayAuthMethods>;
  /** Allowed Card Networks */
  allowedCardNetworks: Array<Scalars['String']>;
  /** Assurance Details Required */
  assuranceDetailsRequired?: Maybe<Scalars['Boolean']>;
  /** Billing Address Parameters */
  billingAddressParameters?: Maybe<GooglePayBillingAddressParams>;
  /** Billing Address Required */
  billingAddressRequired?: Maybe<Scalars['Boolean']>;
};

/**
 * GooglePay config data
 * For GooglePay requests
 * Reference: https://developers.google.com/pay/api/web/reference/request-objects#PaymentDataRequest
 */
export type GooglePayConfig = {
  __typename?: 'GooglePayConfig';
  /** Allowed Payment Methods */
  allowedPaymentMethods?: Maybe<Array<GooglePayPaymentMethod>>;
  /** Major version of Google API that PayPal API Supports */
  apiVersion?: Maybe<Scalars['Int']>;
  /** Minor version of Google API that PayPal API supports */
  apiVersionMinor?: Maybe<Scalars['Int']>;
  /** Merchant Country */
  countryCode?: Maybe<Scalars['String']>;
  /** Specifies if the Merchant is Eligible to Accept GooglePay Payments */
  isEligible: Scalars['Boolean'];
  /** Merchant Information */
  merchantInfo?: Maybe<GooglePayMerchantInfo>;
};

/** Gateway Parameters */
export type GooglePayGatewayParams = {
  __typename?: 'GooglePayGatewayParams';
  /** Gateway */
  gateway: Scalars['String'];
  /** Gateway Merchant ID */
  gatewayMerchantId: Scalars['String'];
};

/**
 * Merchant Information
 * Reference: https://developers.google.com/pay/api/web/reference/request-objects#MerchantInfo
 */
export type GooglePayMerchantInfo = {
  __typename?: 'GooglePayMerchantInfo';
  /** Auth JWT */
  authJwt: Scalars['String'];
  /** Merchant ID */
  merchantId: Scalars['String'];
  /** Merchant Name */
  merchantName?: Maybe<Scalars['String']>;
  /** Merchant Origin */
  merchantOrigin: Scalars['String'];
};

/**
 * Schema for Google Pay contact
 * https://developers.google.com/pay/api/web/reference/response-objects#Address
 */
export type GooglePayPaymentContact = {
  /** The first line of the address. */
  address1?: InputMaybe<Scalars['String']>;
  /** The second line of the address. */
  address2?: InputMaybe<Scalars['String']>;
  /** The third line of the address. */
  address3?: InputMaybe<Scalars['String']>;
  /** A country subdivision, such as a state or province. */
  administrativeArea?: InputMaybe<Scalars['String']>;
  /** ISO 3166-1 alpha-2 country code. */
  countryCode?: InputMaybe<Scalars['String']>;
  /** City, town, neighborhood, or suburb. */
  locality?: InputMaybe<Scalars['String']>;
  /** The full name of the addressee. */
  name?: InputMaybe<Scalars['String']>;
  /** A telephone number, if phoneNumberRequired is set to true in the PaymentDataRequest. */
  phoneNumber?: InputMaybe<Scalars['String']>;
  /** The postal or ZIP code. */
  postalCode?: InputMaybe<Scalars['String']>;
  /** The sorting code. */
  sortingCode?: InputMaybe<Scalars['String']>;
};

/**
 * Payment Method Information
 * type - Requires a type as a String
 * Reference: https://developers.google.com/pay/api/web/reference/request-objects#PaymentMethod
 */
export type GooglePayPaymentMethod = {
  __typename?: 'GooglePayPaymentMethod';
  /** Card Parameters */
  parameters: GooglePayCardParams;
  /** Tokenization Specification */
  tokenizationSpecification: GooglePayTokenizationSpecification;
  /** Payment Method Type */
  type: Scalars['String'];
};

/**
 * Google Pay Payment Method Data
 * See: https://developers.google.com/pay/api/web/reference/response-objects#PaymentMethodData
 */
export type GooglePayPaymentMethodData = {
  /** Description: User-facing message to describe the payment method that funds this transaction. */
  description?: InputMaybe<Scalars['String']>;
  /** Info: The value of this property depends on the payment method type returned. For CARD will be CardInfo. */
  info?: InputMaybe<GooglePayPaymentMethodDataInfo>;
  /** Tokenization Data: Payment tokenization data for the selected payment method. */
  tokenizationData?: InputMaybe<GooglePayTokenizationData>;
  /** Type: PaymentMethod type selected in the Google Pay payment sheet. */
  type?: InputMaybe<Scalars['String']>;
};

/**
 * Google Pay Payment Method Data > Info
 * The value of the info property depends on the payment method type returned. For CARD type the value will be CardInfo.
 * https://developers.google.com/pay/api/web/reference/response-objects#CardInfo
 */
export type GooglePayPaymentMethodDataInfo = {
  /** Assurance Details: This object provides information about the validation performed on the returned payment data if assuranceDetailsRequired is set to true in the CardParameters. */
  assuranceDetails?: InputMaybe<Scalars['JSON']>;
  /** Billing Address: The billing address associated with the provided payment method, if billingAddressRequired is set to true in CardParameters. */
  billingAddress?: InputMaybe<GooglePayPaymentContact>;
  /** Card Details: The details about the card. This value is commonly the last four digits of the selected payment account number. */
  cardDetails?: InputMaybe<Scalars['String']>;
  /** Card Funding Source: The funding source of the card for the selected payment. */
  cardFundingSource?: InputMaybe<Scalars['String']>;
  /** Card Network: The payment card network of the selected payment. */
  cardNetwork?: InputMaybe<Scalars['String']>;
};

/**
 * Google Pay Payment Tokenization Data
 * See: https://developers.google.com/pay/api/web/reference/response-objects#PaymentMethodTokenizationData
 */
export type GooglePayTokenizationData = {
  /** Tokenization Data: Payment tokenization data for the selected payment method. */
  token?: InputMaybe<Scalars['String']>;
  /** The type of tokenization to be applied to the selected payment method. This value matches the type set in PaymentMethodTokenizationSpecification. */
  type?: InputMaybe<Scalars['String']>;
};

/**
 * TokenizationSpecification Parameters
 * Reference: https://developers.google.com/pay/api/web/reference/request-objects#PaymentMethodTokenizationSpecification
 */
export type GooglePayTokenizationSpecification = {
  __typename?: 'GooglePayTokenizationSpecification';
  /** Gateway Parameters */
  parameters: GooglePayGatewayParams;
  /** Tokenization Type */
  type: Scalars['String'];
};

/**
 * GAAC - Google Address Auto Complete
 * Place type is the search criteria for google places API
 * Mostly for PayPal usecase it will be 'address' type
 */
export enum GooglePlacesType {
  /** search by precise address */
  Address = 'ADDRESS',
  /** search by locality or administrative_area_level_3 */
  Cities = 'CITIES',
  /** search by business establishment */
  Establishment = 'ESTABLISHMENT',
  /** search places which may not be precise address or establishment */
  Geocode = 'GEOCODE',
  /** search by city postal_code country and few more address fields */
  Regions = 'REGIONS'
}

/** A container for Griffin Formatted Addresses */
export type GriffinFormattedAddresses = {
  __typename?: 'GriffinFormattedAddresses';
  /** The normalized address returned by ANS */
  formattedNormalizedAddress?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The address entered by the user */
  formattedOriginalAddress?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Address input type for guest flow */
export type GuestAddressInput = {
  /** Portable address: An address first line admin area (Ex: 'CA'), corresponds to state */
  adminArea1?: InputMaybe<Scalars['String']>;
  /** Portable address: An address second line admin area (Ex: 'San Jose'), corresponds to city */
  adminArea2?: InputMaybe<Scalars['String']>;
  /** Portable address: An address two-letter country code (Ex: 'US'), corresponds to country */
  countryCode?: InputMaybe<Scalars['String']>;
  /** An Address postal code (Ex: '95131') */
  postalCode?: InputMaybe<Scalars['String']>;
};

/** Response wrapper for isGuestMemberBenefitsEligibleResolver. */
export type GuestMemberBenefits = {
  __typename?: 'GuestMemberBenefits';
  /** whether the data compared matches */
  isEligible?: Maybe<Scalars['Boolean']>;
};

/** "Fields that provide additional information about a Payer" */
export type GuestUserMetadata = {
  __typename?: 'GuestUserMetadata';
  /** "Whether a provided email address belongs to a User account" */
  emailHasExistingAccount: Scalars['Boolean'];
};

/** An enumeration of types that HTTPMethod can have. GET, POST, PUT, DELETE, etc. */
export enum HttpMethod {
  /** CONNECT */
  Connect = 'CONNECT',
  /** DELETE */
  Delete = 'DELETE',
  /** GET */
  Get = 'GET',
  /** HEAD */
  Head = 'HEAD',
  /** OPTIONS */
  Options = 'OPTIONS',
  /** PATCH */
  Patch = 'PATCH',
  /** POST */
  Post = 'POST',
  /** PUT */
  Put = 'PUT',
  /** REDIRECT */
  Redirect = 'REDIRECT'
}

/**
 * AuthProviderContext
 * IWC context - basically covers all context types
 * Eg: OTPLoginContext, PasskeyEnrollmentContext etc.
 */
export type IwcContext = {
  __typename?: 'IWCContext';
  /** Stringified context for IWC */
  context: Scalars['String'];
};

/** IdentityDocumentInput type represents an identification doc to be added to an account */
export type IdentityDocumentInput = {
  /** Issuer Country */
  issuerCountry?: InputMaybe<Scalars['String']>;
  /** The sub-type of id */
  subType?: InputMaybe<IdentityDocumentSubType>;
  /** The type of id */
  type: IdentityDocumentType;
  /** The value of the identity document. Ex(S1234567) */
  value: Scalars['String'];
};

/**
 * An enumeration of subtypes that a TAX_IDENTIFICATION_NUMBER Type can be.
 * SSN,ITIN, etc.al
 */
export enum IdentityDocumentSubType {
  /** Individual Taxpayer Identification Number */
  Itin = 'ITIN',
  /** Default for no subtype */
  None = 'NONE',
  /** Social Security Number */
  Ssn = 'SSN',
  /** Taxpayer Identification Number */
  Tin = 'TIN'
}

/**
 * An enumeration of types that a Identification Type can be.
 * DRIVERS_LICENSE,NATIONAL_ID, etc.al
 */
export enum IdentityDocumentType {
  /** A CNPJ type of Identity Document (used in Brazil by Businesses) */
  Cnpj = 'CNPJ',
  /** A CPF type of Identity Document (used in Brazil) */
  Cpf = 'CPF',
  /** A drivers license type of Identity Document */
  DriversLicense = 'DRIVERS_LICENSE',
  /** A document issued to a party that is not a citizen of the country */
  ImmigrationId = 'IMMIGRATION_ID',
  /** A medical insurance id type of Identity Document (used as secondary ID in Russia) */
  MedicalInsuranceId = 'MEDICAL_INSURANCE_ID',
  /** A national id type of Identity Document */
  NationalId = 'NATIONAL_ID',
  /** A passport number type of Identity Document */
  PassportNumber = 'PASSPORT_NUMBER',
  /** A pension fund id type of Identity Document (used as secondary ID in Russia) */
  PensionFundId = 'PENSION_FUND_ID',
  /** A tax identification number type of Identity Document (used as secondary ID in Russia) */
  TaxIdentificationNumber = 'TAX_IDENTIFICATION_NUMBER',
  /** A temporary national id type of Identity Document */
  TemporaryNationalId = 'TEMPORARY_NATIONAL_ID'
}

/**
 * The Image interface encapsulates all properties related to an image.
 * Ex: url, width, height
 */
export type Image = {
  /** The height of the image */
  height?: Maybe<Scalars['String']>;
  /** An Image's URL. */
  url?: Maybe<GenericUrl>;
  /** The width of the image */
  width?: Maybe<Scalars['String']>;
};

/**
 * Type of image
 *
 * `jpg`, `png`, etc
 */
export enum ImageType {
  /** gif image */
  Gif = 'gif',
  /** jpg image */
  Jpg = 'jpg',
  /** png image */
  Png = 'png'
}

/** List of types that an Incentives can be. PERCENTAGE, FIXED */
export enum Incentives {
  /** Fixed, fixed amount of incentive */
  Fixed = 'FIXED',
  /** Percentage based incentive, has percent off */
  Percentage = 'PERCENTAGE'
}

/** Represents details for card-related ineligible payment methods, categorized by account types and brand constraints. */
export type IneligibleCardDetails = {
  __typename?: 'IneligibleCardDetails';
  /** A list of account types, each containing a product class and associated brand constraints. */
  accountTypes?: Maybe<Array<Maybe<AccountTypeDetails>>>;
};

/** Represents ineligible payment methods, including detailed information about card account types and brand-level constraints. */
export type IneligibleInstrumentTypes = {
  __typename?: 'IneligibleInstrumentTypes';
  /** Contains account types for card payments, such as CREDIT or DEBIT, and their associated ineligible brands. */
  card?: Maybe<IneligibleCardDetails>;
};

/** Encapsulates all properties related to the initial payment info provided for a subscription transaction */
export type InitialSubscriptionPaymentInfo = {
  __typename?: 'InitialSubscriptionPaymentInfo';
  /** The currency and amount of the first payment for the subscription transaction */
  firstPayment?: Maybe<Amount>;
  /** The currency and amount for the setup fee of the subscription transaction */
  setupFee?: Maybe<Amount>;
  /** The currency and amount for the shipping fee of the subscription transaction */
  shippingAmount?: Maybe<Amount>;
  /** The tax percentage of the subscription transaction */
  taxPercentage?: Maybe<Scalars['String']>;
  /** The currency and amount for the total fee of the subscription transaction */
  totalAmount?: Maybe<Amount>;
};

/** Encapsulates the status of initiate otp confirmation response. */
export type InitiateOtpConfirmationResponse = {
  __typename?: 'InitiateOtpConfirmationResponse';
  /** Overall Status of initiate otp call */
  status?: Maybe<Scalars['String']>;
};

/** Encapsulates all properties related to Inline Checkout eligibility. */
export type InlineCheckoutEligibility = {
  __typename?: 'InlineCheckoutEligibility';
  /** Boolean response conveying eligibility for this flow. */
  eligible: Scalars['Boolean'];
  /** Reasons for ineligibility in the case eligibility is false. */
  ineligibilityReason?: Maybe<Scalars['String']>;
};

/**
 * Encapsulates all data related to a Installment Details.
 * Ex: monthlyPayment, discountAmount, discountPercent, etc.
 */
export type InstallmentDetail = {
  __typename?: 'InstallmentDetail';
  /** Discount amount applied to the payment, if any */
  discountAmount?: Maybe<Amount>;
  /** Discount percentage applied to the payment, if any */
  discountPercent?: Maybe<Scalars['Float']>;
  /** Monthly payment value for current Installment term */
  monthlyPayment?: Maybe<Amount>;
};

/**
 * Encapsulates all properties related to installment related discounts.
 * Ex: currencySymbol, currencyValue, currencyCode, etc.
 */
export type InstallmentDiscount = {
  __typename?: 'InstallmentDiscount';
  /** Amount of discount */
  amount?: Maybe<Amount>;
  /** Amount of discount's percentage (Ex: '5.0') */
  percentage?: Maybe<Scalars['String']>;
};

/**
 * Encapsulates all data related to a Installment option.
 * Ex: term, monthly_payment, total, installmentDetail, etc.
 */
export type InstallmentOption = {
  __typename?: 'InstallmentOption';
  /** Formatted Value of Discount amount given for the current Installment term */
  formattedDiscountAmount?: Maybe<Scalars['String']>;
  /** Formatted Monthly payment value for current Installment term */
  formattedMonthlyPayment?: Maybe<Scalars['String']>;
  /** Formatted value of Purchase cost + total cost APR + total consumer fee (if any) */
  formattedTotalAmount?: Maybe<Scalars['String']>;
  /** Details for the current Installment term like discountAmount, discountPercent and monthlyPayment */
  installmentDetail?: Maybe<InstallmentDetail>;
  /** The term over which to finance the transaction */
  term?: Maybe<Scalars['Int']>;
};

/** Encapsulates all properties related to InstallmentSchedule. */
export type InstallmentSchedule = {
  __typename?: 'InstallmentSchedule';
  /** Consumer Fee for the transaction (Ex: '0,20 EUR') */
  consumerFee?: Maybe<Amount>;
  /** Interest amount on the transaction (Ex: '4,20 EUR') */
  interest?: Maybe<Amount>;
  /** Payment Date of the transaction (Ex: '27 nov.', '14 Mar') */
  paymentDate?: Maybe<Scalars['String']>;
  /** Order of the payment (Ex: 1 or 2 ..) */
  paymentNumber?: Maybe<Scalars['Int']>;
  /** Type of Payment (Ex: 'Down_Payment', 'INSTALLMENT') */
  paymentType?: Maybe<CreditPaymentType>;
  /** Principal amount of transaction (Ex: '204,20 EUR') */
  principal?: Maybe<Amount>;
  /** TotalPayment for the transaction including fee and interest  (Ex: '23,01 EUR') */
  totalPayment?: Maybe<Amount>;
};

/**
 * An enumeration of Installment Type.
 * SINGLE, MULTIPLE
 */
export enum InstallmentType {
  /** Multiple Installments terms */
  Multiple = 'MULTIPLE',
  /** Single Installment term */
  Single = 'SINGLE'
}

/**
 * Encapsulates all properties related to an individual payment installment option
 * Ex: term, totalCost, discountPercentage
 */
export type Installments = {
  __typename?: 'Installments';
  /** Option discount amount */
  discount?: Maybe<InstallmentDiscount>;
  /** Fee Reference Id */
  feeReferenceId?: Maybe<Scalars['String']>;
  /** Option interval duration for installment */
  intervalDuration?: Maybe<Scalars['String']>;
  /** Option monthly payment amount */
  monthlyPayment: Amount;
  /** Option term number (Ex: 3) */
  term: Scalars['Int'];
  /** Option total consumer amount for shared fee */
  totalConsumerFee?: Maybe<ConsumerInstallmentFee>;
  /** Option total cost amount */
  totalCost: Amount;
};

/**
 * Allows selecting an installment option for use when paying
 *
 * Used in the `approveMemberPayment` mutation.
 *
 * Example input (with discount):
 * ```
 * "installmentOption: {
 *   term: 1,
 *   paymentValue: '237.50',
 *   paymentCurrency: 'BRL',
 *   discountValue: '12.50',
 *   discountCurrency: 'BRL',
 *   discountPercentage: '5.0',
 *   totalCostValue: '237.50',
 *   totalCostCurrency: 'BRL',
 * };
 * ```
 *
 * Example input (without discount):
 * ```
 * "installmentOption": {
 *   term: 10,
 *   paymentValue: '25.00',
 *   paymentCurrency: 'BRL',
 *   totalCostValue: '250.00',
 *   totalCostCurrency: 'BRL',
 * };
 * ```
 */
export type InstallmentsInput = {
  /** Currency code for the merchant provided discount (Ex: 'BRL') */
  discountCurrency?: InputMaybe<Scalars['String']>;
  /** Merchant provided discount percentage for the selected installment term (Ex: '5.0') */
  discountPercentage?: InputMaybe<Scalars['String']>;
  /** Value of the merchant provided discount for the selected installment term (Ex: '12.50') */
  discountValue?: InputMaybe<Scalars['String']>;
  /** Fee Reference Id */
  feeReferenceId?: InputMaybe<Scalars['String']>;
  /** Monthly payment currency code for selected installment (Ex: 'BRL') */
  paymentCurrency: Scalars['String'];
  /** Monthly payment for the selected installment term (Ex: '25.00') */
  paymentValue: Scalars['String'];
  /** Installment term (Ex: 5) */
  term: Scalars['Int'];
  /** Currency code for the total cost of the purchase (Ex: 'BRL') */
  totalCostCurrency: Scalars['String'];
  /** Total cost of the purchase (Ex: 250.00) */
  totalCostValue: Scalars['String'];
};

/** Size of an image */
export enum InstitutionCategory {
  /** Image category for the FI brand */
  Brand = 'BRAND',
  /** Secondary image category for the FI brand */
  BrandSecondary = 'BRAND_SECONDARY',
  /** Image category for the institution partner */
  Partner = 'PARTNER',
  /** Image category for financial institution */
  Primary = 'PRIMARY',
  /** Image category for reward program */
  Reward = 'REWARD',
  /** Image category for thumbnail display */
  Thumbnail = 'THUMBNAIL',
  /** Image category for financial institution wallet */
  Wallet = 'WALLET'
}

/** Encapsulates all properties related to card institution images. */
export type InstitutionImage = Image & {
  __typename?: 'InstitutionImage';
  /** The image category (e.g. PARTNER, BRAND, REWARD, etc) */
  category?: Maybe<InstitutionCategory>;
  /** An image's height in pixels (number value only) */
  height?: Maybe<Scalars['String']>;
  /** An image mime type */
  type?: Maybe<Scalars['String']>;
  /** An image's URL. A URL type. */
  url?: Maybe<GenericUrl>;
  /** An image's width in pixels (number value only) */
  width?: Maybe<Scalars['String']>;
};

/** An enumeration of instrument classifications supported by PayPal */
export enum InstrumentClassification {
  /** Bank account */
  Bank = 'BANK',
  /** Co-branded credit card */
  CoBrandedCreditCard = 'CO_BRANDED_CREDIT_CARD',
  /** Credit card */
  CreditCard = 'CREDIT_CARD',
  /** Line of credit offered by PayPal */
  CreditLine = 'CREDIT_LINE',
  /** Debit card */
  DebitCard = 'DEBIT_CARD',
  /** External wallet account */
  ExternalWallet = 'EXTERNAL_WALLET',
  /** Gift card */
  GiftCard = 'GIFT_CARD',
  /** Balance */
  Holding = 'HOLDING',
  /** PayPal-issued prepaid card */
  PaypalPrepaidCard = 'PAYPAL_PREPAID_CARD',
  /** Prepaid card */
  PrepaidCard = 'PREPAID_CARD',
  /** Credit card issued by a merchant */
  PrivateLabelCreditCard = 'PRIVATE_LABEL_CREDIT_CARD',
  /** Rewards currency */
  Rewards = 'REWARDS',
  /** Merchant specific balance, pay after delivery, etc. */
  Tab = 'TAB',
  /** UNKNOWN */
  Unknown = 'UNKNOWN'
}

/** Provides additional context about the FI. */
export type InstrumentContext = {
  __typename?: 'InstrumentContext';
  /** Information about potential issues with issuer authoriazation for this FI */
  authorizationContext?: Maybe<AuthorizationContext>;
  /** Indicates whether the funding instrument is eligible for expiry date updates */
  expiryUpdateEligible?: Maybe<Scalars['Boolean']>;
  /** Represents any disclosures we should display to the end user */
  instrumentDisclosures?: Maybe<Array<Maybe<InstrumentDisclosure>>>;
};

/** Instrument-level disclosure */
export type InstrumentDisclosure = {
  __typename?: 'InstrumentDisclosure';
  /** Type of disclosure */
  type?: Maybe<InstrumentDisclosureType>;
};

/** Valid disclosure types */
export enum InstrumentDisclosureType {
  /** Predicted NSF on bank instrument */
  AchNsfAwarenessDisclosure = 'ACH_NSF_AWARENESS_DISCLOSURE'
}

/** Types of client config integration artifact */
export enum IntegrationArtifactType {
  /** Use this when Merchant has integrated with an old version of BRAINTREE_VZERO that does not ingest JS_V3 or V4. */
  BraintreeVzero = 'BRAINTREE_VZERO',
  /** PayPal Javascript SDK v6 */
  JsSdkV6 = 'JS_SDK_V6',
  /** Checkout.js v3 */
  JsV3 = 'JS_V3',
  /** Checkout.js v4 */
  JsV4 = 'JS_V4',
  /** PPCP Mobile SDK */
  MobileSdk = 'MOBILE_SDK',
  /** Use this when Merchant has integrated using Future Payments Mobile Integration. */
  NativeSdk = 'NATIVE_SDK',
  /** Integration type is not defined */
  None = 'NONE',
  /** PayPal Javascript SDK */
  PaypalJsSdk = 'PAYPAL_JS_SDK',
  /** PayPal Javascript SDK with Shopper Insights */
  PaypalJsSdkWithShopperInsights = 'PAYPAL_JS_SDK_WITH_SHOPPER_INSIGHTS'
}

/**
 * Integration Specific SDK Eligibility. Currently we support two kind of integrations
 * 1. Paypal: Paypal Specific SDK eligibility integration
 * 2. Venmo: Venmo Specific SDK eligibility integraion
 */
export type IntegrationSdkEligibility = {
  __typename?: 'IntegrationSDKEligibility';
  /** Boolean response conveying eligibility for this flow */
  eligibility: Scalars['Boolean'];
  /** showing ineligiblity reasons error message in the case eligibility raises an error */
  ineligibilityErrorMessage?: Maybe<Scalars['String']>;
  /** showing ineligiblity reasons in the case eligibility returns false */
  ineligibilityReason: Scalars['String'];
};

/** An enumeration of billing cycle interval units */
export enum IntervalUnit {
  /** A daily billing cycle */
  Day = 'DAY',
  /** A monthly billing cycle */
  Month = 'MONTH',
  /** A monthly billing cycle for internal visibilty use */
  SemiMonth = 'SEMI_MONTH',
  /** A weekly billing cycle */
  Week = 'WEEK',
  /** A yearly billing cycle */
  Year = 'YEAR'
}

/** Encapsulates all properties related to an item's option selection. */
export type ItemOptionSelection = {
  __typename?: 'ItemOptionSelection';
  /** The description of the selected value (ex: 'Blue') ' */
  description: Scalars['String'];
  /** The name of option field (ex: 'Color'). */
  name: Scalars['String'];
};

/** An enumeration of the KYC (KnowYourCustomer) field types that can be required for sign up. */
export enum KnowYourCustomerField {
  /** A user's date of birth */
  DateOfBirth = 'DATE_OF_BIRTH',
  /** A user's gender */
  Gender = 'GENDER',
  /** A user's identity document number */
  IdentityDocumentNumber = 'IDENTITY_DOCUMENT_NUMBER',
  /** A user's identity document type */
  IdentityDocumentType = 'IDENTITY_DOCUMENT_TYPE',
  /** A user's nationality */
  Nationality = 'NATIONALITY',
  /** A user's occupation */
  Occupation = 'OCCUPATION',
  /** A user's place of birth */
  PlaceOfBirth = 'PLACE_OF_BIRTH',
  /** A user's secondary identity document number */
  SecondaryIdentityDocumentNumber = 'SECONDARY_IDENTITY_DOCUMENT_NUMBER',
  /** A user's secondary identity document type */
  SecondaryIdentityDocumentType = 'SECONDARY_IDENTITY_DOCUMENT_TYPE'
}

/**
 * Encapsulates all properties related to a Legal Agreement accepted by the buyer.
 * This definition is based on OAS API definition for create entities endpoint.
 * OAS API Definition: https://ppaas/api/3719176155268672#apiReference (/v1/onboarding/create-entities).
 */
export type LegalAgreementInput = {
  /** Agreement major version accepted by the buyer. */
  majorVersion: Scalars['String'];
  /** Agreement minor version accepted by the buyer. */
  minorVersion: Scalars['String'];
};

/** Encapsulates all properties related to the Legal Agreements accepted by the buyer. */
export type LegalAgreementsInput = {
  /** User Agreement accepted by the buyer */
  userAgreement?: InputMaybe<LegalAgreementInput>;
};

/** object that includes links to perform additional actions on a token */
export type Link = {
  __typename?: 'Link';
  /** encType */
  encType?: Maybe<Scalars['String']>;
  /** href */
  href?: Maybe<Scalars['String']>;
  /** method */
  method?: Maybe<Scalars['String']>;
  /** rel */
  rel?: Maybe<Scalars['String']>;
};

/**
 * The Locale interface encapsulates all properties related to a locale.
 * Ex: country, language, directionality, etc.
 */
export type Locale = {
  /** A locale's country (Ex: 'US') */
  country?: Maybe<Scalars['String']>;
  /** A locale's culture (Ex: 'en-US') */
  culture?: Maybe<Scalars['String']>;
  /** A locale's directionality (Ex: 'ltr') */
  directionality?: Maybe<Directionality>;
  /** A locale's language (Ex: 'en') */
  language?: Maybe<Scalars['String']>;
  /** A locale's locale (Ex: 'en_US') */
  locale?: Maybe<Scalars['String']>;
};

/** A container type for address input field metadata. */
export type LocaleAddressField = {
  __typename?: 'LocaleAddressField';
  /** Whether or not a field is required */
  isRequired?: Maybe<Scalars['Boolean']>;
  /** Maximum length of field - Ex: 5 */
  maxLength?: Maybe<Scalars['Int']>;
  /** Minimum length of field - Ex: 1 */
  minLength?: Maybe<Scalars['Int']>;
  /** Name of field - Ex: city */
  name?: Maybe<Scalars['String']>;
  /** Validation regex of field */
  regex?: Maybe<Scalars['String']>;
};

/** A container type for address metadata. */
export type LocaleAddressMetadata = {
  __typename?: 'LocaleAddressMetadata';
  /**
   * The address client metadata from Griffin
   *
   * https://github.paypal.com/pages/Globalization-R/griffin-paypal/docs/core-node.html#address-options
   */
  griffinMetadata?: Maybe<Scalars['JSON']>;
  /** A list of ordered fields to be displayed in an address form */
  layout?: Maybe<Array<Maybe<LocaleAddressField>>>;
  /** A list of ordered portable fields to be displayed in an address form */
  portableLayout?: Maybe<Array<Maybe<AddressLineLayout>>>;
  /** A list of localized content strings to be used for the address input labels */
  strings?: Maybe<LocaleAddressStrings>;
};

/** A container type for address state labels. */
export type LocaleAddressState = {
  __typename?: 'LocaleAddressState';
  /** The display text for a state, EX: California, Buenos Aires (Provincia), etc */
  displayText?: Maybe<Scalars['String']>;
  /** The input value of a state, EX: CA, BUENOS AIRES, etc */
  value?: Maybe<Scalars['String']>;
};

/** A container type for address string metadata. */
export type LocaleAddressStrings = {
  __typename?: 'LocaleAddressStrings';
  /** Label for the city field */
  cityLabel?: Maybe<Scalars['String']>;
  /** Label for the line1 field */
  line1Label?: Maybe<Scalars['String']>;
  /** Label for the line2 field */
  line2Label?: Maybe<Scalars['String']>;
  /** Label for optional address fields */
  optionalLabel?: Maybe<Scalars['String']>;
  /** Label for the postal code field */
  postcodeLabel?: Maybe<Scalars['String']>;
  /** Label for the line2 field */
  selectLabel?: Maybe<Scalars['String']>;
  /** Label for the state field */
  stateLabel?: Maybe<Scalars['String']>;
  /** List of LocaleAddressState types */
  stateList?: Maybe<Array<LocaleAddressState>>;
  /** Localized validation error for the postal code */
  validationError?: Maybe<Scalars['String']>;
};

/** A container type for credit card metadata. */
export type LocaleCreditCardMetadata = {
  __typename?: 'LocaleCreditCardMetadata';
  /**
   * Returns a list of formatting and validation metadata for types of credit cards
   * Average SLA response time - 50ms
   *
   * Required Roles: None.
   */
  types: Array<Maybe<CardRule>>;
};

/** A container for the metadata pertaining to how a country displays currency */
export type LocaleCurrencyMetadata = {
  __typename?: 'LocaleCurrencyMetadata';
  /** Country Currency code */
  code: SupportedCountryCurrencies;
  /**
   * Object map of country currency denomincation to decimal digit length
   * EXAMPLE: USD -> 2
   */
  griffinClientDigitsMetadata: Scalars['Int'];
  /**
   * Object map of country currency denomincation to currency character
   * EXAMPLE: USD -> $
   */
  griffinCurrencySupportedSymbolsMetadata: SupportedCurrencySymbolsMetadata;
  /** A container for metadata pertaining to currency styles */
  styles: LocaleStylesCurrencyMetadata;
};

/** A container type for date metadata. */
export type LocaleDateMetadata = {
  __typename?: 'LocaleDateMetadata';
  /** Date format/pattern for backend use (consistently using letters d, m, y) */
  datePattern?: Maybe<Scalars['String']>;
  /** Format display for the user */
  displayFormat?: Maybe<Scalars['String']>;
  /**
   * The localized label for an expiry date
   *
   * > Example for en_US: *MM/YY*
   */
  expiryDatePatternLabel?: Maybe<Scalars['String']>;
};

/** Locale type */
export type LocaleInput = {
  /** country */
  country?: InputMaybe<Scalars['String']>;
  /** language */
  lang?: InputMaybe<Scalars['String']>;
};

/** A container type for locale metadata. */
export type LocaleMetadata = {
  __typename?: 'LocaleMetadata';
  /** A container type for address metadata.  See LocaleAddressMetadata */
  address?: Maybe<LocaleAddressMetadata>;
  /** A list of PayPal business regions a given country is part of. Ex: ['LATAM', 'EM'] */
  businessRegions: Array<Maybe<PayPalBusinessRegions>>;
  /** A container type for credit card metadata.  See LocaleCreditCardMetadata */
  card?: Maybe<LocaleCreditCardMetadata>;
  /** A container for the metadata pertaining to how a country displays currency */
  currency: LocaleCurrencyMetadata;
  /** The country's three character currency code. Ex: USD */
  currencyCode?: Maybe<SupportedCountryCurrencies>;
  /** The country's currency symbol. Ex: $ */
  currencySymbol?: Maybe<Scalars['String']>;
  /** A container type for date metadata.  See LocaleDateMetadata */
  date?: Maybe<LocaleDateMetadata>;
  /** A container type for directionality based on Language */
  directionality: Scalars['String'];
  /**
   * Fields required for a user to sign up for a full member account in
   * a given country.
   */
  knowYourCustomerFields: Array<Maybe<KnowYourCustomerField>>;
  /** A container type for name metadata.  See LocaleNameMetadata */
  name?: Maybe<LocaleNameMetadata>;
  /** A container type for number metadata. see LocaleNumberMetadata */
  number: LocaleNumberMetadata;
  /** A container type for phone metadata.  See LocalePhoneMetadata */
  phone?: Maybe<LocalePhoneMetadata>;
  /**
   * Sugguested default language for given country
   *
   * Required auth states: Any
   */
  suggestedDefaultLanguage?: Maybe<CheckoutContentLanguageCode>;
  /** A list of supported languages for a given country. Ex: ['en', 'fr', 'es', 'zh'] */
  supportedLanguages: Array<CheckoutContentLanguageCode>;
  /** A container type for territory metadata.  See LocaleTerritoryMetadata */
  territories: Array<LocaleTerritoryMetadata>;
};


/** A container type for locale metadata. */
export type LocaleMetadataAddressArgs = {
  countryCode: CountryCodes;
  languageCode?: InputMaybe<CheckoutContentLanguageCode>;
};


/** A container type for locale metadata. */
export type LocaleMetadataBusinessRegionsArgs = {
  countryCode: CountryCodes;
};


/** A container type for locale metadata. */
export type LocaleMetadataCardArgs = {
  countryCode?: InputMaybe<CountryCodes>;
};


/** A container type for locale metadata. */
export type LocaleMetadataCurrencyArgs = {
  countryCode: CountryCodes;
  languageCode?: InputMaybe<CheckoutContentLanguageCode>;
};


/** A container type for locale metadata. */
export type LocaleMetadataCurrencyCodeArgs = {
  countryCode?: InputMaybe<CountryCodes>;
};


/** A container type for locale metadata. */
export type LocaleMetadataCurrencySymbolArgs = {
  countryCode: CountryCodes;
  languageCode?: InputMaybe<CheckoutContentLanguageCode>;
};


/** A container type for locale metadata. */
export type LocaleMetadataDateArgs = {
  countryCode: CountryCodes;
  languageCode?: InputMaybe<CheckoutContentLanguageCode>;
};


/** A container type for locale metadata. */
export type LocaleMetadataDirectionalityArgs = {
  languageCode?: InputMaybe<CheckoutContentCountryCode>;
};


/** A container type for locale metadata. */
export type LocaleMetadataKnowYourCustomerFieldsArgs = {
  countryCode: CountryCodes;
};


/** A container type for locale metadata. */
export type LocaleMetadataNameArgs = {
  countryCode: CountryCodes;
  languageCode?: InputMaybe<CheckoutContentLanguageCode>;
};


/** A container type for locale metadata. */
export type LocaleMetadataNumberArgs = {
  countryCode: CountryCodes;
  languageCode?: InputMaybe<CheckoutContentLanguageCode>;
};


/** A container type for locale metadata. */
export type LocaleMetadataPhoneArgs = {
  countryCode: CountryCodes;
  languageCode?: InputMaybe<CheckoutContentLanguageCode>;
};


/** A container type for locale metadata. */
export type LocaleMetadataSuggestedDefaultLanguageArgs = {
  countryCode: CountryCodes;
};


/** A container type for locale metadata. */
export type LocaleMetadataSupportedLanguagesArgs = {
  countryCode: CountryCodes;
};


/** A container type for locale metadata. */
export type LocaleMetadataTerritoriesArgs = {
  countryCode: CountryCodes;
  languageCode?: InputMaybe<CheckoutContentLanguageCode>;
};

/** The metadata for a particular name. */
export type LocaleNameField = {
  __typename?: 'LocaleNameField';
  /** Indicates whether the name field is required */
  isRequired?: Maybe<Scalars['Boolean']>;
  /** The name of field Ex-givenName */
  name?: Maybe<Scalars['String']>;
};

/** A container type for date metadata. */
export type LocaleNameMetadata = {
  __typename?: 'LocaleNameMetadata';
  /** Object for name griffin metadata */
  griffinMetadata?: Maybe<Scalars['JSON']>;
  /** A list of ordered fields to be displayed in an name form */
  layout?: Maybe<Array<Maybe<LocaleNameField>>>;
  /** A list of localized content strings to be used for the name input labels */
  strings?: Maybe<LocaleNameStrings>;
};

/** A container type for name string metadata. */
export type LocaleNameStrings = {
  __typename?: 'LocaleNameStrings';
  /** Label for the givenName field */
  givenNameLabel?: Maybe<Scalars['String']>;
  /** Label to display optional */
  optionalLabel?: Maybe<Scalars['String']>;
  /** Label for the surname field */
  surnameLabel?: Maybe<Scalars['String']>;
};

/** A container type for number metadata. */
export type LocaleNumberMetadata = {
  __typename?: 'LocaleNumberMetadata';
  /** Character sequence used to signify decimal pattern sign. EXAMPLE: #,##0.### */
  DECIMAL_PATTERN: Scalars['String'];
  /** Character used to signify decimal. EXAMPLE: . */
  DECIMAL_SEP: Scalars['String'];
  /** Character used to signify exponent sign. EXAMPLE: E */
  EXP_SYMBOL: Scalars['String'];
  /** Character used to signify number grouping. EXAMPLE: 1,000 */
  GROUP_SEP: Scalars['String'];
  /** Character used to signify per sign. EXAMPLE: ∞ */
  INFINITY: Scalars['String'];
  /** Character used to signify minus sign. EXAMPLE: - */
  MINUS_SIGN: Scalars['String'];
  /** Character used to signify not a number sign. EXAMPLE: NaN */
  NAN: Scalars['String'];
  /** Character used to signify percent. EXAMPLE: % */
  PERCENT: Scalars['String'];
  /** Character sequence used to signify percent pattern sign. EXAMPLE: #,##0% */
  PERCENT_PATTERN: Scalars['String'];
  /** Character used to signify per mille sign. EXAMPLE: ‰ */
  PERMILL: Scalars['String'];
  /** Character used to signify plus sign. EXAMPLE: + */
  PLUS_SIGN: Scalars['String'];
  /** Character sequence used to signify scientific notation pattern sign. EXAMPLE: #E0 */
  SCIENTIFIC_PATTERN: Scalars['String'];
  /** Character used to signify zero digit. EXAMPLE: 0 */
  ZERO_DIGIT: Scalars['String'];
  /** Object for name griffin metadata */
  griffinMetadata?: Maybe<Scalars['JSON']>;
};

/** A container type for input masks for phones. */
export type LocalePhoneMasks = {
  __typename?: 'LocalePhoneMasks';
  /** A mask used for input fields -- Ex: 00000 00000 */
  fixed?: Maybe<Scalars['String']>;
  /** A mask used for input fields -- Ex: 0000 000000 */
  mobile?: Maybe<Scalars['String']>;
};

/** A container type for phone metadata. */
export type LocalePhoneMetadata = {
  __typename?: 'LocalePhoneMetadata';
  /** A container type for a phone's input masks.  See LocalePhoneMasks */
  masks?: Maybe<LocalePhoneMasks>;
  /** A container type for a phone's input patterns.  See LocalePhonePatterns */
  patterns?: Maybe<LocalePhonePatterns>;
};

/** A container type for input patterns for phones. */
export type LocalePhonePatterns = {
  __typename?: 'LocalePhonePatterns';
  /** A default phone pattern -- Ex: '^(0)?((?:00800|1\d{0,5}|[2-9]\d\d)\d{7})$' */
  default?: Maybe<Scalars['String']>;
  /** A fixed line phone pattern -- Ex: '^(0)?((?:00800|1\d{0,5}|[2-9]\d\d)\d{7})$' */
  fixed?: Maybe<Scalars['String']>;
  /** A mobile phone pattern -- Ex: '^(0)?((?:00800|1\d{0,5}|[2-9]\d\d)\d{7})$' */
  mobile?: Maybe<Scalars['String']>;
};

/** A container for metadata pertaining to currency styles */
export type LocaleStylesCurrencyMetadata = {
  __typename?: 'LocaleStylesCurrencyMetadata';
  /** Currency style metadata */
  currency: Scalars['String'];
  /** ISOCurrency style metadata */
  iSOCurrency: Scalars['String'];
  /** SymbolISO Currency style metadata */
  symbolISOCurrency: Scalars['String'];
};

/** A container type for territory metadata. */
export type LocaleTerritoryMetadata = {
  __typename?: 'LocaleTerritoryMetadata';
  /** A two character country code -- Ex: US */
  code?: Maybe<CountryCodes>;
  /** The international dialing code for the territory -- Ex: 1 */
  internationalDialingCode?: Maybe<Scalars['Int']>;
  /** The full name of the territory -- Ex: United States */
  name?: Maybe<Scalars['String']>;
  /**
   * The name of the business region the country belongs to.
   * Canada and the United States return 'NA'
   * Ex: EMEA
   */
  region?: Maybe<Scalars['String']>;
  /** The suggested default language for the territory -- Ex: en */
  suggestedDefaultLanguage?: Maybe<CheckoutContentLanguageCode>;
};

/**
 * Encapsulates all properties related to a Marketing campaign.
 * Ex: advertisementId, advertiserName, etc.
 * Average SLA response time - 50ms
 */
export type MarketingCampaign = {
  __typename?: 'MarketingCampaign';
  /** A campaign's advertisement ID. (Ex: '210004') */
  advertisementId?: Maybe<Scalars['String']>;
  /** A campaign's advertiser name. (Ex: 'PayPal') */
  advertiserName?: Maybe<Scalars['String']>;
  /** A campaign's buy item ID. (Ex: '582468') */
  buyItemId?: Maybe<Scalars['String']>;
  /** A campaign's ID. (Ex: '111169') */
  campaignId?: Maybe<Scalars['String']>;
  /** A campaign's creative ID. (Ex: '44871') */
  creativeId?: Maybe<Scalars['String']>;
};

/**
 * An enumeration of phases that a MarketingOffer can be in.
 * INITIAL, DISPLAYED, CLICKED, CTA_INITIALIZED, etc.
 */
export enum MarketingOfferPhase {
  /** MarketingOffer is in a clicked phase */
  Clicked = 'CLICKED',
  /** MarketingOffer is in a call to action completed phase */
  CtaCompleted = 'CTA_COMPLETED',
  /** MarketingOffer is in a call to action initialized phase */
  CtaInitialized = 'CTA_INITIALIZED',
  /** MarketingOffer is in a displayed phase */
  Displayed = 'DISPLAYED',
  /** MarketingOffer is in an initial phase */
  Initial = 'INITIAL',
  /** MarketingOffer is in a payment completed phase */
  PayCompleted = 'PAY_COMPLETED',
  /** MarketingOffer is in a payment initialized phase */
  PayInitialized = 'PAY_INITIALIZED'
}

/** An enumeration of statuses that a MarketingOffer can be in. VALID or INVALID */
export enum MarketingOfferStatus {
  /** MarketingOffer has a status of invalid. */
  Invalid = 'INVALID',
  /** MarketingOffer has a status of valid. */
  Valid = 'VALID'
}

/**
 * An enumeration of types that a MarketingOffer can be.
 * ADPAL, INFORMATIONAL, FINANCIAL_PRODUCT, or OTHER
 */
export enum MarketingOfferType {
  /** An ADPAL type of MarketingOffer */
  Adpal = 'ADPAL',
  /** A financial product type of MarketingOffer */
  FinancialProduct = 'FINANCIAL_PRODUCT',
  /** An informational type of MarketingOffer */
  Informational = 'INFORMATIONAL',
  /** An other type of MarketingOffer */
  Others = 'OTHERS'
}

/** Encapsulates all properties related to a merchant. Ex: merchantId, email */
export type Merchant = {
  __typename?: 'Merchant';
  /** Bill Pay Integrator's name. */
  billPayIntegratorName?: Maybe<Scalars['String']>;
  /** Returns a list of cobrands associated with this merchant */
  cobrands?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The country this merchant is located in */
  country?: Maybe<CountryCodes>;
  /** Merchant descriptor (for bank statements) */
  descriptor: Scalars['String'];
  /** The Funding Instruments that are NOT allowed for a transaction based on merchant's configurations */
  disallowedFundingInstrumentsForMerchant?: Maybe<Array<Maybe<FundingInstrumentSubType>>>;
  /**
   * Merchant's email address.
   * @deprecated Merchant email is PII data & should not be passed to Clients
   */
  email?: Maybe<Email>;
  /** Indicates eligibility for trusted beneficiary opt-in experience */
  isEligibleForTrustedBeneficiaryOptIn?: Maybe<Scalars['Boolean']>;
  /** Merchant is gaming and gambling */
  isGambling?: Maybe<Scalars['Boolean']>;
  /** Indicates whether this merchant's charity status has been confirmed by PayPal */
  isPaypalConfirmedCharity?: Maybe<Scalars['Boolean']>;
  /**
   * Indicates whether this merchant has been marked as a trusted beneficiary by the associated user
   * @deprecated Use isEligibleForTrustedBeneficiaryOptIn instead for deciding whether or not to render the Trusted Beneficiary experience
   */
  isTrustedBeneficiary?: Maybe<Scalars['Boolean']>;
  /** The locale of this merchant */
  locale?: Maybe<GenericLocale>;
  /** Merchant's logo. */
  logo?: Maybe<GenericUrl>;
  /** Merchant's ID (Ex: '7VJPAEVGH7B6A') */
  merchantId?: Maybe<Scalars['String']>;
  /** Merchant's brand name. */
  name?: Maybe<Scalars['String']>;
  /** The preferences the Merchant has set */
  preferences?: Maybe<MerchantPreferences>;
  /** Indicates type of checkout integration */
  solution: CheckoutSolutionType;
};

/** Encapsulates all properties related to a merchant's preferences. Ex: autoReturn, PDT */
export type MerchantPreferences = {
  __typename?: 'MerchantPreferences';
  /** If set to true automatically redirects back to merchant site */
  autoReturnToMerchant?: Maybe<Scalars['Boolean']>;
  /** If set to true enables paymentDataTransfer to merchant */
  enablePaymentDataTransfer?: Maybe<Scalars['Boolean']>;
  /** Return URL of the seller set in auto return setting (different from cart return url) */
  returnUrl?: Maybe<Scalars['String']>;
};

/** A profile object that contains merchant specific messaging information */
export type MerchantProfile = {
  __typename?: 'MerchantProfile';
  /** Time to live for the SDK Bundle serving this Merchant */
  configTTL?: Maybe<Scalars['Int']>;
  /** Merchant Configuration Hash */
  hash?: Maybe<Scalars['String']>;
};

/** Schema to do mobile sdk eligibility */
export type MobileSdkEligibility = {
  __typename?: 'MobileSDKEligibility';
  /**
   * Boolean response conveying eligibility for this flow
   * @deprecated Migrating this data into IntegrationSDKEligibility, due to introduction of new mobile SDK integrations, such as Venmo
   */
  eligible: Scalars['Boolean'];
  /**
   * showing ineligibility reasons in the case eligibility is false
   * @deprecated Migrating this data into IntegrationSDKEligibility, due to introduction of new mobile SDK integrations, such as Venmo
   */
  ineligibilityReason: Scalars['String'];
  /** Paypal mobile SDK specific eligibility response */
  paypal: IntegrationSdkEligibility;
  /** Venmo mobile SDK specific eligibility response */
  venmo: IntegrationSdkEligibility;
};

/** The MobileSdkFeatures is returned to query 'mobileSdkFeatures' with the enabled native SDK features for the client. */
export type MobileSdkFeatures = {
  __typename?: 'MobileSdkFeatures';
  /** the elmo experiment with a list of treatments with feature eligibility */
  elmoFeatures: Array<Maybe<ElmoTreatment>>;
};

/** Utilities for tracking this message and the user's interaction with it. */
export type MorsMrTrackingDetails = {
  __typename?: 'MorsMRTrackingDetails';
  /** URL used for click tracking */
  clickUrl?: Maybe<GenericUrl>;
  /** URL used for dismiss tracking */
  dismissUrl?: Maybe<GenericUrl>;
  /** Url used for impression tracking */
  impressionUrl?: Maybe<GenericUrl>;
};

/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type Mutation = {
  __typename?: 'Mutation';
  /**
   * Accept the SEPA Direct Debit Mandate for a given bank account.
   *
   * Required auth states: LOGGEDIN, REMEMBERED, or IDENTIFIED
   */
  acceptSepaMandate?: Maybe<CheckoutSession>;
  /**
   * Tokenless accept the SEPA Direct Debit Mandate for a given bank account.
   *
   * Required auth states: LOGGEDIN
   */
  acceptSepaMandateWithoutToken?: Maybe<Scalars['Boolean']>;
  /**
   * Add primary/shipping address to User's Profile and return the updated/replanned Checkout Session.
   * Required auth states: LOGGEDIN, REMEMBERED, or IDENTIFIED
   */
  addAddressToUser?: Maybe<CheckoutSession>;
  /**
   * The addBank mutation will add a new bank account and update checkoutSession fundingOptions based on the newly added bank account.
   * `authorizations` takes any authorization needs to be completed
   *
   * Required auth states: LOGGEDIN, REMEMBERED, or IDENTIFIED
   */
  addBank?: Maybe<CheckoutSession>;
  /**
   * The addBankAfterStepup mutation is used if the original addBank call throws a RISK_DECLINE_REDIRECT_AUTH_FLOW error from FI due to a SCA
   * requiring stepup. Once the stepup is resolved, the client will call addBankAfterStepup and provide the authContextId they received from
   * xobuyernodeserv in the addBank contingency. The authContextId will be used to grab the original parameters from junonodisk so that the
   * client does not need to re-enter them. Once parameters are grabbed from junonodisk, this operation finishes the addBank steps and adds a
   * new bank account and updates checkoutSession fundingOptions based on the newly added bank account.
   *
   * Required auth states: LOGGEDIN, REMEMBERED, or IDENTIFIED
   */
  addBankAfterStepup?: Maybe<CheckoutSession>;
  /** Add a bank account candidate. */
  addBankCandidate?: Maybe<BankAccount>;
  /**
   * The `addBillingAddress` mutation will add a billing address to the Users billing addresses.
   *
   * If an `instrumentId` is passed in, it will associate the billing address with it.
   *
   * - Requires parameters for an address (Ex: line1, line2, etc.).
   * - Optionally accepts an instrumentId param as a String.
   *
   * Returns a CheckoutSession type.
   *
   * Required auth states: LOGGEDIN, REMEMBERED, or IDENTIFIED
   */
  addBillingAddress?: Maybe<AddBillingAddressResponse>;
  /**
   * The addCard mutation will do the following depends on how arguments are being
   * passed:
   *   - Add a new card
   *   - Perform billing address validation if address.id is missing
   *   - Update checkoutSession fundingOptions based on the newly added card
   *   - paypalRequestId is unique uuid for each add card request. If we don't get it from front end, we generate it using uuid library else we pass whatever came in request.
   * Required auth states: LOGGEDIN, REMEMBERED, or IDENTIFIED
   */
  addCard?: Maybe<CheckoutSession>;
  /**
   * The addCardWithoutToken mutation will do the following:
   *   - Perform billing address validation if address.id is missing
   *   - Add a new card
   *   Required auth states: LOGGEDIN
   */
  addCardWithoutToken?: Maybe<Scalars['Boolean']>;
  /**
   * The addPotentialCard mutation will do the following
   * passed:
   *   - Add a new card to the user wallet
   *   - Update checkoutSession fundingOptions based on the newly added card
   * Required auth states: LOGGEDIN, REMEMBERED, or IDENTIFIED
   */
  addPotentialCard?: Maybe<CheckoutSession>;
  /**
   * The addShippingAddress mutation will add a shipping address to a
   * Users shipping addresses, which can be used when approving the payment transaction.
   * Requires a token param (EC, PAY, or BA token) as a String.
   * Requires additional parameters for an address (Ex: line1, line2, etc.).
   *
   * Optionally accepts a `normalize` parameter that tells us if we need to try to normalize the address.
   * If a corrected address is returned from the Address Normalization Service,
   * then a `ADDRESS_NORMALIZED` Client Contingency is thrown with the normalized address passed down as data.
   *
   * Optionally accepts a `preferredAddress` parameter that tells us if we need to mark the current address
   * as Preferred for the user.
   *
   * Returns a CheckoutSession type.
   *
   * Average SLA response time - 2200ms
   *
   * Required auth states: LOGGEDIN, REMEMBERED, or IDENTIFIED
   */
  addShippingAddress?: Maybe<CheckoutSession>;
  /**
   * The addTaxId mutation will add a Tax Identification number to a Brazil User,
   * if the TAX_ID_REQUIRED contingency is triggered as the user has not yet added a tax id.
   *
   * Requires a:
   *   token param (EC, PAY, or BA token) as a String.
   *   taxId ("123.123.123-12" in BR case) as a String.
   *   type (CPF or CNPJ in BR case) as a TaxIdType.
   *
   * Returns a CheckoutSession type.
   *
   * Required auth states: LOGGEDIN, REMEMBERED.
   */
  addTaxId?: Maybe<CheckoutSession>;
  /**
   * The addUserToCustomerList mutation will add a user to the provided dynamic customer list given the
   * user is present in RPS
   *
   * Requires a dynamic customer list name (Ex: 'CL-6465007365187988655')
   *
   * Required auth states: LOGGEDIN, REMEMBERED, or IDENTIFIED
   */
  addUserToCustomerList?: Maybe<Scalars['Boolean']>;
  /**
   * The applyOfferToUser takes the name of an offer
   * and applies an offer to the user.
   * The offer names are whitelisted here:
   * src/graphql/data/Offers/activeOffers.js
   */
  applyOfferToUser?: Maybe<CheckoutSession>;
  /** Approves the Apple Pay payment. */
  approveApplePayPayment?: Maybe<Scalars['JSON']>;
  /** Approves the Google Pay payment. */
  approveGooglePayPayment?: Maybe<Scalars['JSON']>;
  /**
   * The approveGuestPaymentWithApplePayToken mutation will approve an Apple Pay tokenized guest payment transaction.
   *
   * Requires an applePayPaymentInput param as an ApplePayPaymentInput
   * Requires a token param (EC, PAY, or BA token) as a String
   *
   * Returns a CheckoutSession type.
   *
   * Required auth states: ANONYMOUS
   */
  approveGuestPaymentWithApplePayToken?: Maybe<CheckoutSession>;
  /**
   * The approveGuestPaymentWithCreditCard mutation will approve a guest payment transaction with credit card.
   *
   * If passed an phone number, it will use that phone number for the transaction. Otherwise it will
   * use the one in mayfly checkout session.
   *
   * If passed an first name, it will use that name for the transaction. Otherwise it will
   * use the one in mayfly checkout session.
   *
   * If passed an last name, it will use that name for the transaction. Otherwise it will
   * use the one in mayfly checkout session.
   *
   * If passed an email, it will use that email for the transaction. Otherwise it will
   * use the one in mayfly checkout session.
   *
   * If passed an billing address, it will use that billing address for the transaction. Otherwise it will
   * use the one in mayfly checkout session.
   *
   * If passed an installmentTerm, payment will be approved with selected installment term. Otherwise it will
   * approve with total payment at once. This is only available for Brazil and Mexico at the moment.
   *
   * If provided, a paymentToken is used to complete payment using a Fastlane profile payment instrument.
   * If provided, a card is used to complete payment. Card and paymentToken are mutually exclusive.
   *
   * Requires a token param (EC, PAY, or BA token) as a String
   *
   * Optionally accepts an card as a CardInput (cardNumber, postalCode, cvv, expirationDate)
   * Optionally accepts an email as a String
   * Optionally accepts a fist name as a String
   * Optionally accepts a last name as a String
   * Optionally accepts a phone as a String
   * Optionally accepts a billingAddress as a InputAddress
   * Optionally accepts an installmentTerm
   * Optionally accepts an identityDocument
   * Optionally accepts a paymentToken as a String
   * Optionally accepts a feeReferenceId as a String
   *
   * Returns a CheckoutSession type.
   *
   * Average SLA response time - 13000ms
   *
   * Required auth states: ANONYMOUS
   */
  approveGuestPaymentWithCreditCard?: Maybe<CheckoutSession>;
  /**
   * The approveGuestSignUpPayment mutation will approve a payment transaction for a signup/guest flow
   *
   * Returns a CheckoutSession type.
   *
   * Average SLA response time - 500ms
   *
   * Required auth states: LOGGEDIN, IDENTIFIED
   */
  approveGuestSignUpPayment?: Maybe<CheckoutSession>;
  /**
   * The approveMemberPayment mutation will approve a payment for PayPal members.
   *
   * This interface uses funding option IDs, rather than plan IDs.
   *
   * Requires `token`, the EC, PAY or BA token used for this payment.
   *
   * Requires `primaryFundingOptionId`, which is the primary funding option ID used to fund the payment.
   * Optionally accepts `secondaryFundingOptionIds`, which is an Array of funding option IDs.
   * Optionally accepts `rewards`, which is an Object, containing the rewards ID, amount, and currency code.
   *
   * approveMemberPayment will attempt to find the associated plan given those funding option IDs
   * approveMemberPayment will complete a payment for a WPS Payment.
   *
   * If passed `selectedAddressId`, it will select that address for the payment.
   * If passed `preferredFundingOptionId`, it will select that funding option as preferred for future payments.
   * If passed `preferredShippingAddressId`, it will select that address as preferred for future payments.
   * If passed `preAuthorizationRequired`, it will collect Credit Card status from the issuer to check if its valid (Expired Card, Insufficient funds, etc).
   * If passed `cardCvvValue`, it will resolve cvv value for the currently selected card (primaryFundingOptionId).
   * If passed `card3DSResolve3DSCode`, it will resolve 3DS for the currently selected card (primaryFundingOptionId).
   * If passed `legalAgreements`, it will record user legal consent (User Agreement) data on Notice & Consent API.
   *
   * Returns a CheckoutSession type.
   *
   * Please query for state field to get status of checkoutSession when using this Mutation.
   * If successful, state will change to APPROVED.
   * If not successful, check the PaymentContingencies field to see issues that need to be resolved first.
   *
   * Average SLA response time - 2500ms
   *
   * Required auth states: LOGGEDIN, REMEMBERED, or IDENTIFIED
   */
  approveMemberPayment?: Maybe<CheckoutSession>;
  /**
   * This handles the patch and approval process when a user attempts to process a split payment transaction
   * through the Split Tender interface.
   *
   * Returns a CheckoutSession type
   *
   * Required auth states: LOGGEDIN
   */
  approveMemberPaymentWithSplitFundingOptions?: Maybe<CheckoutSession>;
  /**
   * The approvePayment mutation will approve a payment transaction.
   * If passed an planId, it will select that plan for the transaction.
   * If passed an addressId, it will select that address for the transaction.
   * First, plans will be selected, then addresses will be selected, then the
   * payment will be approved.
   * Requires a token param (EC, PAY, or BA token) as a String
   * Requires a planId as a String
   * Optionally accepts an addressId as a String
   *
   * Returns a CheckoutSession type.
   *
   * Please query for state field to get status of checkoutSession when using this Mutation.
   * If successful, state will change to APPROVED.
   * If not successful, check the PaymentContingencies field to see issues that need to be resolved first.
   *
   * Average SLA response time - 2500ms
   *
   * Required auth states: LOGGEDIN, REMEMBERED, or IDENTIFIED
   */
  approvePayment?: Maybe<CheckoutSession>;
  /**
   * Approve suggested donation
   *
   * Required auth states: LOGGEDIN, REMEMBERED, or IDENTIFIED
   */
  approveSuggestedDonation?: Maybe<Scalars['Boolean']>;
  /**
   * The attemptSetStickyFi mutation will set the sticky/primary funding instrument for
   *   1. Billing Agreements on the Signup flow
   *   2. EC Subscriptions on both Guest and Signup flows
   *
   * Returns a CheckoutSession type.
   *
   * Required auth states: LOGGEDIN, IDENTIFIED
   */
  attemptSetStickyFi?: Maybe<CheckoutSession>;
  /**
   * checkoutGuestWithMemberBenefits mutation will take parameters similar to
   * isMemberBenefitsEligible query and trys to checkout a guest user as a
   * member (by generating member security context on xobuyer)
   *
   * Requires a token param (EC, PAY, or BA token) as a String
   * Requires a firstName ("John") as a String
   * Requires a lastName ("Smith") as a String
   * Requires a email ("example@paypal.com") as a String
   * Requires a phoneNumber ("800-888-8888") as a String
   * Requires a country ("US") as a String
   *
   * Optionally pass a billingAddress as an AddressInput (country, postalCode, state)
   * Optionally pass a currencyConversionType
   * Optionally pass a shippingAddress as an AddressInput (country, postalCode, state)
   * Optionally pass a card as a CardInput (cardNumber, postalCode, cvv, expirationDate)
   * Optionally pass a bank as a BankAccountInput (type, iban, accountNumber, routingNumber)
   *
   * Returns checkoutsession
   *
   * Required auth states: ANONYMOUS
   */
  checkoutGuestWithMemberBenefits?: Maybe<CheckoutSession>;
  /**
   * The clearCheckoutSessionCreditFinancingOption mutation will delete the credit financing option
   * (deprecated, use updateCheckoutSessionCreditFinancingOption instead)
   * @deprecated use updateCheckoutSessionCreditFinancingOption instead
   */
  clearCheckoutSessionCreditFinancingOption?: Maybe<CheckoutSession>;
  /**
   * The clearCreditFinancingOption mutation will delete the credit financing option
   * (deprecated, use updateCheckoutSessionCreditFinancingOption instead)
   * @deprecated use updateCheckoutSessionCreditFinancingOption instead
   */
  clearCreditFinancingOption?: Maybe<Scalars['Boolean']>;
  /**
   * Clear the real time balance contingency(needRealTimeBalanceForBankAccount) to either allow or disallow
   * the payment in case the user has indicated they want to use this bank .
   *
   * Requires the fundingOption Id of the bank and the EC token
   */
  clearRealTimeBalanceContingency?: Maybe<CheckoutSession>;
  /** The completeOtpConfirmation mutation will complete the one-time-password flow for a card account. */
  completeOtpConfirmation?: Maybe<CompleteOtpConfirmationResponse>;
  /** Authorize or capture payment using v2/orders/authorize or capture endpoints given intent */
  completePayment?: Maybe<Scalars['JSON']>;
  /**
   * Marks strongCustomerAuthenticationRequired payment contingency as completed, and removes the contingency from the Checkout Session.
   * Note that a different contingency may be returned after clearing the strongCustomerAuthenticationRequired contingency,
   * so clients should still query for paymentContingencies that are supported.
   */
  completeStrongCustomerAuthentication?: Maybe<CheckoutSession>;
  /**
   * The confirmCreditCardCvv mutation will attach the cvv to the user's funding source on PAPS
   *
   * Requires ConfirmedCreditCardCvvInput as an input type, see schema for reference.
   *
   * Required auth states: LOGGEDIN, REMEMBERED, or IDENTIFIED
   */
  confirmCreditCardCvv?: Maybe<CheckoutSession>;
  /** Risk-based confirm phone confirmation */
  confirmRiskBasedTwoFactorPhoneConfirmation?: Maybe<RiskBasedPhoneConfirmationResponse>;
  /** Identity-based confirm phone confirmation */
  confirmTwoFactorPhoneConfirmation?: Maybe<PhoneConfirmationResponse>;
  /** Create Credit key in Mayfly before redirecting to CAPE */
  createCapeMayflyPayload?: Maybe<Scalars['String']>;
  /**
   * createMemberAccount mutation will take a user's information and password and attempt to create an account
   *
   * Requires a token param (EC, PAY, or BA token) as a String
   * Requires a firstName ("John") as a String
   * Requires a lastName ("Smith") as a String
   *
   * Optionally pass a password ("example123") as a String
   * Optionally pass an email ("example@gmail.com") as a String
   * Optionally pass a billingAddress as an AddressInput (country, postalCode, state)
   * Optionally pass a phoneNumber ("800-888-8888") as a String
   * Optionally pass a shippingAddress as an AddressInput (country, postalCode, state)
   *
   * Returns a CheckoutSession type.
   *
   * Average SLA response time - 2290ms
   *
   * Required auth states: ANONYMOUS
   */
  createMemberAccount?: Maybe<CheckoutSession>;
  /** createOnboardingPaymentPlan mutation will take a user's shipping information and currencyConversionType and attempt to create a checkout session */
  createOnboardingPaymentPlan?: Maybe<CheckoutSession>;
  /**
   * Creates a new Low Scoped accessToken from the provided merchant access token (merchantLSAT)
   * Low Scope Access Token (LSAT) is produced from a client_id without a secret
   * And then it upgrades the lsat thus generated to an upgraded access token using the buyerAccessToken and Order ID
   * Returns the new upgraded access token that will provide access to GET/PATCH on v2/order and POST v2/order/capture and v2/order/authorize checkout APIs
   */
  createUpgradedLowScopeAccessToken?: Maybe<Scalars['String']>;
  /**
   * The deleteShippingAddress mutation will delete a shipping address from a Users
   * shipping addresses, so it cannot be used when approving a payment transaction.
   * Requires a token param (EC, PAY, or BA token) as a String
   * Requires an addressId param as a String Returns a CheckoutSession type.
   *
   * Average SLA response time - 900ms
   *
   * Required auth states: LOGGEDIN, REMEMBERED, or IDENTIFIED
   */
  deleteShippingAddress?: Maybe<CheckoutSession>;
  /**
   * The deleteVault mutation will remove an existing funding source from the vault
   *
   * Required auth states: IDENTIFIED
   */
  deleteVault?: Maybe<Scalars['Boolean']>;
  /**
   * The eConsent mutation will update user's edelivery consent
   * E-Sign consent is the process by which US consumers consent to have their notifications and statements delivered electronically
   *
   * Required auth states: LOGGEDIN, REMEMBERED, or IDENTIFIED
   */
  eConsent?: Maybe<User>;
  /**
   * The enableVault mutation will patch in to cart with the client token (containing a customer id), to transform
   * the existing checkout session into a billing agreement / vault session.
   * Also will patch in client configuration to the BA session
   *
   * Required auth states: ANONYMOUS
   */
  enableVault?: Maybe<Scalars['Boolean']>;
  /** The initiateOtpConfirmation mutation will initiate the one-time-password flow for a card account. */
  initiateOtpConfirmation?: Maybe<InitiateOtpConfirmationResponse>;
  /** Init risk-based phone confirmation */
  initiateRiskBasedTwoFactorPhoneConfirmation?: Maybe<RiskBasedPhoneConfirmationResponse>;
  /** Init identity-based phone confirmation */
  initiateTwoFactorPhoneConfirmation?: Maybe<PhoneConfirmationResponse>;
  /** Invalidate Checkout Session Plan to force replanning next time the Checkout Session is queried */
  invalidateCheckoutSessionPlan?: Maybe<Scalars['Boolean']>;
  /**
   * onboardGuest mutation will take a user's billing information and attempt to create an account
   *
   * Requires a token param (EC, PAY, or BA token) as a String
   * Requires a card as a CardInput (cardNumber, postalCode, cvv, expirationDate)
   * Requires a firstName ("John") as a String
   * Requires a lastName ("Smith") as a String
   *
   * Optionally pass an email ("example@gmail.com") as a String
   * Optionally pass a billingAddress as an AddressInput (country, postalCode, state)
   * Optionally pass a phoneNumber ("800-888-8888") as a String
   * Optionally pass a shippingAddress as an AddressInput (country, postalCode, state)
   *
   * Returns a CheckoutSession type.
   *
   * Average SLA response time - 2350ms
   *
   * Required auth states: ANONYMOUS
   */
  onboardGuest?: Maybe<CheckoutSession>;
  /**
   * onboardGuestForInlineXO mutation will take a user's billing information and attempt to create an account
   *
   * Requires a token param (EC, PAY, or BA token) as a String
   * Requires a card as a CardInput (cardNumber, postalCode, cvv, expirationDate)
   * Requires a firstName ("John") as a String
   * Requires a lastName ("Smith") as a String
   *
   * Optionally pass an email ("example@gmail.com") as a String
   * Optionally pass a billingAddress as an AddressInput (country, postalCode, state)
   * Optionally pass a phoneNumber ("800-888-8888") as a String
   * Optionally pass a shippingAddress as an AddressInput (country, postalCode, state)
   *
   * Returns a CheckoutSession type.
   *
   * Required auth states: ANONYMOUS
   * @deprecated Deprecated flow, code was already removed from client-side
   */
  onboardGuestForInlineXO?: Maybe<CheckoutSession>;
  /**
   * The oneClickPayment mutation will plan and approve a payment in one go.
   * Any contingencies will result in launching the full checkout flow
   *
   * Required auth states: LOGGEDIN, REMEMBERED, or IDENTIFIED
   */
  oneClickPayment?: Maybe<User>;
  /**
   * The optOutWebLLS mutation will unenroll the user from the autologin aka WebLLS feature
   * Mutation will read the assetValue from cookies unless passed directly
   */
  optOutWebLLS?: Maybe<CheckoutSession>;
  /**
   * Preauthorize plan by calling XOPG from SignupLite
   *
   * Required auth states: LOGGEDIN, IDENTIFIED
   */
  preAuthorizePayment?: Maybe<CheckoutSession>;
  /** Patch cart with credit installment and update FI. */
  processCapeReturn?: Maybe<CheckoutSession>;
  /**
   * The processCreditApplyPortableResponse mutation will decrypt the payload received from CAP and provide with
   * the selectedOffer, Repayment instruments and other required credit information
   * which can be used when selecting the Payment option.
   *
   * Requires a encrypted payload as a String.
   * Optionally accepts token as a String.
   *
   * Returns a CheckoutSession type.
   */
  processCreditApplyPortableResponse?: Maybe<CheckoutSession>;
  /** Remove the constraint on the declined funding instrument */
  removeConstraintOnFI?: Maybe<CheckoutSession>;
  /**
   * The replaceCard mutation will do the following depends on how arguments are being
   * passed:
   *   - Replace a new card
   *   - Perform billing address validation if address.id is missing
   *   - Update checkoutSession fundingOptions
   *   - fundingOptionId is required for each replace card request, it is acquired from fundingOptionId from declinedInstrument and sent from front end
   * Required auth states: LOGGEDIN, REMEMBERED, or IDENTIFIED
   */
  replaceCard?: Maybe<CheckoutSession>;
  /**
   * The resolveNeedPhoneContingency mutation will add a phone number to a User,
   * which is needed to complete a transaction, if a merchant requires a phone number from the customer.
   * An additional call will be made to paymentapiplatformserv to
   * clear the PHONE_NUMBER_REQUIRED contingency from the checkout session.
   *
   * If the consentContentId string is passed, it will be used to update the user notification preferences.
   * The consentContentId string is not mandatory because it is only required for US based users.
   *
   * Returns a CheckoutSession type.
   *
   * Required auth states: LOGGEDIN, REMEMBERED, or IDENTIFIED
   */
  resolveNeedPhoneContingency?: Maybe<CheckoutSession>;
  /**
   * Clear 3DS (2.0) contingency. This mutation can be consumed by any other client apps without
   * including any other checkout related business logic
   */
  resolveThreeDsContingency?: Maybe<CheckoutSession>;
  /**
   * resolveTravelRuleContingency mutation will take parameters related to
   * resolving TRAVEL_RULE_ID_REQUIRED contingency during a checkout session.
   * Requires a token param (EC, PAY, or BA token) as a String.
   * Optionally pass an address as an AddressInput (country, postalCode, state).
   * Optionally pass a dateOfBirth as a DateOfBirth (year, month, day).
   * Optionally pass an identityDocument as a IdentityDocumentInput (type, subtype, issuingCountry, value).
   * Returns a CheckoutSession.
   * Required auth states: LOGGEDIN, REMEMBERED, IDENTIFIED
   */
  resolveTravelRuleContingency?: Maybe<CheckoutSession>;
  /** Read Credit key in Mayfly after redirecting from CAPE and update PPC data to GPL cache. */
  retrieveCapeMayflyResponse?: Maybe<CreditRedirectMayflyResponse>;
  /**
   * Save shared card Consent
   * Check to see if Secondary user has given consent for sharing details with Primary card user
   */
  saveSharedCardConsent?: Maybe<Scalars['String']>;
  /**
   * signupNewMember mutation will take a user's billing information and password and attempt to create an account
   *
   * Requires a token param (EC, PAY, or BA token) as a String
   * Requires a card as a CardInput (cardNumber, postalCode, cvv, expirationDate)
   * Requires a firstName ("John") as a String
   * Requires a lastName ("Smith") as a String
   *
   * Optionally pass a password ("example123") as a String
   * Optionally pass an email ("example@gmail.com") as a String
   * Optionally pass a billingAddress as an AddressInput (country, postalCode, state)
   * Optionally pass a phoneNumber ("800-888-8888") as a String
   * Optionally pass a shippingAddress as an AddressInput (country, postalCode, state)
   *
   * Returns a CheckoutSession type.
   *
   * Average SLA response time - 2350ms
   *
   * Required auth states: ANONYMOUS
   */
  signUpNewMember?: Maybe<CheckoutSession>;
  /**
   * 3DS Authenticate endpoint through inbound Switch (switchpaymentsapiserv) used to handle 3DS at transaction time
   * URL: /v1/payment-networks/card-three-d-secure-authentications/${threeDsServerTransactionId}/authenticate
   * Purpose: This API is the last call in 3ds 2.0 resolution process
   * This API is called soon after cardinal calls (after OTP is entered by user) a return url on paypal app.
   * After this call returns success application continue authorize checkout session. Upon failure errors needs to handle
   * at client side(for ex: Incase of xoonboardingnodeweb, error is show on billing page).
   */
  threeDSAuthenticate?: Maybe<ThreeDsAuthenticateResponse>;
  /**
   * 3DS 2.0 FI service handle contingency during addCard:
   *   - Updates a confirmation resource for a given card confirmation respource
   *   - Updates a post-planning Checkout Session with the funding option ID that went through 3DS 2.0 authentication successfully
   * URL:
   *   - filifecycleserv: /v1/wallet/card-accounts/{card_account_id}/confirmations/{confirmation_id}/update
   *   - paymentapiplatserv: /v1/payments/checkout-sessions/{token}/funding-options
   * card-account.update-confirmation
   * Purpose:
   *   The FI API call is the last call in 3ds 2.0 resolution process, it is called soon after cardinal calls (after OTP is entered by user) a return url on paypal app
   *   After this call returns success we continue to call the PAPS API to update the funding options with checkout session, so that this FI will be avaiable for user to proceed checkout.
   *   Upon failure we redirect user to checkout review page, or we show relevant error messaging on UI
   */
  threeDSConfirmationWithUpdateFundingOption?: Maybe<CheckoutSession>;
  /**
   * 3DS lookup endpoint through inbound switch (switchpaymentsapiserv) used to handle 3DS at transaction time
   * URL: /v1/payment-networks/card-three-d-secure-authentications
   * Purpose: when Symphony throws 3ds 2.0 contingency upon planning call, we need to call this API to start the 3ds 2.0
   * resolution process. This is the first call to make, after Device Data Collection(DDC) is triggered in UI.
   * In response of this API we get the urls needed for cardinal iframe to enter OTP.
   */
  threeDSLookUp?: Maybe<ThreeDsLookUpResponse>;
  /**
   * 3DS 2.0 FI service to handle contingency during addCard: Creates a confirmation resource for a given card
   * URL: /v1/wallet/card-accounts/{card_account_id}/confirmations
   * card-account.create-confirmation
   * Purpose: when fi throws 3ds 2.0 contingency upon addCard call, we need to call this API to start the 3ds 2.0
   * resolution process. This is the first call to make, after Device Data Collection(DDC) is triggered in UI.
   * In response of this API we get the urls needed for cardinal iframe to enter OTP (response key step_up_url)
   */
  threedsCreateConfirmation?: Maybe<ThreedsCreateConfirmationResponse>;
  /**
   * 3DS 2.0 FI service handle contingency during addCard: Updates a confirmation resource for a given card confirmation respource
   * URL: /v1/wallet/card-accounts/{card_account_id}/confirmations/{confirmation_id}/update
   * card-account.update-confirmation
   * Purpose: This API is the last call in 3ds 2.0 resolution process
   * This API is called soon after cardinal calls (after OTP is entered by user) a return url on paypal app
   * After this call returns success we continue to call create checkout session. Upon failure we redirect to hermes from xoon, or
   * we show relevant error messaging on hermes
   * @deprecated use threeDSConfirmationWithUpdateFundingOption instead
   */
  threedsUpdateConfirmation?: Maybe<ThreedsUpdateConfirmationResponse>;
  /** trigger post on checkoutSession after user clicks Ready to Continue */
  triggerReplan?: Maybe<CheckoutSession>;
  /**
   * The updateCallbackOptions mutation will update call back shipping methods
   * in to cart. This mutation is for callback url/ instant update api flows.
   *
   * Requires a token param (EC, WPS, PAY, or BA token) as a String
   * Requires shipping options source (FALLBACK/ CALLBACK/ PROFILE ) as a String
   * Optionally accepts shipping methods as an array of objects.
   *
   * Returns a CheckoutSession type.
   */
  updateCallbackOptions?: Maybe<CheckoutSession>;
  /**
   * The updateCard mutation will do the following depends on how arguments are being
   * passed:
   *   - Update a new card
   *   - Perform billing address validation if address.id is missing
   *   - Update checkoutSession fundingOptions
   * Required auth states: LOGGEDIN, REMEMBERED, or IDENTIFIED
   */
  updateCard?: Maybe<CheckoutSession>;
  /**
   * The updateCardWithoutToken mutation will do the following depending on how arguments are being
   * passed:
   *   - Update a new card
   *   - Perform billing address validation if address.id is missing
   * Required auth states: LOGGEDIN
   */
  updateCardWithoutToken?: Maybe<Scalars['Boolean']>;
  /**
   * The updateCheckoutSessionCreditFinancingOption mutation will update(add or remove)
   * the credit financing options for a given session
   */
  updateCheckoutSessionCreditFinancingOption?: Maybe<CheckoutSession>;
  /**
   * Update a post-planning Checkout Session with a funding option ID that was externally updated (eg. through an FI api or some other mutation that does not affect CheckoutSession)
   * @deprecated use threeDSConfirmationWithUpdateFundingOption instead
   */
  updateCheckoutSessionFundingOptions?: Maybe<CheckoutSession>;
  /**
   * The updateClientConfig mutation will patch in client configuration to the checkout session, to identify
   * the selected funding source, integration type, etc.
   *
   * Required auth states: ANONYMOUS
   */
  updateClientConfig?: Maybe<Scalars['Boolean']>;
  /**
   * The updateCurrencyConversionType mutation will update a currency conversion type
   * (Ex: "PAYPAL" or "VENDOR").
   * Requires a token param (EC, PAY, or BA token) as a String
   * Requires a conversionType (Ex: "PAYPAL" or "VENDOR") See CheckoutCurrencyConversionType.
   *
   * Average SLA response time - 115ms
   *
   * Required auth states: LOGGEDIN, REMEMBERED, or IDENTIFIED
   */
  updateCurrencyConversionType?: Maybe<CheckoutSession>;
  /**
   * Guest flow Server-side Shipping Callback mutation that indicates a shipping address changed from the client.
   * Updates the amounts and funding options of the CheckoutSession based on the merchant callback.
   */
  updateGuestShippingAddressCallback?: Maybe<CheckoutSession>;
  /**
   * Guest flow Server-side Shipping Callback mutation that indicates a shipping method selection changed from the client.
   * Updates the amounts and funding options of the CheckoutSession based on the merchant callback.
   * Returns updated CheckoutSession.
   */
  updateGuestShippingMethodCallback?: Maybe<CheckoutSession>;
  /**
   * The updateProfileShippingOptions mutation will update profile shipping methods
   * in to cart.
   *
   * Requires a token param (EC, WPS, PAY, or BA token) as a String
   * Requires shipping options source (FALLBACK/ CALLBACK/ PROFILE ) as a String
   * Optionally accepts shipping methods as an array of objects.
   * Optionally accept profileOverrideAllowed (this is from the response from SnT which help with shipping calculations) as a boolean
   * Optionally accept hideShipping (this value will help determine the shipping calculations) as a boolean
   *
   * Returns a CheckoutSession type.
   */
  updateProfileShippingOptions?: Maybe<CheckoutSession>;
  /**
   * The updateShipping mutation will update shipping options and amount in
   * the cart, or add them if they do not exist.
   *
   * Requires a token param (EC, PAY, or BA token) as a String
   * Required shipping methods as an array of objects.
   *
   * Returns a CheckoutSession type.
   */
  updateShipping?: Maybe<Scalars['JSON']>;
  /**
   * The updateShippingAddress mutation will update a shipping address in a Users
   * shipping addresses, which can be used when approving the payment transaction.
   * Requires a token param (EC, PAY, or BA token) as a String.
   * Requires an addressId param as a String.
   * Requires additional parameters for an address (Ex: line1, city, countryCode).
   * Optionally accepts additional parameters to be updated (Ex: givenName, line2, etc.).
   *
   * This mutation does NOT PATCH/DELETE the previous record, rather it adds a new one entirely with a newly created addressId
   *
   * [//]: # (refer to https://github.paypal.com/ApiSpecifications-R/payments.CommonComponentSpecification/blob/v1.3/v1/schema/address.json for required address fields)
   *
   * Returns a CheckoutSession type.
   *
   * Average SLA response time - 2300ms
   *
   * Required auth states: LOGGEDIN, REMEMBERED, or IDENTIFIED
   */
  updateShippingAddress?: Maybe<CheckoutSession>;
  /**
   * V2 Server-side Shipping Callback mutation that indicates a shipping address selection changed from the client.
   * Updates the amounts and funding options of the CheckoutSession based on the merchant callback.
   */
  updateShippingAddressCallback?: Maybe<CheckoutSession>;
  /**
   * V2 Server-side Shipping Callback mutation that indicates a shipping method selection changed from the client.
   * Updates the amounts and funding options of the CheckoutSession based on the merchant callback.
   *
   * Returns a CheckoutSession type.
   */
  updateShippingMethodCallback?: Maybe<CheckoutSession>;
  /**
   * The updateShippingMethods mutation will update shipping options in the cart, or add
   * them if they do not exist
   *
   * Requires a token param (EC, PAY, or BA token) as a String
   * Requires an shippingMethods param as a CartShippingMethod
   * Optionally accepts additional parameters to be updated (Ex: givenName, line2, etc.)
   *
   * Returns a CheckoutSession type.
   *
   * Average SLA response time - TBDms
   *
   * Required auth states: LOGGEDIN, REMEMBERED, or IDENTIFIED
   */
  updateShippingMethods?: Maybe<CheckoutSession>;
  /**
   * The updateShippingMethodsForGuest mutation will update shipping options in
   * the cart, or add them if they do not exist.
   *
   * Requires a token param (EC, PAY, or BA token) as a String
   * Required shipping methods as an array of objects.
   *
   * Returns a CheckoutSession type.
   */
  updateShippingMethodsForGuest?: Maybe<CheckoutSession>;
  /** Mutation to modify attributes on a user address. */
  updateUserAddressAttributes?: Maybe<CheckoutSession>;
  /**
   * update vault setup token
   *
   * v3/vault/setup-tokens/:id/update is a private endpoint only accessible by internal PayPal services
   * This mutation allows client-side code access to this endpoint while the vault team works on exposing
   * this endpoint externally
   *
   * Oauth2 scope(s): https://uri.paypal.com/services/vault/payment-tokens/read
   */
  updateVaultSetupToken?: Maybe<VaultSetupTokenResponse>;
  /**
   * upgradeGuestToMember mutation takes data from a completed transaction
   * as guest user and upgrades to consumer member account
   *
   * Required auth states: IDENTIFIED
   */
  upgradeGuestToMember?: Maybe<CheckoutSession>;
  /**
   * Upgrade a Low Scope Access Token (LSAT) produced from a client_id without a secret to an upgraded access token
   * that will provide access to GET/PATCH on v2/order and POST v2/order/capture and v2/order/authorize checkout APIs
   * @deprecated use createUpgradedLowScopeAccessToken instead
   */
  upgradeLowScopeAccessToken?: Maybe<Scalars['Boolean']>;
  /**
   * To create/fetch the Venmo Guest Account information to proceed with Checkout
   * @deprecated Venmo guest flow no longer in use, so this should no longer be getting called.
   */
  venmoCredentialExchange?: Maybe<VenmoGuestUser>;
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationAcceptSepaMandateArgs = {
  bankId: Scalars['String'];
  planId?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationAcceptSepaMandateWithoutTokenArgs = {
  bankId: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationAddAddressToUserArgs = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  addressLine3?: InputMaybe<Scalars['String']>;
  addressType?: InputMaybe<AddressType>;
  adminArea1?: InputMaybe<Scalars['String']>;
  adminArea2?: InputMaybe<Scalars['String']>;
  adminArea3?: InputMaybe<Scalars['String']>;
  adminArea4?: InputMaybe<Scalars['String']>;
  amsMatchingScope?: InputMaybe<AmsMatchingScope>;
  city?: InputMaybe<Scalars['String']>;
  countryCode: CountryCodes;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  nonblockingOnPostCodeUpdates?: InputMaybe<Scalars['Boolean']>;
  nonblockingOnStandardUpdates?: InputMaybe<Scalars['Boolean']>;
  normalizationStatus?: InputMaybe<UserAddressNormalizationStatus>;
  normalize?: InputMaybe<Scalars['Boolean']>;
  postalCode?: InputMaybe<Scalars['String']>;
  primary?: InputMaybe<Scalars['Boolean']>;
  replacedAddressId?: InputMaybe<Scalars['String']>;
  setDefault?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationAddBankArgs = {
  authorizations?: InputMaybe<BankAccountAuthorizationsInput>;
  bank: BankAccountInput;
  beneficiary?: InputMaybe<BankAccountBeneficiaryInput>;
  countryCode: CountryCodes;
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationAddBankAfterStepupArgs = {
  authContextId: Scalars['String'];
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationAddBankCandidateArgs = {
  bank: BankAccountInput;
  beneficiary?: InputMaybe<BankAccountBeneficiaryInput>;
  billingAddress?: InputMaybe<AddressInput>;
  countryCode: CountryCodes;
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationAddBillingAddressArgs = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  addressLine3?: InputMaybe<Scalars['String']>;
  adminArea1?: InputMaybe<Scalars['String']>;
  adminArea2?: InputMaybe<Scalars['String']>;
  adminArea3?: InputMaybe<Scalars['String']>;
  adminArea4?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  countryCode: CountryCodes;
  instrumentId?: InputMaybe<Scalars['String']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  postalCode: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationAddCardArgs = {
  address?: InputMaybe<AddCardBillingAddressInput>;
  card: AddCardInput;
  cardType?: InputMaybe<FundingOptionType>;
  isPartialBillingAddress?: InputMaybe<Scalars['Boolean']>;
  paypalRequestId?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
  user: AddCardUserInput;
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationAddCardWithoutTokenArgs = {
  address: AddCardBillingAddressInput;
  card: AddCardInput;
  cardType?: InputMaybe<FundingOptionType>;
  isPartialBillingAddress?: InputMaybe<Scalars['Boolean']>;
  user: AddCardUserInput;
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationAddPotentialCardArgs = {
  address?: InputMaybe<AddCardBillingAddressInput>;
  card: PotentialCardInput;
  cardType?: InputMaybe<FundingOptionType>;
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationAddShippingAddressArgs = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  addressLine3?: InputMaybe<Scalars['String']>;
  adminArea1?: InputMaybe<Scalars['String']>;
  adminArea2?: InputMaybe<Scalars['String']>;
  adminArea3?: InputMaybe<Scalars['String']>;
  adminArea4?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  countryCode: CountryCodes;
  familyName: Scalars['String'];
  givenName: Scalars['String'];
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  normalize?: InputMaybe<Scalars['Boolean']>;
  postalCode?: InputMaybe<Scalars['String']>;
  preferredAddress?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationAddTaxIdArgs = {
  taxId: Scalars['String'];
  token: Scalars['String'];
  type: TaxIdType;
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationAddUserToCustomerListArgs = {
  listName: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationApplyOfferToUserArgs = {
  token: Scalars['String'];
  type: OfferPrograms;
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationApproveApplePayPaymentArgs = {
  billingContact: ApplePayPaymentContact;
  clientID: Scalars['String'];
  merchantID?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderID: Scalars['String'];
  productFlow?: InputMaybe<Scalars['String']>;
  shippingContact?: InputMaybe<ApplePayPaymentContact>;
  token: ApplePayPaymentToken;
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationApproveGooglePayPaymentArgs = {
  clientID: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  orderID: Scalars['String'];
  paymentMethodData: GooglePayPaymentMethodData;
  productFlow?: InputMaybe<Scalars['String']>;
  shippingAddress?: InputMaybe<GooglePayPaymentContact>;
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationApproveGuestPaymentWithApplePayTokenArgs = {
  applePayPaymentInput: ApplePayPaymentInput;
  isSntSupported?: InputMaybe<Scalars['Boolean']>;
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationApproveGuestPaymentWithCreditCardArgs = {
  billingAddress?: InputMaybe<AddressInput>;
  card?: InputMaybe<CardInput>;
  currencyConversionType?: InputMaybe<CheckoutCurrencyConversionType>;
  email?: InputMaybe<Scalars['String']>;
  feeReferenceId?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  identityDocument?: InputMaybe<IdentityDocumentInput>;
  installmentTerm?: InputMaybe<Scalars['Int']>;
  lastName?: InputMaybe<Scalars['String']>;
  paymentToken?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  shippingAddress?: InputMaybe<AddressInput>;
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationApproveGuestSignUpPaymentArgs = {
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationApproveMemberPaymentArgs = {
  balancePreference?: InputMaybe<BalancePreference>;
  card3DSResolve3DSCode?: InputMaybe<Scalars['String']>;
  cardCvvValue?: InputMaybe<Scalars['String']>;
  cryptocurrencyQuoteId?: InputMaybe<Scalars['String']>;
  fullWalletOptIn?: InputMaybe<Scalars['Boolean']>;
  fundingMethodType?: InputMaybe<FundingInstrumentMethodType>;
  legalAgreements?: InputMaybe<LegalAgreementsInput>;
  paycodeEncrypted?: InputMaybe<Scalars['String']>;
  preAuthorizationRequired?: InputMaybe<Scalars['Boolean']>;
  preferredFundingOptionId?: InputMaybe<Scalars['String']>;
  preferredShippingAddressId?: InputMaybe<Scalars['String']>;
  primaryFundingOptionId?: InputMaybe<Scalars['String']>;
  rewards?: InputMaybe<RewardsInput>;
  secondaryFundingOptionIds?: InputMaybe<Array<Scalars['String']>>;
  selectedAddressId?: InputMaybe<Scalars['String']>;
  selectedInstallmentOption?: InputMaybe<InstallmentsInput>;
  setStickyFiRequired?: InputMaybe<Scalars['Boolean']>;
  shareAddressWithDonatee?: InputMaybe<Scalars['Boolean']>;
  strongCustomerAuthenticationCompleted?: InputMaybe<Scalars['Boolean']>;
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationApproveMemberPaymentWithSplitFundingOptionsArgs = {
  fullWalletOptIn?: InputMaybe<Scalars['Boolean']>;
  preferredShippingAddressId?: InputMaybe<Scalars['String']>;
  selectedAddressId?: InputMaybe<Scalars['String']>;
  splitFundingOptions: Array<InputMaybe<SplitFundingOptionsInput>>;
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationApprovePaymentArgs = {
  preferredFundingOptionId?: InputMaybe<Scalars['String']>;
  preferredShippingAddressId?: InputMaybe<Scalars['String']>;
  selectedAddressId?: InputMaybe<Scalars['String']>;
  selectedPlanId: Scalars['String'];
  strongCustomerAuthenticationCompleted?: InputMaybe<Scalars['Boolean']>;
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationApproveSuggestedDonationArgs = {
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationAttemptSetStickyFiArgs = {
  instrumentId?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationCheckoutGuestWithMemberBenefitsArgs = {
  bank?: InputMaybe<BankAccountInput>;
  billingAddress?: InputMaybe<AddressInput>;
  card?: InputMaybe<CardInput>;
  country: CountryCodes;
  currencyConversionType?: InputMaybe<CheckoutCurrencyConversionType>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: PhoneInput;
  shippingAddress?: InputMaybe<AddressInput>;
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationClearCheckoutSessionCreditFinancingOptionArgs = {
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationClearCreditFinancingOptionArgs = {
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationClearRealTimeBalanceContingencyArgs = {
  bankId: Scalars['String'];
  error?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationCompleteOtpConfirmationArgs = {
  card: CompleteCardOtpConfirmationInput;
  fundingInstrumentId: Scalars['String'];
  phone: PhoneInput;
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationCompletePaymentArgs = {
  buyerAccessToken: Scalars['String'];
  clientID: Scalars['String'];
  partnerAttributionId?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationCompleteStrongCustomerAuthenticationArgs = {
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationConfirmCreditCardCvvArgs = {
  input?: InputMaybe<ConfirmCreditCardCvvInput>;
  planId?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationConfirmRiskBasedTwoFactorPhoneConfirmationArgs = {
  authId: Scalars['String'];
  challengeId: Scalars['String'];
  pin: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationConfirmTwoFactorPhoneConfirmationArgs = {
  pin: Scalars['String'];
  verificationId: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationCreateCapeMayflyPayloadArgs = {
  cartAmount?: InputMaybe<Scalars['String']>;
  cartCurrency?: InputMaybe<Scalars['String']>;
  creditFundingInstrumentId: Scalars['String'];
  creditIncentiveDetails?: InputMaybe<CreditIncentiveDetailsInput>;
  isCreditSecondButton?: InputMaybe<Scalars['Boolean']>;
  isCrossCurrencyTransaction?: InputMaybe<Scalars['Boolean']>;
  isPPCInstallments?: InputMaybe<Scalars['Boolean']>;
  isPPCReuse?: InputMaybe<Scalars['Boolean']>;
  pageContext: Scalars['String'];
  returnUriBase: Scalars['String'];
  token: Scalars['String'];
  userSelectedAddressId: Scalars['String'];
  userSelectedPreferredShippingAddressId: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationCreateMemberAccountArgs = {
  billingAddress?: InputMaybe<AddressInput>;
  contentIdentifier?: InputMaybe<Scalars['String']>;
  country: CountryCodes;
  countryOfResidence?: InputMaybe<CountryCodes>;
  crsData?: InputMaybe<CommonReportingStandardsInput>;
  dateOfBirth?: InputMaybe<DateOfBirth>;
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  gender?: InputMaybe<Gender>;
  identityDocument?: InputMaybe<IdentityDocumentInput>;
  lastName: Scalars['String'];
  legalAgreements?: InputMaybe<LegalAgreementsInput>;
  marketingOptOut?: InputMaybe<Scalars['Boolean']>;
  middleName?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<CountryCodes>;
  occupation?: InputMaybe<Occupation>;
  password?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<PhoneInput>;
  placeOfBirth?: InputMaybe<CountryCodes>;
  residentialAddress?: InputMaybe<AddressInput>;
  secondaryIdentityDocument?: InputMaybe<IdentityDocumentInput>;
  shippingAddress?: InputMaybe<AddressInput>;
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationCreateOnboardingPaymentPlanArgs = {
  currencyConversionType?: InputMaybe<CheckoutCurrencyConversionType>;
  cvv?: InputMaybe<Scalars['String']>;
  encryptedCardLoginAccountNumber?: InputMaybe<Scalars['String']>;
  fundingInstrumentId: Scalars['String'];
  shareAddressWithDonatee?: InputMaybe<Scalars['Boolean']>;
  shippingAddress?: InputMaybe<AddressInput>;
  token: Scalars['String'];
  userType: OnboardingExperienceType;
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationCreateUpgradedLowScopeAccessTokenArgs = {
  buyerAccessToken: Scalars['String'];
  merchantLSAT: Scalars['String'];
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationDeleteShippingAddressArgs = {
  addressId: Scalars['String'];
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationDeleteVaultArgs = {
  paymentMethodID: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationEnableVaultArgs = {
  clientConfig?: InputMaybe<ClientConfigInput>;
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationInitiateOtpConfirmationArgs = {
  fundingInstrumentId: Scalars['String'];
  phone: PhoneInput;
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationInitiateRiskBasedTwoFactorPhoneConfirmationArgs = {
  locale?: InputMaybe<LocaleInput>;
  phoneCountry?: InputMaybe<CountryCodes>;
  phoneNumber: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationInitiateTwoFactorPhoneConfirmationArgs = {
  locale?: InputMaybe<LocaleInput>;
  phoneCountry?: InputMaybe<CountryCodes>;
  phoneNumber: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationInvalidateCheckoutSessionPlanArgs = {
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationOnboardGuestArgs = {
  bank?: InputMaybe<BankAccountInput>;
  billingAddress?: InputMaybe<AddressInput>;
  card?: InputMaybe<CardInput>;
  country?: InputMaybe<CountryCodes>;
  currencyConversionType?: InputMaybe<CheckoutCurrencyConversionType>;
  dateOfBirth?: InputMaybe<DateOfBirth>;
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone?: InputMaybe<PhoneInput>;
  shareAddressWithDonatee?: InputMaybe<Scalars['Boolean']>;
  shippingAddress?: InputMaybe<AddressInput>;
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationOnboardGuestForInlineXoArgs = {
  billingAddress?: InputMaybe<AddressInput>;
  billingType?: InputMaybe<Scalars['String']>;
  card?: InputMaybe<CardInput>;
  country?: InputMaybe<CountryCodes>;
  currencyConversionType?: InputMaybe<CheckoutCurrencyConversionType>;
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  isChangeShippingAddressAllowed?: InputMaybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  phone?: InputMaybe<PhoneInput>;
  shippingAddress?: InputMaybe<AddressInput>;
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationOneClickPaymentArgs = {
  selectedInstrumentId: Scalars['String'];
  selectedInstrumentType: Scalars['String'];
  selectedPlanId?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
  useExistingPlanning?: InputMaybe<Scalars['Boolean']>;
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationOptOutWebLlsArgs = {
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationPreAuthorizePaymentArgs = {
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationProcessCapeReturnArgs = {
  financialInstrumentDetails?: InputMaybe<CreditFinancialInstrumentDetailsInput>;
  financialInstrumentId: Scalars['String'];
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationProcessCreditApplyPortableResponseArgs = {
  encryptedPayload: Scalars['String'];
  skipFiContingency?: InputMaybe<Scalars['Boolean']>;
  token: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationRemoveConstraintOnFiArgs = {
  fundingOptionId: Scalars['String'];
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationReplaceCardArgs = {
  address: AddCardBillingAddressInput;
  card: AddCardInput;
  fundingOptionId: Scalars['String'];
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationResolveNeedPhoneContingencyArgs = {
  consentContentId?: InputMaybe<Scalars['String']>;
  country: CountryCodes;
  phone: PhoneInput;
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationResolveThreeDsContingencyArgs = {
  authId: Scalars['String'];
  creditCardId: Scalars['String'];
  planId?: InputMaybe<Scalars['String']>;
  referenceId: Scalars['String'];
  status: ResolveThreeDsContingencyStatus;
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationResolveTravelRuleContingencyArgs = {
  address?: InputMaybe<AddressInput>;
  dateOfBirth?: InputMaybe<DateOfBirth>;
  identityDocument?: InputMaybe<IdentityDocumentInput>;
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationRetrieveCapeMayflyResponseArgs = {
  mayflyKey: Scalars['String'];
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationSaveSharedCardConsentArgs = {
  sharedConsent: Scalars['Boolean'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationSignUpNewMemberArgs = {
  bank?: InputMaybe<BankAccountInput>;
  billingAddress?: InputMaybe<AddressInput>;
  card?: InputMaybe<CardInput>;
  collectedConsents?: InputMaybe<Array<InputMaybe<CollectedConsent>>>;
  contentIdentifier?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCodes>;
  countryOfResidence?: InputMaybe<CountryCodes>;
  countrySpecificFirstName?: InputMaybe<Scalars['String']>;
  countrySpecificLastName?: InputMaybe<Scalars['String']>;
  crsData?: InputMaybe<CommonReportingStandardsInput>;
  currencyConversionType?: InputMaybe<CheckoutCurrencyConversionType>;
  dateOfBirth?: InputMaybe<DateOfBirth>;
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  gender?: InputMaybe<Gender>;
  identityDocument?: InputMaybe<IdentityDocumentInput>;
  isSignupIncentiveOptIn?: InputMaybe<Scalars['Boolean']>;
  isSignupIncentiveOptInStretch?: InputMaybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  legalAgreements?: InputMaybe<LegalAgreementsInput>;
  marketingOptOut?: InputMaybe<Scalars['Boolean']>;
  middleName?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<CountryCodes>;
  occupation?: InputMaybe<Occupation>;
  password?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<PhoneInput>;
  placeOfBirth?: InputMaybe<CountryCodes>;
  residentialAddress?: InputMaybe<AddressInput>;
  secondaryIdentityDocument?: InputMaybe<IdentityDocumentInput>;
  selectedInstallmentOption?: InputMaybe<InstallmentsInput>;
  shareAddressWithDonatee?: InputMaybe<Scalars['Boolean']>;
  shippingAddress?: InputMaybe<AddressInput>;
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationThreeDsAuthenticateArgs = {
  amount: AmountInput;
  authenticatePayload: ThreedsLookUpPayload;
  paymentAuthenticationRequest: Scalars['String'];
  productDetails?: InputMaybe<ProductDetails>;
  threeDsServerTransactionId: Scalars['String'];
  token?: InputMaybe<Scalars['String']>;
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationThreeDsConfirmationWithUpdateFundingOptionArgs = {
  confirmationId: Scalars['String'];
  confirmationMethod: ThreedsConfirmationMethod;
  confirmationStatus?: InputMaybe<Scalars['String']>;
  cvv: Scalars['String'];
  fiId: Scalars['String'];
  referenceId: Scalars['String'];
  token: Scalars['String'];
  transactionId: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationThreeDsLookUpArgs = {
  amount: AmountInput;
  browserInfo?: InputMaybe<ThreedsBrowserDetailsInput>;
  nativeSDK?: InputMaybe<Scalars['Boolean']>;
  partnerDetails?: InputMaybe<PartnerDetails>;
  productDetails?: InputMaybe<ProductDetails>;
  threedsLookUpPayload: ThreedsLookUpPayload;
  token?: InputMaybe<Scalars['String']>;
  traRiskDetails?: InputMaybe<TraRiskDetails>;
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationThreedsCreateConfirmationArgs = {
  bypassConfirmationProcess?: InputMaybe<Scalars['Boolean']>;
  confirmationMethod: ThreedsConfirmationMethod;
  cvv?: InputMaybe<Scalars['String']>;
  fiId?: InputMaybe<Scalars['String']>;
  referenceId?: InputMaybe<Scalars['String']>;
  senderContext: ThreedsSenderContextInput;
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationThreedsUpdateConfirmationArgs = {
  confirmationId: Scalars['String'];
  confirmationMethod: ThreedsConfirmationMethod;
  confirmationStatus?: InputMaybe<Scalars['String']>;
  cvv: Scalars['String'];
  fiId: Scalars['String'];
  referenceId: Scalars['String'];
  transactionId: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationTriggerReplanArgs = {
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationUpdateCallbackOptionsArgs = {
  callbackShippingMethods?: InputMaybe<Array<InputMaybe<CallbackShippingMethodInput>>>;
  shippingOptionsSource?: InputMaybe<ShippingOptionsSource>;
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationUpdateCardArgs = {
  address?: InputMaybe<AddCardBillingAddressInput>;
  card: AddCardInput;
  cardType?: InputMaybe<FundingOptionType>;
  fundingOptionId: Scalars['String'];
  token: Scalars['String'];
  user: AddCardUserInput;
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationUpdateCardWithoutTokenArgs = {
  address: AddCardBillingAddressInput;
  card: AddCardInput;
  cardType?: InputMaybe<FundingOptionType>;
  fundingOptionId: Scalars['String'];
  user: AddCardUserInput;
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationUpdateCheckoutSessionCreditFinancingOptionArgs = {
  fundingInstrumentFinancingDetail?: InputMaybe<FundingInstrumentFinancingInput>;
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationUpdateCheckoutSessionFundingOptionsArgs = {
  fundingOptionId: Scalars['String'];
  threeDSResolved?: InputMaybe<Scalars['Boolean']>;
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationUpdateClientConfigArgs = {
  buttonSessionID?: InputMaybe<Scalars['String']>;
  buyerIntent?: InputMaybe<BuyerIntentType>;
  channel?: InputMaybe<ProductChannel>;
  fundingSource?: InputMaybe<ButtonFundingSourceType>;
  integrationArtifact?: InputMaybe<IntegrationArtifactType>;
  productCode?: InputMaybe<ProductCodeType>;
  productFeature?: InputMaybe<ProductFeatureType>;
  productFlow?: InputMaybe<ProductFlowType>;
  token: Scalars['String'];
  userExperienceFlow?: InputMaybe<UserExperienceFlowType>;
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationUpdateCurrencyConversionTypeArgs = {
  conversionType: CheckoutCurrencyConversionType;
  planId?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationUpdateGuestShippingAddressCallbackArgs = {
  address: GuestAddressInput;
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationUpdateGuestShippingMethodCallbackArgs = {
  shippingMethodId: Scalars['String'];
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationUpdateProfileShippingOptionsArgs = {
  hideShipping?: InputMaybe<Scalars['Boolean']>;
  profileOverrideAllowed?: InputMaybe<Scalars['Boolean']>;
  profileShippingMethods?: InputMaybe<Array<InputMaybe<ProfileShippingMethodInput>>>;
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationUpdateShippingArgs = {
  clientID: Scalars['String'];
  patch: Array<InputMaybe<Scalars['JSON']>>;
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationUpdateShippingAddressArgs = {
  addressId: Scalars['String'];
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  addressLine3?: InputMaybe<Scalars['String']>;
  adminArea1?: InputMaybe<Scalars['String']>;
  adminArea2?: InputMaybe<Scalars['String']>;
  adminArea3?: InputMaybe<Scalars['String']>;
  adminArea4?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  countryCode: CountryCodes;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationUpdateShippingAddressCallbackArgs = {
  addressId: Scalars['String'];
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationUpdateShippingMethodCallbackArgs = {
  shippingMethodId: Scalars['String'];
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationUpdateShippingMethodsArgs = {
  shippingMethods: Array<InputMaybe<ShippingMethodInput>>;
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationUpdateShippingMethodsForGuestArgs = {
  shippingMethods: Array<InputMaybe<ShippingMethodInput>>;
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationUpdateUserAddressAttributesArgs = {
  addressId: Scalars['String'];
  normalizationStatus?: InputMaybe<UserAddressNormalizationStatus>;
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationUpdateVaultSetupTokenArgs = {
  clientId?: InputMaybe<Scalars['String']>;
  idToken?: InputMaybe<Scalars['String']>;
  paymentSource?: InputMaybe<PaymentSource>;
  sdkClientToken?: InputMaybe<Scalars['String']>;
  vaultSetupToken: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationUpgradeGuestToMemberArgs = {
  billingAddress?: InputMaybe<AddressInput>;
  contentIdentifier?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCodes>;
  countryOfResidence?: InputMaybe<CountryCodes>;
  dateOfBirth?: InputMaybe<DateOfBirth>;
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  gender?: InputMaybe<Gender>;
  identityDocument?: InputMaybe<IdentityDocumentInput>;
  lastName: Scalars['String'];
  legalAgreements?: InputMaybe<LegalAgreementsInput>;
  marketingOptOut?: InputMaybe<Scalars['Boolean']>;
  middleName?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<CountryCodes>;
  occupation?: InputMaybe<Occupation>;
  password?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<PhoneInput>;
  placeOfBirth?: InputMaybe<CountryCodes>;
  residentialAddress?: InputMaybe<AddressInput>;
  secondaryIdentityDocument?: InputMaybe<IdentityDocumentInput>;
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationUpgradeLowScopeAccessTokenArgs = {
  buyerAccessToken: Scalars['String'];
  merchantLSAT: Scalars['String'];
  token: Scalars['String'];
};


/** Mutation root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type MutationVenmoCredentialExchangeArgs = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  orderID: Scalars['String'];
  phone: Scalars['String'];
  tspCommonId: Scalars['String'];
};

/**
 * This enum declares several different types of privileges we may allow for
 * first party vetted host apps on iOS and Android.
 */
export enum NativeSdkPrivilege {
  /**
   * Allows the host app to integrate with FireBase and or listen in to the
   * payloads being sent back and forth over that bus.
   */
  FullFirebase = 'FULL_FIREBASE',
  /**
   * Allows the host app to inject networking events on either the inbound or
   * outbound network passes. This would allow talking to the host apps'
   * internal network calls
   */
  FullIoCustomization = 'FULL_IO_CUSTOMIZATION',
  /** Allows the host app to adjust the experience from a UI perspective */
  FullUiCustomization = 'FULL_UI_CUSTOMIZATION'
}

/**
 * The NativeSDKPrivilegedResponse is returned from a query to the field
 * `isPrivilegedHostApp`. The clientId sent to that query as a parameter denotes
 * whether or not the
 */
export type NativeSdkPrivilegedResponse = {
  __typename?: 'NativeSDKPrivilegedResponse';
  /** At least one elevated privilege was found for this host */
  allowed: Scalars['Boolean'];
  /** A list of NativeSDKPrivilege values denoting the capability of the host app */
  privileges: Array<Maybe<NativeSdkPrivilege>>;
  /** Should the `allowed` field return false, this field endeavors to explain why */
  reasoning?: Maybe<Scalars['String']>;
};

/** Encapsulates all properties related to an individual credit offer for non members. */
export type NonMemberCreditOffer = {
  __typename?: 'NonMemberCreditOffer';
  /** APR rate for the offer */
  apr?: Maybe<Rate>;
  /** Credit type (e.g. INST for installment, NI for no interest, PUI for pay upon invoice, etc) */
  creditOfferType?: Maybe<CreditOfferType>;
  /** Unique identifier representing the credit product being offered */
  creditProductIdentifier?: Maybe<CreditProductType>;
  /** Encapsulates all properties related to the offer's down payment */
  downPayment?: Maybe<CreditDownPayment>;
  /** Estimated installments for a credit offer that has installments */
  estimatedInstallments?: Maybe<Array<Maybe<InstallmentSchedule>>>;
  /** Flag indicating if the offer is eligible */
  isEligible?: Maybe<Scalars['Boolean']>;
  /**
   * Flag indicating if there are additional offers with the same APR, same credit type,
   * and same eligibility
   */
  isMultipleApr?: Maybe<Scalars['Boolean']>;
  /**
   * Flag indicating if the option's credit fee is funded by PayPal.
   * If false it is funded by the merchant
   */
  isPayPalSubsidy?: Maybe<Scalars['Boolean']>;
  /** The monthly percentage rate of the credit offer */
  monthlyPercentageRate?: Maybe<Rate>;
  /** The annualized rate - calculated as the monthly rate multiplied by 12 */
  nominalRate?: Maybe<Rate>;
  /** The currency and amount for a financial transaction, such as a balance or payment due. */
  periodicPayment?: Maybe<Amount>;
  /** The total cost, including principal and interest, of the financed transaction */
  totalCost?: Maybe<Amount>;
  /** The amount of interest to be paid over the course of the financed transaction */
  totalInterest?: Maybe<Amount>;
  /** The total term of the credit offer */
  totalNumberOfPayments?: Maybe<Scalars['Int']>;
};

/** Encapsulates all properties related credit offers for non-members. */
export type NonMemberCreditOffers = {
  __typename?: 'NonMemberCreditOffers';
  /** All the eligible non-member offers for a particular transaction */
  allOffers?: Maybe<Array<Maybe<NonMemberCreditOffer>>>;
};

/** Encapsulates all properties we want to extract from a normalized address. Ex: line1, city, postalCode */
export type NormalizedAddress = {
  __typename?: 'NormalizedAddress';
  /** It returns true if the input address is same as normalized address returned by ANS */
  alreadyNormalized?: Maybe<Scalars['Boolean']>;
  /** A normalized billing address city (Ex: 'San Jose') */
  city?: Maybe<Scalars['String']>;
  /** A normalized billing address two-letter country code (Ex: 'US') */
  country?: Maybe<CountryCodes>;
  /** A container for addresses that have been formatted by Griifin for display on the UI */
  griffinFormattedAddresses?: Maybe<GriffinFormattedAddresses>;
  /** A noramlized billing address first line street address (Ex: '2211 North 1st St') */
  line1?: Maybe<Scalars['String']>;
  /** A normalized billing address second line street address (Ex: 'Apt 123') */
  line2?: Maybe<Scalars['String']>;
  /** A normalized billing address postal code (Ex: '95131') */
  postalCode?: Maybe<Scalars['String']>;
  /** A normalized billing address state/province (Ex: 'CA') */
  state?: Maybe<Scalars['String']>;
};

/** An enumeration of all occupations that a user can select */
export enum Occupation {
  /** Accounting */
  Accounting = 'ACCOUNTING',
  /** Administration */
  Administration = 'ADMINISTRATION',
  /** Arts, Culture */
  ArtsAndCulture = 'ARTS_AND_CULTURE',
  /** Business */
  Business = 'BUSINESS',
  /**
   * Items below are a new set for occupancy list, currently in A/B test
   * Experiment: FEATURE_SIGNUP_OCCUPATION_LIST
   *
   * Business Management - Accountant
   */
  BusMgmtAccountant = 'BUS_MGMT_ACCOUNTANT',
  /** Business Management - Accounts Payables/Receivables */
  BusMgmtAcctsPayRecv = 'BUS_MGMT_ACCTS_PAY_RECV',
  /** Business Management - Analyst */
  BusMgmtAnalyst = 'BUS_MGMT_ANALYST',
  /** Business Management - Benefits Administrator */
  BusMgmtBenefitsAdmin = 'BUS_MGMT_BENEFITS_ADMIN',
  /** Business Management - Board Member */
  BusMgmtBoardMember = 'BUS_MGMT_BOARD_MEMBER',
  /** Business Management - Chief Executive Officer */
  BusMgmtCeo = 'BUS_MGMT_CEO',
  /** Business Management - Chief Financial Officer */
  BusMgmtCfo = 'BUS_MGMT_CFO',
  /** Business Management - Chief Marketing Officer */
  BusMgmtCmo = 'BUS_MGMT_CMO',
  /** Business Management - Consultant */
  BusMgmtConsultant = 'BUS_MGMT_CONSULTANT',
  /** Business Management - Chief Operating Officer */
  BusMgmtCoo = 'BUS_MGMT_COO',
  /** Business Management - Corporate Auditor */
  BusMgmtCorpAuditor = 'BUS_MGMT_CORP_AUDITOR',
  /** Business Management - Chief Risk Officer */
  BusMgmtCro = 'BUS_MGMT_CRO',
  /** Business Management - Executive */
  BusMgmtExecutive = 'BUS_MGMT_EXECUTIVE',
  /** Business Management - HR Administrator */
  BusMgmtHrAdmin = 'BUS_MGMT_HR_ADMIN',
  /** Business Management - Inside Sales */
  BusMgmtInsideSales = 'BUS_MGMT_INSIDE_SALES',
  /** Business Management - Mergers & Acquisitions */
  BusMgmtMa = 'BUS_MGMT_MA',
  /** Business Management - Others */
  BusMgmtOthers = 'BUS_MGMT_OTHERS',
  /** Business Management - Outside Sales */
  BusMgmtOutsideSales = 'BUS_MGMT_OUTSIDE_SALES',
  /** Business Management - Payroll Administrator */
  BusMgmtPayrollAdmin = 'BUS_MGMT_PAYROLL_ADMIN',
  /** Business Management - President */
  BusMgmtPresident = 'BUS_MGMT_PRESIDENT',
  /** Business Management - Project Manager */
  BusMgmtProjectMgr = 'BUS_MGMT_PROJECT_MGR',
  /** Business Management - Records Manager */
  BusMgmtRecordsMgr = 'BUS_MGMT_RECORDS_MGR',
  /** Business Management - Recruiter */
  BusMgmtRecruiter = 'BUS_MGMT_RECRUITER',
  /** Business Management - Secretary */
  BusMgmtSecretary = 'BUS_MGMT_SECRETARY',
  /** Business Management - Strategy */
  BusMgmtStrategy = 'BUS_MGMT_STRATEGY',
  /** Business Management - Telemarketing */
  BusMgmtTelemarketing = 'BUS_MGMT_TELEMARKETING',
  /** Business Management - Training */
  BusMgmtTraining = 'BUS_MGMT_TRAINING',
  /** Business Management - Treasurer */
  BusMgmtTreasurer = 'BUS_MGMT_TREASURER',
  /** Communications */
  Communications = 'COMMUNICATIONS',
  /** Construction - Apprentice */
  ConstructionApprentice = 'CONSTRUCTION_APPRENTICE',
  /** Construction - Carpenter */
  ConstructionCarpenter = 'CONSTRUCTION_CARPENTER',
  /** Construction - Drywall */
  ConstructionDrywall = 'CONSTRUCTION_DRYWALL',
  /** Construction - Electrician */
  ConstructionElectrician = 'CONSTRUCTION_ELECTRICIAN',
  /** Construction - Floor Installer */
  ConstructionFloorInstaller = 'CONSTRUCTION_FLOOR_INSTALLER',
  /** Construction - Framer */
  ConstructionFramer = 'CONSTRUCTION_FRAMER',
  /** Construction - Heating/HVAC */
  ConstructionHeatingHvac = 'CONSTRUCTION_HEATING_HVAC',
  /** Construction - Ironworker */
  ConstructionIronworker = 'CONSTRUCTION_IRONWORKER',
  /** Construction - Landscaper */
  ConstructionLandscaper = 'CONSTRUCTION_LANDSCAPER',
  /** Construction - Mason */
  ConstructionMason = 'CONSTRUCTION_MASON',
  /** Construction - Metal Fabrication */
  ConstructionMetalFabrication = 'CONSTRUCTION_METAL_FABRICATION',
  /** Construction - Others */
  ConstructionOthers = 'CONSTRUCTION_OTHERS',
  /** Construction - Painter */
  ConstructionPainter = 'CONSTRUCTION_PAINTER',
  /** Construction - Plumber */
  ConstructionPlumber = 'CONSTRUCTION_PLUMBER',
  /** Construction - Roofer */
  ConstructionRoofer = 'CONSTRUCTION_ROOFER',
  /** Construction - Supervisor */
  ConstructionSupervisor = 'CONSTRUCTION_SUPERVISOR',
  /** Construction - Surveyor */
  ConstructionSurveyor = 'CONSTRUCTION_SURVEYOR',
  /** Construction - Tile Installer */
  ConstructionTileInstaller = 'CONSTRUCTION_TILE_INSTALLER',
  /** Creative - Advertising Executive */
  CreativeAdvertisingExec = 'CREATIVE_ADVERTISING_EXEC',
  /** Creative - Advertising Sales */
  CreativeAdvertisingSales = 'CREATIVE_ADVERTISING_SALES',
  /** Creative - Artist */
  CreativeArtist = 'CREATIVE_ARTIST',
  /** Creative - Author */
  CreativeAuthor = 'CREATIVE_AUTHOR',
  /** Creative - Blogger */
  CreativeBlogger = 'CREATIVE_BLOGGER',
  /** Creative - Computer Animator */
  CreativeComputerAnimator = 'CREATIVE_COMPUTER_ANIMATOR',
  /** Creative - Content Creator */
  CreativeContentCreator = 'CREATIVE_CONTENT_CREATOR',
  /** Creative - Fashion Designer */
  CreativeFashionDesigner = 'CREATIVE_FASHION_DESIGNER',
  /** Creative - Industrial Design */
  CreativeIndustrialDesign = 'CREATIVE_INDUSTRIAL_DESIGN',
  /** Creative - Interior Designer */
  CreativeInteriorDesigner = 'CREATIVE_INTERIOR_DESIGNER',
  /** Creative - Musician */
  CreativeMusician = 'CREATIVE_MUSICIAN',
  /** Creative - Others */
  CreativeOthers = 'CREATIVE_OTHERS',
  /** Creative - Photographer */
  CreativePhotographer = 'CREATIVE_PHOTOGRAPHER',
  /** Creative - Publisher */
  CreativePublisher = 'CREATIVE_PUBLISHER',
  /** Creative - Sculptor */
  CreativeSculptor = 'CREATIVE_SCULPTOR',
  /** Creative - Sound Technician */
  CreativeSoundTechnician = 'CREATIVE_SOUND_TECHNICIAN',
  /** Creative - Web Designer */
  CreativeWebDesigner = 'CREATIVE_WEB_DESIGNER',
  /** Customer Service */
  CustomerService = 'CUSTOMER_SERVICE',
  /** Education */
  Education = 'EDUCATION',
  /** Education - Administrator */
  EducationAdministrator = 'EDUCATION_ADMINISTRATOR',
  /** Education - Adult Educator */
  EducationAdultEducator = 'EDUCATION_ADULT_EDUCATOR',
  /** Education - Early Child Development */
  EducationEarlyChildDevt = 'EDUCATION_EARLY_CHILD_DEVT',
  /** Education - Librarian */
  EducationLibrarian = 'EDUCATION_LIBRARIAN',
  /** Education - Others */
  EducationOthers = 'EDUCATION_OTHERS',
  /** Education - Principal/Director */
  EducationPrincipalVp = 'EDUCATION_PRINCIPAL_VP',
  /** Education - Professor */
  EducationProfessor = 'EDUCATION_PROFESSOR',
  /** Education - Software Trainer */
  EducationSoftwareTrainer = 'EDUCATION_SOFTWARE_TRAINER',
  /** Education - Special Education */
  EducationSpecialEducation = 'EDUCATION_SPECIAL_EDUCATION',
  /** Education - Teacher-College/University */
  EducationTeacherCollUniv = 'EDUCATION_TEACHER_COLL_UNIV',
  /** Education - Teacher-Elementary */
  EducationTeacherElementary = 'EDUCATION_TEACHER_ELEMENTARY',
  /** Education - Teacher-Pre School */
  EducationTeacherPreSchool = 'EDUCATION_TEACHER_PRE_SCHOOL',
  /** Education - Teacher-Secondary */
  EducationTeacherSecondary = 'EDUCATION_TEACHER_SECONDARY',
  /** Education - Teaching Assistant */
  EducationTeachingAssistant = 'EDUCATION_TEACHING_ASSISTANT',
  /** Energy, Utilities */
  EnergyAndUtilities = 'ENERGY_AND_UTILITIES',
  /** Engineering */
  Engineering = 'ENGINEERING',
  /** Engineer - Aeronautic */
  EngineerAeronautic = 'ENGINEER_AERONAUTIC',
  /** Engineer - Architect */
  EngineerArchitect = 'ENGINEER_ARCHITECT',
  /** Engineer - Bio-Engineering */
  EngineerBioEngineering = 'ENGINEER_BIO_ENGINEERING',
  /** Engineer - Chemical */
  EngineerChemical = 'ENGINEER_CHEMICAL',
  /** Engineer - Civil */
  EngineerCivil = 'ENGINEER_CIVIL',
  /** Engineer - Drafting/CAD */
  EngineerDraftingCad = 'ENGINEER_DRAFTING_CAD',
  /** Engineer - Electrical */
  EngineerElectrical = 'ENGINEER_ELECTRICAL',
  /** Engineer - Energy */
  EngineerEnergy = 'ENGINEER_ENERGY',
  /** Engineer - Environmental/Geology */
  EngineerEnviroGeo = 'ENGINEER_ENVIRO_GEO',
  /** Engineer - Industrial */
  EngineerIndustrial = 'ENGINEER_INDUSTRIAL',
  /** Engineer - Marine */
  EngineerMarine = 'ENGINEER_MARINE',
  /** Engineer - Mechanical */
  EngineerMechanical = 'ENGINEER_MECHANICAL',
  /** Engineer - Others */
  EngineerOthers = 'ENGINEER_OTHERS',
  /** Engineer - Process */
  EngineerProcess = 'ENGINEER_PROCESS',
  /** Engineer - Town/City Planning */
  EngineerTownCityPlanning = 'ENGINEER_TOWN_CITY_PLANNING',
  /** Engineer - Urban Planner */
  EngineerUrbanPlanner = 'ENGINEER_URBAN_PLANNER',
  /** Finance */
  Finance = 'FINANCE',
  /** Financial - Accountant */
  FinancialAccountant = 'FINANCIAL_ACCOUNTANT',
  /** Financial - Actuarial Analysis */
  FinancialActuarialAnalysis = 'FINANCIAL_ACTUARIAL_ANALYSIS',
  /** Financial - Administrator/Executive Support */
  FinancialAdminExecSupport = 'FINANCIAL_ADMIN_EXEC_SUPPORT',
  /** Financial - Advisor */
  FinancialAdvisor = 'FINANCIAL_ADVISOR',
  /** Financial - Analysis/Research */
  FinancialAnalysisResearch = 'FINANCIAL_ANALYSIS_RESEARCH',
  /** Financial - Bank Manager */
  FinancialBankManager = 'FINANCIAL_BANK_MANAGER',
  /** Financial - Bank Teller */
  FinancialBankTeller = 'FINANCIAL_BANK_TELLER',
  /** Financial - Bookkeeper */
  FinancialBookkeeper = 'FINANCIAL_BOOKKEEPER',
  /** Financial - Consultant */
  FinancialConsultant = 'FINANCIAL_CONSULTANT',
  /** Financial - Credit Analyst */
  FinancialCreditAnalyst = 'FINANCIAL_CREDIT_ANALYST',
  /** Financial - Credit Manager */
  FinancialCreditManager = 'FINANCIAL_CREDIT_MANAGER',
  /** Financial - Cust Service Representative */
  FinancialCustServiceRep = 'FINANCIAL_CUST_SERVICE_REP',
  /** Financial - Data Entry */
  FinancialDataEntry = 'FINANCIAL_DATA_ENTRY',
  /** Financial - Debt Collections */
  FinancialDebtCollections = 'FINANCIAL_DEBT_COLLECTIONS',
  /** Financial - Economist */
  FinancialEconomist = 'FINANCIAL_ECONOMIST',
  /** Financial - Fund Accounting */
  FinancialFundAccounting = 'FINANCIAL_FUND_ACCOUNTING',
  /** Financial - Insurance Broker */
  FinancialInsuranceBroker = 'FINANCIAL_INSURANCE_BROKER',
  /** Financial - Insurance Claims */
  FinancialInsuranceClaims = 'FINANCIAL_INSURANCE_CLAIMS',
  /** Financial - Investment Analyst */
  FinancialInvestmentAnalyst = 'FINANCIAL_INVESTMENT_ANALYST',
  /** Financial - Investment Broker */
  FinancialInvestmentBroker = 'FINANCIAL_INVESTMENT_BROKER',
  /** Financial - Loan Officer */
  FinancialLoanOfficer = 'FINANCIAL_LOAN_OFFICER',
  /** Financial - Manager */
  FinancialManager = 'FINANCIAL_MANAGER',
  /** Financial - Others */
  FinancialOthers = 'FINANCIAL_OTHERS',
  /** Financial Services */
  FinancialServices = 'FINANCIAL_SERVICES',
  /** Government */
  Government = 'GOVERNMENT',
  /** Health */
  Health = 'HEALTH',
  /** Health - Anesthesiologist */
  HealthAnesthesiologist = 'HEALTH_ANESTHESIOLOGIST',
  /** Health - Dental Hygienist */
  HealthDentalHygienist = 'HEALTH_DENTAL_HYGIENIST',
  /** Health - Dentist */
  HealthDentist = 'HEALTH_DENTIST',
  /** Health - Dietary Specialist */
  HealthDietarySpecialist = 'HEALTH_DIETARY_SPECIALIST',
  /** Health - Doctor - General */
  HealthDoctorGeneral = 'HEALTH_DOCTOR_GENERAL',
  /** Health - Doctor - Specialist */
  HealthDoctorSpecialist = 'HEALTH_DOCTOR_SPECIALIST',
  /** Health - EMT/Paramedic */
  HealthEmtParamedic = 'HEALTH_EMT_PARAMEDIC',
  /** Health - Healthcare Aid */
  HealthHealthcareAid = 'HEALTH_HEALTHCARE_AID',
  /** Health - Hospital Management */
  HealthHospitalMgmt = 'HEALTH_HOSPITAL_MGMT',
  /** Health - Imaging Technician */
  HealthImagingTechnician = 'HEALTH_IMAGING_TECHNICIAN',
  /** Health - Lab Tech/Pathology */
  HealthLabTechPathology = 'HEALTH_LAB_TECH_PATHOLOGY',
  /** Health - Medical Practitioner */
  HealthMedicalPractitioner = 'HEALTH_MEDICAL_PRACTITIONER',
  /** Health - Nurse */
  HealthNurse = 'HEALTH_NURSE',
  /** Health - Occupational Therapy */
  HealthOccupationalTherapy = 'HEALTH_OCCUPATIONAL_THERAPY',
  /** Health - Office Manager */
  HealthOfficeManager = 'HEALTH_OFFICE_MANAGER',
  /** Health - Optical Specialist */
  HealthOpticalSpecialist = 'HEALTH_OPTICAL_SPECIALIST',
  /** Health - Others */
  HealthOthers = 'HEALTH_OTHERS',
  /** Health - Pharmacist */
  HealthPharmacist = 'HEALTH_PHARMACIST',
  /** Health - Physiotherapist */
  HealthPhysiotherapist = 'HEALTH_PHYSIOTHERAPIST',
  /** Health - Psychiatrist */
  HealthPsychiatrist = 'HEALTH_PSYCHIATRIST',
  /** Health - Psychologist */
  HealthPsychologist = 'HEALTH_PSYCHOLOGIST',
  /** Health - Public Health Administrator */
  HealthPublicHealthAdmin = 'HEALTH_PUBLIC_HEALTH_ADMIN',
  /** Health - Radiologist */
  HealthRadiologist = 'HEALTH_RADIOLOGIST',
  /** Health - Social Services */
  HealthSocialServices = 'HEALTH_SOCIAL_SERVICES',
  /** Health - Sports Medicine Specialist */
  HealthSportsMedSpecialist = 'HEALTH_SPORTS_MED_SPECIALIST',
  /** Health - Surgeon */
  HealthSurgeon = 'HEALTH_SURGEON',
  /** Health - Veterinary */
  HealthVeterinary = 'HEALTH_VETERINARY',
  /** Hospitality */
  Hospitality = 'HOSPITALITY',
  /** Hospitality - Bartender */
  HospitalityBartender = 'HOSPITALITY_BARTENDER',
  /** Hospitality - Chef/Cook */
  HospitalityChefCook = 'HOSPITALITY_CHEF_COOK',
  /** Hospitality - Concierge */
  HospitalityConcierge = 'HOSPITALITY_CONCIERGE',
  /** Hospitality - Dishwasher */
  HospitalityDishwasher = 'HOSPITALITY_DISHWASHER',
  /** Hospitality - Event Planner */
  HospitalityEventPlanner = 'HOSPITALITY_EVENT_PLANNER',
  /** Hospitality - Food Services */
  HospitalityFoodServices = 'HOSPITALITY_FOOD_SERVICES',
  /** Hospitality - Guest Services */
  HospitalityGuestServices = 'HOSPITALITY_GUEST_SERVICES',
  /** Hospitality - Host/Hostess */
  HospitalityHostHostess = 'HOSPITALITY_HOST_HOSTESS',
  /** Hospitality - Hotel Management */
  HospitalityHotelManagement = 'HOSPITALITY_HOTEL_MANAGEMENT',
  /** Hospitality - Janitor */
  HospitalityJanitor = 'HOSPITALITY_JANITOR',
  /** Hospitality - Laundry */
  HospitalityLaundry = 'HOSPITALITY_LAUNDRY',
  /** Hospitality - Others */
  HospitalityOthers = 'HOSPITALITY_OTHERS',
  /** Hospitality - Pilot */
  HospitalityPilot = 'HOSPITALITY_PILOT',
  /** Hospitality - Reception */
  HospitalityReception = 'HOSPITALITY_RECEPTION',
  /** Hospitality - Restaurant Management */
  HospitalityRestaurantMgmt = 'HOSPITALITY_RESTAURANT_MGMT',
  /** Hospitality - Room Service */
  HospitalityRoomService = 'HOSPITALITY_ROOM_SERVICE',
  /** Hospitality - Ship Captain */
  HospitalityShipCaptain = 'HOSPITALITY_SHIP_CAPTAIN',
  /** Hospitality - Tour Guide */
  HospitalityTourGuide = 'HOSPITALITY_TOUR_GUIDE',
  /** Hospitality - Tour Operator */
  HospitalityTourOperator = 'HOSPITALITY_TOUR_OPERATOR',
  /** Hospitality - Travel Agent */
  HospitalityTravelAgent = 'HOSPITALITY_TRAVEL_AGENT',
  /** Hospitality - Waiter/Server */
  HospitalityWaiterServer = 'HOSPITALITY_WAITER_SERVER',
  /** Hospitality - Wine Steward */
  HospitalityWineSteward = 'HOSPITALITY_WINE_STEWARD',
  /** Human Resources */
  HumanResources = 'HUMAN_RESOURCES',
  /** Install/Repair - Electrician */
  InstallRepairElectrician = 'INSTALL_REPAIR_ELECTRICIAN',
  /** Install/Repair - Equipment */
  InstallRepairEquipment = 'INSTALL_REPAIR_EQUIPMENT',
  /** Install/Repair - Facility Manager */
  InstallRepairFacilityMgr = 'INSTALL_REPAIR_FACILITY_MGR',
  /** Install/Repair - Locksmith */
  InstallRepairLocksmith = 'INSTALL_REPAIR_LOCKSMITH',
  /** Install/Repair - Others */
  InstallRepairOthers = 'INSTALL_REPAIR_OTHERS',
  /** Install/Repair - Plumber */
  InstallRepairPlumber = 'INSTALL_REPAIR_PLUMBER',
  /** Install/Repair - Small Engine */
  InstallRepairSmallEngine = 'INSTALL_REPAIR_SMALL_ENGINE',
  /** Internet */
  Internet = 'INTERNET',
  /** Legal */
  Legal = 'LEGAL',
  /** Legal - Bailiff */
  LegalBailiff = 'LEGAL_BAILIFF',
  /** Legal - Bylaw Enforcement */
  LegalBylawEnforcement = 'LEGAL_BYLAW_ENFORCEMENT',
  /** Legal - Court Administrator */
  LegalCourtAdministrator = 'LEGAL_COURT_ADMINISTRATOR',
  /** Legal - Court Reporter */
  LegalCourtReporter = 'LEGAL_COURT_REPORTER',
  /** Legal - Customs Officer */
  LegalCustomsOfficer = 'LEGAL_CUSTOMS_OFFICER',
  /** Legal - Judge */
  LegalJudge = 'LEGAL_JUDGE',
  /** Legal - Lawyer */
  LegalLawyer = 'LEGAL_LAWYER',
  /** Legal - Lawyer - Criminal */
  LegalLawyerCriminal = 'LEGAL_LAWYER_CRIMINAL',
  /** Legal - Lawyer - Family */
  LegalLawyerFamily = 'LEGAL_LAWYER_FAMILY',
  /** Legal - Lawyer - Labour */
  LegalLawyerLabour = 'LEGAL_LAWYER_LABOUR',
  /** Legal - Lawyer - Patent/IP */
  LegalLawyerPatentIp = 'LEGAL_LAWYER_PATENT_IP',
  /** Legal - Lawyer - Real Estate */
  LegalLawyerRealEstate = 'LEGAL_LAWYER_REAL_ESTATE',
  /** Legal - Lawyer - Tax */
  LegalLawyerTax = 'LEGAL_LAWYER_TAX',
  /** Legal - Others */
  LegalOthers = 'LEGAL_OTHERS',
  /** Legal - Paralegal/Law Clerk */
  LegalParalegalLawClerk = 'LEGAL_PARALEGAL_LAW_CLERK',
  /** Legal - Police Officer */
  LegalPoliceOfficer = 'LEGAL_POLICE_OFFICER',
  /** Legal - Prison Guard */
  LegalPrisonGuard = 'LEGAL_PRISON_GUARD',
  /** Legal - Regulation Compliance */
  LegalRegCompliance = 'LEGAL_REG_COMPLIANCE',
  /** Legal - Secretary */
  LegalSecretary = 'LEGAL_SECRETARY',
  /** Logistics - Bike Courier */
  LogisticsBikeCourier = 'LOGISTICS_BIKE_COURIER',
  /** Logistics - Cargo Handler */
  LogisticsCargoHandler = 'LOGISTICS_CARGO_HANDLER',
  /** Logistics - Courier */
  LogisticsCourier = 'LOGISTICS_COURIER',
  /** Logistics - Customs Broker */
  LogisticsCustomsBroker = 'LOGISTICS_CUSTOMS_BROKER',
  /** Logistics - Dispatcher */
  LogisticsDispatcher = 'LOGISTICS_DISPATCHER',
  /** Logistics - Driver */
  LogisticsDriver = 'LOGISTICS_DRIVER',
  /** Logistics - Hazardous Materials Handler */
  LogisticsHazMatHandler = 'LOGISTICS_HAZ_MAT_HANDLER',
  /** Logistics - Import/Export */
  LogisticsImportExport = 'LOGISTICS_IMPORT_EXPORT',
  /** Logistics - Inventory Management */
  LogisticsInventoryMgmt = 'LOGISTICS_INVENTORY_MGMT',
  /** Logistics - Machine Operator */
  LogisticsMachineOperator = 'LOGISTICS_MACHINE_OPERATOR',
  /** Logistics - Mail Carrier */
  LogisticsMailCarrier = 'LOGISTICS_MAIL_CARRIER',
  /** Logistics - Mail Room */
  LogisticsMailRoom = 'LOGISTICS_MAIL_ROOM',
  /** Logistics - Others */
  LogisticsOthers = 'LOGISTICS_OTHERS',
  /** Logistics - Rail Operator */
  LogisticsRailOperator = 'LOGISTICS_RAIL_OPERATOR',
  /** Logistics - Shipper/Receiver */
  LogisticsShipperReceiver = 'LOGISTICS_SHIPPER_RECEIVER',
  /** Logistics - Ship Captain */
  LogisticsShipCaptain = 'LOGISTICS_SHIP_CAPTAIN',
  /** Logistics - Vendor Management */
  LogisticsVendorMgmt = 'LOGISTICS_VENDOR_MGMT',
  /** Manufacturing */
  Manufacturing = 'MANUFACTURING',
  /** Marketing */
  Marketing = 'MARKETING',
  /** Natural Resources - Arborist */
  NatResourcesArborist = 'NAT_RESOURCES_ARBORIST',
  /** Natural Resources - Biologic Research */
  NatResourcesBioResearch = 'NAT_RESOURCES_BIO_RESEARCH',
  /** Natural Resources - Chemist */
  NatResourcesChemist = 'NAT_RESOURCES_CHEMIST',
  /** Natural Resources - Consultant */
  NatResourcesConsultant = 'NAT_RESOURCES_CONSULTANT',
  /** Natural Resources - Engineer */
  NatResourcesEngineer = 'NAT_RESOURCES_ENGINEER',
  /** Natural Resources - Environmental Analyst */
  NatResourcesEnviroAnalyst = 'NAT_RESOURCES_ENVIRO_ANALYST',
  /** Natural Resources - Environmental Science */
  NatResourcesEnviroScience = 'NAT_RESOURCES_ENVIRO_SCIENCE',
  /** Natural Resources - Farmer */
  NatResourcesFarmer = 'NAT_RESOURCES_FARMER',
  /** Natural Resources - Fisherman */
  NatResourcesFisherman = 'NAT_RESOURCES_FISHERMAN',
  /** Natural Resources - Land Surveyor */
  NatResourcesLandSurveyor = 'NAT_RESOURCES_LAND_SURVEYOR',
  /** Natural Resources - Logger */
  NatResourcesLogger = 'NAT_RESOURCES_LOGGER',
  /** Natural Resources - Metallurgist */
  NatResourcesMetallurgist = 'NAT_RESOURCES_METALLURGIST',
  /** Natural Resources - Miner */
  NatResourcesMiner = 'NAT_RESOURCES_MINER',
  /** Natural Resources - Oil Worker */
  NatResourcesOilWorker = 'NAT_RESOURCES_OIL_WORKER',
  /** Natural Resources - Others */
  NatResourcesOthers = 'NAT_RESOURCES_OTHERS',
  /** Natural Resources - Project Manager */
  NatResourcesProjectMgr = 'NAT_RESOURCES_PROJECT_MGR',
  /** Non-profit */
  NonProfit = 'NON_PROFIT',
  /** Others */
  Others = 'OTHERS',
  /** Public Service - City Counselor */
  PublicSvcCityCounselor = 'PUBLIC_SVC_CITY_COUNSELOR',
  /** Public Service - Federal Member of Parliament */
  PublicSvcFederalMp = 'PUBLIC_SVC_FEDERAL_MP',
  /** Public Service - Firefighter */
  PublicSvcFirefighter = 'PUBLIC_SVC_FIREFIGHTER',
  /** Public Service - Imam */
  PublicSvcImam = 'PUBLIC_SVC_IMAM',
  /** Public Service - Municipal Clerk */
  PublicSvcMunicipalClerk = 'PUBLIC_SVC_MUNICIPAL_CLERK',
  /** Public Service - Nun */
  PublicSvcNun = 'PUBLIC_SVC_NUN',
  /** Public Service - Others */
  PublicSvcOthers = 'PUBLIC_SVC_OTHERS',
  /** Public Service - Police Officer */
  PublicSvcPoliceOfficer = 'PUBLIC_SVC_POLICE_OFFICER',
  /** Public Service - Politician */
  PublicSvcPolitician = 'PUBLIC_SVC_POLITICIAN',
  /** Public Service - Priest */
  PublicSvcPriest = 'PUBLIC_SVC_PRIEST',
  /** Public Service - Provincial MPP */
  PublicSvcProvincialMpp = 'PUBLIC_SVC_PROVINCIAL_MPP',
  /** Public Service - Rabbi */
  PublicSvcRabbi = 'PUBLIC_SVC_RABBI',
  /** Public Service - Spiritual Leader */
  PublicSvcSpiritualLeader = 'PUBLIC_SVC_SPIRITUAL_LEADER',
  /** Public Service - Waste Removal */
  PublicSvcWasteRemoval = 'PUBLIC_SVC_WASTE_REMOVAL',
  /** Recreation */
  Recreation = 'RECREATION',
  /** Religion */
  Religion = 'RELIGION',
  /** Research */
  Research = 'RESEARCH',
  /** Retail - Buyer */
  RetailBuyer = 'RETAIL_BUYER',
  /** Retail - Cashier */
  RetailCashier = 'RETAIL_CASHIER',
  /** Retail - Executive */
  RetailExecutive = 'RETAIL_EXECUTIVE',
  /** Retail - Franchisee */
  RetailFranchisee = 'RETAIL_FRANCHISEE',
  /** Retail - Franchisor */
  RetailFranchisor = 'RETAIL_FRANCHISOR',
  /** Retail - Marketing */
  RetailMarketing = 'RETAIL_MARKETING',
  /** Retail - Merchandiser */
  RetailMerchandiser = 'RETAIL_MERCHANDISER',
  /** Retail - Night Crew */
  RetailNightCrew = 'RETAIL_NIGHT_CREW',
  /** Retail - Others */
  RetailOthers = 'RETAIL_OTHERS',
  /** Retail - Pharmacist */
  RetailPharmacist = 'RETAIL_PHARMACIST',
  /** Retail - Stock Room */
  RetailStockRoom = 'RETAIL_STOCK_ROOM',
  /** Retail - Store Manager */
  RetailStoreManager = 'RETAIL_STORE_MANAGER',
  /** Retail - Travel Agent */
  RetailTravelAgent = 'RETAIL_TRAVEL_AGENT',
  /** Retired */
  Retired = 'RETIRED',
  /** Sales */
  Sales = 'SALES',
  /** Sports, Fitness */
  SportsAndFitness = 'SPORTS_AND_FITNESS',
  /** Student */
  Student = 'STUDENT',
  /** Technology */
  Technology = 'TECHNOLOGY',
  /** Technology - Chief Information Officer */
  TechCio = 'TECH_CIO',
  /** Technology - Code Developer */
  TechCodeDeveloper = 'TECH_CODE_DEVELOPER',
  /** Technology - Database Administrator */
  TechDatabaseAdmin = 'TECH_DATABASE_ADMIN',
  /** Technology - Information Security */
  TechInformationSecurity = 'TECH_INFORMATION_SECURITY',
  /** Technology - Infrastructure Administrator */
  TechInfrastructureAdmin = 'TECH_INFRASTRUCTURE_ADMIN',
  /** Technology - Network Architect */
  TechNetworkArchitect = 'TECH_NETWORK_ARCHITECT',
  /** Technology - Others */
  TechOthers = 'TECH_OTHERS',
  /** Technology - Project Manager */
  TechProjectManager = 'TECH_PROJECT_MANAGER',
  /** Technology - Quality Analyst */
  TechQualityAnalyst = 'TECH_QUALITY_ANALYST',
  /** Technology - Support Analyst */
  TechSupportAnalyst = 'TECH_SUPPORT_ANALYST',
  /** Technology - Systems Analyst */
  TechSystemsAnalyst = 'TECH_SYSTEMS_ANALYST',
  /** Technology - Systems Architect */
  TechSystemsArchitect = 'TECH_SYSTEMS_ARCHITECT',
  /** Technology - Technical Writer */
  TechTechnicalWriter = 'TECH_TECHNICAL_WRITER',
  /** Technology - Telecom Administrator */
  TechTelecomAdmin = 'TECH_TELECOM_ADMIN',
  /** Technology - Website Developer */
  TechWebsiteDeveloper = 'TECH_WEBSITE_DEVELOPER',
  /** Trade */
  Trade = 'TRADE',
  /** Transportation */
  Transportation = 'TRANSPORTATION',
  /** Travel */
  Travel = 'TRAVEL',
  /** Unemployed */
  Unemployed = 'UNEMPLOYED'
}

/** Encapsulates offer details */
export type Offer = {
  __typename?: 'Offer';
  /** Indicates type of an offer's balance. Example: PSB, MSB, etc */
  balanceType?: Maybe<BalanceType>;
  /** offer id */
  id: Scalars['String'];
  /** max discount based on percent offer */
  maxDiscount?: Maybe<Amount>;
  /** int value of a percent off of a offer */
  percentOff?: Maybe<Scalars['Int']>;
  /** descriptive name for the offer */
  shortTitle?: Maybe<Scalars['String']>;
  /** type of Incentives, etc: PERCENTAGE or FIXED */
  type?: Maybe<Incentives>;
};

/** An enumeration of white-listed offer programs */
export enum OfferPrograms {
  /**
   * Split Tender (inactive)
   * @deprecated Offer program budget reached, inactive offer
   */
  SplitTender = 'SPLIT_TENDER'
}

/** An enumeration of Checkout onboarding experiences */
export enum OnboardingExperienceType {
  /** Optional guest experience */
  Guest = 'GUEST',
  /** Forced sign up */
  SignUp = 'SIGN_UP'
}

/** Encapsulates all properties related to open banking contingency */
export type OpenBankingContingency = {
  __typename?: 'OpenBankingContingency';
  /** The contigency reasons for the RTB contingencies */
  contingencyReasons?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The open banking contingency type: need consent or real time balance */
  contingencyType?: Maybe<OpenBankingContingencyType>;
  /** The bank id or the funding option id of the bank which has the RTB contingencies[either fetch real time balance or get user consent] */
  encryptedId: Scalars['String'];
};

/** An enumeration of OpenBanking contingency types */
export enum OpenBankingContingencyType {
  /** need Consent For Bank Account Info Retrieval */
  NeedConsentForBankAccount = 'NEED_CONSENT_FOR_BANK_ACCOUNT',
  /** need RealTime Balance For Bank Account */
  NeedRealtimeBalanceForBankAccount = 'NEED_REALTIME_BALANCE_FOR_BANK_ACCOUNT'
}

/**
 * AuthProviderContext
 * Login Context for UL OTP
 * TODO: this can be replaced with IWCContext type
 * Reason: This type has a specific name with Otp prefix
 * We can use a generic type IWCContext which works for
 * all the queries we have
 */
export type OtpLoginContext = {
  __typename?: 'OtpLoginContext';
  /** Stringified context for IWC */
  context: Scalars['String'];
};

/** Partner Details */
export type PartnerDetails = {
  /** Partner / facilitator Account Number */
  accountNumber?: InputMaybe<Scalars['String']>;
  /** account status */
  accountStatus?: InputMaybe<AccountStatus>;
  /** account type */
  accountType?: InputMaybe<AccountType>;
  /** Business information */
  businessInformation?: InputMaybe<BusinessInformation>;
  /** email address */
  emailAddress?: InputMaybe<Scalars['String']>;
  /** party id */
  partyId?: InputMaybe<Scalars['String']>;
  /** phone info */
  phoneInfo?: InputMaybe<PhoneInput>;
  /** is restricted account */
  restrictedAccount?: InputMaybe<Scalars['Boolean']>;
};

/** An enumeration of PayPal business regions */
export enum PayPalBusinessRegions {
  /** Asia Pacific */
  Apac = 'APAC',
  /** Emerging Market */
  Em = 'EM',
  /** Europe, Middle East, and Africa */
  Emea = 'EMEA',
  /** Latin America */
  Latam = 'LATAM',
  /** North America */
  Na = 'NA'
}

/** Encapsulates all properties related to a PaycodeContingency type */
export type PaycodeContingency = {
  __typename?: 'PaycodeContingency';
  /** Number of attempts to clear the paycode contingency */
  attempts?: Maybe<Scalars['Int']>;
  /** Resolution cause for current contingency (Ex: 'NEED_3D_SECURE_AUTHENTICATION') */
  causeName: Scalars['String'];
  /** Resolution contingency name (Ex: 'PAYER_ACTION_REQUIRED') */
  name?: Maybe<Scalars['String']>;
};

/** Data, Ex: merchantId, email of all payees in a cart" */
export type Payee = {
  __typename?: 'Payee';
  /** Merchant's email address */
  email?: Maybe<Email>;
  /** Merchant's ID (Ex: '7VJPAEVGH7B6A') */
  merchantId?: Maybe<Scalars['String']>;
};

/** Payer Disclaimer values */
export enum PayerDisclaimer {
  /** Cobranded type */
  Cobranded = 'COBRANDED'
}

/**
 * Encapsulates all data related to a Checkout session's payment contingencies
 * Ex: threeDomainSecure, cvvConfirm, etc.
 */
export type PaymentContingencies = {
  __typename?: 'PaymentContingencies';
  /**
   *   A checkout session's payment contingency cvv confirmation related data.
   *
   * Required auth states: LOGGEDIN, REMEMBERED, or IDENTIFIED
   */
  confirmCreditCardCvvData?: Maybe<ConfirmCreditCardCvvContingency>;
  /** A checkout session's payment contingency to get payer consent for fetching the real time bank balance information. */
  needConsentForBankAccountInfoRetrieval?: Maybe<OpenBankingContingency>;
  /** A checkout session's payment contingency on fetching the real time bank balance information */
  needRealTimeBalanceForBankAccount?: Maybe<OpenBankingContingency>;
  /**
   * Indicates that paycode is required.
   * Contains the information needed to pass on to auth modules to resolve this contingency.
   */
  paycodeRequired?: Maybe<PaycodeContingency>;
  /**
   * A checkout session's SEPA mandate contingency related data.
   *
   * Required auth states: LOGGEDIN, REMEMBERED, or IDENTIFIED
   */
  sepaMandateAcceptanceNeeded?: Maybe<BankAccount>;
  /**
   * Indicates that Strong Customer Authentication is required.
   * Contains the information needed to pass on to auth modules to resolve this contingency.
   */
  strongCustomerAuthenticationRequired?: Maybe<StrongCustomerAuthenticationRequiredContingency>;
  /**
   * A Checkout session's payment contingency for 3DS (2.0)
   *
   * Required auth states: LOGGEDIN, REMEMBERED, or IDENTIFIED
   */
  threeDSContingencyData?: Maybe<ThreeDomainSecureResolutionContingency>;
  /**
   * A Checkout session's payment contingency ThreeDomainSecure related data.
   * Average SLA response time: 2050ms
   *
   * Required auth states: LOGGEDIN, REMEMBERED, or IDENTIFIED
   */
  threeDomainSecure?: Maybe<ThreeDomainSecureContingency>;
};


/**
 * Encapsulates all data related to a Checkout session's payment contingencies
 * Ex: threeDomainSecure, cvvConfirm, etc.
 */
export type PaymentContingenciesThreeDomainSecureArgs = {
  experiences?: InputMaybe<Array<InputMaybe<ThreeDsPaymentExperience>>>;
};

/** Container type for payment eligibility flags for EPM (eligible payment methods) */
export type PaymentEligibility = {
  __typename?: 'PaymentEligibility';
  /** whether the payment method is branded or not */
  branded?: Maybe<Scalars['Boolean']>;
  /** Whether or not a user is eligible for a payment type (Ex: VENMO) */
  eligible?: Maybe<Scalars['Boolean']>;
  /** Child products for a given funding source */
  products: FundingProductsEligibility;
  /** Reasons why a payment is eligible */
  reasons: Array<Maybe<Scalars['String']>>;
  /** Whether or not payment type is vaultable */
  vaultable?: Maybe<Scalars['Boolean']>;
  /** Vaulted Instruments for payment method */
  vaultedInstruments?: Maybe<Array<Maybe<VaultInstrumentData>>>;
};

/**
 * Encapsulates all properties related to a plan.
 * Ex: planId, primaryFundingOption, secondaryFundingOption, isSelected, etc.
 *
 * DEPRECATE: Use Plan instead of PaymentPlan, to avoid duplication
 */
export type PaymentPlan = {
  __typename?: 'PaymentPlan';
  /** Backup funding instrument. */
  backupFundingOption?: Maybe<FundingInstrument>;
  /** Currency conversion information */
  currencyConversion?: Maybe<CheckoutCurrencyConversion>;
  /**
   * Whether or not a PaymentPlan is selected. If you are listing out plans in a UI,
   * and need to show that a plan is selected, use this property.
   */
  isSelected?: Maybe<Scalars['Boolean']>;
  /** ID (Ex: '716015457e394cebb555f9804fb22227') */
  planId?: Maybe<Scalars['String']>;
  /** Primary funding instrument. */
  primaryFundingOption?: Maybe<FundingInstrument>;
  /** Secondary funding instrument. */
  secondaryFundingOption?: Maybe<FundingInstrument>;
};

/** Payment Source object to store in vault. Currently only supporting Card but will also accept paypal, venmo, and apple pay */
export type PaymentSource = {
  /** card */
  card?: InputMaybe<Card>;
};

/**
 * For tokenized cards, the source that the payment token came from
 * https://github.paypal.com/ApiSpecifications-R/CommonComponentsSpecification/blob/master/v4/schema/json/openapi-2.0/wallet_instrument/token_source.json
 */
export enum PaymentTokenSource {
  /** Payment token is from Apple Pay */
  ApplePay = 'APPLE_PAY'
}

/**
 * Encapsulates all properties related to a person's name.
 * Ex: givenName, middleName, familyName, fullName, etc.
 */
export type PersonName = {
  __typename?: 'PersonName';
  /** A person's family name, or last name (Ex: 'Doe') */
  familyName?: Maybe<Scalars['String']>;
  /** A person's full name (Ex: 'Mr. William Alan Doe, Jr.') */
  fullName?: Maybe<Scalars['String']>;
  /** A person's given name, or first name (Ex: 'William') */
  givenName?: Maybe<Scalars['String']>;
  /** A person's informal name (Ex: 'Javier') */
  informalName?: Maybe<Scalars['String']>;
  /** A person's middle name (Ex: 'Alan') */
  middleName?: Maybe<Scalars['String']>;
  /** A person's salutation (Ex: 'Mr') */
  salutation?: Maybe<Scalars['String']>;
  /** A person's suffix (Ex: 'Jr') */
  suffix?: Maybe<Scalars['String']>;
};

/** Phone confirmation response */
export type PhoneConfirmationResponse = {
  __typename?: 'PhoneConfirmationResponse';
  /** Verification ID from identity2faserv */
  id?: Maybe<Scalars['String']>;
  /** Phone confirmation state */
  state?: Maybe<PhoneConfirmationState>;
  /** Expiry of the phone confirmation session */
  validUntil?: Maybe<GenericDate>;
};

/** Phone confirmation state */
export enum PhoneConfirmationState {
  /** CONFIRMED */
  Confirmed = 'CONFIRMED',
  /** PENDING */
  Pending = 'PENDING',
  /** UNKNOWN */
  Unknown = 'UNKNOWN'
}

/** Buyer's phone contact information (number, countryCode, etc) */
export type PhoneInput = {
  /** A phone country code (Ex: '1') */
  countryCode: Scalars['String'];
  /** A phone number (Ex: '8058881234') */
  number: Scalars['String'];
  /** An phone type (Ex: 'Work', 'Cell', etc) */
  type?: InputMaybe<PhoneInputType>;
};

/** Phone contact "types" */
export enum PhoneInputType {
  /** Business phone number */
  Business = 'BUSINESS',
  /** Customer service phone number */
  CustomerService = 'CUSTOMER_SERVICE',
  /** Home phone number */
  Home = 'HOME',
  /** Mobile phone number */
  Mobile = 'MOBILE',
  /** Work phone number */
  Work = 'WORK'
}

/** An enumeration of types that an Phone can be. MAIN, WORK, MOBILE, FAX, OTHER */
export enum PhoneType {
  /** Phone is a fax phone */
  Fax = 'FAX',
  /** Phone is a main phone */
  Main = 'MAIN',
  /** Phone is a mobile phone */
  Mobile = 'MOBILE',
  /** Phone is another type of phone */
  Other = 'OTHER',
  /** Phone is a work phone */
  Work = 'WORK'
}

/**
 * A plan describes a way that the user can pay for a transaction. It includes the
 * list of funding sources that will be used, and optionally, backup or currency
 * conversion options that apply to using the plan.
 */
export type Plan = {
  __typename?: 'Plan';
  /**
   * Plan's backup funding instrument, that will be charged if the `fundingSources`
   * are unable to fund the transaction. Applies to plans with banks.
   */
  backupFundingInstrument?: Maybe<FundingInstrument>;
  /**
   * Plan's backup funding option. Applies to banks.
   * @deprecated Renamed to `backupFundingInstrument` for consistent naming of funding instrument types.
   */
  backupFundingOption?: Maybe<FundingOption>;
  /** Plan's currency conversion options, if any. */
  currencyConversion?: Maybe<CheckoutCurrencyConversion>;
  /** A plan's funding contingencies */
  fundingContingencies: Array<Maybe<FundingContingency>>;
  /**
   * The array of funding sources that will be used to fund the payment in the plan,
   * and details about how those sources will be charged.
   */
  fundingSources?: Maybe<Array<Maybe<FundingSource>>>;
  /** Plan's ID (Ex: '716015457e394cebb555f9804fb22227') */
  id?: Maybe<Scalars['ID']>;
  /**
   * A Plan is selected. If you are listing out plans in a UI,
   * and need to show that a plan is selected, use this property.
   */
  isSelected?: Maybe<Scalars['Boolean']>;
  /**
   * Plan's ID (Ex: '716015457e394cebb555f9804fb22227')
   * @deprecated Renamed to use `id` instead to better match good graphQL schema practices.
   */
  planId?: Maybe<Scalars['String']>;
  /**
   * Plan's pre authorization data. The type and amount that needs to be used for pre-authorization
   * during the `approveMemberPayment` mutation.
   */
  preAuthorizationData?: Maybe<PreAuthorizationData>;
  /**
   * Plan's primary funding option.
   * @deprecated Mappings improved to separate the instrument and the details about the fundingSource - see fundingSources instead
   */
  primaryFundingOption?: Maybe<FundingOption>;
  /**
   * Plan's secondary funding option.
   * @deprecated Use `secondaryFundingOptions` instead - there may be more than one secondary option in this plan.
   */
  secondaryFundingOption?: Maybe<FundingOption>;
  /**
   * Plan's secondary funding options.
   * @deprecated Mappings improved to separate the instrument and the details about the fundingSource - see fundingSources instead
   */
  secondaryFundingOptions?: Maybe<Array<Maybe<FundingOption>>>;
  /** Total values of each currency in the plan. */
  totalsPerCurrency?: Maybe<Array<Maybe<Amount>>>;
};

/**
 * Encapsulates solo plans and split plans.
 * A solo plan is one that only is associated with one primary funding option.
 * A split plan is one that has secondary funding options.
 */
export type PlanTypes = {
  __typename?: 'PlanTypes';
  /** A plan with one funding option. */
  soloPlan?: Maybe<Plan>;
  /** A plan with more than one funding option. */
  splitPlans?: Maybe<Array<Maybe<Plan>>>;
};

/** Encapsulates details of the potential funding instrument */
export type PotentialCard = {
  __typename?: 'PotentialCard';
  /** Expiration date of a card (Ex: '02/2021') */
  expirationDate?: Maybe<Scalars['String']>;
  /** Potential card's uuid (Ex: '3d799230-b198-11ea-b3de-0242ac130004') */
  id?: Maybe<Scalars['ID']>;
  /**
   * The card art image
   *
   * Takes optional input for image size and type
   */
  image?: Maybe<CardImage>;
  /**
   * Funding instrument's sub type of it's `type`.
   * (EX: 'CREDIT', 'DEBIT', 'CHECKING', 'SAVINGS').
   */
  instrumentSubType?: Maybe<FundingInstrumentSubType>;
  /** Funding instrument's issuer product description. This is the card issuer's product and brand information. For Example, Chase Sapphire Reserve. */
  issuerProductDescription?: Maybe<Scalars['String']>;
  /** Last digits of a credit card */
  lastDigits?: Maybe<Scalars['String']>;
  /** Funding option's brand (Ex: 'AMEX') */
  name?: Maybe<Scalars['String']>;
  /** Source variable indicates which flow the user used the card in like, guest or xoom, etc.,. */
  source?: Maybe<Scalars['String']>;
  /** Indicates the type of the funding instrument */
  type?: Maybe<FundingOptionType>;
};


/** Encapsulates details of the potential funding instrument */
export type PotentialCardImageArgs = {
  size?: InputMaybe<SquareImageSize>;
  type?: InputMaybe<ImageType>;
};

/** PotentialCard input type represents a card to be added to an account */
export type PotentialCardInput = {
  /** 3 or 4 digits security code of the given card (Ex: '123' or '3456') depends on the type of credit card */
  cardVerificationCode: Scalars['String'];
  /** potential card uuid  (Ex: 'uuid1234'). Unique identifier of the potential card. */
  id: Scalars['String'];
};

/** Encapsulates pre authorization data for a funding instrument */
export type PreAuthorizationData = {
  __typename?: 'PreAuthorizationData';
  /** Amount indicates the amount the authorization is to be done for, depending on the currency and the local currencyValue */
  amount?: Maybe<Amount>;
  /** Type of Authorization to be done on the card, 'PARTIAL' indicates a $1 auth, 'FULL' indicates the full auth */
  authType?: Maybe<CardAuthType>;
};

/** Instrument-level predicted approval score from Risk */
export enum PredictedApprovalScore {
  /** HIGH */
  High = 'HIGH',
  /** LOW */
  Low = 'LOW',
  /** MEDIUM */
  Medium = 'MEDIUM'
}

/**
 * The channel (type of browser/device) that the user is coming from
 * https://github.paypal.com/ApiSpecifications-R/CommonComponentsSpecification/blob/master/v4/schema/json/openapi-2.0/product_experience.json#L232
 */
export enum ProductChannel {
  /** A native app on a mobile device. */
  MobileApp = 'MOBILE_APP',
  /** A browser on a mobile device. */
  MobileWeb = 'MOBILE_WEB',
  /** A browser on a PC. */
  Web = 'WEB'
}

/** An enumeration of possible PayPal product code */
export enum ProductCode {
  /** invoicing */
  Invoicing = 'INVOICING',
  /** no_code_payment_solution */
  NoCodePaymentSolution = 'NO_CODE_PAYMENT_SOLUTION',
  /** website_payments_standard */
  WebsitePaymentsStandard = 'WEBSITE_PAYMENTS_STANDARD'
}

/**
 * Types of client config product code
 * https://github.paypal.com/ApiSpecifications-R/CommonComponentsSpecification/blob/master/v4/schema/json/openapi-2.0/client_configuration.json#L9
 */
export enum ProductCodeType {
  /** The payment acceptance solution is a billing agreement. */
  BillingAgreements = 'BILLING_AGREEMENTS',
  /** Billing plan and subcription solution */
  BillingSubscriptions = 'BILLING_SUBSCRIPTIONS',
  /** The payment acceptance solution is credit card. */
  DirectCreditCard = 'DIRECT_CREDIT_CARD',
  /** The payment acceptance solution is express checkout. */
  ExpressCheckout = 'EXPRESS_CHECKOUT',
  /** The payment acceptance solution is website payment standard. */
  WebsitePaymentsStandard = 'WEBSITE_PAYMENTS_STANDARD'
}

/** Product Details */
export type ProductDetails = {
  /** Api */
  api?: InputMaybe<Threedsapi>;
  /** Entry Point */
  entryPoint?: InputMaybe<ThreedsEntryPoint>;
  /** Integration Artifact */
  integrationArtifact?: InputMaybe<ThreedsIntegrationArtifacts>;
  /** Payment Method - reused  entry point */
  paymentMethod?: InputMaybe<ThreedsEntryPoint>;
  /** Product code */
  productCode?: InputMaybe<ThreedsProductCode>;
  /** Product Feature */
  productFeature?: InputMaybe<ThreedsProductFeature>;
  /** Product Flow */
  productFlow?: InputMaybe<ThreedsProductFlow>;
  /** Experience */
  userExperienceFlow?: InputMaybe<ThreedsUserExperienceFlow>;
};

/**
 * Types of product feature
 * https://github.paypal.com/ApiSpecifications-R/CommonComponentsSpecification/blob/master/v4/schema/json/openapi-2.0/client_configuration.json#L163
 */
export enum ProductFeatureType {
  /** The payment product features a payment for donations. */
  Donation = 'DONATION'
}

/**
 * Types of client config product flow
 * https://github.paypal.com/ApiSpecifications-R/CommonComponentsSpecification/blob/master/v4/schema/json/openapi-2.0/product_experience.json#L305
 */
export enum ProductFlowType {
  /** Accelerated Checkout Flow */
  AcceleratedCheckout = 'ACCELERATED_CHECKOUT',
  /** A buyer signing up for a billing agreement. */
  BuyerApprovalBillingAgreementCreate = 'BUYER_APPROVAL_BILLING_AGREEMENT_CREATE',
  /** A purchase flow which buyer also approves creation of a billing agreement. */
  BuyerApprovalBillingAgreementWithPurchase = 'BUYER_APPROVAL_BILLING_AGREEMENT_WITH_PURCHASE',
  /** A buyer signing up for a Subscription. */
  BuyerApprovalSubscriptionsCreate = 'BUYER_APPROVAL_SUBSCRIPTIONS_CREATE',
  /** An applicant applies for a credit product from a checkout session. */
  CreditAppliedAtCheckout = 'CREDIT_APPLIED_AT_CHECKOUT',
  /** Identifies transactions to a crowdfunded money pool. */
  CrowdfundingCampaigns = 'CROWDFUNDING_CAMPAIGNS',
  /** Flow identifier for donation collected as crowd funding for a charity. */
  CrowdfundingCampaignsCharities = 'CROWDFUNDING_CAMPAIGNS_CHARITIES',
  /** Flow identifier to say donation flow from button code we share with merchant. */
  DonateButton = 'DONATE_BUTTON',
  /** Flow identifier to say crowd funding donation flow from button code we share with merchant. */
  DonateButtonCampaign = 'DONATE_BUTTON_CAMPAIGN',
  /** Flow identifier to say donation flow in regualar internal from button code shared with merchant. */
  DonateButtonRecurring = 'DONATE_BUTTON_RECURRING',
  /** Flow identifier to say donation collected through PayPal Giving Fund. */
  FundraiserDirect = 'FUNDRAISER_DIRECT',
  /** Flow identifier to say donation collected through PayPal Giving Fund for a partner. */
  FundraiserPartner = 'FUNDRAISER_PARTNER',
  /** A web application handles the user's checkout interaction. */
  Hermes = 'HERMES',
  /** A purchase flow where buyer is redirected from Hosted Sole Solution checkout application */
  HostedSoleSolution = 'HOSTED_SOLE_SOLUTION',
  /** The application handles the PayPal Plus flow. */
  PaypalPlus = 'PAYPAL_PLUS',
  /** Smart Payment Buttons */
  SmartPaymentButtons = 'SMART_PAYMENT_BUTTONS'
}

/**
 * Encapsulates all properties related to a profile image.
 * Ex: url, profileImageType, width, height
 */
export type ProfileImage = Image & {
  __typename?: 'ProfileImage';
  /** A profile image's height */
  height?: Maybe<Scalars['String']>;
  /** A profile image's type. A ProfileImageType type. */
  type?: Maybe<ProfileImageType>;
  /** A profile image's URL.  A URL type. */
  url?: Maybe<GenericUrl>;
  /** A profile image's width */
  width?: Maybe<Scalars['String']>;
};

/**
 * An enumeration of types that ProfileImage can have.
 *
 * See: https://engineering.paypalcorp.com/confluence/display/PayPalMediaService/Image+Request+Metadata+Data#ImageRequestMetadataData-ImageIds
 */
export enum ProfileImageType {
  /** 300x300 */
  L = 'L',
  /** 200x200 */
  M = 'M',
  /** 96x96 */
  S = 'S',
  /** 96x96 */
  Size_0 = 'SIZE_0',
  /** 400x400 */
  Size_1 = 'SIZE_1',
  /** 200x200 */
  Size_2 = 'SIZE_2',
  /** 800x800 */
  Size_3 = 'SIZE_3',
  /** 640x480 */
  Size_4 = 'SIZE_4',
  /** 100x75 */
  Size_5 = 'SIZE_5',
  /** 70x70 */
  Size_6 = 'SIZE_6',
  /** 150x150 */
  Size_7 = 'SIZE_7',
  /** 400x300 */
  Size_8 = 'SIZE_8',
  /** 200x150 */
  Size_9 = 'SIZE_9',
  /** 9999x9999 */
  Size_10 = 'SIZE_10',
  /** 310x90 */
  Size_11 = 'SIZE_11',
  /** 500x500 */
  Size_12 = 'SIZE_12',
  /** 120x42 */
  Size_13 = 'SIZE_13',
  /** 64x64 */
  Size_14 = 'SIZE_14',
  /** 225x125 */
  Size_15 = 'SIZE_15',
  /** 400x300 */
  Size_16 = 'SIZE_16',
  /** 80x80 */
  Size_17 = 'SIZE_17',
  /** 800x600 */
  Size_20 = 'SIZE_20',
  /** 60x60 */
  Size_22 = 'SIZE_22',
  /** 80x80 */
  Size_23 = 'SIZE_23',
  /** 298x298 */
  Size_24 = 'SIZE_24',
  /** 140x140 */
  Size_26 = 'SIZE_26',
  /** 180x60 */
  Size_28 = 'SIZE_28',
  /** 900x300 */
  Size_29 = 'SIZE_29',
  /** 300x115 */
  Size_30 = 'SIZE_30',
  /** 300x225 */
  Size_31 = 'SIZE_31',
  /** 1600x1600 */
  Size_32 = 'SIZE_32',
  /** 48x48 */
  Size_33 = 'SIZE_33',
  /** 50x50 */
  Size_34 = 'SIZE_34',
  /** 300x300 */
  Size_35 = 'SIZE_35',
  /** 150x40 */
  Size_36 = 'SIZE_36',
  /** 175x175 */
  Size_37 = 'SIZE_37',
  /** 115x115 */
  Size_38 = 'SIZE_38',
  /** 32x32 */
  Size_39 = 'SIZE_39',
  /** 80x60 */
  Size_40 = 'SIZE_40',
  /** 467x467 */
  Size_41 = 'SIZE_41',
  /** 225x70 */
  Size_42 = 'SIZE_42',
  /** 221x330 */
  Size_43 = 'SIZE_43',
  /** 425x34 */
  Size_44 = 'SIZE_44',
  /** 1200x1200 */
  Size_45 = 'SIZE_45',
  /** 623x290 */
  Size_47 = 'SIZE_47',
  /** 1024x1024 */
  Size_48 = 'SIZE_48',
  /** 200x170 */
  Size_49 = 'SIZE_49',
  /** 100x85 */
  Size_50 = 'SIZE_50',
  /** 90x90 */
  Size_51 = 'SIZE_51',
  /** 132x123 */
  Size_52 = 'SIZE_52',
  /** 190x100 */
  Size_53 = 'SIZE_53',
  /** 122x122 */
  Size_54 = 'SIZE_54',
  /** 286x214 */
  Size_55 = 'SIZE_55',
  /** 100x100 */
  Size_56 = 'SIZE_56',
  /** 1600x1600 */
  Size_57 = 'SIZE_57',
  /** 640x640 */
  Size_58 = 'SIZE_58',
  /** 960x960 */
  Size_59 = 'SIZE_59',
  /** 225x225 */
  Size_62 = 'SIZE_62',
  /** 300x120 */
  Size_65 = 'SIZE_65',
  /** 82x35 */
  Size_66 = 'SIZE_66',
  /** 728x90 */
  Size_67 = 'SIZE_67',
  /** 256x35 */
  Size_68 = 'SIZE_68',
  /** 120x60 */
  Size_69 = 'SIZE_69',
  /** 64x35 */
  Size_70 = 'SIZE_70',
  /** 55x55 */
  Size_71 = 'SIZE_71',
  /** 500x375 */
  Size_72 = 'SIZE_72',
  /** 65x65 */
  Size_73 = 'SIZE_73',
  /** 135x115 */
  Size_74 = 'SIZE_74',
  /** 430x325 */
  Size_75 = 'SIZE_75',
  /** 400x320 */
  Size_76 = 'SIZE_76',
  /** 72x54 */
  Size_77 = 'SIZE_77',
  /** 75x56 */
  Size_78 = 'SIZE_78',
  /** 320x240 */
  Size_79 = 'SIZE_79',
  /** 600x450 */
  Size_80 = 'SIZE_80',
  /** 92x72 */
  Size_81 = 'SIZE_81',
  /** 147x147 */
  Size_82 = 'SIZE_82',
  /** 358x358 */
  Size_83 = 'SIZE_83',
  /** 498x498 */
  Size_84 = 'SIZE_84',
  /** 726x726 */
  Size_85 = 'SIZE_85',
  /** 70x53 */
  Size_87 = 'SIZE_87',
  /** 175x130 */
  Size_88 = 'SIZE_88',
  /** 600x500 */
  Size_89 = 'SIZE_89',
  /** 220x220 */
  Size_90 = 'SIZE_90',
  /** 276x276 */
  Size_91 = 'SIZE_91',
  /** 560x420 */
  Size_92 = 'SIZE_92',
  /** 360x480 */
  Size_93 = 'SIZE_93',
  /** 280x210 */
  Size_94 = 'SIZE_94',
  /** 180x240 */
  Size_95 = 'SIZE_95',
  /** 205x75 */
  Size_96 = 'SIZE_96',
  /** 90x90 */
  Size_97 = 'SIZE_97',
  /** 180x170 */
  Size_98 = 'SIZE_98',
  /** 650x412 */
  Size_100 = 'SIZE_100',
  /** 107x88 */
  Size_101 = 'SIZE_101',
  /** 247x187 */
  Size_102 = 'SIZE_102',
  /** 180x180 */
  Size_103 = 'SIZE_103',
  /** 720x215 */
  Size_104 = 'SIZE_104',
  /** 980x340 */
  Size_105 = 'SIZE_105',
  /** 160x160 */
  Size_106 = 'SIZE_106',
  /** 1000x1000 */
  Size_107 = 'SIZE_107',
  /** 250x90 */
  Size_109 = 'SIZE_109',
  /** 462x360 */
  Size_110 = 'SIZE_110',
  /** 225x155 */
  Size_111 = 'SIZE_111',
  /** 225x195 */
  Size_112 = 'SIZE_112',
  /** 450x450 */
  Size_113 = 'SIZE_113',
  /** 67x67 */
  Size_114 = 'SIZE_114',
  /** 216x216 */
  Size_115 = 'SIZE_115',
  /** 250x250 */
  Size_116 = 'SIZE_116',
  /** 190x190 */
  Size_117 = 'SIZE_117',
  /** 275x275 */
  Size_118 = 'SIZE_118',
  /** 110x110 */
  Size_119 = 'SIZE_119',
  /** 170x170 */
  Size_120 = 'SIZE_120',
  /** 135x135 */
  Size_121 = 'SIZE_121',
  /** 440x420 */
  Size_134 = 'SIZE_134',
  /** 275x375 */
  Size_135 = 'SIZE_135',
  /** 120x80 */
  Size_136 = 'SIZE_136',
  /** 200x64 */
  Size_137 = 'SIZE_137',
  /** 200x42 */
  Size_138 = 'SIZE_138',
  /** 380x380 */
  Size_139 = 'SIZE_139',
  /** 1134x700 */
  Size_140 = 'SIZE_140',
  /** 156x156 */
  Size_141 = 'SIZE_141',
  /** 112x76 */
  Size_142 = 'SIZE_142',
  /** 400x400 */
  Xl = 'XL',
  /** 64x64 */
  Xs = 'XS',
  /** 500x500 */
  Xxl = 'XXL',
  /** 32x32 */
  Xxs = 'XXS',
  /** 800x800 */
  Xxxl = 'XXXL'
}

/** Shipping methods to display to the buyer */
export type ProfileShippingMethodInput = {
  /** Default shipping method returned from cart/profile/callback url */
  default: Scalars['Boolean'];
  /** Unique UUID for this input */
  id?: InputMaybe<Scalars['String']>;
  /** Custom label to display to the buyer for this method */
  label?: InputMaybe<Scalars['String']>;
  /** Whether or not this is the selected method */
  selected: Scalars['Boolean'];
  /** Shipping Amount value for this method */
  shippingAmount?: InputMaybe<AmountInput>;
  /** Shipping method that is mapped over to get the value passed to payload */
  shippingMethodType?: InputMaybe<Scalars['String']>;
  /** Tax Amount value for this method */
  taxAmount?: InputMaybe<AmountInput>;
};

/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type Query = {
  __typename?: 'Query';
  /**
   * GAAC - Google Address Auto Complete
   *
   * Make Google api call to get address auto suggestion based on line1 of address field
   *
   * count - number of results to return
   * countries - array of countries in which user typed partial address should be matched
   * input - whatever user typed in line1 of address field (partial line1 address field)
   * language - the returned address suggestions language
   * location - latitude,longitude (it is a scalar with validation)
   * offset - Integer which decides the number of letters to look for from first word of input
   * radius - radius around location provided, but not a strictBound to this region
   * sessionId - is a unique key generated by frontend to keep the billing for
   *   google API billing needs. Session ID makes sure google bills paypal per user basis and
   *   not per API call
   * strictBounds - bound the address returned to location + radius region, which is like drawing
   *   a circle around the location (lat,long) with radius length of X meters and return matching
   *   address only within the circle
   * types - look for a address or business establishment - refer google docs on places API
   *
   * Required Roles: None
   */
  addressAutoComplete?: Maybe<AddressAutoComplete>;
  /**
   * GAAC - Google Address Auto Complete
   *
   * Make Google api call to get normalized address using a place_id we get from addressAutoComplete api call
   *
   * language - the returned address suggestions language
   * placeId - placeId got from addressAutoComplete api call
   * region - The region code (us, ca), specified as a ccTLD (country code top-level domain)
   *   more details - https://developers.google.com/places/web-service/details
   * sessionId - is a unique key generated by frontend to keep the billing for
   *   google API billing needs. Session ID makes sure google bills paypal per user basis and
   *   not per API call
   * normalize - if this flag is true, the returned address will be normalized with AMS.
   *
   * Required Roles: None
   */
  addressFromAutoCompletePlaceId?: Maybe<AddressForPlaceId>;
  /**
   * Allows you to query for a formatted address based on the information passed
   * to us by the user during a checkout session
   *
   * Requires a pay/EC token: (Ex: "EC-1R520585JJ019435S")
   */
  addressNormalization?: Maybe<NormalizedAddress>;
  /**
   * Allows you to query for a formatted address and shows which fields are incorrect
   * Please use either of the 2 format as a set.
   *   1. Old Coarse fields ( line1, line2, city, state, country, postalCode) soon to be deprecated
   *   2. New portable address fields (addressLine1, addressLine2, addressLine3, adminArea1, adminArea2, adminArea3,
   *     adminArea4, countryCode, postalCode)
   */
  addressValidation?: Maybe<ValidatedAddress>;
  /**
   * Allows you to fetch html, css, and js information necessary to display the app download banner
   * on the client.
   *
   * App download banner endpoint in commonutilsnodeserv expects device details to be passed in the request.
   * Client applications querying for app download banner from xobuernodeserv should pass below parameters to
   * show the banner on the client.
   *
   * App download banner works on logged in and non-logged in state.
   *
   * If the request is not eligible for app download banner, all 3 response object keys (css, js and html) will
   * return with empty string
   *
   * deviceType - Possible values are DESKTOP, TABLET, MOBILE
   * deviceOS - Example values are iOS, Android
   * isMobile - if the device is a mobile
   * deviceOSVersion: OS version of the device, xo-gears device api can be use to fetch this data, pass 'Unknown' if the value is not present
   * flow - flow name that is making the graphql call, used in PS for message config. Non mandatory
   */
  appDownloadBanner?: Maybe<AppDownloadBanner>;
  /**
   * Determines if the merchant is an eligible Apple Pay merchant and
   * returns the Apple Pay session
   *
   * The field useRealWallet is only applicable in the Sandbox environment.
   * In other environments, it will be ignored.
   */
  applePayMerchantSession?: Maybe<ApplePayMerchantSession>;
  /**
   * Returns an Apple Pay Merchant session created when PayPal as a Merchant
   *
   *
   * If passed a domain URL, it will use that domain for creating the Merchant Session.
   * Otherwise it will default to "www.paypal.com" in production env.
   *
   * Required auth states: ANONYMOUS
   */
  applePayMerchantSessionForPayPal?: Maybe<ApplePayMerchantSession>;
  /** Returns supported networks (FIs) and merchant country code for Apple Pay requests */
  applepayConfig?: Maybe<ApplepayConfig>;
  /**
   * Auth token exchange
   *
   * This query is used to get a token by providing another kind of token.
   * The conversions available right now are:
   * 1) idToken -> accessToken,
   * 2) accessToken -> authCode
   */
  auth?: Maybe<Auth>;
  /** Returns burnable rewards for the specified transaction */
  burnableRewards: BurnableRewards;
  /** Calclate Shipping and Taxes */
  calculateShippingAndTaxes?: Maybe<ShippingAndTaxes>;
  /**
   * Allows you to query for card definitions.
   *
   * cardNumber - a partial or full card number for which to retrieve definitions
   * countryCode - a country code that represents the user's country (e.g. 'US')
   *
   * If a countryCode is not provided, it will be detected based on the request.
   *
   * Required Roles: None
   * @deprecated Moved to cardMeta
   */
  cardDefinitions: Array<Maybe<CardDefinition>>;
  /** Allows you to query for card metadata */
  cardMeta: CardMeta;
  /** Allows you to fetch customization for elements (eg: tagline in an SPB) in checkout flow */
  checkoutCustomization?: Maybe<CheckoutCustomization>;
  /** Returns propensity score for different xo products */
  checkoutPropensityScore?: Maybe<CheckoutPropensityScore>;
  /**
   * checkoutSession query returns a CheckoutSession type.
   * Requires a token param (EC, PAY, or BA token) as a String
   * Average SLA response time - 1750ms
   *
   * if enableCache is passed as true. Any successful plan will be cached for one time use only.
   *
   * flows, productName, and dcvv are optional and are used for the create checkout session payload
   *
   * Required Roles: See CheckoutSession
   */
  checkoutSession?: Maybe<CheckoutSession>;
  /**
   * Allows you to query for a Consumer(Tesla) Signup flow id
   *
   * Requires a redirectUrl which will be used by the
   * Consumer flow to redirect the buyer after going through the
   * Consumer flow.
   */
  consumerFlowId?: Maybe<ConsumerFlowId>;
  /**
   * Allows you to fetch html, css, and js information necessary to display the cookie banner
   * on the client. Determined by locale headers/cookies on the request.
   *
   * If cookie banner is not necessary, empty strings will be returned.
   */
  cookieBanner?: Maybe<CookieBanner>;
  /**
   * Allows you to query for currency conversion rates and metadata
   * between two currencies (Ex: "USD" and "SGD")
   *
   * Requires a sourceCurrency (Ex: "USD")
   * Requires a sourceValue (Ex: "1.00"
   * Requires a targetCurrency (Ex: "SGD")
   * Requires a countryCode that represents the user's country code(Ex: "US")
   *
   * Required Roles: None.
   */
  currencyConversion?: Maybe<CheckoutCurrencyConversion>;
  /**
   * Allows you to query for currency conversion rates and metadata
   * from a token and a credit card number
   *
   * Requires a PAY/EC token (Ex: "EC-5NY05678GP2575040")
   * Requires a credit card number (Ex: '4111111111111111')
   * Optional country code (Ex: "US")
   * Optional card brand (Ex: "VISA")
   *
   * If neither the card brand or country code are passed then they will
   * be derived from a card bin API call
   *
   * Required Roles: None.
   */
  currencyConversionFromCreditCard?: Maybe<CheckoutCurrencyConversion>;
  /**
   * Allows for evaluating a dynamic segment using dynsegmentationserv
   *
   * Requires a segment name (Ex: "ALL_20200101_Something")
   *
   * Required Roles: LOGGEDIN, REMEMBERED, or IDENTIFIED
   */
  dynamicSegmentEvaluation?: Maybe<Scalars['Boolean']>;
  /** Returns earnable rewards for the specified transaction */
  earnableRewards?: Maybe<EstimatedRewards>;
  /**
   * Allows you to fetch eligible Installments based on merchant preferences.
   * If cardNumber is passed, installments will be fetched for the given card.
   *
   * Requires a payToken (Ex: "EC-1R520585JJ019435S")
   *
   * Optional cardNumber (Ex: "4111111111111111")
   */
  eligibleInstallments?: Maybe<EligibleInstallments>;
  /**
   * Allows querying elmo for treatments
   * app - Optional name of the Component/pool field in the Elmo UI (Ex: "checkoutuinodeweb")
   * filters - Optional array of filters to pass to Elmo (Ex: [{ key: "Country", value: "US" }]).
   *       This list of filters will be compiled to an object - { "filters.Country": "US" }
   * experimentNameSubstring - Optional string. If provided, the list of treatments in the result
   *       will be limited to treatments whose experiment name containts this string.
   * res - Resource name, can pass a comma separated list (Ex: "checkout:landing::features")
   * uid - Optional unique identifier
   */
  elmoExperiment: ElmoExperiment;
  /**
   * Allows querying elmo for treatments by using values from an API call as filter
   * app - Optional name of the Component/pool field in the Elmo UI (Ex: "checkoutuinodeweb")
   * filters - Optional array of filters to pass to Elmo (Ex: [{ key: "Country", value: "US" }]).
   *       This list of filters will be compiled to an object - { "filters.Country": "US" }
   * realTimeFilters - required field which consists of key valu pair [{key: "accoun_id", value: MERCHANT_ID }]
   *       where the value is substituted with a value returned from an API call
   *       You can find the API configuration in data/Experimentation/constants.js
   * token - required field as the basic checkout session API calls require token
   * res - Resource name, can pass a comma separated list (Ex: "checkout:landing::features")
   * uid - Optional unique identifier
   */
  elmoExperimentWithRealTimeFilters: ElmoExperiment;
  /**
   * The pxpTests query returns an Array of Experiment types.
   * See the 'pxpTest' query for more information on parameters.
   *
   * Average SLA response time - 42ms
   * @deprecated PXP experiments are deprecated. Use elmo experiments instead and query for elmoExperiment
   */
  experiments?: Maybe<Array<Maybe<Experiment>>>;
  /** Interface with the firebase api */
  firebase: FireBase;
  /** Returns whether the flow is eligible for signup or guest */
  flowEligibility?: Maybe<FlowEligibleMethods>;
  /**
   * Allows you to fetch eligible funding sources based on different criteria
   *
   * Optional clientID
   * Optional currency (Ex: "USD")
   * Optional country (Ex: "US")
   * Requires a language (Ex: "en")
   * Requires an intent (Ex: SALE)
   * Requires commit
   * Requires vault
   * Requires disableFunding (Ex: [EPS]
   * Optional merchantID
   * Optional cookies
   * Optional ip
   * Optional userAgent
   * Optional buttonSessionId
   */
  fundingEligibility?: Maybe<FundingEligibility>;
  /**
   * Allows you to fetch html, css, and js information related if GDPR related banner
   * is required for a client. Determined by locale headers/cookies on the request.
   *
   * If GDPR banner is not necessary, empty strings will be returned.
   * @deprecated Moved to cookieBanner
   */
  gdprBanner?: Maybe<GdprBanner>;
  /**
   * issuerBasedInstallments query returns installments options for a given card and buyer country.
   * Requires a token param (EC token) as a String
   * CC number is optional for BR flows, but required for MX flows.
   * Requires a buyer country as a String
   * card type is optional for MX flows, but required for BR flows.
   *
   * Required Roles: None.
   */
  getInstallmentsForOnboardingFlows?: Maybe<Array<Maybe<Installments>>>;
  /**
   * getInstallmentsForVaultedToken query allows you to query installments based on Vaulted Token.
   *
   * Requires a token param (EC, PAY, or BA token) as a String
   * Requires a vaultedToken as a String. It is a tokenized credit card passed in from MX UCC flows.
   *
   * Required Roles: None.
   */
  getInstallmentsForVaultedToken?: Maybe<Array<Maybe<Installments>>>;
  /** GooglePayConfig */
  googlePayConfig: GooglePayConfig;
  /** Boolean value indicating whether user has previously had a GPL loan */
  hasPreviousGplLoan?: Maybe<Scalars['Boolean']>;
  /** Determines flow eligibility for Inline Checkout. */
  inlineCheckoutEligibility?: Maybe<InlineCheckoutEligibility>;
  /**
   * PayPal Provisioning Platform is P3 which helps users to add their card to PayPal through partners or issuers.
   * More on P3 https://engineering.paypalcorp.com/confluence/display/PAYM/P3+@+XO
   * Institutions provides details of available financial institution that are supporting for P3 experience.
   */
  institutions: Array<FinancialInstitution>;
  /**
   * isMemberBenefitsEligible query will take some attributes of guest user and try to
   * match it with existing member account fetched based on guest user's email
   *
   * Requires a token param (EC, PAY, or BA token) as a String
   * Requires a firstName ("John") as a String
   * Requires a lastName ("Smith") as a String
   * Requires a email ("example@paypal.com") as a String
   * Requires a phoneNumber ("800-888-8888") as a String
   * Requires a country ("US") as a String
   *
   * Optionally pass a billingAddress as an AddressInput (country, postalCode, state)
   * Optionally pass a shippingAddress as an AddressInput (country, postalCode, state)
   * Optionally pass a card as a CardInput (cardNumber, postalCode, cvv, expirationDate)
   * Optionally pass a bank as a BankAccountInput (type, iban, accountNumber, routingNumber)
   *
   * Returns a Boolean type.
   *
   * Required auth states: ANONYMOUS
   */
  isGuestMemberBenefitsEligible?: Maybe<GuestMemberBenefits>;
  /** Whether or not a guest is eligible for upgrade to member.  A Boolean. */
  isGuestUpgradeableToMember?: Maybe<Scalars['Boolean']>;
  /**
   * Determine if a given clientID is vetted for use with the native mobile
   * checkout SDK as a privileged host.
   *
   * - clientId: the client id registered at developer.paypal.com for your
   * development needs.
   */
  isPrivilegedHost?: Maybe<NativeSdkPrivilegedResponse>;
  /**
   * Metadata specific to a locale
   *
   * If a country is not provided, it will be derived using default locale resolution rules (Ex: `checkoutSession.locale`)
   *
   * Required auth states: Any
   */
  localeMetadata?: Maybe<LocaleMetadata>;
  /**
   * Determines flow eligibility for the Web to Mobile SDK integration. The query takes in a set
   * number of parameters to determine eligibility for two main usecases.
   *
   * When no EC token is present, we'll take in paramteters form the Smart Payment Buttons to determine
   * eligibility at the moment of rendering the buttons
   *
   * When the EC token is present, we'll inspect the checkout session to determin transaction eligibility at
   * the moment of fallback, or when going to native SDK in case there's a buyer specific reason
   */
  mobileSDKEligibility?: Maybe<MobileSdkEligibility>;
  /**
   * This query is used by native SDK team to fetch the elmo experiment which
   * tells the client the feature eligibility for IOS and Android flows.
   * resourceName - Elmo Resource name used to retrieve the corresponding experiments (Ex: "mxo:android::preauth")
   * deviceLocale - The mobile divice locale
   * nativeSdkVersion - the native SDK version, will pass as the App version in elmo filter
   * merchantAppVersion - the merchant app version
   */
  mobileSdkFeatures?: Maybe<MobileSdkFeatures>;
  /** Retrieves login context for UL OTP */
  otpLoginContext?: Maybe<OtpLoginContext>;
  /** Retrieves login context for UL OTP (Weasley) */
  otpLoginContextForSignup?: Maybe<OtpLoginContext>;
  /** Retrieves passkey enrollment context from nodeidentitytoken */
  passkeyEnrollmentContext?: Maybe<IwcContext>;
  /** Funding instruments from user's guest checkout experience. */
  potentialCards?: Maybe<Array<Maybe<PotentialCard>>>;
  /** Returns PPC Approvability Score for current user */
  ppcApprovabilityScore?: Maybe<Scalars['Float']>;
  /**
   * Smart Wallet Lookup
   *
   * If passed an payment method nonce, it will use that nonce to pull in vaulted card details from Braintree. Otherwise it will
   * use PayPal vaulted cards. The branded flag must be set to true for nonce detokenization, otherwise it will default to PayPal
   * vaulted cards.
   */
  smartWallet?: Maybe<SmartWallet>;
  /**
   * Get a signed JsonWebToken for threeDS new stack (2.0 with inbound switch integration)
   * We need JWT token for two reasons:
   * 1. Device Data Collection needs a set of key values to be signed by key from keymaker and the
   *    entire signed string value is posted to DDC iframe
   * 2. Challenge Iframe needs a JWT value to be posted to trigger a OTP popup iframe
   * NOTE: Basically this API will sign whatever allowed keys you pass in request. There is no differentiation
   * in business logic of this API based on above two cases.
   *
   * referenceId - Unique ID generated by this API. This is populated only when 3DS is required and request is not in transactional context.
   *               Only applicable for 3DS
   * cardBin - first 9 digits of credit card - it returned as part of contingency data from FI.
   *   This parameter is optional for Switch api's.
   * jwtIssuer - JWT issuer returned from contingency data.
   * jwtOrgUnitId - JWT org unit ID returned from contingency data.
   * redirectUrl - url returned by ACS(Access Control Server) part of initial 3ds call
   *   which needs to send it to cardinal before loading challenge page.
   * returnUrl - call back route on frontend app to which cardinal can return after OTP is submitted by user.
   * transactionId = The ID of the transaction that is associated with this 3D Secure authentication. Only applicable for 3DS
   * paymentAuthenticationRequest - The encoded payment request generated by Centinel.
   * authenticationProvider - Payment Authentication provider
   *
   * Required auth states: any
   */
  threeDSJwt?: Maybe<Scalars['String']>;
  /** The context object shared between Unified Login and Checkout */
  unifiedLoginContext?: Maybe<UnifiedLoginContext>;
  /** Given a payerID and optionally a merchantId, returns information about a merchant messaging profile. */
  upstreamMessaging?: Maybe<UpstreamMessaging>;
  /**
   * Allows you to fetch fields for a User.
   *
   * *NOTE* This is for the currently logged in user.  In the future,
   * this query *could* allow you to pass a user ID to retrieve another user
   * such as in a student account use case where a parent is permitted to see
   * a child/student account information.
   *
   * Average SLA response time - 30ms
   *
   * Required Roles: LOGGEDIN, REMEMBERED, IDENTIFIED
   */
  user?: Maybe<User>;
  /**
   * Allows you to fetch User Agreement's data necessary to display the correct version
   * and link for the User Agreement on the client. Determined by Consent API response.
   *
   * If Consent API provides no data, empty strings will be returned.
   *
   * flow - CHECKOUT => for member use cases and ONBOARDING => for guest and sign up use cases
   */
  userAgreement?: Maybe<UserAgreement>;
  /**
   * Validates an address, including city/state/zip combinations.
   *
   * No EC token is required.
   */
  validateAddress?: Maybe<ValidateAddressResponse>;
  /**
   * Validate the payees on an order (by token)
   * Ensures that the merchantIds match the order's payees
   */
  validatePayees?: Maybe<ValidatePayeesResponse>;
  /**
   * Retrieves data from wallet
   *
   * Required Roles: LOGGEDIN
   */
  wallet: Wallet;
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryAddressAutoCompleteArgs = {
  count?: InputMaybe<Scalars['Int']>;
  countries?: InputMaybe<Array<InputMaybe<CountryCodes>>>;
  input: Scalars['String'];
  language?: InputMaybe<CheckoutContentLanguageCode>;
  location?: InputMaybe<Scalars['GeoLocation']>;
  offset?: InputMaybe<Scalars['Int']>;
  radius?: InputMaybe<Scalars['Int']>;
  sessionId: Scalars['String'];
  strictBounds?: InputMaybe<Scalars['Boolean']>;
  types?: InputMaybe<GooglePlacesType>;
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryAddressFromAutoCompletePlaceIdArgs = {
  language?: InputMaybe<CheckoutContentLanguageCode>;
  normalize?: InputMaybe<Scalars['Boolean']>;
  placeId: Scalars['ID'];
  region?: InputMaybe<Scalars['String']>;
  sessionId: Scalars['String'];
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryAddressNormalizationArgs = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCodes>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  processMode?: InputMaybe<AddressNormalizationProcessModes>;
  scope?: InputMaybe<AddressNormalizationScopes>;
  state?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
  transliterationType?: InputMaybe<AddressNormalizationTransliterationType>;
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryAddressValidationArgs = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  addressLine3?: InputMaybe<Scalars['String']>;
  adminArea1?: InputMaybe<Scalars['String']>;
  adminArea2?: InputMaybe<Scalars['String']>;
  adminArea3?: InputMaybe<Scalars['String']>;
  adminArea4?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCodes>;
  countryCode?: InputMaybe<CountryCodes>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryAppDownloadBannerArgs = {
  deviceOS: Scalars['String'];
  deviceOSVersion: Scalars['String'];
  deviceType: DeviceType;
  flow?: InputMaybe<Scalars['String']>;
  isMobile: Scalars['Boolean'];
  nonce: Scalars['String'];
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryApplePayMerchantSessionArgs = {
  clientID: Scalars['String'];
  displayName?: InputMaybe<Scalars['String']>;
  merchantDomain: Scalars['String'];
  merchantID?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderID?: InputMaybe<Scalars['String']>;
  url: Scalars['String'];
  useRealWallet?: InputMaybe<Scalars['Boolean']>;
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryApplePayMerchantSessionForPayPalArgs = {
  merchantDomain?: InputMaybe<Scalars['String']>;
  orderID?: InputMaybe<Scalars['String']>;
  productCode: ProductCode;
  url: Scalars['String'];
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryApplepayConfigArgs = {
  buyerCountry?: InputMaybe<CountryCodes>;
  clientId: Scalars['String'];
  merchantId: Array<InputMaybe<Scalars['String']>>;
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryAuthArgs = {
  accessToken?: InputMaybe<Scalars['String']>;
  authCode?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['String']>;
  idToken?: InputMaybe<Scalars['String']>;
  refreshToken?: InputMaybe<Scalars['String']>;
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryBurnableRewardsArgs = {
  buyerId: Scalars['String'];
  token: Scalars['String'];
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryCalculateShippingAndTaxesArgs = {
  locale: LocaleInput;
  shippingAddress: AddressInput;
  token: Scalars['String'];
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryCardDefinitionsArgs = {
  cardNumber: Scalars['String'];
  countryCode?: InputMaybe<CountryCodes>;
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryCardMetaArgs = {
  cardNumber: Scalars['String'];
  countryCode?: InputMaybe<CountryCodes>;
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryCheckoutCustomizationArgs = {
  buttonLabel?: InputMaybe<ButtonLabels>;
  buttonSessionId?: InputMaybe<Scalars['String']>;
  buttonSize?: InputMaybe<ButtonSizes>;
  buyerCountry?: InputMaybe<CountryCodes>;
  clientId?: InputMaybe<Scalars['String']>;
  commit?: InputMaybe<Scalars['Boolean']>;
  cookies?: InputMaybe<Scalars['String']>;
  creditRiskVerified?: InputMaybe<Scalars['Boolean']>;
  currency?: InputMaybe<SupportedCountryCurrencies>;
  deviceInfo?: InputMaybe<DeviceInfo>;
  domain?: InputMaybe<Scalars['String']>;
  installmentPeriod?: InputMaybe<Scalars['String']>;
  intent?: InputMaybe<FundingEligibilityIntent>;
  ip?: InputMaybe<Scalars['String']>;
  layout?: InputMaybe<ButtonLayouts>;
  locale: LocaleInput;
  merchantId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  renderedButtons?: InputMaybe<Array<InputMaybe<FundingButtonType>>>;
  taglineEnabled?: InputMaybe<Scalars['Boolean']>;
  userAgent?: InputMaybe<Scalars['String']>;
  vault?: InputMaybe<Scalars['Boolean']>;
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryCheckoutPropensityScoreArgs = {
  country: CountryCodes;
  token: Scalars['String'];
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryCheckoutSessionArgs = {
  dcvv?: InputMaybe<Scalars['String']>;
  enableCache?: InputMaybe<Scalars['Boolean']>;
  flows?: InputMaybe<CheckoutFlow>;
  productName?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryConsumerFlowIdArgs = {
  redirectUrl: Scalars['String'];
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryCookieBannerArgs = {
  nonce?: InputMaybe<Scalars['String']>;
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryCurrencyConversionArgs = {
  countryCode: CountryCodes;
  language: Scalars['String'];
  sourceCurrency: SupportedCountryCurrencies;
  sourceValue: Scalars['String'];
  targetCurrency: SupportedCountryCurrencies;
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryCurrencyConversionFromCreditCardArgs = {
  cardBrand?: InputMaybe<CardIssuerType>;
  cardNumber: Scalars['String'];
  country?: InputMaybe<CountryCodes>;
  token: Scalars['String'];
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryDynamicSegmentEvaluationArgs = {
  segmentName: Scalars['String'];
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryEarnableRewardsArgs = {
  buyerAccountNumber: Scalars['String'];
  buyerCountryCode: Scalars['String'];
  token: Scalars['String'];
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryEligibleInstallmentsArgs = {
  cardNumber?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryElmoExperimentArgs = {
  app?: InputMaybe<Scalars['String']>;
  experimentNameSubstring?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<ElmoFilterInput>>>;
  res: Scalars['String'];
  uid?: InputMaybe<Scalars['String']>;
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryElmoExperimentWithRealTimeFiltersArgs = {
  app?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<ElmoFilterInput>>>;
  realTimeFilters: Array<ElmoRealTimeFilterInput>;
  res: Scalars['String'];
  token: Scalars['String'];
  uid?: InputMaybe<Scalars['String']>;
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryExperimentsArgs = {
  tests?: InputMaybe<Array<InputMaybe<ExperimentInput>>>;
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryFlowEligibilityArgs = {
  merchantCountry: CountryCodes;
  merchantId: Scalars['String'];
  token: Scalars['String'];
  transactionCountry: CountryCodes;
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryFundingEligibilityArgs = {
  allowed?: InputMaybe<Array<InputMaybe<SupportedPaymentMethodsType>>>;
  buttonSessionId?: InputMaybe<Scalars['String']>;
  buyerCountry?: InputMaybe<CountryCodes>;
  clientId?: InputMaybe<Scalars['String']>;
  commit?: InputMaybe<Scalars['Boolean']>;
  cookies?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<SupportedCountryCurrencies>;
  disableCard?: InputMaybe<Array<InputMaybe<SupportedCardsType>>>;
  disableFunding?: InputMaybe<Array<InputMaybe<SupportedPaymentMethodsType>>>;
  domain?: InputMaybe<Scalars['String']>;
  enableFunding?: InputMaybe<Array<InputMaybe<SupportedPaymentMethodsType>>>;
  intent?: InputMaybe<FundingEligibilityIntent>;
  ip?: InputMaybe<Scalars['String']>;
  merchantId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userAgent?: InputMaybe<Scalars['String']>;
  vault?: InputMaybe<Scalars['Boolean']>;
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryGdprBannerArgs = {
  nonce?: InputMaybe<Scalars['String']>;
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryGetInstallmentsForOnboardingFlowsArgs = {
  buyerCountry: CountryCodes;
  cardNumber?: InputMaybe<Scalars['String']>;
  cardType?: InputMaybe<CardIssuerType>;
  token: Scalars['String'];
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryGetInstallmentsForVaultedTokenArgs = {
  token: Scalars['String'];
  vaultedToken: Scalars['String'];
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryGooglePayConfigArgs = {
  buyerCountry?: InputMaybe<CountryCodes>;
  clientId: Scalars['String'];
  merchantId: Array<InputMaybe<Scalars['String']>>;
  merchantOrigin?: InputMaybe<Scalars['String']>;
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryInlineCheckoutEligibilityArgs = {
  clientId: Scalars['String'];
  merchantId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryIsGuestMemberBenefitsEligibleArgs = {
  bank?: InputMaybe<BankAccountInput>;
  billingAddress?: InputMaybe<AddressInput>;
  card?: InputMaybe<CardInput>;
  country: CountryCodes;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: PhoneInput;
  shippingAddress?: InputMaybe<AddressInput>;
  token: Scalars['String'];
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryIsGuestUpgradeableToMemberArgs = {
  billingAddress: AddressInput;
  card: CardInput;
  country: CountryCodes;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  token: Scalars['String'];
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryIsPrivilegedHostArgs = {
  clientId: Scalars['String'];
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryMobileSdkEligibilityArgs = {
  buttonSessionID?: InputMaybe<Scalars['String']>;
  buyerAccessToken?: InputMaybe<Scalars['String']>;
  buyerCountry?: InputMaybe<Scalars['String']>;
  buyerLanguage?: InputMaybe<Scalars['String']>;
  cookies?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  domain?: InputMaybe<Scalars['String']>;
  enableFunding?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  facilitatorClientID?: InputMaybe<Scalars['String']>;
  fundingSource?: InputMaybe<Scalars['String']>;
  intent?: InputMaybe<Scalars['String']>;
  isBillingAgreementSupported?: InputMaybe<Scalars['Boolean']>;
  isCryptoPaymentsSupported?: InputMaybe<Scalars['Boolean']>;
  merchantID?: InputMaybe<Scalars['String']>;
  nativeAppVersion?: InputMaybe<Scalars['String']>;
  nativeSdkVersion?: InputMaybe<Scalars['String']>;
  os?: InputMaybe<Scalars['String']>;
  sdkjsVersion?: InputMaybe<Scalars['String']>;
  shippingCallbackEnabled?: InputMaybe<Scalars['Boolean']>;
  skipElmo?: InputMaybe<Scalars['Boolean']>;
  stickinessID?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  userAgent?: InputMaybe<Scalars['String']>;
  vault?: InputMaybe<Scalars['Boolean']>;
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryMobileSdkFeaturesArgs = {
  additionalFilters?: InputMaybe<Array<InputMaybe<ElmoFilterInput>>>;
  clientId: Scalars['String'];
  deviceLocale?: InputMaybe<Scalars['String']>;
  merchantAppVersion?: InputMaybe<Scalars['String']>;
  nativeSdkVersion?: InputMaybe<Scalars['String']>;
  resourceName: Scalars['String'];
  token?: InputMaybe<Scalars['String']>;
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryOtpLoginContextArgs = {
  integrationType: Scalars['String'];
  token: Scalars['String'];
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryOtpLoginContextForSignupArgs = {
  token: Scalars['String'];
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryPasskeyEnrollmentContextArgs = {
  integrationType: Scalars['String'];
  token: Scalars['String'];
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryPotentialCardsArgs = {
  token: Scalars['String'];
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QuerySmartWalletArgs = {
  allowBillingPayments?: InputMaybe<Scalars['Boolean']>;
  amount?: InputMaybe<Scalars['String']>;
  branded?: InputMaybe<Scalars['Boolean']>;
  buttonSessionID?: InputMaybe<Scalars['String']>;
  clientId: Scalars['String'];
  currency?: InputMaybe<Scalars['String']>;
  merchantId?: InputMaybe<Array<Scalars['String']>>;
  orderID?: InputMaybe<Scalars['String']>;
  paymentMethodNonce?: InputMaybe<Scalars['String']>;
  userAccessToken?: InputMaybe<Scalars['String']>;
  userIdToken?: InputMaybe<Scalars['String']>;
  userRefreshToken?: InputMaybe<Scalars['String']>;
  vetted?: InputMaybe<Scalars['Boolean']>;
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryThreeDsJwtArgs = {
  authenticationProvider?: InputMaybe<Scalars['String']>;
  cardBin?: InputMaybe<Scalars['String']>;
  cardType?: InputMaybe<Scalars['String']>;
  jwtIssuer: Scalars['String'];
  jwtOrgUnitId?: InputMaybe<Scalars['String']>;
  paymentAuthenticationRequest?: InputMaybe<Scalars['String']>;
  redirectUrl?: InputMaybe<Scalars['String']>;
  referenceId: Scalars['String'];
  returnUrl?: InputMaybe<Scalars['String']>;
  transactionId?: InputMaybe<Scalars['String']>;
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryUnifiedLoginContextArgs = {
  token: Scalars['String'];
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryUpstreamMessagingArgs = {
  clientId?: InputMaybe<Scalars['String']>;
  merchantId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryUserAgreementArgs = {
  flow: EvalPolicyFlowType;
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryValidateAddressArgs = {
  city?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<CountryCodes>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};


/** Query root type.  See https://graphql.org/learn/execution/#root-fields-resolvers */
export type QueryValidatePayeesArgs = {
  merchantIds: Array<Scalars['String']>;
  token: Scalars['String'];
};

/** Encapsulates all properties related to a rate (i.e. a percentage). */
export type Rate = {
  __typename?: 'Rate';
  /** Number formatted to the localized style (e.g. 0,25) */
  formattedNumber?: Maybe<Scalars['String']>;
  /** Number as a percentage formatted to the localized style (e.g. 0,25 %) */
  formattedNumberAsPercentage?: Maybe<Scalars['String']>;
  /** Unformatted number (e.g. 0.25) */
  unformattedNumber?: Maybe<Scalars['String']>;
};

/** Allowed statuses for resolveThreeDsContingency status */
export enum ResolveThreeDsContingencyStatus {
  /** 3DS resolution flow failed due to error or decline */
  Failure = 'FAILURE',
  /** 3DS resolution flow was successful */
  Success = 'SUCCESS'
}

/** Encapsulates all properties related to Rewards for a funding instrument */
export type Rewards = {
  __typename?: 'Rewards';
  /** The available rewards value and its equivalent monetary value */
  availableRewards?: Maybe<AvailableRewards>;
  /** Rewards that can be converted to currency equivalent or not */
  balance?: Maybe<RewardsBalance>;
  /** The minimum and maximum constraints on how rewards can be used */
  constraints?: Maybe<RewardsConstraints>;
  /** The necessary metadata to convert rewards to monetary value and vice versa */
  conversionMetadata?: Maybe<RewardsConversionMetadata>;
  /** The ID for Rewards */
  id?: Maybe<Scalars['String']>;
  /**
   * The rewards image
   *
   * Takes optional input for image size and type
   */
  image?: Maybe<GenericImage>;
  /** The card issuer rewards details */
  issuer?: Maybe<RewardsIssuer>;
  /** The rewards redemption type */
  redemptionType?: Maybe<RewardsRedemptionType>;
  /** The related card ID */
  relatedCardId?: Maybe<Scalars['String']>;
  /**
   * The reward type (i.e. `CHASE_REWARDS_POINTS`)
   *
   * This is used to determine what _type_ of rewards that's shown to the user. This is the combination of rewards issuer name and the issuer instrument type from the issuer data.
   * @deprecated Instead of using the rewardType, the reward content and behavior are determined by the redemptionType, the issuer name and denominationTypeDescription
   */
  rewardType?: Maybe<Scalars['String']>;
  /** The rewards terms and conditions url */
  termsUrl?: Maybe<Scalars['String']>;
};


/** Encapsulates all properties related to Rewards for a funding instrument */
export type RewardsImageArgs = {
  size?: InputMaybe<SquareImageSize>;
  type?: InputMaybe<ImageType>;
};

/** Encapsulates all properties related to Rewards Balance */
export type RewardsBalance = {
  __typename?: 'RewardsBalance';
  /** If the rewards can be converted to the currency equivalent */
  isConvertable?: Maybe<Scalars['Boolean']>;
  /** Currency to which rewards can be converted */
  targetCurrencyCode?: Maybe<SupportedCountryCurrencies>;
};

/** Encapsulates all properties related to Rewards constraints */
export type RewardsConstraints = {
  __typename?: 'RewardsConstraints';
  /** The maximum amount the user can spend when using rewards */
  maximumSpend?: Maybe<Amount>;
  /** The maximum usable rewards */
  maximumUsable?: Maybe<Amount>;
  /** The minimum amount the user can spend when using rewards */
  minimumSpend?: Maybe<Amount>;
};

/** Encapsulates all properties related to Rewards conversion */
export type RewardsConversionMetadata = {
  __typename?: 'RewardsConversionMetadata';
  /** Conversion factor when converting from rewards to monetary value */
  conversionFactor?: Maybe<Scalars['Float']>;
  /** The decimal precisions when converting from from rewards to monetary value and vice versa */
  decimalPrecision?: Maybe<RewardsDecimalPrecision>;
  /** The rounding modes when converting from from rewards to monetary value and vice versa */
  roundingMode?: Maybe<RewardsRoundingMode>;
};

/** The type of Rewards conversion */
export enum RewardsConversionType {
  /** Converting from amount to rewards */
  AmountToRewards = 'AMOUNT_TO_REWARDS',
  /** Converting from rewards to amount */
  RewardsToAmount = 'REWARDS_TO_AMOUNT'
}

/** The decimal precision for Rewards conversion */
export type RewardsDecimalPrecision = {
  __typename?: 'RewardsDecimalPrecision';
  /** Decimal precision for conversion from rewards to amount */
  toAmount?: Maybe<Scalars['Float']>;
  /** Decimal precision for conversion from amount to rewards */
  toRewards?: Maybe<Scalars['Float']>;
};

/**
 * Rewards input when paying with rewards.
 *
 * Used in the `approveMemberPayment` mutation.
 *
 * Example input:
 * ```
 * "rewards": {
 *   "id": "GI-XXXXXXXXXXXXX",
 *   "amount": "20",
 *   "currency": "USD"
 * }
 * ```
 */
export type RewardsInput = {
  /** Rewards amount to use toward the transaction */
  amount: Scalars['String'];
  /** Rewards currency code */
  currency: Scalars['String'];
  /** Rewards funding source ID */
  id: Scalars['String'];
};

/**
 * The card issuer rewards details
 *
 * This contains the name of the issuer, type of rewards instrument, and the name of the rewards product (i.e. `Ultimate Rewards® Points`)
 */
export type RewardsIssuer = {
  __typename?: 'RewardsIssuer';
  /**
   * The type of rewards
   * @deprecated Instead of using the instrumentType, the reward content and behavior are determined by the redemptionType, the issuer name and denominationTypeDescription
   */
  instrumentType?: Maybe<Scalars['String']>;
  /** The name of the rewards product like `Ultimate Rewards® Points` */
  issuerProductDescription?: Maybe<Scalars['String']>;
  /** The name of the rewards issuer */
  name?: Maybe<Scalars['String']>;
};

/** The Rewards redemption type */
export enum RewardsRedemptionType {
  /** Rewards are deducted from the rewards balance */
  RealTime = 'REAL_TIME',
  /** Rewards are used for a statement credit */
  StatementCredit = 'STATEMENT_CREDIT',
  /** Rewards are used with a specified dollar amount applied as a statement credit toward the purchase */
  StatementCreditWithAmountChoice = 'STATEMENT_CREDIT_WITH_AMOUNT_CHOICE'
}

/** The rounding modes when converting a Rewards value */
export type RewardsRoundingMode = {
  __typename?: 'RewardsRoundingMode';
  /** Rounding mode for conversion from rewards to amount */
  toAmount?: Maybe<RewardsRoundingModeType>;
  /** Rounding mode for conversion from amount to rewards */
  toRewards?: Maybe<RewardsRoundingModeType>;
};

/**
 * The mode of Rewards rounding
 *
 * https://docs.oracle.com/javase/7/docs/api/java/math/RoundingMode.html
 */
export enum RewardsRoundingModeType {
  /** Rounding mode to round towards zero. */
  Down = 'DOWN',
  /** Rounding mode to round towards _nearest neighbor_ unless both neighbors are equidistant, in which case round down. */
  HalfDown = 'HALF_DOWN',
  /** Rounding mode to round towards the _nearest neighbor_ unless both neighbors are equidistant, in which case, round towards the even neighbor. */
  HalfEven = 'HALF_EVEN',
  /** Rounding mode to round towards _nearest neighbor_ unless both neighbors are equidistant, in which case round up. */
  HalfUp = 'HALF_UP',
  /** Rounding is unnecessary */
  Unnecessary = 'UNNECESSARY',
  /** Rounding mode to round away from zero. */
  Up = 'UP'
}

/** Risk-based phone confirmation response */
export type RiskBasedPhoneConfirmationResponse = {
  __typename?: 'RiskBasedPhoneConfirmationResponse';
  /** Auth ID from riskchallengeserv */
  authId?: Maybe<Scalars['String']>;
  /** Challenge ID from riskchallengeserv */
  challengeId?: Maybe<Scalars['String']>;
  /** Phone confirmation state */
  state?: Maybe<ExtendedPhoneConfirmationState>;
};

/**
 * An enumeration of risk level indicator a merchant can have.
 *     "LOW_RISK", "MEDIUM_RISK", "HIGH_RISK"
 */
export enum RiskLevelIndicatorType {
  /** High Risk */
  HighRisk = 'HIGH_RISK',
  /** Low Risk */
  LowRisk = 'LOW_RISK',
  /** Medium Risk */
  MediumRisk = 'MEDIUM_RISK'
}

/** An enumeration of possible RPS customer list that can be used in xobuyer */
export enum RpsCustomerList {
  /** weasley - optional guest merchant list */
  OptionalGuestMerchantList = 'OPTIONAL_GUEST_MERCHANT_LIST'
}

/** An enumeration of possible RPS customer list that can be used in xobuyer */
export enum RpsSegmentName {
  /** weasley - optional guest merchant list */
  OptionalGuestMerchantsSegment = 'OPTIONAL_GUEST_MERCHANTS_SEGMENT',
  /** weasley - real money gaming merchant list */
  RmgMerchantsSegment = 'RMG_MERCHANTS_SEGMENT',
  /** weasley - signup incentives safe merchant list */
  SignupIncentivesSafeMerchantsSegment = 'SIGNUP_INCENTIVES_SAFE_MERCHANTS_SEGMENT'
}

/** Provides the user's current SCA status and exemption reason, if any */
export type SecureCustomerAuthenticationContext = {
  __typename?: 'SecureCustomerAuthenticationContext';
  /** The reason the buyer was exempted from SCA (if any) */
  exemptReason?: Maybe<SecureCustomerAuthenticationExemptReason>;
  /** The buyer's current SCA status */
  status?: Maybe<SecureCustomerAuthenticationStatus>;
};

/** An enumeration of possible SecureCustomerAuthenticationContext statuses */
export enum SecureCustomerAuthenticationExemptReason {
  /** Exempt as the buyer is not present */
  BuyerNotPresent = 'BUYER_NOT_PRESENT',
  /** Exempt from SCA as the cart total is below the threshold */
  LowValueTransaction = 'LOW_VALUE_TRANSACTION',
  /** Exempt as this is a reference transaction */
  ReferenceTransaction = 'REFERENCE_TRANSACTION',
  /** Exempt as user has marked the merchant as a trusted beneficiary */
  TrustedBeneficiary = 'TRUSTED_BENEFICIARY'
}

/** An enumeration of possible SecureCustomerAuthenticationContext statuses */
export enum SecureCustomerAuthenticationStatus {
  /** User has completed SCA */
  Complete = 'COMPLETE',
  /** User is exempt from SCA */
  Exempt = 'EXEMPT',
  /** User has provided at most one factor of authentication */
  InProgress = 'IN_PROGRESS'
}

/**
 * Encapsulates all properties related to a credit as FI offer for the RYI page that a user selected.
 * Average SLA response time - 50ms - (This might change)
 */
export type SelectedCrcOffer = {
  /** Offer ID for the offer returned by crcofferserv */
  crcOfferId?: InputMaybe<Scalars['String']>;
  /** Financing code is the id for a particular offer returned by credit financing serv. */
  financingCode?: InputMaybe<Scalars['String']>;
};

/**
 * Encapsulates all properties related to the pre-selected FI from Mors/EDS component for Pi30 flows
 * Average SLA response time - 50ms - (This might change)
 */
export type SelectedCrCfi = {
  /** Id of the FI as a string (ex: 'BA-DSJODJSISDNALSD') */
  id: Scalars['String'];
  /** The last four digits of the user's fi number as a String (Ex: '7062') */
  lastFourDigits: Scalars['String'];
  /** The name associated to the fi (Ex: 'Deutsche Bank') */
  name: Scalars['String'];
};

/** Encapsulates all properties related to a SepaMandateAcceptenceNeededContingency type */
export type SepaMandateAcceptenceNeededContingency = {
  __typename?: 'SepaMandateAcceptenceNeededContingency';
  /** bankAccount related to contingency */
  bankAccount?: Maybe<BankAccount>;
};

/** Encapsulates all properties related to a ShippingAndTaxCharges from shiptaxcalcserv. */
export type ShippingAndTaxCharges = {
  __typename?: 'ShippingAndTaxCharges';
  /** Unique UUID */
  id?: Maybe<Scalars['String']>;
  /** Shipping charges */
  shipping?: Maybe<ShippingCharges>;
  /** Tax charges */
  tax?: Maybe<TaxCharges>;
};

/** Encapsulates all properties related to a ShippingAndTaxes from shiptaxcalcserv. */
export type ShippingAndTaxes = {
  __typename?: 'ShippingAndTaxes';
  /** List of shipping and tax charges */
  charges: Array<ShippingAndTaxCharges>;
  /** Whether shipping is supported for this region */
  isShippingRegionSupported: Scalars['Boolean'];
  /** Whether tax is required for shipping */
  isTaxOnShippingRequired: Scalars['Boolean'];
  /** Whether profile override is allowed */
  profileOverrideAllowed?: Maybe<Scalars['Boolean']>;
  /** Shipping options source ('PROFILE' or 'CALLBACK' or 'FALLBACK') */
  shippingOptionsSource: ShippingOptionsSource;
  /** Whether shipping options are shown */
  shouldShowShippingOptions: Scalars['Boolean'];
};

/** Encapsulates all properties related to a ShippingCharges from shiptaxcalcserv. */
export type ShippingCharges = {
  __typename?: 'ShippingCharges';
  /** Duration for delivery to arrive (Ex: 3-5 business days) */
  deliveryTime?: Maybe<Scalars['String']>;
  /** Whether insurance option is offered */
  hasInsurance: Scalars['Boolean'];
  /** Unique identifier for the shipping option */
  id: Scalars['String'];
  /** Insurance amount for this shipping option */
  insuranceAmount?: Maybe<Amount>;
  /** Default shipping option */
  isDefaultShippingOption: Scalars['Boolean'];
  /** Display name for shipping option */
  label?: Maybe<Scalars['String']>;
  /** Shipping amount for this shipping option */
  shippingAmount: Amount;
  /** Type of shipping method needed to update selected shipping method to update the cart */
  shippingMethodType?: Maybe<Scalars['String']>;
  /** Type of shipping method ('SHIPPING' or 'PICKUP') */
  type: ShippingMethodType;
};

/** Shipping methods to display to the buyer */
export type ShippingMethodInput = {
  /** Amount value for this method */
  amount: AmountInput;
  /** Unique ID which represents this option */
  id: Scalars['String'];
  /** Custom label to display to the buyer for this method */
  label: Scalars['String'];
  /** Whether or not this is the selected method */
  selected: Scalars['Boolean'];
  /** Type of shipping method (Ex: 'SHIPPING') */
  type: ShippingMethodType;
};

/** Types, or categories for ShippingMethods to have. */
export enum ShippingMethodType {
  /** Pick up at location */
  Pickup = 'PICKUP',
  /** Pick up from person */
  PickupFromPerson = 'PICKUP_FROM_PERSON',
  /** Pick up in store */
  PickupInStore = 'PICKUP_IN_STORE',
  /** Ship to home address */
  Shipping = 'SHIPPING'
}

/** The shipping options source type */
export enum ShippingOptionsSource {
  /** Shipping options are from callback url */
  Callback = 'CALLBACK',
  /** Fallback to button param if calling external url fails */
  Fallback = 'FALLBACK',
  /** Shipping charges are calculated from profile or button params */
  Profile = 'PROFILE'
}

/** Lists possible transaction Signature status identifier. */
export enum SignatureVerificationStatus {
  /** Indicates that the PARes could not be validated. */
  No = 'NO',
  /** Indicates that the signature of the PARes (Payment Authentication Response) has been validated successfully and the message contents can be trusted */
  Yes = 'YES'
}

/**
 * Get a recognized user's smart wallet. This api works:
 *
 * - 1. Can be used using a orderID and buyer access token from a login session.
 * - 2. With either an existing buyer access token, billing agreement, or vault
 * - Returns both branded and unbranded FIs
 */
export type SmartWallet = {
  __typename?: 'SmartWallet';
  /** Card Smart Funding */
  card: SmartWalletFunding;
  /** Credit Smart Funding */
  credit: SmartWalletFunding;
  /** PayPal Smart Funding */
  paypal: SmartWalletFunding;
  /** Venmo Smart Funding */
  venmo: SmartWalletFunding;
};

/** An funding type within a buyer's smart wallet */
export type SmartWalletFunding = {
  __typename?: 'SmartWalletFunding';
  /** List of Smart Wallet funding instruments */
  instruments: Array<SmartWalletInstrument>;
};

/** An instrument within a buyer's smart wallet */
export type SmartWalletInstrument = {
  __typename?: 'SmartWalletInstrument';
  /** Buyer access token to use to approve the payment on checkout rails */
  accessToken?: Maybe<Scalars['String']>;
  /** Funding source is branded or unbranded */
  branded?: Maybe<Scalars['Boolean']>;
  /** Instrument ID to use when paying on checkout rails */
  instrumentID?: Maybe<Scalars['String']>;
  /** Issuer Product Description */
  issuerProductDescription?: Maybe<Scalars['String']>;
  /** Label to show for the FI (last-4 / email) */
  label?: Maybe<Scalars['String']>;
  /** Logo to show for the FI (e.g. card art url) */
  logoUrl?: Maybe<Scalars['String']>;
  /** Can the payment be made in one click */
  oneClick?: Maybe<Scalars['Boolean']>;
  /** PlanID associated with this instrument. */
  planID?: Maybe<Scalars['String']>;
  /** Secondary instruments associated */
  secondaryInstruments?: Maybe<Array<SmartWalletSecondaryInstrument>>;
  /** Token ID to use when paying on vault rails */
  tokenID?: Maybe<Scalars['String']>;
  /** Instrument type. card / bank / credit / balance */
  type?: Maybe<Scalars['String']>;
  /** Card vendor */
  vendor?: Maybe<Scalars['String']>;
};

/** A secondary instrument associated with an instrument during planning */
export type SmartWalletSecondaryInstrument = {
  __typename?: 'SmartWalletSecondaryInstrument';
  /** Instrument ID to use when paying on checkout rails */
  instrumentID?: Maybe<Scalars['String']>;
  /** Label to show for the FI (last-4 / email) */
  label?: Maybe<Scalars['String']>;
  /** Logo to show for the FI (e.g. card art url) */
  logoUrl?: Maybe<Scalars['String']>;
  /** Instrument type card / bank / credit / balance */
  type?: Maybe<Scalars['String']>;
};

/** Encapsulates the Split Funding Option object item */
export type SplitFundingOptions = {
  __typename?: 'SplitFundingOptions';
  /** Highlights the maxiumum amount for this funding instrument if there is a limit */
  availableAmount?: Maybe<Amount>;
  /** Determines whether user can edit the amount in the UX */
  canEditAmount: Scalars['Boolean'];
  /** List of Funding Instrument IDs this funding option can split with */
  canSplitWith: Array<Maybe<Scalars['ID']>>;
  /** Funding Instrument Object */
  fundingInstrument: FundingInstrument;
  /** Funding Instrument ID */
  id: Scalars['ID'];
  /** Determines eligibility for a Primary/Backup funding instrument */
  isEligibleForPrimaryInstrument: Scalars['Boolean'];
  /** Determine if user must use the full amount for this instrument like INCENTIVEs */
  mustUseFullAmount: Scalars['Boolean'];
};

/** Represents the data required for completing an Approve Payment for Split Tender */
export type SplitFundingOptionsInput = {
  /** Amount to apply to Funding Instrument */
  amount: AmountInput;
  /** Funding Instrument Type */
  fundingInstrumentType: FundingInstrumentType;
  /** Funding Instrument ID */
  id: Scalars['ID'];
  /** User Selected Instrument to be the Backup/Primary - must have one in the list */
  isPrimaryInstrument: Scalars['Boolean'];
};

/** Size of an image */
export enum SquareImageSize {
  /** Large 300x300 px */
  L = 'L',
  /** Medium 200x200 px */
  M = 'M',
  /** Small 96x96 px */
  S = 'S',
  /** Extra large 400x400 px */
  Xl = 'XL',
  /** Extra small 50x50 px */
  Xs = 'XS',
  /** Extra extra large 500x500 px */
  Xxl = 'XXL',
  /** Extra extra small 32x32 px */
  Xxs = 'XXS',
  /** Extra extra extra large 800x800 px */
  Xxxl = 'XXXL'
}

/** status of token */
export enum Status {
  /** Setup token is ready to be vaulted. If a buyer approval contigency was returned, it is has been approved */
  Approved = 'APPROVED',
  /** A setup token is initialized with minimal information, more data must be added to the setup-token to be vaulted */
  Created = 'CREATED',
  /** buyer contingency */
  PayerActionRequired = 'PAYER_ACTION_REQUIRED',
  /** A vaulted payment method token has been tokenized for short term (one time) use */
  Tokenized = 'TOKENIZED',
  /** The payment token has been updated */
  Updated = 'UPDATED',
  /** The payment token has been vaulted  */
  Vaulted = 'VAULTED'
}

/**
 * Data required to resolve the Strong Customer Authentication (SCA) Contingency.
 * Before completing checkout or updating any account related info, user needs to complete another auth flow.
 */
export type StrongCustomerAuthenticationRequiredContingency = {
  __typename?: 'StrongCustomerAuthenticationRequiredContingency';
  /** ID to be passed to the auth flow that will be collecting the user's auth, as part of the arguments. */
  contextId?: Maybe<Scalars['ID']>;
};

/** Encapsulates all properties related to the billing cycles for a subscription transaction */
export type SubscriptionBillingCycles = {
  __typename?: 'SubscriptionBillingCycles';
  /** The currency and amount for a financial transaction, such as a balance or payment due */
  fixedPrice?: Maybe<Amount>;
  /** Frequency of the billing cycle */
  frequency?: Maybe<BillingCycleFrequency>;
  /** Number of times the billing cycle should be executed */
  totalCycles?: Maybe<Scalars['String']>;
};

/** Encapsulates all properties related to a new or current subscription plan. */
export type SubscriptionDetails = {
  __typename?: 'SubscriptionDetails';
  /** Initial Payment Details for the agreement token */
  initialPaymentInfo?: Maybe<InitialSubscriptionPaymentInfo>;
  /** Plan Details */
  plan?: Maybe<SubscriptionPlanDetails>;
};

/** Encapsulates all properties related to a subscription plan's details. */
export type SubscriptionPlanDetails = {
  __typename?: 'SubscriptionPlanDetails';
  /** An array of billing cycles for trial and regular billing */
  billingCycles?: Maybe<Array<Maybe<SubscriptionBillingCycles>>>;
  /** The PayPal-generated unique ID for the plan resource. (Ex: 'P-5ML4271244454362WXNWU5NQ') */
  id?: Maybe<Scalars['String']>;
  /** Name of the plan (Ex: 'Netflix Plan 17012019') */
  name?: Maybe<Scalars['String']>;
  /** The date and time, in [Internet date and time format](https://tools.ietf.org/html/rfc3339#section-5.6). */
  startTime?: Maybe<Scalars['String']>;
};

/** Encapsulates all properties related to a subscription plan's tax details. */
export type SubscriptionTaxDetails = {
  __typename?: 'SubscriptionTaxDetails';
  /** Description of the tax */
  description?: Maybe<Scalars['String']>;
  /** Whether tax is already included in the billing amount - defaults to false */
  inclusive?: Maybe<Scalars['Boolean']>;
  /** Taxation represented as a fixed-point, signed decimal number percentage */
  percentage?: Maybe<Scalars['String']>;
};

/**
 * Encapsulates all properties related to a SuggestedDonationfor the RYI page.
 * Average SLA response time - 50ms
 */
export type SuggestedDonation = {
  __typename?: 'SuggestedDonation';
  /** A suggested donation content, a JSON object includes suggested charity details, donation amount and UI content. */
  content?: Maybe<SuggestedDonationContent>;
  /** A suggested donation reference ID. */
  id?: Maybe<Scalars['ID']>;
  /** Uitilities for tracking this suggested donation and the user's interaction with it. */
  trackingDetails?: Maybe<MorsMrTrackingDetails>;
};

/** Encapsulates all properties related to a SuggestedDonationContent. */
export type SuggestedDonationContent = {
  __typename?: 'SuggestedDonationContent';
  /** suggested donation amount */
  amount?: Maybe<Amount>;
  /** title message showing at give at checkout feature */
  donateMessage: Scalars['String'];
  /** donation purpose message showing at give at checkout email receipt and transaction details */
  donationPurpose?: Maybe<Scalars['String']>;
  /** legal message body (array) showing at give at checkout feature */
  legalDisclaimerBodyMessage?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** legal message header showing at give at checkout feature */
  legalDisclaimerHeaderMessage?: Maybe<Scalars['String']>;
  /** the suggested nonprofit/charity model id */
  modelId?: Maybe<Scalars['String']>;
  /** model score assigned to this suggested nonprofit */
  modelScore?: Maybe<Scalars['String']>;
  /** nonprofit id defined by cause */
  nonprofitId: Scalars['ID'];
  /** nonprofit logo url */
  nonprofitLogoUrl: GenericUrl;
  /** nonprofit name */
  nonprofitName: Scalars['String'];
  /** nonprofit paypal id (aka payer_id) */
  nonprofitPayPalId?: Maybe<Scalars['String']>;
  /** promotional message showing at give at checkout feature (optional) */
  promoMessage?: Maybe<Scalars['String']>;
};

/** Encapsulates all supplementary data present in the Cart. */
export type Supplementary = {
  __typename?: 'Supplementary';
  /** The initiation intent for this cart */
  initiationIntent?: Maybe<CartIntent>;
};

/** User's associated information passed by the merchant" */
export type SuppliedUserInfo = {
  __typename?: 'SuppliedUserInfo';
  /** Cart's associated email passed by the merchant */
  email?: Maybe<Email>;
  /** Metadata related to the information passed by the merchant */
  evaluatedUserData?: Maybe<GuestUserMetadata>;
  /** Cart's associated name passed by the merchant */
  name?: Maybe<PersonName>;
  /** Cart's associated phone passed by the merchant */
  phone?: Maybe<GenericPhone>;
  /** Cart's associated tax information passed by the merchant */
  taxInfo?: Maybe<TaxInfo>;
};

/** Supported card vendors */
export enum SupportedCardsType {
  /** AMERICAN EXPRESS */
  Amex = 'AMEX',
  /** CUP */
  Cup = 'CUP',
  /** DINERS */
  Diners = 'DINERS',
  /** DISCOVER */
  Discover = 'DISCOVER',
  /** ELO */
  Elo = 'ELO',
  /** HIPER */
  Hiper = 'HIPER',
  /** JCB */
  Jcb = 'JCB',
  /** MAESTRO */
  Maestro = 'MAESTRO',
  /** MASTERCARD */
  Mastercard = 'MASTERCARD',
  /** VISA */
  Visa = 'VISA'
}

/** An enumeration of supported country currencies that CurrencyConversion query allows */
export enum SupportedCountryCurrencies {
  /** United Arab Emirates Dirham (AED) */
  Aed = 'AED',
  /** Afghan Afghani (AFN) */
  Afn = 'AFN',
  /** Albania Lek (ALL) */
  All = 'ALL',
  /** Armenian Dram (AMD) */
  Amd = 'AMD',
  /** Netherlands Antillian Guilder (ANG) */
  Ang = 'ANG',
  /** Angolian Kwanza (AOA) */
  Aoa = 'AOA',
  /** Argentine Peso (ARS) */
  Ars = 'ARS',
  /** Australian Dollar (AUD) */
  Aud = 'AUD',
  /** Aruban Guilder (AWG) */
  Awg = 'AWG',
  /** Azerbaijan Manat (AZN) */
  Azn = 'AZN',
  /** Bosnian Convertible Mark (BAM) */
  Bam = 'BAM',
  /** Barbados Dollar (BBD) */
  Bbd = 'BBD',
  /** Bangladeshi Taka (BDT) */
  Bdt = 'BDT',
  /** Bulgarian Lev (BGN) */
  Bgn = 'BGN',
  /** Bahraini Dinar (BHD) */
  Bhd = 'BHD',
  /** Burundi Franc (BIF) */
  Bif = 'BIF',
  /** Bermudian Dollar (BMD) */
  Bmd = 'BMD',
  /** Brunei Dollar (BND) */
  Bnd = 'BND',
  /** Bolivian Boliviano (BNB) */
  Bob = 'BOB',
  /** Brazilian Real (BRL) */
  Brl = 'BRL',
  /** Bahamian Dollar (BSD) */
  Bsd = 'BSD',
  /** Bhutan Ngultrum (BTN) */
  Btn = 'BTN',
  /** Botswana Pula (BWP) */
  Bwp = 'BWP',
  /** Belarusian Ruble (BYN) */
  Byn = 'BYN',
  /** Belize Dollar (BZD) */
  Bzd = 'BZD',
  /** Canadian Dollar (CAD) */
  Cad = 'CAD',
  /** Dem. Republic, Congo Franc Congolais (CDF) */
  Cdf = 'CDF',
  /** Swiss Franc (CHF) */
  Chf = 'CHF',
  /** Chilean Peso (CLP) */
  Clp = 'CLP',
  /** Chinese Yuan Renminbi (CNY) */
  Cny = 'CNY',
  /** Colombian Peso (COP) */
  Cop = 'COP',
  /** Costa Rican Colon (CRC) */
  Crc = 'CRC',
  /** Cuban Convertible Peso (CUC) */
  Cuc = 'CUC',
  /** Cuban Peso (CUP) */
  Cup = 'CUP',
  /** Cape Verde Escudo (CVE) */
  Cve = 'CVE',
  /** Czech Koruna (CZK) */
  Czk = 'CZK',
  /** Djibouti Franc (DJF) */
  Djf = 'DJF',
  /** Danish Krone (DKK) */
  Dkk = 'DKK',
  /** Dominican Peso (DOP) */
  Dop = 'DOP',
  /** Algerian Dinar (DZD) */
  Dzd = 'DZD',
  /** Estonian Kroon (EEK) */
  Eek = 'EEK',
  /** Egyptian Pound (EGP) */
  Egp = 'EGP',
  /** Eritrean Nakfa (ERN) */
  Ern = 'ERN',
  /** Ethiopian Birr (ETB) */
  Etb = 'ETB',
  /** Euro (EUR) */
  Eur = 'EUR',
  /** Fiji Dollar (FJD) */
  Fjd = 'FJD',
  /** Falkland Islands Pound (FKP) */
  Fkp = 'FKP',
  /** Pound Sterling (GBP) */
  Gbp = 'GBP',
  /** Georgian Lari (GEL) */
  Gel = 'GEL',
  /** Ghanaian Cedi (GHS) */
  Ghs = 'GHS',
  /** Gibraltar Pound (GIP) */
  Gip = 'GIP',
  /** Gambian Dalasi (GMD) */
  Gmd = 'GMD',
  /** Guinea Franc (GNF) */
  Gnf = 'GNF',
  /** Guatemalan Quetzal (GTQ) */
  Gtq = 'GTQ',
  /** Guyana Dollar (GYD) */
  Gyd = 'GYD',
  /** Hong Kong Dollar (HKD) */
  Hkd = 'HKD',
  /** Honduran Lempira (HNL) */
  Hnl = 'HNL',
  /** Croatian Kuna (HRK) */
  Hrk = 'HRK',
  /** Haitian gourde (HTG) */
  Htg = 'HTG',
  /** Hungarian Forint (HUF) */
  Huf = 'HUF',
  /** Indonesian Rupiah (IDR) */
  Idr = 'IDR',
  /** New Israeli Shekel (ILS) */
  Ils = 'ILS',
  /** Indian Rupee (INR) */
  Inr = 'INR',
  /** Iraqi Dinar (IQD) */
  Iqd = 'IQD',
  /** Iranian rial (IRR) */
  Irr = 'IRR',
  /** Iceland Krona (ISK) */
  Isk = 'ISK',
  /** Jamaican Dollar (JMD) */
  Jmd = 'JMD',
  /** Jordanian Dinar (JOD) */
  Jod = 'JOD',
  /** Japanese Yen (JPY) */
  Jpy = 'JPY',
  /** Kenyan Shilling (KES) */
  Kes = 'KES',
  /** Kyrgyzstani Som (KGS) */
  Kgs = 'KGS',
  /** Cambodian Riel (KHR) */
  Khr = 'KHR',
  /** Comoro Franc (KMF) */
  Kmf = 'KMF',
  /** North Korean Won (KPW) */
  Kpw = 'KPW',
  /** South Korean Won (KRW) */
  Krw = 'KRW',
  /** Kuwaiti Dinar (KWD) */
  Kwd = 'KWD',
  /** Cayman Islands Dollar (KYD) */
  Kyd = 'KYD',
  /** Kazahstan Tenge (KYD) */
  Kzt = 'KZT',
  /** Lao Kip (LAK) */
  Lak = 'LAK',
  /** Lebanese Pound (LBP) */
  Lbp = 'LBP',
  /** Sri Lanka Rupee (LKR) */
  Lkr = 'LKR',
  /** Liberian Dollar (LRD) */
  Lrd = 'LRD',
  /** Lesotho Loti (LSL) */
  Lsl = 'LSL',
  /** Lithuanian Litas (LTL) */
  Ltl = 'LTL',
  /** Latvian Lats (LVL) */
  Lvl = 'LVL',
  /** Libyan Dinar (LYD) */
  Lyd = 'LYD',
  /** Malagasy Franc (MAD) */
  Mad = 'MAD',
  /** Moldovan Leu (MDL) */
  Mdl = 'MDL',
  /** Malagasy Ariary (MGA) */
  Mga = 'MGA',
  /** Macedonian Denar (MKD) */
  Mkd = 'MKD',
  /** Myanmar Kyat (MMK) */
  Mmk = 'MMK',
  /** Mongolian Tugrik / Tugrug (MNT) */
  Mnt = 'MNT',
  /** Macanese Pataca (MOP) */
  Mop = 'MOP',
  /** Mauritanian Ouguiya (MRO) */
  Mro = 'MRO',
  /** Mauritanian Ouguiya (MRU) */
  Mru = 'MRU',
  /** Mauritius Rupee (MUR) */
  Mur = 'MUR',
  /** Maldivian Rufiyaa (MVR) */
  Mvr = 'MVR',
  /** Malawi Kwacha (MWK) */
  Mwk = 'MWK',
  /** Mexican Peso (MXN) */
  Mxn = 'MXN',
  /** Malaysian Ringgit (MYR) */
  Myr = 'MYR',
  /** Mozambican metical (MZN) */
  Mzn = 'MZN',
  /** Namibia Dollar (Rand) */
  Nad = 'NAD',
  /** Nigerian Naira (NGN) */
  Ngn = 'NGN',
  /** Nicaraguan Cordoba Oro (NIO) */
  Nio = 'NIO',
  /** Norwegian Krone (NOK) */
  Nok = 'NOK',
  /** Nepalese Rupee (NPR) */
  Npr = 'NPR',
  /** New Zealand Dollar (NZD) */
  Nzd = 'NZD',
  /** Omani Rial (OMR) */
  Omr = 'OMR',
  /** Panamanian Balboa (PAB) */
  Pab = 'PAB',
  /** Peruvian Nuevo Sol (PEN) */
  Pen = 'PEN',
  /** Papua New Guinean Kina (PGK) */
  Pgk = 'PGK',
  /** Philippine Peso (PHP) */
  Php = 'PHP',
  /** Pakistani Rupee (PKR) */
  Pkr = 'PKR',
  /** Zloty (PLN) */
  Pln = 'PLN',
  /** Paraguay Guarani (PYG) */
  Pyg = 'PYG',
  /** Qatari Rial (QAR) */
  Qar = 'QAR',
  /** Romanian New Leu (RON) */
  Ron = 'RON',
  /** Serbian Dinar (RSD) */
  Rsd = 'RSD',
  /** Russian Rubble (RUB) */
  Rub = 'RUB',
  /** Russian Ruble (RUR) */
  Rur = 'RUR',
  /** Rwandan Franc (RWF) */
  Rwf = 'RWF',
  /** Saudi Riyal (SAR) */
  Sar = 'SAR',
  /** Solomon Islands Dollar (SBD) */
  Sbd = 'SBD',
  /** Seychellois Rupee (SCR) */
  Scr = 'SCR',
  /** Sudanese Pound (SDG) */
  Sdg = 'SDG',
  /** Swedish Krona (SEK) */
  Sek = 'SEK',
  /** Singapore Dollar (SGD) */
  Sgd = 'SGD',
  /** Saint Helena Pound (SHP) */
  Shp = 'SHP',
  /** Sierra Leone Leone (SLL) */
  Sll = 'SLL',
  /** Somali Shilling (SOS) */
  Sos = 'SOS',
  /** Surinamese Dollar (SRD) */
  Srd = 'SRD',
  /** South Sudanese Pound (SSP) */
  Ssp = 'SSP',
  /** Sao Tome and Principe Dobra (STD) */
  Std = 'STD',
  /** Sao Tome and Principe Dobra (STN) */
  Stn = 'STN',
  /** Salvadoran Colon (SVC) */
  Svc = 'SVC',
  /** Syrian Pound (SYP) */
  Syp = 'SYP',
  /** Swaziland Lilangeni (SZL) */
  Szl = 'SZL',
  /** Baht (THB) */
  Thb = 'THB',
  /** Tajikistan Somoni (TJS) */
  Tjs = 'TJS',
  /** Turkish Lira (TL) */
  Tl = 'TL',
  /** Turkmen Manat (TMT) */
  Tmt = 'TMT',
  /** Tunisian Dinar (TND) */
  Tnd = 'TND',
  /** Tongan Paʻanga (TOP) */
  Top = 'TOP',
  /** New Turkish Lira (TRY) */
  Try = 'TRY',
  /** Trinidad and Tobago Dollar (TTD) */
  Ttd = 'TTD',
  /** New Taiwan Dollar (TWD) */
  Twd = 'TWD',
  /** Tanzanian Shilling (TZS) */
  Tzs = 'TZS',
  /** Ukrainian Hryvnia (UAH) */
  Uah = 'UAH',
  /** Uganda Shilling (UGX) */
  Ugx = 'UGX',
  /** US Dollar (USD) */
  Usd = 'USD',
  /** Uruguayan Peso Uruguayo (UYU) */
  Uyu = 'UYU',
  /** Uzbekistani Som (UZS) */
  Uzs = 'UZS',
  /** Venezuelan Bolivar Fuerte (VEF) */
  Vef = 'VEF',
  /** Venezuelan Bolivar Soberano (VES) */
  Ves = 'VES',
  /** Vietnamese Dong (VND) */
  Vnd = 'VND',
  /** Vanuatu Vatu (VUV) */
  Vuv = 'VUV',
  /** Samoan Tala (WST) */
  Wst = 'WST',
  /** CFA Franc BEAC (XAF) */
  Xaf = 'XAF',
  /** East Caribbean Dollar (XCD) */
  Xcd = 'XCD',
  /** West African CFA Franc (XOF) */
  Xof = 'XOF',
  /** CFP Franc (XPF) */
  Xpf = 'XPF',
  /** Yemeni Rial (YER) */
  Yer = 'YER',
  /** South African Rand (ZAR) */
  Zar = 'ZAR',
  /** Zambian Kwacha (ZMW) */
  Zmw = 'ZMW'
}

/** An enumeration of types that currency could have. International, code, plural etc. */
export type SupportedCurrencySymbolsMetadata = {
  __typename?: 'SupportedCurrencySymbolsMetadata';
  /** A pattern which represents the code of current country (Ex: $ for an en-US locale) */
  code: Scalars['String'];
  /** A pattern which represent the currency international */
  international: Scalars['String'];
  /** A pattern for indicating what represent (Ex: 'Plural 1 -> en-US'  */
  plural: Scalars['String'];
  /** The separator according to the current locale */
  separator: Scalars['String'];
  /** A symbol according to the current locale */
  symbol: Scalars['String'];
};

/** Supported funding sources returned by IDS(Instrument Definition Service) */
export type SupportedFundingSource = {
  __typename?: 'SupportedFundingSource';
  /** Brand name of the funding source(Ex: 'VISA', 'AMEX', 'MASTER_CARD', 'DISCOVER') */
  brand?: Maybe<CardIssuerType>;
  /** Logo image of the funding source brand */
  brandLogoUrl?: Maybe<GenericUrl>;
  /** Issuers of the funding source brand */
  issuers?: Maybe<Array<Maybe<SupportedFundingSourceIssuer>>>;
};

/** Issuers of a funding source's brand returned by IDS */
export type SupportedFundingSourceIssuer = {
  __typename?: 'SupportedFundingSourceIssuer';
  /** Issuer's logo image url */
  issuerLogoUrl?: Maybe<GenericUrl>;
  /** Issuer's name */
  name?: Maybe<Scalars['String']>;
  /** Issuer's priority rank to show */
  rank?: Maybe<Scalars['Int']>;
  /** Issuer's possible subtypes(Ex: 'CREDIT', 'DEBIT') */
  usage?: Maybe<Array<Maybe<FundingInstrumentSubType>>>;
};

/** Supported payment methods */
export enum SupportedPaymentMethodsType {
  /** Apple Pay -- [Link](https://en.wikipedia.org/wiki/Apple_Pay)  */
  Applepay = 'APPLEPAY',
  /** BANCONTACT -- Used typically in Belgium -- [Link](https://www.bancontact.com/en/what-does-bancontact-stand-for) */
  Bancontact = 'BANCONTACT',
  /** Blik -- Used in poland -- [Link](ask product) */
  Blik = 'BLIK',
  /** Boleto -- Used in Brazil -- [Link](https://en.wikipedia.org/wiki/Boleto) */
  Boleto = 'BOLETO',
  /** Boletobancario -- Used in Brazil -- [Link](https://en.wikipedia.org/wiki/Boleto) */
  Boletobancario = 'BOLETOBANCARIO',
  /** Credit card */
  Card = 'CARD',
  /** PayPal Credit */
  Credit = 'CREDIT',
  /** ELV -- Used typically in Europe -- [Link](https://en.wikipedia.org/wiki/Single_Euro_Payments_Area) */
  Elv = 'ELV',
  /** EPS -- Used typically in Austria -- [Link](https://www.adyen.com/payment-methods/eps) */
  Eps = 'EPS',
  /** GIROPAY -- Used typically in Germany -- [Link](https://en.wikipedia.org/wiki/Giropay) */
  Giropay = 'GIROPAY',
  /** IDEAL -- Used in the Netherlands -- [Link](https://www.ideal.nl/en/consumers/what-is-ideal/) */
  Ideal = 'IDEAL',
  /** Itau */
  Itau = 'ITAU',
  /** Maxima -- Used in Lithuania -- [Link](https://docs.paymentwall.com/payment-method/maxima) */
  Maxima = 'MAXIMA',
  /** Mercadopgo -- Used in brazil and mexico -- [Link](https://www.mercadopago.com.ar/) */
  Mercadopago = 'MERCADOPAGO',
  /** Multibanco -- Used in portugal  -- [Link](https://en.wikipedia.org/wiki/multibanco) */
  Multibanco = 'MULTIBANCO',
  /** MYBANK -- Used typically in Italy -- [Link](https://www.mybank.eu/) */
  Mybank = 'MYBANK',
  /** OXXO -- Used in Mexico -- [Link](https://www.allpago.com/our-services/mexican-payment-processing/) */
  Oxxo = 'OXXO',
  /** P24 -- Used typically in Poland -- [Link](https://stripe.com/docs/sources/p24) */
  P24 = 'P24',
  /** Paidy -- Used in Japan -- [Link](https://en.wikipedia.org/wiki/Paidy) */
  Paidy = 'PAIDY',
  /** PayPal Pay Later */
  Paylater = 'PAYLATER',
  /** Payu -- Used in poland -- [Link](ask product) */
  Payu = 'PAYU',
  /** Satispay -- Used in multiple European countries -- -- [Link](https://www.satispay.com/it-it/) */
  Satispay = 'SATISPAY',
  /** SEPA -- Used typically in Europe -- [Link](https://en.wikipedia.org/wiki/Single_Euro_Payments_Area) */
  Sepa = 'SEPA',
  /** SOFORT -- Used typically in Germany -- [Link](https://www.adyen.com/payment-methods/sofort) */
  Sofort = 'SOFORT',
  /** Trustly -- Used in poland -- [Link](ask product) */
  Trustly = 'TRUSTLY',
  /** Venmo */
  Venmo = 'VENMO',
  /** WeChat Pay -- Used in China -- [Link](https://stripe.com/docs/sources/wechat-pay) */
  Wechatpay = 'WECHATPAY',
  /** Zimpler -- Used typically for gambling -- [Link](https://www.zimpler.com/) */
  Zimpler = 'ZIMPLER'
}

/**
 * Identify the tag for pricing preference.
 * The value can be one of the following IC_PLUS_ENROLLED, IC_PLUS_PLUS_ENROLLED, ACCOUNT_LEVEL_GROSS_BILLING_ENABLED, PAYPAL_BALANCE_USER  or IS_SHARED_IDENTITY_HUB.
 */
export enum TagType {
  /** Indicates Full-stack Gross Settlement enabled flag. */
  AccountLevelGrossBillingEnabled = 'ACCOUNT_LEVEL_GROSS_BILLING_ENABLED',
  /** Indicates ic_plus_enrolled tag. */
  IcPlusEnrolled = 'IC_PLUS_ENROLLED',
  /** Indicates ic_plus_plus_enrolled tag. */
  IcPlusPlusEnrolled = 'IC_PLUS_PLUS_ENROLLED',
  /** Indicate the account is a hub account for hybrid path merchants. */
  IsSharedIdentityHub = 'IS_SHARED_IDENTITY_HUB',
  /** Indicates managed_accounts tag. */
  ManagedAccounts = 'MANAGED_ACCOUNTS',
  /** Indicate user holds balance account, earlier known as cash-plus account. */
  PaypalBalanceUser = 'PAYPAL_BALANCE_USER'
}

/** Encapsulates all properties related to a TaxCharges from shiptaxcalcserv. */
export type TaxCharges = {
  __typename?: 'TaxCharges';
  /** Tax on item amount */
  item?: Maybe<Amount>;
  /** Tax on total amount */
  total?: Maybe<Amount>;
};

/** Encapsulates all additional information the user needs to present when paying taxes in another country */
export type TaxDetailsInput = {
  /** A two character country code -- Ex: AU */
  countryCode: CountryCodes;
  /** Reasons to why an user does not have a Taxpayer ID */
  noTaxPayerIdReason?: InputMaybe<Scalars['String']>;
  /** The value that is associated with the taxpayer ID -- Ex: SSN: 999-323-1234 */
  taxPayerIdValue?: InputMaybe<Scalars['String']>;
};

/**
 * An enumeration of Tax Id types.
 * CPF, CNPJ
 */
export enum TaxIdType {
  /** Tax Id for BR business accounts */
  Cnpj = 'CNPJ',
  /** Tax Id for BR personal accounts */
  Cpf = 'CPF'
}

/** Tax information of the payer" */
export type TaxInfo = {
  __typename?: 'TaxInfo';
  /** Tax id (Ex: '65864757322') */
  taxId?: Maybe<Scalars['String']>;
  /** The type of Tax id(Ex: CPF) */
  taxIdType?: Maybe<Scalars['String']>;
};

/** Encapsulates all properties related to a ThreeDSLookUp. */
export type ThreeDsAuthenticateResponse = {
  __typename?: 'ThreeDSAuthenticateResponse';
  /** Unique transaction identifier assigned by the Access Control Server (ACS) to identify a single transaction. */
  accessControlServerTransactionId?: Maybe<Scalars['String']>;
  /** Indicates the exemptions applied for the given transaction. */
  acquirerScaExemptionIndicators?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Provides additional information as to why the transaction status result has the specific value. */
  authStatusReasonRaw?: Maybe<Scalars['String']>;
  /**
   * The outcome of the issuer's authentication.
   * Possible values are: Y: Successful; merchant is protected. N: Failed; no protection.
   *   U: Unable to complete; no protection. A: Successful; merchant is protected.
   */
  authenticationThreeDSStatus?: Maybe<Scalars['String']>;
  /**
   * Indicates the type of authentication that was used to challenge the card holder.
   * Possible Enums values are
   *   "STATIC": "Indicates Fixed Password."
   *   "DYNAMIC": "Indicates One Time Password, could be single step or multi step."
   *   "OUT_OF_BAND": "Indicates Biometric, over the phone."
   *   "DECOUPLED": "Indicates decoupled authentication."
   */
  authenticationType?: Maybe<Scalars['String']>;
  /** The card financial instrument (FI) brand. */
  cardBrandProcessed?: Maybe<CardIssuerType>;
  /**
   * The CAVV value is a cryptographic value calculated by the issuer.
   * The CAVV is unique to the cardholder and to the transaction that was authenticated.
   * Also known as CAVV for Visa VbV and JCB JSecure.
   */
  cavv?: Maybe<Scalars['String']>;
  /** Indicates the algorithm used to generate the CAVV/AAV value. */
  cavvAlgorithm?: Maybe<Scalars['String']>;
  /** Indicates the challenge cancelation reason. This field gives information on why the authentication was canceled. */
  challengeCanceledReason?: Maybe<Scalars['String']>;
  /** Unique transaction identifier assigned by the Directory Server (DS) to identify a single transaction. */
  dsTransactionId?: Maybe<Scalars['String']>;
  /**
   * The Electronic Commerce Indicator (ECI).
   * MasterCard: 01: Merchant Liability 02: Issuer Liability Visa: 05: Issuer Liability 06: Issuer Liability 07: Merchant Liability.
   * Possible Enums values are
   *   "NO_SECURITY": "No security. This matches the raw ECI flag of 00 or 07."
   *   "CHANNEL_ENCRYPTION": "Channel encryption."
   *   "RECURRING_TRANSACTION": "Recurring transaction."
   *   "APPROVED_AUTHENTICATION": "Approved authentication. This matches the raw ECI flag of 02 or 05."
   *   "SINGLE_PAYMENT_TRANSACTION": "Single payment transaction."
   *   "INSTALLMENT_PAYMENT": "Installment payment."
   *   "ATTEMPTED_AUTHENTICATION": "Attempted authentication. This matches the raw ECI flag of 01 or 06."
   *   "SECURITY_NO_AUTHENTICATION": "Security no authentication."
   */
  eciIndicator?: Maybe<Scalars['String']>;
  /**
   * Status of authentication eligibility. If not Y, then the cardholder is not eligible for authentication.
   * Possible values are: Y: Enrolled N: Not enrolled U: Cardholder authentication unavailable.
   */
  enrollmentStatus?: Maybe<EnrollmentStatusType>;
  /** Indicates liability of 3DS transaction is shifted to issuer. */
  liabilityShift?: Maybe<Scalars['Boolean']>;
  /** Pares Status */
  paresStatus?: Maybe<Scalars['String']>;
  /** The PayPal acquiring BIN to be used for authorization. */
  paypalAcquiringBin?: Maybe<Scalars['String']>;
  /** The PayPal acquiring MID to be used for authorization. */
  paypalAcquiringMid?: Maybe<Scalars['String']>;
  /**
   * Transaction Signature status identifier.
   * Possible Enums values are
   *   "YES": "Indicates that the signature of the PARes has been validated successfully and the message contents can be trusted"
   *   "NO": "Indicates that the PARes could not be validated."
   */
  signatureVerificationStatus?: Maybe<SignatureVerificationStatus>;
  /** This flag is an indicator whether to throw 3DS contingency or not. */
  skipThreeDSEnforcement?: Maybe<Scalars['Boolean']>;
  /**
   * This is the raw value received from the external source.
   * This should be passed on the authorization transaction to the Gateway/Processor.
   */
  threeDSEcommerceIndicator?: Maybe<Scalars['String']>;
  /**
   * This is the raw value received from the external source. Transaction Signature status identifier.
   * Possible Enums values are
   *   "Y": "Successful - Signature validation is successful."
   *   "N": "Failed - Indicates that the payload could not be validated."
   */
  threeDSSignatureStatus?: Maybe<Scalars['String']>;
  /**
   * Overall 3DS status of the transaction.
   * Possible Enums values are
   *   "UNKNOWN": "The 3DS transaction status is unknown."
   *   "SUCCESS": "The 3DS transaction is approved or accepted."
   *   "DECLINE": "The 3DS transaction is declined by external entity or per internal business rules."
   *   "SYSTEM_ERROR": "The 3DS transaction is error due to external or internal system issues."
   *   "CHALLENGE_REQUIRED": "Indicates 3DS challenge required."
   */
  threeDSStatus?: Maybe<Scalars['String']>;
  /** The transaction handle, transaction ID, and instruction ID. */
  threeDSTransactionId?: Maybe<Scalars['String']>;
  /**
   * This is the raw value received from the external source.
   * Universal Cardholder Authentication Field (UCAF) Indicator value provided by the issuer.
   * Possible Enums values are
   *   "0": "Non-SecureCode transaction, bypassed by the Merchant."
   *   "1": "Merchant-Only SecureCode transaction."
   *   "2": "Fully authenticated SecureCode transaction."
   */
  threeDSUcafIndicator?: Maybe<Scalars['String']>;
  /**
   * The 3D Secure authentication version that was used to process the transaction.
   * (e.g. 1.0.2 or 2.1.0) It is usually an output from Cardinal authentication APIs.
   */
  threeDSVersion?: Maybe<Scalars['String']>;
  /** Provides additional information as to why the transaction status result has the specific value. */
  threeDsAuthenticationReason?: Maybe<Scalars['String']>;
  /**
   * Universal cardholder presence indicator (e.g. whether UCAF is supported, whether it is populated, etc.).
   * Possible Enums values are
   *   "NOT_SUPPORTED": "Not supported."
   *   "SUPPORTED_NOT_POPULATED": "Supported, not populated."
   *   "SUPPORTED_POPULATED": "supported and populated."
   *   "SUPPORTED_STATIC_AVV_POPULATED": "Supported static avv populated."
   *   "ISSUER_RISK_DECISION": "Issuer risk decision."
   *   "MERCHANT_RISK_DECISION": "Merchant risk decision."
   *   "PARTIAL_SHIPMENT_OR_RECURRING_PAYMENT": "Partial shipment Or Recurring payment."
   */
  ucafIndicator?: Maybe<Scalars['String']>;
  /** Xid field contains the vsec transaction ID (XID) that is a unique number generated by the merchant server to identify the transaction. */
  xid?: Maybe<Scalars['String']>;
};

/** Encapsulates all properties related to a ThreeDSContingencyContextData type */
export type ThreeDsContingencyContextData = {
  __typename?: 'ThreeDSContingencyContextData';
  /** Payment Authentication provider (Ex: 'CARDINAL', 'PAYPAL', 'UNKNOWN') */
  authenticationProvider?: Maybe<Scalars['String']>;
  /** In case of co branded cards, payments can choose any of the available card brands. This field indicates the Card Brand that will be used for authentication. */
  cardBrandProcessed?: Maybe<CardIssuerType>;
  /** If the contingency is a data only contingency, this will be true */
  dataOnlyIndicator?: Maybe<Scalars['Boolean']>;
  /** Up to 10 digits of the card number bin */
  deviceDataCollectionBin?: Maybe<Scalars['String']>;
  /**
   * Cardinal commerce url to launch for device data collection from the client
   * (Ex: 'https://centinelapistag.cardinalcommerce.com/V1/Cruise/Collect')
   */
  deviceDataCollectionUrl?: Maybe<GenericUrl>;
  /**
   * JWT related information which contains issuer, orgUnitId, validity & type
   * This is required for the subsequent JWT token creation
   */
  jwtSpecification?: Maybe<ThreeDsJwtSpecification>;
  /** Reason for 3DS (2.0) contingency (Ex: 'PAYPAL_POLICY') */
  reason?: Maybe<ThreedsContingencyReasonType>;
  /**
   * Unique ID for 3DS (2.0) transaction, each transaction will have a unique referenceId
   * generated by paymentsetupapiserv (Ex: '20200336306496587')
   */
  referenceId: Scalars['String'];
  /** Card source (Ex: 'CARD_STATE') */
  source?: Maybe<ThreedsContingencySourceType>;
};

/**
 * Encapsulates all properties related to a ThreeDSJwtSpecification which
 * include the issuer and validity algorithem & etc
 */
export type ThreeDsJwtSpecification = {
  __typename?: 'ThreeDSJwtSpecification';
  /** JWT validity duration (Ex: 'PT1H') */
  jwtDuration: Scalars['String'];
  /** JWT issuer returned from contingency data (Ex: '5cb5d0582ee58f1f8c35c33e') */
  jwtIssuer: Scalars['String'];
  /** JWT org unit ID returned from contingency data (Ex: '5d0c1e91031e732650d22a25') */
  jwtOrgUnitId: Scalars['String'];
  /** Encryption type (Ex: 'JWT') */
  type?: Maybe<Scalars['String']>;
};

/** Encapsulates all properties related to a ThreeDSLookUpResponse. */
export type ThreeDsLookUpResponse = {
  __typename?: 'ThreeDSLookUpResponse';
  /** Unique transaction identifier assigned by the Access Control Server (ACS) to identify a single transaction. */
  accessControlServerTransactionId?: Maybe<Scalars['String']>;
  /** Indicates the exemptions applied for the given transaction. */
  acquirerScaExemptionIndicators?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Clients embed access control server (ACS) URL in payload while redirecting to complete 3DS challenge with issuer. */
  acsURL?: Maybe<GenericUrl>;
  /** Provides additional information as to why the transaction status result has the specific value. */
  authStatusReasonRaw?: Maybe<Scalars['String']>;
  /** Payment Authentication provider (Ex: 'CARDINAL', 'PAYPAL', 'UNKNOWN') */
  authenticationProvider?: Maybe<Scalars['String']>;
  /** The outcome of the issuer's authentication. */
  authenticationThreeDSStatus?: Maybe<Scalars['String']>;
  /** The card financial instrument (FI) brand. */
  cardBrandProcessed?: Maybe<CardIssuerType>;
  /**
   * The CAVV value is a cryptographic value calculated by the issuer.
   * The CAVV is unique to the cardholder and to the transaction that was authenticated.
   * Also known as CAVV for Visa VbV and JCB JSecure.
   */
  cavv?: Maybe<Scalars['String']>;
  /** Indicates the algorithm used to generate the CAVV/AAV value. */
  cavvAlgorithm?: Maybe<Scalars['String']>;
  /** Unique transaction identifier assigned by the Directory Server (DS) to identify a single transaction. */
  dsTransactionId?: Maybe<Scalars['String']>;
  /**
   * Status of authentication eligibility. If not Y, then the cardholder is not eligible for authentication.
   * Possible values are: Y: Enrolled N: Not enrolled U: Cardholder authentication unavailable.
   */
  enrollmentStatus?: Maybe<EnrollmentStatusType>;
  /** Indicates liability of 3DS transaction is shifted to issuer. */
  liabilityShift?: Maybe<Scalars['Boolean']>;
  /** Pares Status */
  paresStatus?: Maybe<Scalars['String']>;
  /** The payment authentication parameter to send to the third-party URL during redirect. */
  paymentAuthenticationRequest?: Maybe<Scalars['String']>;
  /** The PayPal acquiring BIN to be used for authorization. */
  paypalAcquiringBin?: Maybe<Scalars['String']>;
  /** The PayPal acquiring MID to be used for authorization. */
  paypalAcquiringMid?: Maybe<Scalars['String']>;
  /** The third-party URL to which to redirect the card holder to complete the 3D Secure authentication. */
  redirectURL?: Maybe<GenericUrl>;
  /**
   * Transaction Signature status identifier.
   * Possible Enums values are
   *   "YES": "Indicates that the signature of the PARes has been validated successfully and the message contents can be trusted"
   *   "NO": "Indicates that the PARes could not be validated."
   */
  signatureVerificationStatus?: Maybe<SignatureVerificationStatus>;
  /**
   * This is the raw value received from the external source.
   * This should be passed on the authorization transaction to the Gateway/Processor.
   */
  threeDSEcommerceIndicator?: Maybe<Scalars['String']>;
  /** Overall 3DS status of the transaction */
  threeDSStatus?: Maybe<Scalars['String']>;
  /** Universal cardholder presence indicator (e.g. whether UCAF is supported, whether it is populated, etc.). */
  threeDSUcafIndicator?: Maybe<Scalars['String']>;
  /**
   * The 3D Secure authentication version that was used to process the transaction.
   * (e.g. 1.0.2 or 2.1.0) It is usually an output from Cardinal authentication APIs.
   */
  threeDSVersion?: Maybe<Scalars['String']>;
  /** Provides additional information as to why the transaction status result has the specific value. */
  threeDsAuthenticationReason?: Maybe<Scalars['String']>;
  /** The processor trace number. */
  threeDsProcessorTraceNumber?: Maybe<Scalars['String']>;
  /** Unique transaction identifier assigned by the Directory Server (DS) to identify a single transaction. */
  threeDsServerTransactionId?: Maybe<Scalars['String']>;
  /** The transaction handle, transaction ID, and instruction ID. */
  transactionId?: Maybe<Scalars['String']>;
  /** The normalized description for the transaction status. */
  transactionStatusCode?: Maybe<Scalars['String']>;
  /** The response message. */
  transactionStatusMessage?: Maybe<Scalars['String']>;
  /** Xid field contains the vsec transaction ID (XID) that is a unique number generated by the merchant server to identify the transaction. */
  xid?: Maybe<Scalars['String']>;
};

/** Represents the data required for completing 3DS verification */
export type ThreeDsParamsInput = {
  /** The type of the response param */
  key?: InputMaybe<Scalars['String']>;
  /** Value of the response param */
  value?: InputMaybe<Scalars['String']>;
};

/** Encapsulates all properties related to a ThreeDSPaymentCardData type */
export type ThreeDsPaymentCardData = {
  __typename?: 'ThreeDSPaymentCardData';
  /** Name of the account owner */
  accountOwnerName?: Maybe<PersonName>;
  /** Bank identification number for given payment card */
  bankIdentificationNumber?: Maybe<Scalars['String']>;
  /** Associated billing address for given payment cared */
  billingAddress?: Maybe<CheckoutBillingAddress>;
  /** Product class the current funding instrument (Ex: 'CREDIT') */
  cardProductClass?: Maybe<FundingInstrumentSubType>;
  /** Currency code for the current funding instrument (Ex: 'EUR') */
  currencyCode?: Maybe<Scalars['String']>;
  /** Encrypted version of the lat four digits  (Ex: 'ABcK1jYv.0IWASX72C-UCE-09crt3uFbkQwhWpnIC.jYt4yRFQjBvw') */
  encryptedNumber: Scalars['String'];
  /** Expire month for the current funding instrument (Ex: '01') */
  expireMonth?: Maybe<Scalars['String']>;
  /** Expire year for the current funding instrument (Ex: '2022') */
  expireYear?: Maybe<Scalars['String']>;
  /** Funding instrument's ID (Ex: 'CC-Q9E5QAHF4ESLJ') */
  id?: Maybe<Scalars['ID']>;
  /** Last four digits for the given funding instrument (Ex: '2431') */
  number: Scalars['String'];
  /** Flag indicates is a partial_fpan or not */
  partialFpan?: Maybe<Scalars['Boolean']>;
  /** Card issuer for the current funding instrument (Ex: 'MASTER_CARD') */
  type: CardIssuerType;
};

/** List of supported experiences for 3DS verification */
export enum ThreeDsPaymentExperience {
  /**
   * Hopfree 3DS experience
   * - The 3DS Pin is entered in an input field on the Paypal's Checkout Page
   */
  Hopfree = 'HOPFREE',
  /**
   * 3DS within IFrame
   * - The 3DS Bank page is loaded in an iframe within Paypal's Checkout page
   */
  Iframe = 'IFRAME',
  /**
   * Full-page redirect experience
   * - The User is redirected to 3DS Bank Page from Paypal's Checkout Page
   */
  Redirect = 'REDIRECT'
}

/** Encapsulates everything related to request params provided by bank for completing 3DS verification */
export type ThreeDsRequestParams = {
  __typename?: 'ThreeDSRequestParams';
  /** The type of the request param */
  key?: Maybe<Scalars['String']>;
  /** Value of the request param */
  value?: Maybe<Scalars['String']>;
};

/** Encapsulates all properties related to a ThreeDSResolution type */
export type ThreeDsResolution = {
  __typename?: 'ThreeDSResolution';
  /**
   * Details information in regards to current 3DS contingency which encapusates JWT & cardinal
   * related information
   */
  contingencyContext?: Maybe<ThreeDsContingencyContextData>;
  /**
   * Details information in regards to current selected funding instrument for resolving
   * 3DS (2.0) contingency
   */
  paymentCard?: Maybe<ThreeDsPaymentCardData>;
  /** Resolution name for the current selected funding instrument (Ex: 'RESOLVE_3D_SECURE_AUTHENTICATION') */
  resolutionName: Scalars['String'];
  /** (Ex: 'PAYMENT_CARD') */
  type?: Maybe<Scalars['String']>;
};

/**
 * Encapsulates all properties related to ACS Data
 * Ex: redirectUrl, method, status, etc.
 */
export type ThreeDomainSecureContingency = {
  __typename?: 'ThreeDomainSecureContingency';
  /** The encrypted id of the user's credit card */
  encryptedId: Scalars['String'];
  /** The experience for the 3DS verfication (iframe/redirect/hopfree) */
  experience?: Maybe<ThreeDsPaymentExperience>;
  /** The method that is used to redirect the card holder to third-party site for 3D secure confirmation (Ex: 'GET') */
  method?: Maybe<HttpMethod>;
  /** The payment authentication parameter to send to the third-party URL during redirect */
  parameter?: Maybe<Scalars['String']>;
  /** The third-party URL to which to redirect the card holder to complete the 3D Secure authentication (Ex: 'https//www.example.com') */
  redirectUrl?: Maybe<GenericUrl>;
  /** The parameters required to be passed to the bank page for completing 3DS verification */
  requestParams?: Maybe<Array<Maybe<ThreeDsRequestParams>>>;
  /** The 3D Secure API call status */
  status?: Maybe<ApiCallStatus>;
};

/** Encapsulates all properties related to a ThreeDomainSecureResolutionContingency type */
export type ThreeDomainSecureResolutionContingency = {
  __typename?: 'ThreeDomainSecureResolutionContingency';
  /** Resolution cause for current contingency (Ex: 'NEED_3D_SECURE_AUTHENTICATION') */
  causeName: Scalars['String'];
  /** Resolution contingency name (Ex: 'PAYER_ACTION_REQUIRED') */
  name?: Maybe<Scalars['String']>;
  /** Actual 3DS (2.0) contingency resolution for the current selected funding instrument */
  resolution?: Maybe<ThreeDsResolution>;
};

/** 3DS new switch inbound service: browser details for 3ds FI create-confirmation call */
export type ThreedsBrowserDetailsInput = {
  /** Indicates browser color used during the transaction - UNKNOWN,1_BIT,4_BITS,8_BITS,15_BITS,16_BITS,24_BITS,32_BITS,48_BITS - getting it as Int and form internally */
  colorDepth: Scalars['Int'];
  /** Indicates if browser is Java enabled or not */
  javaEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Indicates browser language set during the transaction */
  language?: InputMaybe<Scalars['String']>;
  /** Indicates browser screen height set during the transaction */
  screenHeight: Scalars['Int'];
  /** Indicates browser screen width set during the transaction */
  screenWidth: Scalars['Int'];
  /** Indicates Time Zone used during the transaction */
  timeZoneOffset: Scalars['Int'];
  /** user  agent - used during transaction to override the header value */
  userAgent?: InputMaybe<Scalars['String']>;
  /** window size - FULL_PAGE */
  windowSize?: InputMaybe<Scalars['String']>;
};

/**
 * An enumeration of confirmation methods in 3DS 2.0 stack.
 * ONLINE_SECURE_AUTHENTICATION, ONE_RANDOM_CHARGE_CONFIRMATION, TWO_RANDOM_CHARGE_CONFIRMATION
 */
export enum ThreedsConfirmationMethod {
  /** possible enum value, do not use for hermes, xoon */
  OneRandomChargeConfirmation = 'ONE_RANDOM_CHARGE_CONFIRMATION',
  /** Used in all web flows - hermes xoon etc. */
  OnlineSecureAuthentication = 'ONLINE_SECURE_AUTHENTICATION',
  /** possible enum value, do not use for hermes, xoon */
  TwoRandomChargeConfirmation = 'TWO_RANDOM_CHARGE_CONFIRMATION'
}

/** Types for threeDS contingency reason. */
export enum ThreedsContingencyReasonType {
  /** DataOnly3DS */
  DataOnly_3Ds = 'DATA_ONLY_3DS',
  /** Merchant Requested */
  MerchantRequested = 'MERCHANT_REQUESTED',
  /** PayPal Policy */
  PaypalPolicy = 'PAYPAL_POLICY',
  /** Regulatory mandate */
  RegulatoryMandate = 'REGULATORY_MANDATE',
  /** Soft Decline */
  SoftDecline = 'SOFT_DECLINE',
  /** Unknown */
  Unknown = 'UNKNOWN'
}

/** Types for threeDS contingency source. */
export enum ThreedsContingencySourceType {
  /** threeDs because of authorization requirement */
  Authorization = 'AUTHORIZATION',
  /** threeDs contingency for third start card (card added at profile but not resolved contingency) */
  CardState = 'CARD_STATE',
  /** payment context - at transaction */
  PaymentContext = 'PAYMENT_CONTEXT',
  /** paypal risk triggers this */
  PaypalRisk = 'PAYPAL_RISK',
  /** Unknown */
  Unknown = 'UNKNOWN'
}

/**
 * 3DS new switch inbound service: Creates a confirmation resource for a given card
 * URL: /v1/wallet/card-accounts/{card_account_id}/confirmations
 * card-account.create-confirmation
 */
export type ThreedsCreateConfirmationResponse = {
  __typename?: 'ThreedsCreateConfirmationResponse';
  /** Payment Authentication provider (Ex: 'CARDINAL', 'PAYPAL', 'UNKNOWN') */
  authenticationProvider?: Maybe<Scalars['String']>;
  /** Brand of the Card */
  brand?: Maybe<Scalars['String']>;
  /** FI confirmation ID */
  confirmationId?: Maybe<Scalars['String']>;
  /** FI confirmation method - ONLINE_SECURE_AUTHENTICATION ONE_RANDOM_CHARGE_CONFIRMATION TWO_RANDOM_CHARGE_CONFIRMATION */
  confirmationMethod?: Maybe<ThreedsConfirmationMethod>;
  /** The encoded payment request generated by Centinel. */
  payload?: Maybe<Scalars['String']>;
  /** Indicates whether online authentication is required or not. Only applicable for 3DS */
  redirectUrl?: Maybe<GenericUrl>;
  /** Unique ID generated by this API. This is populated only when 3DS is required and request is not in transactional context. Only applicable for 3DS */
  referenceId?: Maybe<Scalars['String']>;
  /** Over all 3DS Status - SUCCESS, FAILED */
  status?: Maybe<Scalars['String']>;
  /** The fully qualified URL to redirect the Consumer to complete the Consumer Authentication transaction using the Cardinal Cruise API integration. */
  stepUpUrl?: Maybe<GenericUrl>;
  /** The ID of the transaction that is associated with this 3D Secure authentication. Only applicable for 3DS */
  transactionId?: Maybe<Scalars['String']>;
  /** 3DS version 1.0/2.0. Only applicable for 3DS */
  version?: Maybe<Scalars['String']>;
};

/** An enumeration of Product entry point in 3DS 2.0 stack. */
export enum ThreedsEntryPoint {
  /** Alternate Payment - The transaction is initiated from Alternative Payment AliPay. */
  PayWithAltpayAlipay = 'PAY_WITH_ALTPAY_ALIPAY',
  /** Alternate Payment - The transaction is initiated from Alternative Payment Bancontact. */
  PayWithAltpayBancontact = 'PAY_WITH_ALTPAY_BANCONTACT',
  /** Alternate Payment - The transaction is initiated from Alternative Payment Boleto. */
  PayWithAltpayBoleto = 'PAY_WITH_ALTPAY_BOLETO',
  /** Alternate Payment - The transaction is initiated from Alternative Payment Boletobancario. */
  PayWithAltpayBoletobancario = 'PAY_WITH_ALTPAY_BOLETOBANCARIO',
  /** Alternate Payment - The transaction is initiated from Alternative Payment EPS. */
  PayWithAltpayEps = 'PAY_WITH_ALTPAY_EPS',
  /** Alternate Payment - The transaction is initiated from Alternative Payment iDeal. */
  PayWithAltpayIdeal = 'PAY_WITH_ALTPAY_IDEAL',
  /** Alternate Payment - The transaction is initiated from Alternative Payment Multibanco. */
  PayWithAltpayMultibanco = 'PAY_WITH_ALTPAY_MULTIBANCO',
  /** Alternate Payment - The transaction is initiated from Alternative Payment MyBank. */
  PayWithAltpayMybank = 'PAY_WITH_ALTPAY_MYBANK',
  /** Alternate Payment - The transaction is initiated from Alternative Payment OXXO. */
  PayWithAltpayOxxo = 'PAY_WITH_ALTPAY_OXXO',
  /** Alternate Payment - The transaction is initiated from Alternative Payment P24. */
  PayWithAltpayP24 = 'PAY_WITH_ALTPAY_P24',
  /** Alternate Payment - The transaction is initiated from Alternative Payment Paidy. */
  PayWithAltpayPaidy = 'PAY_WITH_ALTPAY_PAIDY',
  /** Alternate Payment - The transaction is initiated from Alternative Payment Satispay. */
  PayWithAltpaySatispay = 'PAY_WITH_ALTPAY_SATISPAY',
  /** Alternate Payment - The transaction is initiated from Alternative Payment Sofort. */
  PayWithAltpaySofort = 'PAY_WITH_ALTPAY_SOFORT',
  /** Alternate Payment - The transaction is initiated from Alternative Payment WeChatPay. */
  PayWithAltpayWechatpay = 'PAY_WITH_ALTPAY_WECHATPAY',
  /** Alternate Payment - The transaction is initiated from Alternative Payment Zimpler. */
  PayWithAltpayZimpler = 'PAY_WITH_ALTPAY_ZIMPLER',
  /** Card - The transaction is initiated from a credit card. */
  PayWithCard = 'PAY_WITH_CARD',
  /** PayPal - The transaction is initiated from PayPal. */
  PayWithPaypal = 'PAY_WITH_PAYPAL',
  /** Credit - The transaction is initiated from PayPal credit. */
  PayWithPaypalCredit = 'PAY_WITH_PAYPAL_CREDIT',
  /** Venmo - The transaction is initiated from Venmo. */
  PayWithVenmo = 'PAY_WITH_VENMO',
  /** Unknown */
  Unknown = 'UNKNOWN'
}

/** An enumeration of Product integration artifact in 3DS 2.0 stack. */
export enum ThreedsIntegrationArtifacts {
  /** BT VZERO */
  BraintreeVzero = 'BRAINTREE_VZERO',
  /** SPB V3 */
  JsV3 = 'JS_V3',
  /** SPB V4 */
  JsV4 = 'JS_V4',
  /** Native SDK */
  NativeSdk = 'NATIVE_SDK',
  /** None */
  None = 'NONE',
  /** PayPal sdk */
  PaypalJsSdk = 'PAYPAL_JS_SDK'
}

/** An enumeration of paymentMode in 3DS 2.0 stack. */
export enum ThreedsPaymentDevice {
  /** pass when the device is a Computer */
  Computer = 'COMPUTER',
  /** pass when the device is Mobile */
  Mobile = 'MOBILE',
  /** pass when the device is a Tablet */
  Tablet = 'TABLET',
  /** pass when the device type is not known */
  Unknown = 'UNKNOWN'
}

/** An enumeration of Product Code in 3DS 2.0 stack. */
export enum ThreedsProductCode {
  /** BA */
  BillingAgreements = 'BILLING_AGREEMENTS',
  /** SUBSCRIPTIONS */
  BillingSubscriptions = 'BILLING_SUBSCRIPTIONS',
  /** DCC */
  DirectCreditCard = 'DIRECT_CREDIT_CARD',
  /** Express Checkout */
  ExpressCheckout = 'EXPRESS_CHECKOUT',
  /** Masspay */
  Payouts = 'PAYOUTS',
  /** WPS */
  WebsitePaymentStandard = 'WEBSITE_PAYMENT_STANDARD'
}

/** An enumeration of Product feature in 3DS 2.0 stack. */
export enum ThreedsProductFeature {
  /** Direct Credit Card (DCC / UCC) */
  DirectCreditCardApi = 'DIRECT_CREDIT_CARD_API',
  /** None */
  None = 'NONE',
  /** Orders */
  Orders = 'ORDERS',
  /** PayPal Complete Payments */
  PaypalCompletePayments = 'PAYPAL_COMPLETE_PAYMENTS'
}

/** An enumeration of Product flow in 3DS 2.0 stack. */
export enum ThreedsProductFlow {
  /** BA Create - A buyer signing up for a billing agreement */
  BuyerApprovalBillingAgreementCreate = 'BUYER_APPROVAL_BILLING_AGREEMENT_CREATE',
  /** BA with purchase - A purchase flow which buyer also approves creation of a billing agreement */
  BuyerApprovalBillingAgreementWithPurchase = 'BUYER_APPROVAL_BILLING_AGREEMENT_WITH_PURCHASE',
  /** Subscriptions Create- A buyer signing up for a Subscription. */
  BuyerApprovalSubscriptionsCreate = 'BUYER_APPROVAL_SUBSCRIPTIONS_CREATE',
  /** BA Modify - A billing agreement modification flow intiated by consumer on paypal.com */
  ConsumerExpBillingAgreementModify = 'CONSUMER_EXP_BILLING_AGREEMENT_MODIFY',
  /** Subscriptions Modify - A subscription modification flow intiated by consumer on paypal.com. */
  ConsumerExpSubscriptionsModify = 'CONSUMER_EXP_SUBSCRIPTIONS_MODIFY',
  /** Hermes - A web application handles the user's checkout interaction. */
  Hermes = 'HERMES',
  /** HSS */
  HostedSoleSolution = 'HOSTED_SOLE_SOLUTION',
  /** HSS Payflow */
  HostedSoleSolutionPayFlow = 'HOSTED_SOLE_SOLUTION_PAY_FLOW',
  /** Legacy Checkout API Flow */
  Legacy = 'LEGACY',
  /** PP+ */
  PaypalPlus = 'PAYPAL_PLUS',
  /** Prox - An eBay application handles the user's PayPal checkout experience. */
  Prox = 'PROX',
  /** SPB */
  SmartPaymentButtons = 'SMART_PAYMENT_BUTTONS'
}

/** 3DS new switch inbound service: sender context for 3ds FI create-confirmation call */
export type ThreedsSenderContextInput = {
  /** Indicates Header Information of the browser used during the transaction */
  browserDetails: ThreedsBrowserDetailsInput;
  /** Indicates channel of the device - SDK,BROWSER,3RI */
  deviceChannel: Scalars['String'];
  /** Channel where 3DS is performed - MOBILE, COMPUTER, TABLET, UNKNOWN */
  paymentMode: ThreedsPaymentDevice;
};

/**
 * 3DS new switch inbound service: Updates a confirmation resource for a given card confirmation respource
 * URL: /v1/wallet/card-accounts/{card_account_id}/confirmations/{confirmation_id}/update
 * card-account.update-confirmation
 */
export type ThreedsUpdateConfirmationResponse = {
  __typename?: 'ThreedsUpdateConfirmationResponse';
  /** FI confirmation method - ONLINE_SECURE_AUTHENTICATION ONE_RANDOM_CHARGE_CONFIRMATION TWO_RANDOM_CHARGE_CONFIRMATION */
  confirmationMethod?: Maybe<ThreedsConfirmationMethod>;
  /** Over all 3DS Status */
  status?: Maybe<Scalars['String']>;
  /** 3DS version 1.0/2.0. Only applicable for 3DS */
  version?: Maybe<Scalars['String']>;
};

/** An enumeration of Product experience flow in 3DS 2.0 stack. */
export enum ThreedsUserExperienceFlow {
  /** Full Page - The buyer interacts with PayPal by opening PayPal.com directly on browser */
  FullPage = 'FULL_PAGE',
  /** Full Page - The consumer's browser does a 302 redirect to <a href='https://www.paypal.com/us/home'>paypal.com</a> from the third-party site. */
  FullPageRedirect = 'FULL_PAGE_REDIRECT',
  /** InContext - The buyer interacts with <a href='https://www.paypal.com/us/home'>paypal.com</a> in an iframe or pop up window, which is a modal that is outside or hovers over the existing merchant experience. */
  Incontext = 'INCONTEXT',
  /** Inline - The buyer interacts with <a href='https://www.paypal.com/us/home'>paypal.com</a> through an iframe on the merchant site, and is in line with the existing merchant experience. */
  Inline = 'INLINE',
  /** Native - The buyer interacts with PayPal through PayPal's native SDK. */
  Native = 'NATIVE'
}

/** An enumeration of Product api in 3DS 2.0 stack. */
export enum Threedsapi {
  /** Billing V1 */
  BillingV1 = 'BILLING_V1',
  /** Legacy Billing apis */
  LegacyBillingApi = 'LEGACY_BILLING_API',
  /** Legacy apis */
  LegacyCheckoutApi = 'LEGACY_CHECKOUT_API',
  /** Legacy RP */
  LegacyRecurringPayments = 'LEGACY_RECURRING_PAYMENTS',
  /** None */
  None = 'NONE',
  /** Order V1 */
  OrderV1 = 'ORDER_V1',
  /** Order V2 */
  OrderV2 = 'ORDER_V2',
  /** Payment V1 */
  PaymentsV1 = 'PAYMENTS_V1',
  /** RP */
  RecurringPaymentsV1 = 'RECURRING_PAYMENTS_V1',
  /** Subscriptions V1 */
  SubscriptionsV1 = 'SUBSCRIPTIONS_V1'
}

/** Transaction Risk Analysis (TRA) decision details */
export type TraRiskDetails = {
  /** Converted currency code Risk TRA (Ex: 'USD') */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Converted currency value Risk TRA(Ex: '0.01') */
  currencyValue?: InputMaybe<Scalars['String']>;
  /** TRA exemption threshold */
  threshold?: InputMaybe<Scalars['Int']>;
  /** TRA exemption decision */
  traDecision?: InputMaybe<Scalars['String']>;
};

/** URLs for tracking the message and the user's interaction with it. */
export type TrackingDetails = {
  __typename?: 'TrackingDetails';
  /** URL used for click tracking */
  clickUrl?: Maybe<Scalars['String']>;
  /** Url used for impression tracking */
  impressionUrl?: Maybe<Scalars['String']>;
};

/** Encapsulates everything related to a TrackingTag. Ex: type, values, stringValue */
export type TrackingTag = {
  __typename?: 'TrackingTag';
  /** The values of the TrackingTag, represented as a String (Ex: '6496,2252,1234') */
  stringValue?: Maybe<Scalars['String']>;
  /** The type of the TrackingTag (Ex: 'qc') */
  type?: Maybe<TrackingTagType>;
  /** The values of the TrackingTag, represented as an Array (Ex: [6496, 2252, 1234]) */
  values?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

/**
 * An enumeration of types that TrackingTag can have. qe, qt, qc, qp, etc
 * The meaning of these tags have been lost over time
 * Not even the PXP team knows what they are ;-)
 * But, they're useful for clients who want to log these values to FPTI.
 * See https://github.paypal.com/Experimentation-R/pxpexecserv/blob/8c511074aee6cbd8a0177c4013e14487774ca380/ExperimentationExecution/src/main/java/com/paypal/experimentation/domain/core/common/TagNames.java#L3
 */
export enum TrackingTagType {
  /** Nobody knows what this means */
  Ct = 'CT',
  /** Nobody knows what this means */
  Exoe = 'EXOE',
  /** Nobody knows what this means */
  Exos = 'EXOS',
  /** Nobody knows what this means */
  Exot = 'EXOT',
  /** Nobody knows what this means */
  Oe = 'OE',
  /** Nobody knows what this means */
  Os = 'OS',
  /** Nobody knows what this means */
  Ot = 'OT',
  /** Nobody knows what this means */
  Pxpm = 'PXPM',
  /** Nobody knows what this means */
  Pxpmg = 'PXPMG',
  /** Nobody knows what this means */
  Pxpmu = 'PXPMU',
  /** Qualified Context */
  Qc = 'QC',
  /** Qualified Experiment */
  Qe = 'QE',
  /** Nobody knows what this means */
  Qp = 'QP',
  /** Qualified Treatment */
  Qt = 'QT',
  /** Nobody knows what this means */
  Se = 'SE',
  /** Nobody knows what this means */
  St = 'ST',
  /** Nobody knows what this means */
  Upe = 'UPE',
  /** Nobody knows what this means */
  Upt = 'UPT',
  /** Nobody knows what this means */
  Uqc = 'UQC',
  /** Nobody knows what this means */
  Uqp = 'UQP',
  /** Nobody knows what this means */
  Uqt = 'UQT',
  /** Nobody knows what this means */
  Xt = 'XT'
}

/**
 * An enumeration of states that a Transaction can be in.
 * PENDING, COMPLETED, REFUNDED, PARTIALLY_REFUNDED or DENIED
 */
export enum TransactionState {
  /** Transaction authorized */
  Authorized = 'AUTHORIZED',
  /** The transaction has successfully completed. */
  Completed = 'COMPLETED',
  /** PayPal has declined to process this transaction. */
  Denied = 'DENIED',
  /** The transaction was partially refunded. */
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  /** The transaction is pending. */
  Pending = 'PENDING',
  /** The transaction was fully refunded. */
  Refunded = 'REFUNDED'
}

/** Encapsulates everything related to a Treatment. Ex: treatmentId, name, factors */
export type Treatment = {
  __typename?: 'Treatment';
  /** An Array of Factor types, which are key/value pairs associated with this experiment. */
  factors?: Maybe<Array<Maybe<Factor>>>;
  /** Name of the treatment */
  name?: Maybe<Scalars['String']>;
  /** ID of the treatment */
  treatmentId?: Maybe<Scalars['ID']>;
};

/**
 * Encapsulates all properties related to a URL.
 * Ex: protocol, host, port, hostname, query, href, etc.
 * See https://nodejs.org/api/url.html#url_class_url for more details.
 */
export type Url = {
  /** Username/password portion of the URL (Ex: user:pass) */
  auth?: Maybe<Scalars['String']>;
  /** Fragment portion of the URL including the leading ASCII hash (#) character. (Ex: #hash) */
  hash?: Maybe<Scalars['String']>;
  /** Full lower-cased host portion of the URL (Ex: google.com:8000) */
  host?: Maybe<Scalars['String']>;
  /** Hostname portion of the URL.  Does not contain a port. (Ex: google.com) */
  hostname?: Maybe<Scalars['String']>;
  /** The serialized, full URL with all properties included. (Ex: https://google.com/path?key=value#hash) */
  href?: Maybe<Scalars['String']>;
  /** Path portion of the URL which includes the query string. (Ex: /path?key=value) */
  path?: Maybe<Scalars['String']>;
  /** Path portion of the URL, but does not include the query string. (Ex: /path) */
  pathname?: Maybe<Scalars['String']>;
  /** Numeric port portion of the URL (Ex: 8000) */
  port?: Maybe<Scalars['String']>;
  /** Protocol property of the URL (Ex: https:) */
  protocol?: Maybe<Scalars['String']>;
  /** Query string of the URL.  Does not include the leading question mark (?) character. (Ex: key=value) */
  query?: Maybe<Scalars['String']>;
  /** Query params of the URL, as an Object */
  queryParams?: Maybe<Scalars['JSON']>;
  /** Search property consists of the entire 'query string' portion of the URL, including the leading ASCII question mark (?) character. (Ex: ?key=value) */
  search?: Maybe<Scalars['String']>;
  /** If true, two forward slashes are required following the colon in the protocol */
  slashes?: Maybe<Scalars['Boolean']>;
};

/** Encapsulates the data shared between Unified Login and Checkout */
export type UnifiedLoginContext = {
  __typename?: 'UnifiedLoginContext';
  /** Metadata about the transaction's Checkout experience */
  experienceMetadata?: Maybe<UnifiedLoginContextExperienceMetadata>;
};

/** Encapsulates the metadata relating to Checkout experience from Unified Login */
export type UnifiedLoginContextExperienceMetadata = {
  __typename?: 'UnifiedLoginContextExperienceMetadata';
  /** Metadata about onboarding experience if the user sees that flow */
  onboardingData?: Maybe<UnifiedLoginContextOnboardingData>;
};

/** Encapsulates the data relating to onboarding from Unified Login */
export type UnifiedLoginContextOnboardingData = {
  __typename?: 'UnifiedLoginContextOnboardingData';
  /** Indicates if the Apple Pay button was shown to the user */
  applePayButtonSeen?: Maybe<Scalars['Boolean']>;
  /** Email a user entered on the login page */
  email?: Maybe<Email>;
  /** Whether or not a user already has a full member account */
  hasExistingAccount?: Maybe<Scalars['Boolean']>;
  /** Indicates what type of login method a user was presented with on UL */
  loginMethod?: Maybe<Scalars['String']>;
  /** Experience the user selected on the log in page (EX: SIGN_UP, GUEST) */
  userIntent?: Maybe<OnboardingExperienceType>;
};

/** Upstream Messaging related properties */
export type UpstreamMessaging = {
  __typename?: 'UpstreamMessaging';
  /** Merchant Profile for upstream messaging */
  merchantProfile?: Maybe<MerchantProfile>;
};

/**
 * Encapsulates all properties related to a User.
 * Ex: Name, Addresses, Profile Photos, etc.
 * Average SLA response time - 70ms
 *
 * Required auth states: LOGGEDIN, REMEMBERED or IDENTIFIED
 */
export type User = {
  __typename?: 'User';
  /**
   * A User's addresses, an Array of UserAddress types.
   * Optionally, you can query by address type (AddressType).
   * Otherwise, all addresses are returned.
   * Average SLA response time - 70ms
   */
  addresses?: Maybe<Array<Maybe<UserAddress>>>;
  /**
   * Encapsulates all properties related to a User's auth status.
   * Ex: Access token
   */
  auth?: Maybe<Auth>;
  /**
   * An Array of CheckoutBillingAddress types.
   *
   * Average SLA response time -- 30ms
   */
  billingAddresses?: Maybe<Array<Maybe<CheckoutBillingAddress>>>;
  /**
   * A User's edelivery consent (true - eConsent is required and missing, false - eConsent is already completed)
   * E-Sign consent is the process by which US consumers consent to have their notifications and statements delivered electronically
   */
  eConsent?: Maybe<Scalars['Boolean']>;
  /** If a user is eligible to hold paypal balance or not */
  eligibleToHoldBalance?: Maybe<Scalars['Boolean']>;
  /** A User's email address. Average SLA response time - 70ms */
  email?: Maybe<Email>;
  /** A user's locale. Average SLA response time - 70ms */
  locale?: Maybe<GenericLocale>;
  /** A User's name. Average SLA response time - 70ms */
  name?: Maybe<PersonName>;
  /**
   * A User's phone numbers, an Array of GenericPhone types.
   * Optionally, you can query by phone type (PhoneType).
   * Otherwise, all phone numbers are returned.
   * Average SLA response time - 70ms
   */
  phones?: Maybe<Array<Maybe<GenericPhone>>>;
  /**
   * A User's profile image, a ProfileImage type.
   * You can query by width, height, or type (ProfileImageType).
   * Average SLA response time - 80ms
   */
  profileImage?: Maybe<ProfileImage>;
  /**
   * A User's profile images, an Array of ProfileImage types.
   * Average SLA response time - 80ms
   */
  profileImages?: Maybe<Array<Maybe<ProfileImage>>>;
  /** User ID (or an encrypted account number) Average SLA response time - 70ms */
  userId?: Maybe<Scalars['String']>;
};


/**
 * Encapsulates all properties related to a User.
 * Ex: Name, Addresses, Profile Photos, etc.
 * Average SLA response time - 70ms
 *
 * Required auth states: LOGGEDIN, REMEMBERED or IDENTIFIED
 */
export type UserAddressesArgs = {
  type?: InputMaybe<AddressType>;
};


/**
 * Encapsulates all properties related to a User.
 * Ex: Name, Addresses, Profile Photos, etc.
 * Average SLA response time - 70ms
 *
 * Required auth states: LOGGEDIN, REMEMBERED or IDENTIFIED
 */
export type UserProfileImageArgs = {
  height?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<ProfileImageType>;
  width?: InputMaybe<Scalars['Int']>;
};

/**
 * Encapsulates all properties related to a user's address.
 * Ex: line1, city, state, postalCode, fullAddress, isDefaultBilling, etc.
 */
export type UserAddress = Address & {
  __typename?: 'UserAddress';
  /** An Address ID (Ex: '285166') */
  addressId?: Maybe<Scalars['String']>;
  /** An Address city (Ex: 'San Jose') */
  city?: Maybe<Scalars['String']>;
  /** An Address two-letter country code (Ex: 'US') */
  country?: Maybe<Scalars['String']>;
  /** An Address on a single line (Ex: '2211 North 1st St, Apt 123, San Jose, CA 95131') */
  fullAddress?: Maybe<Scalars['String']>;
  /** If an Address is the default billing address */
  isDefaultBilling?: Maybe<Scalars['Boolean']>;
  /** If an Address is the default shipping address */
  isDefaultShipping?: Maybe<Scalars['Boolean']>;
  /** If an Address is the primary address */
  isPrimary?: Maybe<Scalars['Boolean']>;
  /** An Address is selected. If you are listing out addresses in a UI, and need to show that an address is selected, use this property. */
  isSelected?: Maybe<Scalars['Boolean']>;
  /** An Address first line street address (Ex: '2211 North 1st St') */
  line1?: Maybe<Scalars['String']>;
  /** An Address second line street address (Ex: 'Apt 123') */
  line2?: Maybe<Scalars['String']>;
  /** An Address postal code (Ex: '95131') */
  postalCode?: Maybe<Scalars['String']>;
  /** An Address state/province (Ex: 'CA') */
  state?: Maybe<Scalars['String']>;
  /** Type of Address (Ex: 'SHIPPING').  See AddressType enum. */
  type?: Maybe<AddressType>;
};

/** Enumeration for address normalization_status set to user profile */
export enum UserAddressNormalizationStatus {
  /** The user rejected the normalized version of the address in favor of this address */
  NormalizationRejected = 'NORMALIZATION_REJECTED',
  /** Address is normalized */
  Normalized = 'NORMALIZED',
  /** It is unclear whether this address is normalized */
  Unknown = 'UNKNOWN'
}

/** Encapsulates all properties related to the Consent API response related to user legal consent */
export type UserAgreement = {
  __typename?: 'UserAgreement';
  /** A string of the active url of the User Agreement. Signup flows use activeUrl */
  activeUrl: Scalars['String'];
  /** A string of the mayor version of the User Agreement */
  majorVersion: Scalars['String'];
  /** A string of the minor version of the User Agreement */
  minorVersion: Scalars['String'];
  /** A string of the url of the Upcoming Policies. Member flows use upcomingUrl */
  upcomingUrl: Scalars['String'];
};

/** User rewards campaign details */
export type UserEstimatedReward = {
  __typename?: 'UserEstimatedReward';
  /** Unique identifier of the rewards campaign */
  campaignId?: Maybe<Scalars['String']>;
  /** Long description of the campaign */
  campaignLongDescription?: Maybe<Scalars['String']>;
  /** Short description of the campaign, eg Feb. StoreA Cashback Campaign */
  campaignShortDescription?: Maybe<Scalars['String']>;
  /** List of associated rewards offers */
  estimatedRewards?: Maybe<Array<Maybe<EstimatedReward>>>;
  /** Time that a campaign will expire, formatted according to https://tools.ietf.org/html/rfc3339#section-5.6 */
  expirationTime?: Maybe<Scalars['String']>;
  /** Merchant details associated with the rewards campaign */
  merchantDetails?: Maybe<EstimatedRewardMerchantDetails>;
  /** The percent back that a campaign will provide */
  percent?: Maybe<Scalars['String']>;
  /** Reward Tag based on the Leap attribution */
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Term Link for the Reward */
  termsLink?: Maybe<Scalars['String']>;
};

/** Types of client config user experience */
export enum UserExperienceFlowType {
  /** The consumer's browser does a 302 redirect to <a href="https://www.paypal.com/us/home">paypal.com</a> from the third-party site. */
  FullPageRedirect = 'FULL_PAGE_REDIRECT',
  /** The flow is initated via Honey modal */
  HoneyModal = 'HONEY_MODAL',
  /** Incontext window */
  Incontext = 'INCONTEXT',
  /** Inline iframe */
  Inline = 'INLINE',
  /** Native SDK */
  Native = 'NATIVE',
  /** The flow is initiated via Paypal Consumer app */
  PaypalConsumerApp = 'PAYPAL_CONSUMER_APP',
  /** Implicit login on web channel */
  WebLls = 'WEB_LLS'
}

/** A User's auth type/role */
export enum UserRole {
  /** Guest */
  Identified = 'IDENTIFIED',
  /** Logged in PayPal Member */
  Loggedin = 'LOGGEDIN',
  /** Partially logged in PayPal Member w/ 'Remember me' */
  Remembered = 'REMEMBERED'
}

/** Response wrapper for validateAddress. */
export type ValidateAddressResponse = {
  __typename?: 'ValidateAddressResponse';
  /** Whether or not an address is valid */
  success?: Maybe<Scalars['Boolean']>;
};

/** Error Response for Validate Payees */
export type ValidatePayeesError = {
  __typename?: 'ValidatePayeesError';
  /** An optional description of the error */
  description?: Maybe<Scalars['String']>;
  /** The string value of the error */
  error: Scalars['String'];
  /** Severity of the error - either Error or Warning */
  severity: Scalars['String'];
};

/** Response wrapper for ValidatePayees. */
export type ValidatePayeesResponse = {
  __typename?: 'ValidatePayeesResponse';
  /** The validation error for the call */
  error?: Maybe<ValidatePayeesError>;
  /** Whether or not the Payees are valid */
  success?: Maybe<Scalars['Boolean']>;
};

/** Encapsulates all properties we want to extract from a validated address. Ex: line1, city, postalCode */
export type ValidatedAddress = {
  __typename?: 'ValidatedAddress';
  /** Portable address: An address first line street address */
  addressLine1?: Maybe<Scalars['String']>;
  /** Portable address: An address second line street address */
  addressLine2?: Maybe<Scalars['String']>;
  /** Portable address: An address third line street address */
  addressLine3?: Maybe<Scalars['String']>;
  /** Address Type */
  addressType?: Maybe<AmsAddressTypeCode>;
  /** Portable address: An address first line admin area */
  adminArea1?: Maybe<Scalars['String']>;
  /** Portable address: An address second line admin area */
  adminArea2?: Maybe<Scalars['String']>;
  /** Portable address: An address third line admin area */
  adminArea3?: Maybe<Scalars['String']>;
  /** Portable address: An address forth line admin area */
  adminArea4?: Maybe<Scalars['String']>;
  /** Metadata returned by AMS. A structure representing information about the address elements itself after the verification process. This includes how similar the value is to the input and what changes were made to the value. */
  amsMetadata?: Maybe<AmsMetadata>;
  /** Shows which fields need fixing from the user. */
  badFields: AddressFieldBools;
  /** A billing address city (Ex: 'San Jose') */
  city?: Maybe<Scalars['String']>;
  /** A billing address two-letter country code (Ex: 'US') */
  country?: Maybe<Scalars['String']>;
  /** Portable address: An address two-letter country code */
  countryCode?: Maybe<Scalars['String']>;
  /** Shows the original and reformatted address in an array of address parts as formatted by Griffin */
  formatAddressHistory?: Maybe<GriffinFormattedAddresses>;
  /** Shows the full address in multiple lines that is formatted by AMS */
  formattedAddress: Array<Maybe<Scalars['String']>>;
  /** Returns true if the address was reformatted */
  isReformatted?: Maybe<Scalars['Boolean']>;
  /** Returns true if the address is valid */
  isValidAddress?: Maybe<Scalars['Boolean']>;
  /** A billing address first line street address (Ex: '2211 North 1st St') */
  line1?: Maybe<Scalars['String']>;
  /** A billing address second line street address (Ex: 'Apt 123') */
  line2?: Maybe<Scalars['String']>;
  /** Shows the degree of confidence with respect to the mailability of the address. */
  mailability?: Maybe<Scalars['String']>;
  /** A billing address postal code (Ex: '95131') */
  postalCode?: Maybe<Scalars['String']>;
  /** A billing address state/province (Ex: 'CA') */
  state?: Maybe<Scalars['String']>;
  /** AMS status, value is one of 'INVALID', 'CORRECTED', 'VERIFIED' */
  status?: Maybe<AmsAddressNormalizationStatus>;
};

/** Data for vaulted instrument */
export type VaultInstrumentData = {
  __typename?: 'VaultInstrumentData';
  /** id representing the vaulted instrument */
  id?: Maybe<Scalars['String']>;
  /** label representing the vaulted instrument */
  label?: Maybe<VaultInstrumentLabelInfo>;
};

/** Label Info for Vaulted Instrument */
export type VaultInstrumentLabelInfo = {
  __typename?: 'VaultInstrumentLabelInfo';
  /** Description for the vaulted instrument (Ex: PayPal for foo.bar.com) */
  description?: Maybe<Scalars['String']>;
};

/** response object from the v3/vault/setup-token endpoint. This particular object is a token definition */
export type VaultSetupTokenResponse = {
  __typename?: 'VaultSetupTokenResponse';
  /** customer */
  customer?: Maybe<Customer>;
  /** id of the setup token */
  id?: Maybe<Scalars['String']>;
  /** links */
  links?: Maybe<Array<Maybe<Link>>>;
  /** status of token */
  status?: Maybe<Status>;
};

/** Venmo Shadow Guest account details needed for Checkout */
export type VenmoGuestUser = {
  __typename?: 'VenmoGuestUser';
  /** Venmo Guest Account Access Token */
  accessToken?: Maybe<Scalars['String']>;
  /** The digital CVV of an Open Loop Token instrument */
  dcvv?: Maybe<Scalars['String']>;
  /** Venmo User's email as shown on ther Venmo app profile */
  email?: Maybe<Email>;
  /** The paypal Instrument ID associated to the Venmo Guest Account */
  instrumentID?: Maybe<Scalars['String']>;
  /** Venmo User's full name */
  name?: Maybe<PersonName>;
};

/** Interface for wallet API */
export type Wallet = {
  __typename?: 'Wallet';
  /**
   * Retrieve the details for a bank account.
   *
   * Required Roles: LOGGEDIN
   */
  bank: BankAccount;
  /**
   * Retrieve the details from a credit card.
   *
   * Required Roles: LOGGEDIN
   */
  card: CardDetails;
  /**
   * Provides a quicker way to query eligibility data based on a users wallet instruments
   *
   * Required Roles: LOGGEDIN
   */
  flags: WalletFlags;
};


/** Interface for wallet API */
export type WalletBankArgs = {
  bankId: Scalars['String'];
};


/** Interface for wallet API */
export type WalletCardArgs = {
  cardId: Scalars['String'];
};

/** Eligibility flags from the Wallet API */
export type WalletFlags = {
  __typename?: 'WalletFlags';
  /** Indicates whether the wallet contains rewards accounts */
  areRewardsPresent: Scalars['Boolean'];
  /** Indicates whether the user is opt in into full wallet */
  fullWalletOptStatus: FullWalletStatus;
};

/** Three DS LookUp payload */
export type ThreedsLookUpPayload = {
  /** Specifies how the partner-specific merchant account is managed. The value can be one of the following LINKED_HYBRID, STANDALONE_HYBRID or PARTNER_MANAGED. */
  accountManagementType?: InputMaybe<AccountManagementType>;
  /** Account identifier of partner or its sub-organization/entity, which has a direct relation with Acquirer */
  acquirerAssociatedAccountId?: InputMaybe<Scalars['String']>;
  /** billing address of card */
  billingAddress?: InputMaybe<AddressInput>;
  /** The card financial instrument (FI) brand. */
  cardBrand?: InputMaybe<CardIssuerType>;
  /** @Deprecated: This value is determined based on data in the checkout session */
  cardTransactionCharacteristics?: InputMaybe<CardTransactionType>;
  /** card usage - possible values CREDIT or DEBIT */
  cardUsage?: InputMaybe<FundingInstrumentSubType>;
  /** credit card Id - PayPal internal credit card id */
  creditCardId?: InputMaybe<Scalars['String']>;
  /** indicates whether cvv is provided in the request */
  cvvPresenceIndicator?: InputMaybe<Scalars['Boolean']>;
  /** email address */
  email?: InputMaybe<Scalars['String']>;
  /** encrypted card number that needs to be passed to ACE which is returned in 3DS contingency from post of checkoutsession */
  encryptedCardNumber: Scalars['String'];
  /** expiration month */
  expirationMonth: Scalars['String'];
  /** expiration year - 4 digit year */
  expirationYear: Scalars['String'];
  /** clients identification for downstream services. EX: HERMES, HELIOS, etc */
  flowId: Scalars['String'];
  /** merchant category code */
  merchantCategoryCode?: InputMaybe<Scalars['String']>;
  /** phone information of the payer */
  phoneInfo?: InputMaybe<Array<InputMaybe<PhoneInput>>>;
  /** Indicates the risk classification of the transaction. Clients can determine this risk level based on - the past history of the merchant's chargeback rates, depending on the when the merchant was onboarded, or the amount of the transaction etc. */
  riskLevelIndicator?: InputMaybe<RiskLevelIndicatorType>;
  /** shipping address of the purchase */
  shippingAddress?: InputMaybe<AddressInput>;
  /** shipping phone of the purchase */
  shippingPhone?: InputMaybe<PhoneInput>;
  /** The tags representing the processing preferences. */
  tags?: InputMaybe<Array<InputMaybe<TagType>>>;
  /** Reason for 3DS contingency */
  threeDSContingencyReason?: InputMaybe<ThreedsContingencyReasonType>;
  /** Source for 3DS contingency */
  threeDSContingencySource?: InputMaybe<ThreedsContingencySourceType>;
  /** reference ID for the 3DS of the Card */
  threeDSReferenceId: Scalars['String'];
  /** Unbranded Payment Indicator */
  unbrandedPaymentIndicator?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateGuestShippingAddressCallbackMutationMutationVariables = Exact<{
  token: Scalars['String'];
  address: GuestAddressInput;
}>;


export type UpdateGuestShippingAddressCallbackMutationMutation = { __typename?: 'Mutation', updateGuestShippingAddressCallback?: { __typename?: 'CheckoutSession', cart?: { __typename?: 'Cart', items?: Array<{ __typename: 'CartItem', name?: string | null, quantity?: number | null } | null> | null, amounts?: { __typename?: 'CartAmounts', discount?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, handlingFee?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, insurance?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, shipping?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, shippingAndHandling?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, shippingDiscount?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, subtotal?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, tax?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, total?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencySymbol?: string | null } | null } | null, shippingMethods?: Array<{ __typename?: 'CartShippingMethod', id?: string | null, type?: ShippingMethodType | null, label?: string | null, selected?: boolean | null, amount?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null } | null } | null> | null } | null } | null };

export type AddressAutocompleteQueryQueryVariables = Exact<{
  count?: InputMaybe<Scalars['Int']>;
  countries?: InputMaybe<Array<InputMaybe<CountryCodes>> | InputMaybe<CountryCodes>>;
  input: Scalars['String'];
  language?: InputMaybe<CheckoutContentLanguageCode>;
  location?: InputMaybe<Scalars['GeoLocation']>;
  radius?: InputMaybe<Scalars['Int']>;
  sessionId: Scalars['String'];
}>;


export type AddressAutocompleteQueryQuery = { __typename?: 'Query', addressAutoComplete?: { __typename?: 'AddressAutoComplete', suggestions?: Array<{ __typename?: 'AddressAutoCompleteElement', addressText?: string | null, mainText?: string | null, placeId?: string | null, secondaryText?: string | null } | null> | null } | null };

export type AddressAutocompleteFromPostalCodeQueryQueryVariables = Exact<{
  postalCode: Scalars['String'];
  token: Scalars['String'];
  country?: InputMaybe<CountryCodes>;
}>;


export type AddressAutocompleteFromPostalCodeQueryQuery = { __typename?: 'Query', addressNormalization?: { __typename?: 'NormalizedAddress', line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null } | null };

export type AddressFromAutocompletePlaceIdQueryQueryVariables = Exact<{
  language?: InputMaybe<CheckoutContentLanguageCode>;
  placeId: Scalars['ID'];
  sessionId: Scalars['String'];
}>;


export type AddressFromAutocompletePlaceIdQueryQuery = { __typename?: 'Query', addressFromAutoCompletePlaceId?: { __typename?: 'AddressForPlaceId', address?: { __typename?: 'GenericAddress', line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null } | null } | null };

export type CheckoutSessionDataQueryQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type CheckoutSessionDataQueryQuery = { __typename?: 'Query', checkoutSession?: { __typename?: 'CheckoutSession', allowedCardIssuers?: Array<CardIssuerType | null> | null, checkoutSessionType?: CheckoutSessionType | null, cart?: { __typename?: 'Cart', soldoutUrl?: string | null, showSoldoutPage?: boolean | null, description?: string | null, intent?: CartIntent | null, noteToBuyer?: string | null, formattedPhoneNumber?: string | null, phoneNumber?: string | null, billingAddress?: { __typename?: 'CartAddress', city?: string | null, country?: CountryCodes | null, line1?: string | null, line2?: string | null, postalCode?: string | null, state?: string | null, formattedFullAddress?: string | null } | null, cancelUrl?: { __typename?: 'GenericURL', href?: string | null } | null, email?: { __typename?: 'Email', stringValue?: string | null } | null, payer?: { __typename?: 'SuppliedUserInfo', name?: { __typename?: 'PersonName', familyName?: string | null, givenName?: string | null } | null } | null, shippingAddress?: { __typename?: 'CartShippingAddress', city?: string | null, country?: CountryCodes | null, firstName?: string | null, isStoreAddress?: boolean | null, lastName?: string | null, line1?: string | null, line2?: string | null, postalCode?: string | null, state?: string | null, formattedFullAddress?: string | null } | null, amounts?: { __typename?: 'CartAmounts', discount?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, handlingFee?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, insurance?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, shipping?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, shippingAndHandling?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, shippingDiscount?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, subtotal?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, tax?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, total?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencySymbol?: string | null } | null } | null, items?: Array<{ __typename?: 'CartItem', description?: string | null, details?: any | null, name?: string | null, quantity?: number | null, total?: { __typename?: 'Amount', currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null } | null, unitPrice?: { __typename?: 'Amount', currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null } | null> | null, totalAllowedOverCaptureAmount?: { __typename?: 'Amount', currencyFormatSymbolISOCurrency?: string | null } | null, subscriptionDetails?: { __typename: 'SubscriptionDetails', initialPaymentInfo?: { __typename: 'InitialSubscriptionPaymentInfo', taxPercentage?: string | null, setupFee?: { __typename: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null } | null, firstPayment?: { __typename: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null } | null, shippingAmount?: { __typename: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null } | null, totalAmount?: { __typename: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null } | null } | null, plan?: { __typename: 'SubscriptionPlanDetails', id?: string | null, name?: string | null, startTime?: string | null, billingCycles?: Array<{ __typename: 'SubscriptionBillingCycles', totalCycles?: string | null, fixedPrice?: { __typename: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null } | null, frequency?: { __typename: 'BillingCycleFrequency', intervalUnit?: IntervalUnit | null, intervalCount?: number | null } | null } | null> | null } | null } | null, shippingMethods?: Array<{ __typename?: 'CartShippingMethod', id?: string | null, type?: ShippingMethodType | null, label?: string | null, selected?: boolean | null, amount?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null } | null } | null> | null } | null, merchant: { __typename?: 'Merchant', country?: CountryCodes | null, merchantId?: string | null, name?: string | null } } | null };

export type ConsumerFlowIdQueryQueryVariables = Exact<{
  redirectUrl: Scalars['String'];
}>;


export type ConsumerFlowIdQueryQuery = { __typename?: 'Query', consumerFlowId?: { __typename?: 'ConsumerFlowId', flowId: string } | null };

export type FetchPhoneMetadataQueryQueryVariables = Exact<{
  countryCode: CountryCodes;
}>;


export type FetchPhoneMetadataQueryQuery = { __typename?: 'Query', localeMetadata?: { __typename?: 'LocaleMetadata', phone?: { __typename?: 'LocalePhoneMetadata', masks?: { __typename?: 'LocalePhoneMasks', mobile?: string | null } | null, patterns?: { __typename?: 'LocalePhonePatterns', default?: string | null } | null } | null } | null };

export type BuyerFragment = { __typename?: 'CheckoutSession', buyer?: { __typename?: 'User', userId?: string | null, auth?: { __typename?: 'Auth', accessToken?: string | null } | null } | null };

export type FundingOptionsFragment = { __typename?: 'CheckoutSession', fundingOptions?: Array<{ __typename?: 'FundingOption', allPlans?: Array<{ __typename?: 'Plan', fundingSources?: Array<{ __typename?: 'FundingSource', fundingInstrument?: { __typename?: 'FundingInstrument', id?: string | null } | null, amount?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyValue?: string | null } | null } | null> | null } | null> | null, fundingInstrument: { __typename?: 'FundingInstrument', id?: string | null, lastDigits?: string | null, name?: string | null, nameDescription?: string | null, type?: FundingOptionType | null } } | null> | null };

export type ThreeDsContingencyDataFragment = { __typename?: 'PaymentContingencies', threeDSContingencyData?: { __typename?: 'ThreeDomainSecureResolutionContingency', name?: string | null, causeName: string, resolution?: { __typename?: 'ThreeDSResolution', type?: string | null, resolutionName: string, paymentCard?: { __typename?: 'ThreeDSPaymentCardData', expireYear?: string | null, expireMonth?: string | null, currencyCode?: string | null, cardProductClass?: FundingInstrumentSubType | null, id?: string | null, encryptedNumber: string, type: CardIssuerType, number: string, bankIdentificationNumber?: string | null, billingAddress?: { __typename?: 'CheckoutBillingAddress', line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, country?: string | null, postalCode?: string | null } | null } | null, contingencyContext?: { __typename?: 'ThreeDSContingencyContextData', authenticationProvider?: string | null, cardBrandProcessed?: CardIssuerType | null, reason?: ThreedsContingencyReasonType | null, referenceId: string, source?: ThreedsContingencySourceType | null, deviceDataCollectionUrl?: { __typename?: 'GenericURL', href?: string | null } | null, jwtSpecification?: { __typename?: 'ThreeDSJwtSpecification', jwtDuration: string, jwtIssuer: string, jwtOrgUnitId: string, type?: string | null } | null } | null } | null } | null };

export type ThreeDomainSecureFragment = { __typename?: 'PaymentContingencies', threeDomainSecure?: { __typename?: 'ThreeDomainSecureContingency', status?: ApiCallStatus | null, method?: HttpMethod | null, parameter?: string | null, experience?: ThreeDsPaymentExperience | null, redirectUrl?: { __typename?: 'GenericURL', href?: string | null } | null, requestParams?: Array<{ __typename?: 'ThreeDSRequestParams', key?: string | null, value?: string | null } | null> | null } | null };

export type IsGuestMemberBenefitsEligibleQueryQueryVariables = Exact<{
  bank?: InputMaybe<BankAccountInput>;
  billingAddress?: InputMaybe<AddressInput>;
  card?: InputMaybe<CardInput>;
  country: CountryCodes;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: PhoneInput;
  shippingAddress?: InputMaybe<AddressInput>;
  token: Scalars['String'];
}>;


export type IsGuestMemberBenefitsEligibleQueryQuery = { __typename?: 'Query', isGuestMemberBenefitsEligible?: { __typename?: 'GuestMemberBenefits', isEligible?: boolean | null } | null };

export type ApproveOnboardPaymentMutationMutationVariables = Exact<{
  token: Scalars['String'];
  instrumentId?: InputMaybe<Scalars['String']>;
  isBillingAgreement: Scalars['Boolean'];
  supportedThreeDsExperiences?: InputMaybe<Array<InputMaybe<ThreeDsPaymentExperience>> | InputMaybe<ThreeDsPaymentExperience>>;
}>;


export type ApproveOnboardPaymentMutationMutation = { __typename?: 'Mutation', attemptSetStickyFi?: { __typename?: 'CheckoutSession', buyer?: { __typename?: 'User', userId?: string | null } | null } | null, approveGuestSignUpPayment?: { __typename?: 'CheckoutSession', buyer?: { __typename?: 'User', userId?: string | null, email?: { __typename?: 'Email', stringValue?: string | null } | null, name?: { __typename?: 'PersonName', fullName?: string | null } | null } | null, fundingOptions?: Array<{ __typename?: 'FundingOption', fundingInstrument: { __typename?: 'FundingInstrument', id?: string | null, lastDigits?: string | null, name?: string | null, nameDescription?: string | null, type?: FundingOptionType | null } } | null> | null, merchant: { __typename?: 'Merchant', name?: string | null, preferences?: { __typename?: 'MerchantPreferences', autoReturnToMerchant?: boolean | null, enablePaymentDataTransfer?: boolean | null, returnUrl?: string | null } | null }, shippingAddresses?: Array<{ __typename?: 'CheckoutShippingAddress', fullAddress?: string | null, name?: { __typename?: 'PersonName', fullName?: string | null } | null } | null> | null, paymentContingencies?: { __typename?: 'PaymentContingencies', threeDomainSecure?: { __typename?: 'ThreeDomainSecureContingency', status?: ApiCallStatus | null, method?: HttpMethod | null, parameter?: string | null, experience?: ThreeDsPaymentExperience | null, redirectUrl?: { __typename?: 'GenericURL', href?: string | null } | null, requestParams?: Array<{ __typename?: 'ThreeDSRequestParams', key?: string | null, value?: string | null } | null> | null } | null, threeDSContingencyData?: { __typename?: 'ThreeDomainSecureResolutionContingency', name?: string | null, causeName: string, resolution?: { __typename?: 'ThreeDSResolution', type?: string | null, resolutionName: string, paymentCard?: { __typename?: 'ThreeDSPaymentCardData', expireYear?: string | null, expireMonth?: string | null, currencyCode?: string | null, cardProductClass?: FundingInstrumentSubType | null, id?: string | null, encryptedNumber: string, type: CardIssuerType, number: string, bankIdentificationNumber?: string | null, billingAddress?: { __typename?: 'CheckoutBillingAddress', line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, country?: string | null, postalCode?: string | null } | null } | null, contingencyContext?: { __typename?: 'ThreeDSContingencyContextData', authenticationProvider?: string | null, cardBrandProcessed?: CardIssuerType | null, reason?: ThreedsContingencyReasonType | null, referenceId: string, source?: ThreedsContingencySourceType | null, deviceDataCollectionUrl?: { __typename?: 'GenericURL', href?: string | null } | null, jwtSpecification?: { __typename?: 'ThreeDSJwtSpecification', jwtDuration: string, jwtIssuer: string, jwtOrgUnitId: string, type?: string | null } | null } | null } | null } | null } | null, cart?: { __typename?: 'Cart', paymentId?: string | null, intent?: CartIntent | null, returnUrl?: { __typename?: 'GenericURL', href?: string | null, pathname?: string | null } | null, cancelUrl?: { __typename?: 'GenericURL', href?: string | null, pathname?: string | null } | null, items?: Array<{ __typename?: 'CartItem', quantity?: number | null, name?: string | null, sku?: string | null, unitPrice?: { __typename?: 'Amount', currencyValue?: string | null, currencyFormat?: string | null } | null, itemOptionSelections?: Array<{ __typename?: 'ItemOptionSelection', name: string, description: string } | null> | null } | null> | null, amounts?: { __typename?: 'CartAmounts', subtotal?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyValue?: string | null } | null, tax?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyValue?: string | null } | null, shipping?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyValue?: string | null } | null, insurance?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyValue?: string | null } | null, handlingFee?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyValue?: string | null } | null, total?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null } | null, discount?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyValue?: string | null } | null } | null } | null, completedPaymentInfo?: { __typename?: 'CompletedPaymentInfo', transactionId?: string | null, transactionState?: TransactionState | null, receiptId?: string | null, softDescriptor?: string | null, postbackData?: any | null } | null } | null };

export type CreateMemberAccountMutationMutationVariables = Exact<{
  billingAddress?: InputMaybe<AddressInput>;
  contentIdentifier?: InputMaybe<Scalars['String']>;
  country: CountryCodes;
  crsData?: InputMaybe<CommonReportingStandardsInput>;
  dateOfBirth?: InputMaybe<DateOfBirth>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  gender?: InputMaybe<Gender>;
  identityDocument?: InputMaybe<IdentityDocumentInput>;
  lastName: Scalars['String'];
  marketingOptOut?: InputMaybe<Scalars['Boolean']>;
  nationality?: InputMaybe<CountryCodes>;
  occupation?: InputMaybe<Occupation>;
  password?: InputMaybe<Scalars['String']>;
  phone: PhoneInput;
  placeOfBirth?: InputMaybe<CountryCodes>;
  secondaryIdentityDocument?: InputMaybe<IdentityDocumentInput>;
  shippingAddress?: InputMaybe<AddressInput>;
  token: Scalars['String'];
  residentialAddress?: InputMaybe<AddressInput>;
  legalAgreements?: InputMaybe<LegalAgreementsInput>;
}>;


export type CreateMemberAccountMutationMutation = { __typename?: 'Mutation', onboardAccount?: { __typename?: 'CheckoutSession', buyer?: { __typename?: 'User', userId?: string | null, auth?: { __typename?: 'Auth', accessToken?: string | null } | null } | null } | null };

export type CreateOnboardingPaymentPlanMutationMutationVariables = Exact<{
  currencyConversionType?: InputMaybe<CheckoutCurrencyConversionType>;
  cvv?: InputMaybe<Scalars['String']>;
  encryptedCardLoginAccountNumber?: InputMaybe<Scalars['String']>;
  fundingInstrumentId: Scalars['String'];
  shareAddressWithDonatee?: InputMaybe<Scalars['Boolean']>;
  shippingAddress?: InputMaybe<AddressInput>;
  supportedThreeDsExperiences?: InputMaybe<Array<InputMaybe<ThreeDsPaymentExperience>> | InputMaybe<ThreeDsPaymentExperience>>;
  token: Scalars['String'];
  userType: OnboardingExperienceType;
}>;


export type CreateOnboardingPaymentPlanMutationMutation = { __typename?: 'Mutation', createOnboardingPaymentPlan?: { __typename?: 'CheckoutSession', flags?: { __typename?: 'CheckoutSessionFlags', is3DSecureRequired?: boolean | null } | null, paymentContingencies?: { __typename?: 'PaymentContingencies', threeDomainSecure?: { __typename?: 'ThreeDomainSecureContingency', status?: ApiCallStatus | null, method?: HttpMethod | null, parameter?: string | null, experience?: ThreeDsPaymentExperience | null, redirectUrl?: { __typename?: 'GenericURL', href?: string | null } | null, requestParams?: Array<{ __typename?: 'ThreeDSRequestParams', key?: string | null, value?: string | null } | null> | null } | null, threeDSContingencyData?: { __typename?: 'ThreeDomainSecureResolutionContingency', name?: string | null, causeName: string, resolution?: { __typename?: 'ThreeDSResolution', type?: string | null, resolutionName: string, paymentCard?: { __typename?: 'ThreeDSPaymentCardData', expireYear?: string | null, expireMonth?: string | null, currencyCode?: string | null, cardProductClass?: FundingInstrumentSubType | null, id?: string | null, encryptedNumber: string, type: CardIssuerType, number: string, bankIdentificationNumber?: string | null, billingAddress?: { __typename?: 'CheckoutBillingAddress', line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, country?: string | null, postalCode?: string | null } | null } | null, contingencyContext?: { __typename?: 'ThreeDSContingencyContextData', authenticationProvider?: string | null, cardBrandProcessed?: CardIssuerType | null, reason?: ThreedsContingencyReasonType | null, referenceId: string, source?: ThreedsContingencySourceType | null, deviceDataCollectionUrl?: { __typename?: 'GenericURL', href?: string | null } | null, jwtSpecification?: { __typename?: 'ThreeDSJwtSpecification', jwtDuration: string, jwtIssuer: string, jwtOrgUnitId: string, type?: string | null } | null } | null } | null } | null } | null, buyer?: { __typename?: 'User', userId?: string | null, auth?: { __typename?: 'Auth', accessToken?: string | null } | null } | null, fundingOptions?: Array<{ __typename?: 'FundingOption', allPlans?: Array<{ __typename?: 'Plan', fundingSources?: Array<{ __typename?: 'FundingSource', fundingInstrument?: { __typename?: 'FundingInstrument', id?: string | null } | null, amount?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyValue?: string | null } | null } | null> | null } | null> | null, fundingInstrument: { __typename?: 'FundingInstrument', id?: string | null, lastDigits?: string | null, name?: string | null, nameDescription?: string | null, type?: FundingOptionType | null } } | null> | null } | null };

export type OnboardGuestMutationMutationVariables = Exact<{
  bank?: InputMaybe<BankAccountInput>;
  billingAddress?: InputMaybe<AddressInput>;
  card?: InputMaybe<CardInput>;
  country?: InputMaybe<CountryCodes>;
  currencyConversionType?: InputMaybe<CheckoutCurrencyConversionType>;
  dateOfBirth?: InputMaybe<DateOfBirth>;
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone?: InputMaybe<PhoneInput>;
  shareAddressWithDonatee?: InputMaybe<Scalars['Boolean']>;
  shippingAddress?: InputMaybe<AddressInput>;
  supportedThreeDsExperiences?: InputMaybe<Array<InputMaybe<ThreeDsPaymentExperience>> | InputMaybe<ThreeDsPaymentExperience>>;
  token: Scalars['String'];
}>;


export type OnboardGuestMutationMutation = { __typename?: 'Mutation', onboardAccount?: { __typename?: 'CheckoutSession', buyer?: { __typename?: 'User', userId?: string | null, auth?: { __typename?: 'Auth', accessToken?: string | null } | null } | null, flags?: { __typename?: 'CheckoutSessionFlags', is3DSecureRequired?: boolean | null } | null, paymentContingencies?: { __typename?: 'PaymentContingencies', threeDomainSecure?: { __typename?: 'ThreeDomainSecureContingency', status?: ApiCallStatus | null, method?: HttpMethod | null, parameter?: string | null, experience?: ThreeDsPaymentExperience | null, redirectUrl?: { __typename?: 'GenericURL', href?: string | null } | null, requestParams?: Array<{ __typename?: 'ThreeDSRequestParams', key?: string | null, value?: string | null } | null> | null } | null, threeDSContingencyData?: { __typename?: 'ThreeDomainSecureResolutionContingency', name?: string | null, causeName: string, resolution?: { __typename?: 'ThreeDSResolution', type?: string | null, resolutionName: string, paymentCard?: { __typename?: 'ThreeDSPaymentCardData', expireYear?: string | null, expireMonth?: string | null, currencyCode?: string | null, cardProductClass?: FundingInstrumentSubType | null, id?: string | null, encryptedNumber: string, type: CardIssuerType, number: string, bankIdentificationNumber?: string | null, billingAddress?: { __typename?: 'CheckoutBillingAddress', line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, country?: string | null, postalCode?: string | null } | null } | null, contingencyContext?: { __typename?: 'ThreeDSContingencyContextData', authenticationProvider?: string | null, cardBrandProcessed?: CardIssuerType | null, reason?: ThreedsContingencyReasonType | null, referenceId: string, source?: ThreedsContingencySourceType | null, deviceDataCollectionUrl?: { __typename?: 'GenericURL', href?: string | null } | null, jwtSpecification?: { __typename?: 'ThreeDSJwtSpecification', jwtDuration: string, jwtIssuer: string, jwtOrgUnitId: string, type?: string | null } | null } | null } | null } | null } | null, fundingOptions?: Array<{ __typename?: 'FundingOption', allPlans?: Array<{ __typename?: 'Plan', fundingSources?: Array<{ __typename?: 'FundingSource', fundingInstrument?: { __typename?: 'FundingInstrument', id?: string | null } | null, amount?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyValue?: string | null } | null } | null> | null } | null> | null, fundingInstrument: { __typename?: 'FundingInstrument', id?: string | null, lastDigits?: string | null, name?: string | null, nameDescription?: string | null, type?: FundingOptionType | null } } | null> | null } | null };

export type PreAuthorizePaymentMutationMutationVariables = Exact<{
  token: Scalars['String'];
  supportedThreeDsExperiences?: InputMaybe<Array<InputMaybe<ThreeDsPaymentExperience>> | InputMaybe<ThreeDsPaymentExperience>>;
}>;


export type PreAuthorizePaymentMutationMutation = { __typename?: 'Mutation', preAuthorizePayment?: { __typename?: 'CheckoutSession', declinedInstruments?: Array<{ __typename?: 'DeclinedInstrument', id?: string | null, name?: string | null, normalizedProcessorResponse?: string | null } | null> | null, paymentContingencies?: { __typename?: 'PaymentContingencies', threeDomainSecure?: { __typename?: 'ThreeDomainSecureContingency', status?: ApiCallStatus | null, method?: HttpMethod | null, parameter?: string | null, experience?: ThreeDsPaymentExperience | null, redirectUrl?: { __typename?: 'GenericURL', href?: string | null } | null, requestParams?: Array<{ __typename?: 'ThreeDSRequestParams', key?: string | null, value?: string | null } | null> | null } | null, threeDSContingencyData?: { __typename?: 'ThreeDomainSecureResolutionContingency', name?: string | null, causeName: string, resolution?: { __typename?: 'ThreeDSResolution', type?: string | null, resolutionName: string, paymentCard?: { __typename?: 'ThreeDSPaymentCardData', expireYear?: string | null, expireMonth?: string | null, currencyCode?: string | null, cardProductClass?: FundingInstrumentSubType | null, id?: string | null, encryptedNumber: string, type: CardIssuerType, number: string, bankIdentificationNumber?: string | null, billingAddress?: { __typename?: 'CheckoutBillingAddress', line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, country?: string | null, postalCode?: string | null } | null } | null, contingencyContext?: { __typename?: 'ThreeDSContingencyContextData', authenticationProvider?: string | null, cardBrandProcessed?: CardIssuerType | null, reason?: ThreedsContingencyReasonType | null, referenceId: string, source?: ThreedsContingencySourceType | null, deviceDataCollectionUrl?: { __typename?: 'GenericURL', href?: string | null } | null, jwtSpecification?: { __typename?: 'ThreeDSJwtSpecification', jwtDuration: string, jwtIssuer: string, jwtOrgUnitId: string, type?: string | null } | null } | null } | null } | null } | null } | null };

export type SignUpNewMemberMutationMutationVariables = Exact<{
  bank?: InputMaybe<BankAccountInput>;
  billingAddress?: InputMaybe<AddressInput>;
  card?: InputMaybe<CardInput>;
  contentIdentifier?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCodes>;
  countrySpecificFirstName?: InputMaybe<Scalars['String']>;
  countrySpecificLastName?: InputMaybe<Scalars['String']>;
  crsData?: InputMaybe<CommonReportingStandardsInput>;
  currencyConversionType?: InputMaybe<CheckoutCurrencyConversionType>;
  dateOfBirth?: InputMaybe<DateOfBirth>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  gender?: InputMaybe<Gender>;
  identityDocument?: InputMaybe<IdentityDocumentInput>;
  lastName: Scalars['String'];
  marketingOptOut?: InputMaybe<Scalars['Boolean']>;
  nationality?: InputMaybe<CountryCodes>;
  occupation?: InputMaybe<Occupation>;
  password?: InputMaybe<Scalars['String']>;
  phone: PhoneInput;
  placeOfBirth?: InputMaybe<CountryCodes>;
  secondaryIdentityDocument?: InputMaybe<IdentityDocumentInput>;
  selectedInstallmentOption?: InputMaybe<InstallmentsInput>;
  shareAddressWithDonatee?: InputMaybe<Scalars['Boolean']>;
  shippingAddress?: InputMaybe<AddressInput>;
  supportedThreeDsExperiences?: InputMaybe<Array<InputMaybe<ThreeDsPaymentExperience>> | InputMaybe<ThreeDsPaymentExperience>>;
  token: Scalars['String'];
  residentialAddress?: InputMaybe<AddressInput>;
  isSignupIncentiveOptIn?: InputMaybe<Scalars['Boolean']>;
  isSignupIncentiveOptInStretch?: InputMaybe<Scalars['Boolean']>;
  legalAgreements?: InputMaybe<LegalAgreementsInput>;
  collectedConsents?: InputMaybe<Array<InputMaybe<CollectedConsent>> | InputMaybe<CollectedConsent>>;
}>;


export type SignUpNewMemberMutationMutation = { __typename?: 'Mutation', onboardAccount?: { __typename?: 'CheckoutSession', flags?: { __typename?: 'CheckoutSessionFlags', is3DSecureRequired?: boolean | null } | null, paymentContingencies?: { __typename?: 'PaymentContingencies', threeDomainSecure?: { __typename?: 'ThreeDomainSecureContingency', status?: ApiCallStatus | null, method?: HttpMethod | null, parameter?: string | null, experience?: ThreeDsPaymentExperience | null, redirectUrl?: { __typename?: 'GenericURL', href?: string | null } | null, requestParams?: Array<{ __typename?: 'ThreeDSRequestParams', key?: string | null, value?: string | null } | null> | null } | null, threeDSContingencyData?: { __typename?: 'ThreeDomainSecureResolutionContingency', name?: string | null, causeName: string, resolution?: { __typename?: 'ThreeDSResolution', type?: string | null, resolutionName: string, paymentCard?: { __typename?: 'ThreeDSPaymentCardData', expireYear?: string | null, expireMonth?: string | null, currencyCode?: string | null, cardProductClass?: FundingInstrumentSubType | null, id?: string | null, encryptedNumber: string, type: CardIssuerType, number: string, bankIdentificationNumber?: string | null, billingAddress?: { __typename?: 'CheckoutBillingAddress', line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, country?: string | null, postalCode?: string | null } | null } | null, contingencyContext?: { __typename?: 'ThreeDSContingencyContextData', authenticationProvider?: string | null, cardBrandProcessed?: CardIssuerType | null, reason?: ThreedsContingencyReasonType | null, referenceId: string, source?: ThreedsContingencySourceType | null, deviceDataCollectionUrl?: { __typename?: 'GenericURL', href?: string | null } | null, jwtSpecification?: { __typename?: 'ThreeDSJwtSpecification', jwtDuration: string, jwtIssuer: string, jwtOrgUnitId: string, type?: string | null } | null } | null } | null } | null } | null, buyer?: { __typename?: 'User', userId?: string | null, auth?: { __typename?: 'Auth', accessToken?: string | null } | null } | null, fundingOptions?: Array<{ __typename?: 'FundingOption', allPlans?: Array<{ __typename?: 'Plan', fundingSources?: Array<{ __typename?: 'FundingSource', fundingInstrument?: { __typename?: 'FundingInstrument', id?: string | null } | null, amount?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyValue?: string | null } | null } | null> | null } | null> | null, fundingInstrument: { __typename?: 'FundingInstrument', id?: string | null, lastDigits?: string | null, name?: string | null, nameDescription?: string | null, type?: FundingOptionType | null } } | null> | null } | null };

export type GetPasskeyEnrollmentContextQueryVariables = Exact<{
  browserName: Scalars['String'];
  channel: Scalars['String'];
  countryCodeAsString: Scalars['String'];
  integrationType: Scalars['String'];
  os: Scalars['String'];
  token: Scalars['String'];
}>;


export type GetPasskeyEnrollmentContextQuery = { __typename?: 'Query', passkeyEnrollmentContext?: { __typename?: 'IWCContext', context: string } | null, elmoExperiment: { __typename: 'ElmoExperiment', treatments: Array<{ __typename: 'ElmoTreatment', experimentId: string, experimentName: string, treatmentId: string, treatmentName: string, factors?: Array<{ __typename: 'ElmoTreatmentFactor', key: string, value: string } | null> | null } | null> } };

export type AddressNormalizationFragmentFragment = { __typename?: 'NormalizedAddress', line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, alreadyNormalized?: boolean | null, griffinFormattedAddresses?: { __typename?: 'GriffinFormattedAddresses', formattedOriginalAddress?: Array<string | null> | null, formattedNormalizedAddress?: Array<string | null> | null } | null };

export type GetAddressNormalizationQueryQueryVariables = Exact<{
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCodes>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
  transliterationType?: InputMaybe<AddressNormalizationTransliterationType>;
}>;


export type GetAddressNormalizationQueryQuery = { __typename?: 'Query', addressNormalization?: { __typename?: 'NormalizedAddress', line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, alreadyNormalized?: boolean | null, griffinFormattedAddresses?: { __typename?: 'GriffinFormattedAddresses', formattedOriginalAddress?: Array<string | null> | null, formattedNormalizedAddress?: Array<string | null> | null } | null } | null };

export type GetNormalizedAddressesQueryQueryVariables = Exact<{
  shippingcity?: InputMaybe<Scalars['String']>;
  shippingcountry?: InputMaybe<CountryCodes>;
  shippingline1?: InputMaybe<Scalars['String']>;
  shippingline2?: InputMaybe<Scalars['String']>;
  shippingpostalCode?: InputMaybe<Scalars['String']>;
  shippingstate?: InputMaybe<Scalars['String']>;
  billingcity?: InputMaybe<Scalars['String']>;
  billingcountry?: InputMaybe<CountryCodes>;
  billingline1?: InputMaybe<Scalars['String']>;
  billingline2?: InputMaybe<Scalars['String']>;
  billingpostalCode?: InputMaybe<Scalars['String']>;
  billingstate?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
  transliterationType?: InputMaybe<AddressNormalizationTransliterationType>;
}>;


export type GetNormalizedAddressesQueryQuery = { __typename?: 'Query', shippingAddress?: { __typename?: 'NormalizedAddress', line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, alreadyNormalized?: boolean | null, griffinFormattedAddresses?: { __typename?: 'GriffinFormattedAddresses', formattedOriginalAddress?: Array<string | null> | null, formattedNormalizedAddress?: Array<string | null> | null } | null } | null, billingAddress?: { __typename?: 'NormalizedAddress', line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, alreadyNormalized?: boolean | null, griffinFormattedAddresses?: { __typename?: 'GriffinFormattedAddresses', formattedOriginalAddress?: Array<string | null> | null, formattedNormalizedAddress?: Array<string | null> | null } | null } | null };

export type SoldOutPageQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type SoldOutPageQuery = { __typename?: 'Query', checkoutSession?: { __typename?: 'CheckoutSession', cart?: { __typename?: 'Cart', soldoutUrl?: string | null, showSoldoutPage?: boolean | null, items?: Array<{ __typename?: 'CartItem', name?: string | null, quantity?: number | null } | null> | null } | null, merchant: { __typename?: 'Merchant', name?: string | null } } | null };

export type CheckoutGuestWithMemberBenefitsMutationMutationVariables = Exact<{
  bank?: InputMaybe<BankAccountInput>;
  billingAddress?: InputMaybe<AddressInput>;
  card?: InputMaybe<CardInput>;
  country: CountryCodes;
  currencyConversionType?: InputMaybe<CheckoutCurrencyConversionType>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: PhoneInput;
  shippingAddress?: InputMaybe<AddressInput>;
  supportedThreeDsExperiences?: InputMaybe<Array<InputMaybe<ThreeDsPaymentExperience>> | InputMaybe<ThreeDsPaymentExperience>>;
  token: Scalars['String'];
}>;


export type CheckoutGuestWithMemberBenefitsMutationMutation = { __typename?: 'Mutation', checkoutGuestWithMemberBenefits?: { __typename?: 'CheckoutSession', flags?: { __typename?: 'CheckoutSessionFlags', is3DSecureRequired?: boolean | null } | null, paymentContingencies?: { __typename?: 'PaymentContingencies', threeDomainSecure?: { __typename?: 'ThreeDomainSecureContingency', status?: ApiCallStatus | null, method?: HttpMethod | null, parameter?: string | null, experience?: ThreeDsPaymentExperience | null, redirectUrl?: { __typename?: 'GenericURL', href?: string | null } | null, requestParams?: Array<{ __typename?: 'ThreeDSRequestParams', key?: string | null, value?: string | null } | null> | null } | null, threeDSContingencyData?: { __typename?: 'ThreeDomainSecureResolutionContingency', name?: string | null, causeName: string, resolution?: { __typename?: 'ThreeDSResolution', type?: string | null, resolutionName: string, paymentCard?: { __typename?: 'ThreeDSPaymentCardData', expireYear?: string | null, expireMonth?: string | null, currencyCode?: string | null, cardProductClass?: FundingInstrumentSubType | null, id?: string | null, encryptedNumber: string, type: CardIssuerType, number: string, bankIdentificationNumber?: string | null, billingAddress?: { __typename?: 'CheckoutBillingAddress', line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, country?: string | null, postalCode?: string | null } | null } | null, contingencyContext?: { __typename?: 'ThreeDSContingencyContextData', authenticationProvider?: string | null, cardBrandProcessed?: CardIssuerType | null, reason?: ThreedsContingencyReasonType | null, referenceId: string, source?: ThreedsContingencySourceType | null, deviceDataCollectionUrl?: { __typename?: 'GenericURL', href?: string | null } | null, jwtSpecification?: { __typename?: 'ThreeDSJwtSpecification', jwtDuration: string, jwtIssuer: string, jwtOrgUnitId: string, type?: string | null } | null } | null } | null } | null } | null, buyer?: { __typename?: 'User', userId?: string | null, auth?: { __typename?: 'Auth', accessToken?: string | null } | null } | null, fundingOptions?: Array<{ __typename?: 'FundingOption', allPlans?: Array<{ __typename?: 'Plan', fundingSources?: Array<{ __typename?: 'FundingSource', fundingInstrument?: { __typename?: 'FundingInstrument', id?: string | null } | null, amount?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyValue?: string | null } | null } | null> | null } | null> | null, fundingInstrument: { __typename?: 'FundingInstrument', id?: string | null, lastDigits?: string | null, name?: string | null, nameDescription?: string | null, type?: FundingOptionType | null } } | null> | null } | null };

export type ConfirmOneTimePasswordConfirmationMutationMutationVariables = Exact<{
  card: CompleteCardOtpConfirmationInput;
  fundingInstrumentId: Scalars['String'];
  phone: PhoneInput;
}>;


export type ConfirmOneTimePasswordConfirmationMutationMutation = { __typename?: 'Mutation', completeOtpConfirmation?: { __typename?: 'CompleteOtpConfirmationResponse', status?: string | null } | null };

export type InitiateOneTimePasswordConfirmationMutationMutationVariables = Exact<{
  fundingInstrumentId: Scalars['String'];
  phone: PhoneInput;
}>;


export type InitiateOneTimePasswordConfirmationMutationMutation = { __typename?: 'Mutation', initiateOtpConfirmation?: { __typename?: 'InitiateOtpConfirmationResponse', status?: string | null } | null };

export type ConfirmTwoFactorPhoneConfirmationMutationMutationVariables = Exact<{
  pin: Scalars['String'];
  verificationId: Scalars['String'];
}>;


export type ConfirmTwoFactorPhoneConfirmationMutationMutation = { __typename?: 'Mutation', confirmTwoFactorPhoneConfirmation?: { __typename?: 'PhoneConfirmationResponse', id?: string | null, state?: PhoneConfirmationState | null, validUntil?: { __typename?: 'GenericDate', timeMedium?: string | null } | null } | null };

export type ConfirmRiskBasedTwoFactorPhoneConfirmationMutationMutationVariables = Exact<{
  pin: Scalars['String'];
  authId: Scalars['String'];
  challengeId: Scalars['String'];
}>;


export type ConfirmRiskBasedTwoFactorPhoneConfirmationMutationMutation = { __typename?: 'Mutation', confirmRiskBasedTwoFactorPhoneConfirmation?: { __typename?: 'RiskBasedPhoneConfirmationResponse', authId?: string | null, challengeId?: string | null, state?: ExtendedPhoneConfirmationState | null } | null };

export type InitiateTwoFactorPhoneConfirmationMutationMutationVariables = Exact<{
  phoneNumber: Scalars['String'];
  locale: LocaleInput;
  phoneCountry: CountryCodes;
}>;


export type InitiateTwoFactorPhoneConfirmationMutationMutation = { __typename?: 'Mutation', initiateTwoFactorPhoneConfirmation?: { __typename?: 'PhoneConfirmationResponse', id?: string | null, state?: PhoneConfirmationState | null, validUntil?: { __typename?: 'GenericDate', timeMedium?: string | null } | null } | null };

export type InitiateRiskBasedTwoFactorPhoneConfirmationMutationMutationVariables = Exact<{
  phoneNumber: Scalars['String'];
  locale: LocaleInput;
  phoneCountry: CountryCodes;
}>;


export type InitiateRiskBasedTwoFactorPhoneConfirmationMutationMutation = { __typename?: 'Mutation', initiateRiskBasedTwoFactorPhoneConfirmation?: { __typename?: 'RiskBasedPhoneConfirmationResponse', authId?: string | null, challengeId?: string | null, state?: ExtendedPhoneConfirmationState | null } | null };

export type UpgradeGuestToMemberMutationMutationVariables = Exact<{
  billingAddress?: InputMaybe<AddressInput>;
  contentIdentifier?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCodes>;
  dateOfBirth?: InputMaybe<DateOfBirth>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  gender?: InputMaybe<Gender>;
  identityDocument?: InputMaybe<IdentityDocumentInput>;
  lastName: Scalars['String'];
  marketingOptOut?: InputMaybe<Scalars['Boolean']>;
  nationality?: InputMaybe<CountryCodes>;
  occupation?: InputMaybe<Occupation>;
  password?: InputMaybe<Scalars['String']>;
  phone: PhoneInput;
  placeOfBirth?: InputMaybe<CountryCodes>;
  secondaryIdentityDocument?: InputMaybe<IdentityDocumentInput>;
  token: Scalars['String'];
  residentialAddress?: InputMaybe<AddressInput>;
  legalAgreements?: InputMaybe<LegalAgreementsInput>;
}>;


export type UpgradeGuestToMemberMutationMutation = { __typename?: 'Mutation', upgradeGuestToMember?: { __typename?: 'CheckoutSession', buyer?: { __typename?: 'User', userId?: string | null, auth?: { __typename?: 'Auth', accessToken?: string | null } | null } | null } | null };

export type SuggestedDefaultLanguagesQueryQueryVariables = Exact<{
  countryCode: CountryCodes;
  languageCode: CheckoutContentLanguageCode;
}>;


export type SuggestedDefaultLanguagesQueryQuery = { __typename?: 'Query', localeMetadata?: { __typename?: 'LocaleMetadata', territories: Array<{ __typename?: 'LocaleTerritoryMetadata', code?: CountryCodes | null, suggestedDefaultLanguage?: CheckoutContentLanguageCode | null }> } | null };

export type CookieBannerQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type CookieBannerQueryQuery = { __typename?: 'Query', cookieBanner?: { __typename?: 'CookieBanner', js: string, css: string, html: string } | null };

export type BankCurrencyConversionQueryQueryVariables = Exact<{
  countryCode: CountryCodes;
  language: Scalars['String'];
  sourceCurrency: SupportedCountryCurrencies;
  sourceValue: Scalars['String'];
  targetCurrency: SupportedCountryCurrencies;
}>;


export type BankCurrencyConversionQueryQuery = { __typename?: 'Query', currencyConversion?: { __typename?: 'CheckoutCurrencyConversion', spread?: string | null, from?: { __typename?: 'Amount', currencyFormatSymbolISOCurrency?: string | null } | null, issuedDate?: { __typename?: 'GenericDate', dateTimeShort?: string | null } | null, to?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null } | null } | null };

export type SupportedFundingSourcesQueryQueryVariables = Exact<{
  token: Scalars['String'];
  userCountry?: InputMaybe<CountryCodes>;
}>;


export type SupportedFundingSourcesQueryQuery = { __typename?: 'Query', checkoutSession?: { __typename?: 'CheckoutSession', supportedFundingSources?: Array<{ __typename?: 'SupportedFundingSource', issuers?: Array<{ __typename?: 'SupportedFundingSourceIssuer', name?: string | null, usage?: Array<FundingInstrumentSubType | null> | null, rank?: number | null, issuerLogoUrl?: { __typename?: 'GenericURL', href?: string | null } | null } | null> | null } | null> | null } | null };

export type CardMetaQueryQueryVariables = Exact<{
  cardNumber: Scalars['String'];
  countryCode?: InputMaybe<CountryCodes>;
  shouldGetCardCobrand: Scalars['Boolean'];
  shouldGetCardDefinitions: Scalars['Boolean'];
}>;


export type CardMetaQueryQuery = { __typename?: 'Query', cardMeta: { __typename?: 'CardMeta', cobrand?: string | null, definitions?: Array<{ __typename?: 'CardDefinition', brand: CardIssuerType, classifications: Array<InstrumentClassification | null>, confirmationMethods: Array<string | null>, countryCode?: CountryCodes | null } | null> } };

export type InstallmentOptionsQueryQueryVariables = Exact<{
  buyerCountry: CountryCodes;
  cardNumber: Scalars['String'];
  cardType?: InputMaybe<CardIssuerType>;
  token: Scalars['String'];
}>;


export type InstallmentOptionsQueryQuery = { __typename?: 'Query', getInstallmentsForOnboardingFlows?: Array<{ __typename?: 'Installments', term: number, feeReferenceId?: string | null, discount?: { __typename?: 'InstallmentDiscount', percentage?: string | null, amount?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyFormatSymbolISOCurrency?: string | null, currencySymbol?: string | null, currencyValue?: string | null } | null } | null, monthlyPayment: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyFormatSymbolISOCurrency?: string | null, currencySymbol?: string | null, currencyValue?: string | null }, totalCost: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyFormatSymbolISOCurrency?: string | null, currencySymbol?: string | null, currencyValue?: string | null }, totalConsumerFee?: { __typename?: 'ConsumerInstallmentFee', percentage?: string | null, amount?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyFormatSymbolISOCurrency?: string | null, currencySymbol?: string | null, currencyValue?: string | null } | null } | null } | null> | null };

export type UpdateCallbackOptionsMutationMutationVariables = Exact<{
  callbackShippingMethods?: InputMaybe<Array<InputMaybe<CallbackShippingMethodInput>> | InputMaybe<CallbackShippingMethodInput>>;
  shippingOptionsSource?: InputMaybe<ShippingOptionsSource>;
  token: Scalars['String'];
}>;


export type UpdateCallbackOptionsMutationMutation = { __typename?: 'Mutation', updateCallbackOptions?: { __typename?: 'CheckoutSession', cart?: { __typename?: 'Cart', amounts?: { __typename?: 'CartAmounts', discount?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, handlingFee?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, insurance?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, shipping?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, shippingAndHandling?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, shippingDiscount?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, subtotal?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, tax?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, total?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencySymbol?: string | null } | null } | null } | null } | null };

export type UpdateGuestShippingMethodCallbackMutationMutationVariables = Exact<{
  token: Scalars['String'];
  shippingMethodId: Scalars['String'];
}>;


export type UpdateGuestShippingMethodCallbackMutationMutation = { __typename?: 'Mutation', updateGuestShippingMethodCallback?: { __typename?: 'CheckoutSession', cart?: { __typename?: 'Cart', items?: Array<{ __typename: 'CartItem', name?: string | null, quantity?: number | null } | null> | null, amounts?: { __typename?: 'CartAmounts', discount?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, handlingFee?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, insurance?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, shipping?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, shippingAndHandling?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, shippingDiscount?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, subtotal?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, tax?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, total?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencySymbol?: string | null } | null } | null, shippingMethods?: Array<{ __typename?: 'CartShippingMethod', id?: string | null, type?: ShippingMethodType | null, label?: string | null, selected?: boolean | null, amount?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null } | null } | null> | null } | null } | null };

export type UpdateProfileShippingOptionsMutationMutationVariables = Exact<{
  hideShipping: Scalars['Boolean'];
  profileOverrideAllowed: Scalars['Boolean'];
  profileShippingMethods?: InputMaybe<Array<InputMaybe<ProfileShippingMethodInput>> | InputMaybe<ProfileShippingMethodInput>>;
  token: Scalars['String'];
}>;


export type UpdateProfileShippingOptionsMutationMutation = { __typename?: 'Mutation', updateProfileShippingOptions?: { __typename?: 'CheckoutSession', cart?: { __typename?: 'Cart', shippingAddress?: { __typename?: 'CartShippingAddress', firstName?: string | null, lastName?: string | null, line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: CountryCodes | null } | null, amounts?: { __typename?: 'CartAmounts', discount?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, handlingFee?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, insurance?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, shipping?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, shippingAndHandling?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, shippingDiscount?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, subtotal?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, tax?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, total?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencySymbol?: string | null } | null } | null } | null } | null };

export type CalcShippingAndTaxesQueryQueryVariables = Exact<{
  token: Scalars['String'];
  locale: LocaleInput;
  shippingAddress: AddressInput;
}>;


export type CalcShippingAndTaxesQueryQuery = { __typename?: 'Query', calculateShippingAndTaxes?: { __typename?: 'ShippingAndTaxes', isShippingRegionSupported: boolean, shippingOptionsSource: ShippingOptionsSource, isTaxOnShippingRequired: boolean, shouldShowShippingOptions: boolean, profileOverrideAllowed?: boolean | null, charges: Array<{ __typename?: 'ShippingAndTaxCharges', id?: string | null, shipping?: { __typename?: 'ShippingCharges', id: string, type: ShippingMethodType, isDefaultShippingOption: boolean, hasInsurance: boolean, label?: string | null, deliveryTime?: string | null, shippingMethodType?: string | null, shippingAmount: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null }, insuranceAmount?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null } | null } | null, tax?: { __typename?: 'TaxCharges', item?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null } | null, total?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null } | null } | null }> } | null };

export type ProfileShippingOptionsQueryQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type ProfileShippingOptionsQueryQuery = { __typename?: 'Query', checkoutSession?: { __typename?: 'CheckoutSession', cart?: { __typename?: 'Cart', shippingAddress?: { __typename?: 'CartShippingAddress', firstName?: string | null, lastName?: string | null, line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: CountryCodes | null } | null, amounts?: { __typename?: 'CartAmounts', discount?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, handlingFee?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, insurance?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, shipping?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, shippingAndHandling?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, shippingDiscount?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, subtotal?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, tax?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, total?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencySymbol?: string | null } | null } | null } | null } | null };

export type CreateBankAccountCandidateMutationVariables = Exact<{
  bank: BankAccountInput;
  beneficiary?: InputMaybe<BankAccountBeneficiaryInput>;
  billingAddress?: InputMaybe<AddressInput>;
  countryCode: CountryCodes;
}>;


export type CreateBankAccountCandidateMutation = { __typename?: 'Mutation', addBankCandidate?: { __typename?: 'BankAccount', accountNumber: string, accountNumberShort: string, bankIdentifierCode: string, currencyCode: string, id: string, nickname?: string | null, routingNumber: string, type: BankAccountType, beneficiaries: Array<{ __typename?: 'BankAccountBeneficiary', fullName: string } | null>, billingAddress?: { __typename?: 'GenericAddress', city?: string | null, fullAddress?: string | null } | null, creditor?: { __typename?: 'BankAccountCreditor', id: string, name: string, address?: { __typename?: 'GenericAddress', fullAddress?: string | null } | null } | null, issuer?: { __typename?: 'BankAccountIssuer', branchLocation?: string | null, city: string, country: CountryCodes, name: string } | null } | null };

export type InitialDataQueryQueryVariables = Exact<{
  channel: Scalars['String'];
  countryCode: CountryCodes;
  countryCodeAsString: Scalars['String'];
  isBaslAsString: Scalars['String'];
  languageCode: CheckoutContentLanguageCode;
  token: Scalars['String'];
  fundingSource?: InputMaybe<ButtonFundingSourceType>;
}>;


export type InitialDataQueryQuery = { __typename?: 'Query', checkoutSession?: { __typename: 'CheckoutSession', allowedCardIssuers?: Array<CardIssuerType | null> | null, cardProductClasses: Array<InstrumentClassification | null>, checkoutSessionType?: CheckoutSessionType | null, userAction: CheckoutUserAction, cart?: { __typename: 'Cart', billingType?: BillingType | null, callbackIntegrationType?: CallbackIntegrationType | null, callbackVersion?: CallbackVersion | null, consentCode?: string | null, intent?: CartIntent | null, formattedPhoneNumber?: string | null, phoneNumber?: string | null, soldoutUrl?: string | null, showSoldoutPage?: boolean | null, amounts?: { __typename: 'CartAmounts', hideAmountDetails?: boolean | null, discount?: { __typename: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyValue?: string | null } | null, handlingFee?: { __typename: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyValue?: string | null } | null, insurance?: { __typename: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyValue?: string | null } | null, insuranceAndHandling?: { __typename: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyValue?: string | null } | null, shipping?: { __typename: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyValue?: string | null } | null, shippingAndShippingDiscount?: { __typename: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyValue?: string | null } | null, shippingDiscount?: { __typename: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyValue?: string | null } | null, subtotal?: { __typename: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyValue?: string | null } | null, tax?: { __typename: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyValue?: string | null } | null, total?: { __typename: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyValue?: string | null, currencyFormatSymbolISOCurrency?: string | null, currencyFormat?: string | null, currencySymbol?: string | null } | null } | null, billingAddress?: { __typename: 'CartAddress', city?: string | null, country?: CountryCodes | null, line1?: string | null, line2?: string | null, postalCode?: string | null, state?: string | null, formattedFullAddress?: string | null } | null, cancelUrl?: { __typename: 'GenericURL', href?: string | null } | null, email?: { __typename: 'Email', stringValue?: string | null } | null, items?: Array<{ __typename: 'CartItem', name?: string | null, quantity?: number | null } | null> | null, payer?: { __typename: 'SuppliedUserInfo', evaluatedUserData?: { __typename: 'GuestUserMetadata', emailHasExistingAccount: boolean } | null, name?: { __typename: 'PersonName', familyName?: string | null, givenName?: string | null } | null } | null, totalAllowedOverCaptureAmount?: { __typename?: 'Amount', currencyFormatSymbolISOCurrency?: string | null } | null, shippingAddress?: { __typename: 'CartShippingAddress', city?: string | null, country?: CountryCodes | null, firstName?: string | null, isStoreAddress?: boolean | null, lastName?: string | null, line1?: string | null, line2?: string | null, postalCode?: string | null, state?: string | null, formattedFullAddress?: string | null } | null, shippingMethods?: Array<{ __typename: 'CartShippingMethod', id?: string | null, type?: ShippingMethodType | null, label?: string | null, selected?: boolean | null, amount?: { __typename: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null } | null } | null> | null, subscriptionDetails?: { __typename: 'SubscriptionDetails', initialPaymentInfo?: { __typename: 'InitialSubscriptionPaymentInfo', taxPercentage?: string | null, setupFee?: { __typename: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null } | null, firstPayment?: { __typename: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null } | null, shippingAmount?: { __typename: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null } | null, totalAmount?: { __typename: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null } | null } | null, plan?: { __typename: 'SubscriptionPlanDetails', id?: string | null, name?: string | null, startTime?: string | null, billingCycles?: Array<{ __typename: 'SubscriptionBillingCycles', totalCycles?: string | null, fixedPrice?: { __typename: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null } | null, frequency?: { __typename: 'BillingCycleFrequency', intervalUnit?: IntervalUnit | null, intervalCount?: number | null } | null } | null> | null } | null } | null } | null, creditMeta: { __typename: 'CreditMeta', upstreamCreditPresentment: boolean }, flags?: { __typename: 'CheckoutSessionFlags', blockNonDomesticPayer?: boolean | null, blockNonDomesticShipping?: boolean | null, blockNonDomesticCards?: boolean | null, hasPayLaterIntent?: boolean | null, hideShipping?: boolean | null, isBillingAgreement?: boolean | null, isChangeShippingAddressAllowed?: boolean | null, isDebitRequired?: boolean | null, isDonation?: boolean | null, isGuestEligible?: boolean | null, isInvoiceFlow?: boolean | null, isOptionallyShareAddress?: boolean | null, isShippingAddressRequired?: boolean | null, isSntSupported?: boolean | null, isSignupIncentiveEligible?: boolean | null, isSignupIncentiveEligibleStretchRewards?: boolean | null, isWPS?: boolean | null, isWpsAutobilling?: boolean | null, isWpsInstallmentPlan?: boolean | null, isWpsSubscription?: boolean | null } | null, merchant: { __typename: 'Merchant', cobrands?: Array<string | null> | null, country?: CountryCodes | null, merchantId?: string | null, name?: string | null, billPayIntegratorName?: string | null, logo?: { __typename: 'GenericURL', href?: string | null } | null, preferences?: { __typename: 'MerchantPreferences', autoReturnToMerchant?: boolean | null, enablePaymentDataTransfer?: boolean | null } | null }, nonMemberCreditOffers?: { __typename: 'NonMemberCreditOffers', allOffers?: Array<{ __typename: 'NonMemberCreditOffer', creditProductIdentifier?: CreditProductType | null, isEligible?: boolean | null } | null> | null } | null } | null, elmoExperimentWithRealTimeFilters: { __typename: 'ElmoExperiment', treatments: Array<{ __typename: 'ElmoTreatment', experimentId: string, experimentName: string, treatmentId: string, treatmentName: string, factors?: Array<{ __typename: 'ElmoTreatmentFactor', key: string, value: string } | null> | null } | null> }, localeMetadata?: { __typename: 'LocaleMetadata', businessRegions: Array<PayPalBusinessRegions | null>, currencyCode?: SupportedCountryCurrencies | null, currencySymbol?: string | null, suggestedDefaultLanguage?: CheckoutContentLanguageCode | null, supportedLanguages: Array<CheckoutContentLanguageCode>, date?: { __typename: 'LocaleDateMetadata', displayFormat?: string | null, datePattern?: string | null } | null, phone?: { __typename: 'LocalePhoneMetadata', masks?: { __typename: 'LocalePhoneMasks', mobile?: string | null } | null, patterns?: { __typename: 'LocalePhonePatterns', default?: string | null } | null } | null } | null, unifiedLoginContext?: { __typename: 'UnifiedLoginContext', experienceMetadata?: { __typename: 'UnifiedLoginContextExperienceMetadata', onboardingData?: { __typename: 'UnifiedLoginContextOnboardingData', applePayButtonSeen?: boolean | null, loginMethod?: string | null, hasExistingAccount?: boolean | null, userIntent?: OnboardingExperienceType | null, email?: { __typename: 'Email', stringValue?: string | null } | null } | null } | null } | null, userAgreement?: { __typename?: 'UserAgreement', minorVersion: string, majorVersion: string, activeUrl: string } | null };

export type DeferredFeatureQueryVariables = Exact<{
  channel: Scalars['String'];
  countryCodeAsString: Scalars['String'];
  isBaslAsString: Scalars['String'];
  isForcedGuest: Scalars['String'];
  token: Scalars['String'];
  integrationType: Scalars['String'];
}>;


export type DeferredFeatureQuery = { __typename?: 'Query', otpLoginContext?: { __typename: 'OtpLoginContext', context: string } | null, elmoExperiment: { __typename: 'ElmoExperiment', treatments: Array<{ __typename: 'ElmoTreatment', experimentId: string, experimentName: string, treatmentId: string, treatmentName: string, factors?: Array<{ __typename: 'ElmoTreatmentFactor', key: string, value: string } | null> | null } | null> } };

export type AddressMetadataFragment = { __typename?: 'LocaleAddressMetadata', layout?: Array<{ __typename?: 'LocaleAddressField', maxLength?: number | null, minLength?: number | null, isRequired?: boolean | null, name?: string | null, regex?: string | null } | null> | null, strings?: { __typename?: 'LocaleAddressStrings', cityLabel?: string | null, line1Label?: string | null, line2Label?: string | null, optionalLabel?: string | null, postcodeLabel?: string | null, stateLabel?: string | null, stateList?: Array<{ __typename?: 'LocaleAddressState', displayText?: string | null, value?: string | null }> | null } | null };

export type CartAmountsFragment = { __typename?: 'Cart', amounts?: { __typename?: 'CartAmounts', discount?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, handlingFee?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, insurance?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, shipping?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, shippingAndHandling?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, shippingDiscount?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, subtotal?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, tax?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, total?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencySymbol?: string | null } | null } | null };

export type CartDonePageFragment = { __typename?: 'CheckoutSession', cart?: { __typename?: 'Cart', paymentId?: string | null, intent?: CartIntent | null, returnUrl?: { __typename?: 'GenericURL', href?: string | null, pathname?: string | null } | null, cancelUrl?: { __typename?: 'GenericURL', href?: string | null, pathname?: string | null } | null, items?: Array<{ __typename?: 'CartItem', quantity?: number | null, name?: string | null, sku?: string | null, unitPrice?: { __typename?: 'Amount', currencyValue?: string | null, currencyFormat?: string | null } | null, itemOptionSelections?: Array<{ __typename?: 'ItemOptionSelection', name: string, description: string } | null> | null } | null> | null, amounts?: { __typename?: 'CartAmounts', subtotal?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyValue?: string | null } | null, tax?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyValue?: string | null } | null, shipping?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyValue?: string | null } | null, insurance?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyValue?: string | null } | null, handlingFee?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyValue?: string | null } | null, total?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null } | null, discount?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyValue?: string | null } | null } | null } | null };

export type CartItemsFragment = { __typename?: 'Cart', items?: Array<{ __typename?: 'CartItem', description?: string | null, details?: any | null, name?: string | null, quantity?: number | null, total?: { __typename?: 'Amount', currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null } | null, unitPrice?: { __typename?: 'Amount', currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null } | null> | null };

export type CartOvercaptureFragment = { __typename?: 'Cart', totalAllowedOverCaptureAmount?: { __typename?: 'Amount', currencyFormatSymbolISOCurrency?: string | null } | null };

export type SubscriptionDetailsFragment = { __typename?: 'Cart', subscriptionDetails?: { __typename: 'SubscriptionDetails', initialPaymentInfo?: { __typename: 'InitialSubscriptionPaymentInfo', taxPercentage?: string | null, setupFee?: { __typename: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null } | null, firstPayment?: { __typename: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null } | null, shippingAmount?: { __typename: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null } | null, totalAmount?: { __typename: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null } | null } | null, plan?: { __typename: 'SubscriptionPlanDetails', id?: string | null, name?: string | null, startTime?: string | null, billingCycles?: Array<{ __typename: 'SubscriptionBillingCycles', totalCycles?: string | null, fixedPrice?: { __typename: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null } | null, frequency?: { __typename: 'BillingCycleFrequency', intervalUnit?: IntervalUnit | null, intervalCount?: number | null } | null } | null> | null } | null } | null };

export type CompletedPaymentInfoFragment = { __typename?: 'CheckoutSession', completedPaymentInfo?: { __typename?: 'CompletedPaymentInfo', transactionId?: string | null, transactionState?: TransactionState | null, receiptId?: string | null, softDescriptor?: string | null, postbackData?: any | null } | null };

export type ShippingMethodsFragment = { __typename?: 'Cart', shippingMethods?: Array<{ __typename?: 'CartShippingMethod', id?: string | null, type?: ShippingMethodType | null, label?: string | null, selected?: boolean | null, amount?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null } | null } | null> | null };

export type AddressMetadataQueryQueryVariables = Exact<{
  countryCode: CountryCodes;
  languageCode: CheckoutContentLanguageCode;
}>;


export type AddressMetadataQueryQuery = { __typename?: 'Query', localeMetadata?: { __typename?: 'LocaleMetadata', address?: { __typename?: 'LocaleAddressMetadata', layout?: Array<{ __typename?: 'LocaleAddressField', maxLength?: number | null, minLength?: number | null, isRequired?: boolean | null, name?: string | null, regex?: string | null } | null> | null, strings?: { __typename?: 'LocaleAddressStrings', cityLabel?: string | null, line1Label?: string | null, line2Label?: string | null, optionalLabel?: string | null, postcodeLabel?: string | null, stateLabel?: string | null, stateList?: Array<{ __typename?: 'LocaleAddressState', displayText?: string | null, value?: string | null }> | null } | null } | null } | null };

export type AppDownloadBannerQueryQueryVariables = Exact<{
  deviceOS: Scalars['String'];
  deviceOSVersion: Scalars['String'];
  deviceType: DeviceType;
  isMobile: Scalars['Boolean'];
  nonce: Scalars['String'];
  flow?: InputMaybe<Scalars['String']>;
}>;


export type AppDownloadBannerQueryQuery = { __typename?: 'Query', appDownloadBanner?: { __typename: 'AppDownloadBanner', css: string, html: string, js: string } | null };

export type ShowApplePayButtonQueryVariables = Exact<{
  countryCodeAsString: Scalars['String'];
  token: Scalars['String'];
}>;


export type ShowApplePayButtonQuery = { __typename?: 'Query', elmoExperimentWithRealTimeFilters: { __typename: 'ElmoExperiment', treatments: Array<{ __typename: 'ElmoTreatment', experimentId: string, experimentName: string, treatmentId: string, treatmentName: string, factors?: Array<{ __typename: 'ElmoTreatmentFactor', key: string, value: string } | null> | null } | null> } };

export type CheckoutSessionQueryQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type CheckoutSessionQueryQuery = { __typename?: 'Query', checkoutSession?: { __typename?: 'CheckoutSession', cart?: { __typename?: 'Cart', amounts?: { __typename?: 'CartAmounts', discount?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, handlingFee?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, insurance?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, shipping?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, shippingAndHandling?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, shippingDiscount?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, subtotal?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, tax?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null, total?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencySymbol?: string | null } | null } | null, items?: Array<{ __typename?: 'CartItem', description?: string | null, details?: any | null, name?: string | null, quantity?: number | null, total?: { __typename?: 'Amount', currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null } | null, unitPrice?: { __typename?: 'Amount', currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null, currencyFormat?: string | null } | null } | null> | null, totalAllowedOverCaptureAmount?: { __typename?: 'Amount', currencyFormatSymbolISOCurrency?: string | null } | null, shippingMethods?: Array<{ __typename?: 'CartShippingMethod', id?: string | null, type?: ShippingMethodType | null, label?: string | null, selected?: boolean | null, amount?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null } | null } | null> | null, subscriptionDetails?: { __typename: 'SubscriptionDetails', initialPaymentInfo?: { __typename: 'InitialSubscriptionPaymentInfo', taxPercentage?: string | null, setupFee?: { __typename: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null } | null, firstPayment?: { __typename: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null } | null, shippingAmount?: { __typename: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null } | null, totalAmount?: { __typename: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null } | null } | null, plan?: { __typename: 'SubscriptionPlanDetails', id?: string | null, name?: string | null, startTime?: string | null, billingCycles?: Array<{ __typename: 'SubscriptionBillingCycles', totalCycles?: string | null, fixedPrice?: { __typename: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null } | null, frequency?: { __typename: 'BillingCycleFrequency', intervalUnit?: IntervalUnit | null, intervalCount?: number | null } | null } | null> | null } | null } | null } | null } | null };

export type CurrencyConversionFromCreditCardQueryQueryVariables = Exact<{
  cardBrand?: InputMaybe<CardIssuerType>;
  cardNumber: Scalars['String'];
  country?: InputMaybe<CountryCodes>;
  token: Scalars['String'];
}>;


export type CurrencyConversionFromCreditCardQueryQuery = { __typename?: 'Query', currencyConversionFromCreditCard?: { __typename?: 'CheckoutCurrencyConversion', canChangeConversionType?: boolean | null, feeRateFormatted?: string | null, spread?: string | null, type?: CheckoutCurrencyConversionType | null, from?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null } | null, to?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null } | null } | null };

export type GriffinMetadataQueryQueryVariables = Exact<{
  countryCode: CountryCodes;
  languageCode: CheckoutContentLanguageCode;
  shippingCountryCode: CountryCodes;
}>;


export type GriffinMetadataQueryQuery = { __typename?: 'Query', localeMetadata?: { __typename?: 'LocaleMetadata', currencyCode?: SupportedCountryCurrencies | null, address?: { __typename?: 'LocaleAddressMetadata', layout?: Array<{ __typename?: 'LocaleAddressField', maxLength?: number | null, minLength?: number | null, isRequired?: boolean | null, name?: string | null, regex?: string | null } | null> | null, strings?: { __typename?: 'LocaleAddressStrings', cityLabel?: string | null, line1Label?: string | null, line2Label?: string | null, optionalLabel?: string | null, postcodeLabel?: string | null, stateLabel?: string | null, stateList?: Array<{ __typename?: 'LocaleAddressState', displayText?: string | null, value?: string | null }> | null } | null } | null, shippingAddress?: { __typename?: 'LocaleAddressMetadata', layout?: Array<{ __typename?: 'LocaleAddressField', maxLength?: number | null, minLength?: number | null, isRequired?: boolean | null, name?: string | null, regex?: string | null } | null> | null, strings?: { __typename?: 'LocaleAddressStrings', cityLabel?: string | null, line1Label?: string | null, line2Label?: string | null, optionalLabel?: string | null, postcodeLabel?: string | null, stateLabel?: string | null, stateList?: Array<{ __typename?: 'LocaleAddressState', displayText?: string | null, value?: string | null }> | null } | null } | null, date?: { __typename?: 'LocaleDateMetadata', displayFormat?: string | null, datePattern?: string | null } | null, phone?: { __typename?: 'LocalePhoneMetadata', masks?: { __typename?: 'LocalePhoneMasks', mobile?: string | null } | null, patterns?: { __typename?: 'LocalePhonePatterns', default?: string | null } | null } | null, territories: Array<{ __typename?: 'LocaleTerritoryMetadata', code?: CountryCodes | null, internationalDialingCode?: number | null, name?: string | null, region?: string | null, suggestedDefaultLanguage?: CheckoutContentLanguageCode | null }> } | null };

export type GuestUpgradeableToMemberQueryVariables = Exact<{
  token: Scalars['String'];
  billingAddress: AddressInput;
  card: CardInput;
  country: CountryCodes;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
}>;


export type GuestUpgradeableToMemberQuery = { __typename?: 'Query', isGuestUpgradeableToMember?: boolean | null };

export type WpsDonePageQueryQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type WpsDonePageQueryQuery = { __typename?: 'Query', checkoutSession?: { __typename?: 'CheckoutSession', merchant: { __typename?: 'Merchant', name?: string | null, preferences?: { __typename?: 'MerchantPreferences', autoReturnToMerchant?: boolean | null, enablePaymentDataTransfer?: boolean | null, returnUrl?: string | null } | null }, buyer?: { __typename?: 'User', userId?: string | null, email?: { __typename?: 'Email', stringValue?: string | null } | null, name?: { __typename?: 'PersonName', fullName?: string | null } | null } | null, fundingOptions?: Array<{ __typename?: 'FundingOption', fundingInstrument: { __typename?: 'FundingInstrument', lastDigits?: string | null, name?: string | null, nameDescription?: string | null, type?: FundingOptionType | null } } | null> | null, shippingAddresses?: Array<{ __typename?: 'CheckoutShippingAddress', fullAddress?: string | null, name?: { __typename?: 'PersonName', fullName?: string | null } | null } | null> | null, cart?: { __typename?: 'Cart', paymentId?: string | null, intent?: CartIntent | null, returnUrl?: { __typename?: 'GenericURL', href?: string | null, pathname?: string | null } | null, cancelUrl?: { __typename?: 'GenericURL', href?: string | null, pathname?: string | null } | null, items?: Array<{ __typename?: 'CartItem', quantity?: number | null, name?: string | null, sku?: string | null, unitPrice?: { __typename?: 'Amount', currencyValue?: string | null, currencyFormat?: string | null } | null, itemOptionSelections?: Array<{ __typename?: 'ItemOptionSelection', name: string, description: string } | null> | null } | null> | null, amounts?: { __typename?: 'CartAmounts', subtotal?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyValue?: string | null } | null, tax?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyValue?: string | null } | null, shipping?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyValue?: string | null } | null, insurance?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyValue?: string | null } | null, handlingFee?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyValue?: string | null } | null, total?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyFormatSymbolISOCurrency?: string | null, currencyValue?: string | null } | null, discount?: { __typename?: 'Amount', currencyCode?: SupportedCountryCurrencies | null, currencyFormat?: string | null, currencyValue?: string | null } | null } | null } | null, completedPaymentInfo?: { __typename?: 'CompletedPaymentInfo', transactionId?: string | null, transactionState?: TransactionState | null, receiptId?: string | null, softDescriptor?: string | null, postbackData?: any | null } | null } | null };

export type WeasleyEligibilityQueryVariables = Exact<{
  channel: Scalars['String'];
  countryCodeAsString: Scalars['String'];
  res: Scalars['String'];
  token: Scalars['String'];
}>;


export type WeasleyEligibilityQuery = { __typename?: 'Query', elmoExperimentWithRealTimeFilters: { __typename: 'ElmoExperiment', treatments: Array<{ __typename: 'ElmoTreatment', experimentId: string, experimentName: string, treatmentId: string, treatmentName: string, factors?: Array<{ __typename: 'ElmoTreatmentFactor', key: string, value: string } | null> | null } | null> } };
